var COVER_CATALOG = [{"handle":"beoplay-beosound-a9-cover-verve","name":"Verve","colors":["Blue","Orange"],"mood":"Bold / Dramatic","style":"Abstract Art","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beoplay-beosound-a9-cover-verve.jpg?v=1777361396","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90240.jpg","variantId":46216914829500},{"handle":"beoplay-beosound-a9-cover-eclat","name":"Éclat","colors":["Blue"],"mood":"Bold / Dramatic","style":"Cubist / Collage","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beoplay-beosound-a9-cover-eclat-cubist-portrait.jpg?v=1776157013","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90239.jpg","variantId":46191921299644},{"handle":"beoplay-beosound-a9-kvadrat-cover-natural","name":"Natural","colors":["Grey","White"],"mood":"Elegant / Refined","style":"Textile / Fabric","category":"Kvadrat Premium","price":295,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beoplay-beosound-a9-kvadrat-cover-natural.jpg?v=1775726024","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-kvadrat-natural.jpg?v=1781632297","variantId":46177083916476},{"handle":"beoplay-beosound-a9-cover-ivory-pine","name":"Ivory Pine","colors":["Green","Red"],"mood":"Warm / Peaceful","style":"Japanese Ink Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beoplay-beosound-a9-cover-ivory-pine.jpg?v=1773830350","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90238.jpg?v=1781622449","variantId":45724871459004},{"handle":"beoplay-beosound-a9-cover-lucky-trot","name":"Lucky Trot","colors":["Red","Green"],"mood":"Warm / Joyful","style":"Folk Illustration","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beosound-a9-cover-lucky-trot-horse-floral-design.jpg?v=1773396405","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90237.jpg","variantId":45724851863740},{"handle":"beoplay-beosound-a9-cover-winter-friends","name":"Winter Friends","colors":["Blue","White"],"mood":"Dreamy / Ethereal","style":"Storybook Illustration","category":"Artist Collaboration","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beosound-a9-cover-winter-friends.jpg?v=1773396743","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-winter-friends.jpg?v=1781769617","variantId":45418337009852},{"handle":"beoplay-beosound-a9-cover-silent-pine","name":"Silent Pine","colors":["Green","Red"],"mood":"Warm / Peaceful","style":"Botanical Illustration","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/Beosound_A9_Cover_Silent_Pine.jpg?v=1773397530","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90231.jpg","variantId":45418336026812},{"handle":"beoplay-beosound-a9-cover-festive-rebel","name":"Festive Rebel","colors":["Black","Red"],"mood":"Playful / Fun","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/Festive-Rebel-1.jpg?v=1763009883","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90233.jpg","variantId":45418335109308},{"handle":"beoplay-beosound-a9-cover-carnival-mosaic","name":"Carnival Mosaic","colors":["Multicolour"],"mood":"Playful / Fun","style":"Geometric","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A92_77c7b287-afe1-47b1-80bc-be8b655d67ee.jpg?v=1757746897","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90230.jpg","variantId":45186399699132},{"handle":"beoplay-beosound-a9-cover-the-wave","name":"The Wave","colors":["Blue"],"mood":"Calm / Serene","style":"Minimalist","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-1_0d6960ad-acd1-4f11-b5e2-e14aefa754e9.jpg?v=1754639577","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90229.jpg","variantId":45066126131388},{"handle":"beoplay-beosound-a9-cover-radiant-horizon","name":"Radiant Horizon","colors":["Orange","Pink"],"mood":"Warm / Joyful","style":"Abstract Art","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_fd549b90-1630-4cc0-8d6e-12b682a06885.jpg?v=1743133793","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90226.jpg?v=1781622449","variantId":44631087055036},{"handle":"beoplay-beosound-a9-cover-blue-reverie","name":"Blue Reverie","colors":["Blue"],"mood":"Calm / Serene","style":"Abstract Art","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_13886d39-15fe-4abe-bd3a-1089cde51c2e.jpg?v=1743131414","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90224.jpg","variantId":44630973317308},{"handle":"beoplay-beosound-a9-cover-solid-white","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-solid-white.jpg?v=1781613153","name":"Solid White","colors":["White"],"mood":"Calm / Serene","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/2_7d657735-55e5-4649-9bcb-c30e5abaf611.jpg?v=1736761345","variantId":44446215241916},{"handle":"beoplay-beosound-a9-cover-solid-black","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-solid-black.jpg?v=1781613153","name":"Solid Black","colors":["Black"],"mood":"Elegant / Refined","style":"Minimalist","category":"Solid Color","price":99,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/1_eb148115-e8b7-457f-a176-a6964c534fc0.jpg?v=1736761180","variantId":44445950902460},{"handle":"beoplay-beosound-a9-cover-lunar-snake","name":"Lunar Snake","colors":["Red","Blue"],"mood":"Bold / Dramatic","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A9-1_5ad18e08-5b21-46b1-a42b-bf7bacb7fff7.jpg?v=1735292759","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90212.jpg","variantId":44418633728188},{"handle":"beoplay-beosound-a9-golden-blossom","name":"Golden Blossom","colors":["Brown / Earth","Red"],"mood":"Elegant / Refined","style":"Botanical Illustration","category":"Nature & Botanical","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/Golden-Blossom.jpg?v=1735292476","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90215.jpg","variantId":44418621767868},{"handle":"beoplay-beosound-a9-cover-pine-joy","name":"Pine Joy","colors":["Green"],"mood":"Warm / Peaceful","style":"Botanical Illustration","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_c49df179-1753-435f-9a76-805b87703279.jpg?v=1731404491","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90194.jpg?v=1781613153","variantId":44274734661820},{"handle":"beoplay-beosound-a9-cover-david-noel","name":"BeoPlay / BeoSound A9 Cover  - David Noël","colors":["Red","White"],"mood":"Playful / Fun","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_0d18552f-7c87-4138-afac-16cae6e9d647.jpg?v=1731218562","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-david-noel.jpg","variantId":44259027255484},{"handle":"beoplay-beosound-a9-cover-venus-noel","name":"Venus Noël","colors":["Red","White"],"mood":"Playful / Fun","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_997d82a4-54f5-4c5a-8002-8284b51fd1d3.jpg?v=1731218502","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90192.jpg","variantId":44259026895036},{"handle":"beoplay-beosound-a9-cover-frosty-joy","name":"BeoPlay / BeoSound A9 Cover  - Frosty Joy","colors":["White","Grey"],"mood":"Playful / Fun","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_360fa39b-483c-49a7-8863-43d5d536add3.jpg?v=1731218426","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90191.jpg","variantId":44259026731196},{"handle":"beoplay-beosound-a9-cover-hohoho","name":"BeoPlay / BeoSound A9 Cover  - HOHOHO","colors":["Red","Blue"],"mood":"Festive / Celebratory","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_5d01ac76-aa4b-48a6-8167-319545417b3b.jpg?v=1731218234","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-hohoho.jpg","variantId":44259026665660},{"handle":"beoplay-beosound-a9-cover-nordic-ice","name":"BeoPlay / BeoSound A9 Cover  - Nordic Ice","colors":["Blue","White"],"mood":"Calm / Serene","style":"Minimalist","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/0284f820ac64a5d15b992e0882f85b24.jpg?v=1729245533","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90189.jpg","variantId":44202317217980},{"handle":"beoplay-beosound-a9-kvadrat-cover-indigo-blue","name":"Indigo Blue","colors":["Blue"],"mood":"Elegant / Refined","style":"Textile / Fabric","category":"Kvadrat Premium","price":135,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/22.jpg?v=1724060298","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-kvadrat-indigo-blue.jpg?v=1781632297","variantId":44076983124156},{"handle":"beoplay-beosound-a9-cover-pastel-chill","name":"Pastel Chill","colors":["Pink","Blue"],"mood":"Calm / Serene","style":"Abstract Art","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/ice-0.jpg?v=1723513857","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90188.jpg","variantId":44064952484028},{"handle":"beoplay-beosound-a9-cover-luminous-dusk","name":"Luminous Dusk","colors":["Purple","Orange"],"mood":"Calm / Serene","style":"Abstract Art","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/0.jpg?v=1723513573","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90187.jpg","variantId":44064943276220},{"handle":"beoplay-beosound-a9-cover-goldtone","name":"BeoPlay / BeoSound A9 Cover  - Goldtone","colors":["Brown / Earth"],"mood":"Elegant / Refined","style":"Minimalist","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A9-1_1d8e40c2-1c01-4080-a9cb-f773b8bbacde.jpg?v=1722335304","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90186-goldtone.jpg?v=1781622449","variantId":44038220644540},{"handle":"beoplay-beosound-a9-cover-purple-haze","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90184.jpg?v=1781613153","name":"Purple Haze","colors":["Purple"],"mood":"Dreamy / Ethereal","style":"Botanical Illustration","category":"Nature & Botanical","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/Purple-Haze1.jpg?v=1713691975","variantId":43658101358780},{"handle":"beoplay-beosound-a9-cover-english-garden","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90183.jpg?v=1781613153","name":"English Garden","colors":["Orange","Green"],"mood":"Warm / Peaceful","style":"Botanical Illustration","category":"Nature & Botanical","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/English-Garden1.jpg?v=1713691696","variantId":43658094903484},{"handle":"beoplay-beosound-a9-cover-lemon-lush","name":"Lemon Lush","colors":["Yellow","Green"],"mood":"Fresh / Vibrant","style":"Botanical Illustration","category":"Nature & Botanical","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/Lemon-Lush1.jpg?v=1713690223","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90182.jpg","variantId":43658067214524},{"handle":"beoplay-beosound-a9-cover-tranquil-blaze","name":"Tranquil Blaze","colors":["Red","White"],"mood":"Warm / Peaceful","style":"Abstract Art","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/98191706183255_.pic.jpg?v=1706183299","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90181.jpg?v=1781622449","variantId":43293355999420},{"handle":"beoplay-beosound-a9-cover-serene-ember","name":"Serene Ember","colors":["Red","White"],"mood":"Warm / Peaceful","style":"Abstract Art","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/98081706183152_.pic.jpg?v=1706183190","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90180.jpg?v=1781622449","variantId":43290679541948},{"handle":"beoplay-beosound-a9-cover-velocity-checkered","name":"Velocity Checkered","colors":["Black","White"],"mood":"Bold / Dramatic","style":"Geometric","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/00_36a31cf3-4764-42c9-8582-f79a2b33334a.jpg?v=1701941068","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90175.jpg","variantId":43164761194684},{"handle":"beoplay-beosound-a9-cover-seasons-enchantment","name":"Seasons Enchantment","colors":["Red","Green"],"mood":"Festive / Celebratory","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_6068730a-67dd-4fec-a597-f197e18b9f34.jpg?v=1700475805","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90176.jpg","variantId":43041695236284},{"handle":"beoplay-beosound-a9-cover-sapphire-drama","name":"Sapphire Drama","colors":["Blue"],"mood":"Bold / Dramatic","style":"Abstract Art","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/00_2569e102-de56-45d5-933b-5ee10d90d287.jpg?v=1698131601","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90174.jpg","variantId":43035454865596},{"handle":"beoplay-beosound-a9-cover-caracalla","name":"Caracalla","colors":["Green","Red","Brown / Earth"],"mood":"Elegant / Refined","style":"Geometric","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/00_7b7880e8-1626-43b6-8ec2-e267aaaf692e.jpg?v=1696901189","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90173.jpg","variantId":42987999133884},{"handle":"beoplay-beosound-a9-cover-barbie-pink","name":"Barbie Pink","colors":["Pink"],"mood":"Playful / Fun","style":"Minimalist","category":"Solid Color","price":69,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/Barbie-Pink.jpg?v=1693299809","variantId":42848834027708,"preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-barbie-pink.jpg?v=1781613153"},{"handle":"beoplay-beosound-a9-kvadrat-cover-infantry-green","name":"Infantry Green","colors":["Green"],"mood":"Elegant / Refined","style":"Textile / Fabric","category":"Kvadrat Premium","price":135,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beoplay-a9-cover-green.jpg?v=1689583660","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-kvadrat-infantry-green.jpg?v=1781632297","variantId":42838167716028},{"handle":"beoplay-beosound-a9-kvadrat-cover-gold","name":"Gold","colors":["Brown / Earth"],"mood":"Elegant / Refined","style":"Textile / Fabric","category":"Kvadrat Premium","price":350,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/BEOPLAY-_A9_GOLD.jpg?v=1689674615","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-gold-kvadrat.jpg?v=1781632297","variantId":42838167126204},{"handle":"beoplay-beosound-a9-kvadrat-cover-grey","name":"Grey","colors":["Grey"],"mood":"Elegant / Refined","style":"Textile / Fabric","category":"Kvadrat Premium","price":145,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/1_af57a363-fd4b-4dc7-be2d-c5d014dbd008.jpg?v=1724060258","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-kvadrat-grey.jpg?v=1781632297","variantId":42838166700220},{"handle":"beoplay-beosound-a9-kvadrat-cover-pebble-white","name":"Pebble White","colors":["White"],"mood":"Elegant / Refined","style":"Textile / Fabric","category":"Kvadrat Premium","price":175,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9_kvadratcover_white_new.jpg?v=1689674799","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-kvadrat-pebble-white.jpg?v=1781632297","variantId":42837323841724},{"handle":"beoplay-beosound-a9-kvadrat-cover-pink","name":"Pink","colors":["Pink"],"mood":"Warm / Peaceful","style":"Textile / Fabric","category":"Kvadrat Premium","price":175,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beoplay-beosound-a9-kvadrat-cover-pink.jpg?v=1775644336","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-kvadrat-pink.jpg?v=1781632297","variantId":42837322629308},{"handle":"beoplay-beosound-a9-kvadrat-cover-warm-taupe","name":"Warm Taupe","colors":["Brown / Earth"],"mood":"Elegant / Refined","style":"Textile / Fabric","category":"Kvadrat Premium","price":175,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9_bronze.jpg?v=1689674583","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-kvadrat-warm-taupe.jpg?v=1781771032","variantId":42837321613500},{"handle":"beoplay-beosound-a9-kvadrat-cover-light-grey","name":"Light Grey","colors":["Grey"],"mood":"Elegant / Refined","style":"Textile / Fabric","category":"Kvadrat Premium","price":175,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9_kvadratcover_grey_new.jpg?v=1689674461","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-kvadrat-light-grey.jpg?v=1781632297","variantId":42837320761532},{"handle":"beoplay-beosound-a9-cover-summer-bliss","name":"Summer Bliss","colors":["Blue","Green"],"mood":"Fresh / Vibrant","style":"Photography","category":"Nature & Botanical","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_051d1e65-95b7-4560-977a-aa586af20f31.jpg?v=1688379402","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90170.jpg","variantId":42756310859964},{"handle":"beoplay-beosound-a9-cover-polka-dots","name":"Polka Dots","colors":["Black","White"],"mood":"Playful / Fun","style":"Geometric","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/01_4db3703c-438d-4307-93cb-26c8716ec0b0.jpg?v=1688378101","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90169.jpg?v=1781622449","variantId":42756272554172},{"handle":"beoplay-beosound-a9-cover-emerald-ears","name":"Emerald Ears","colors":["Green","White"],"mood":"Playful / Fun","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/1_08baa851-3b2b-459b-89c1-5f9cf4856c85.jpg?v=1672905024","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90168.jpg","variantId":42442295410876},{"handle":"beoplay-beosound-a9-cover-garden-bunny","name":"Garden Bunny","colors":["Black","Green"],"mood":"Warm / Joyful","style":"Storybook Illustration","category":"Nature & Botanical","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/1_abc1abe3-6c7d-4ae2-a822-67cb89c34c3b.jpg?v=1672905051","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90167.jpg?v=1781622449","variantId":42442293641404},{"handle":"beoplay-beosound-a9-cover-christmas-wonderland","name":"Christmas Wonderland","colors":["Red","White"],"mood":"Festive / Celebratory","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/01_d6806bcd-0196-48f6-bec7-cb07b3f69aba.jpg?v=1669977739","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90166.jpg","variantId":42388453589180},{"handle":"beoplay-beosound-a9-cover-rudolph","name":"Rudolph","colors":["Red"],"mood":"Playful / Fun","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/01_a3b67edf-ecd9-4a53-8903-935b2c020297.jpg?v=1669977685","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90165.jpg?v=1781622449","variantId":42388450115772},{"handle":"beoplay-beosound-a9-cover-astronaut-x-yuya-hashizume","name":"Astronaut x Yuya Hashizume","colors":["White","Brown / Earth"],"mood":"Dreamy / Ethereal","style":"Anime / Manga","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/01_64f9c274-f46e-408f-b46e-27fa69814cb6.jpg?v=1667969158","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90164.jpg","variantId":42327355424956},{"handle":"beoplay-beosound-a9-cover-neon-spacesuit-x-yuya-hashizume","name":"Neon Spacesuit x Yuya Hashizume","colors":["Pink","Purple"],"mood":"Playful / Fun","style":"Anime / Manga","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/e45a6328dbc4382e612c906fa46f85cf_1f356cc8-8887-4a18-a5f8-5c71607ef5a6.jpg?v=1677840899","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90163.jpg?v=1781622449","variantId":42327355064508},{"handle":"beoplay-beosound-a9-cover-cat-x-yuya-hashizume","name":"Cat x Yuya Hashizume","colors":["Brown / Earth","Grey"],"mood":"Warm / Peaceful","style":"Anime / Manga","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/01_11fef0e6-ea77-4242-82fb-846bc5366765.jpg?v=1667974073","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90162.jpg?v=1781622449","variantId":42327354638524},{"handle":"beoplay-beosound-a9-cover-at-dawn-x-subin-lim","name":"At Dawn X Subin Lim","colors":["Pink","Green"],"mood":"Dreamy / Ethereal","style":"Storybook Illustration","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/001_9c6c62dd-97d1-4a00-8c68-932fd0b08992.jpg?v=1667969247","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90161.jpg?v=1781622449","variantId":42327351853244},{"handle":"beoplay-beosound-a9-cover-meeting-place-x-subin-lim","name":"Meeting Place X Subin Lim","colors":["Pink","Green"],"mood":"Dreamy / Ethereal","style":"Storybook Illustration","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/001_63b6a0f0-706e-41b5-abc1-8ff4dd64b8b1.jpg?v=1667969298","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90160.jpg?v=1781622449","variantId":42327351361724},{"handle":"beoplay-beosound-a9-cover-companion-x-subin-lim","name":"Companion x Subin Lim","colors":["Pink","Green"],"mood":"Warm / Joyful","style":"Storybook Illustration","category":"Artist Collaboration","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/001_fac4b655-8465-4450-958c-cbb90250377c.jpg?v=1667969273","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90159.jpg?v=1781622449","variantId":42327348150460},{"handle":"beoplay-beosound-a9-cover-tiger-print","name":"Tiger Print","colors":["Orange","Black"],"mood":"Bold / Dramatic","style":"Photography","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/1_54727161-780c-472e-8e4f-9e43a5602dd7.jpg?v=1648372450","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90158.jpg","variantId":41603341254844},{"handle":"beoplay-beosound-a9-cover-in-the-wild","name":"In the Wild","colors":["Orange","Black"],"mood":"Playful / Fun","style":"Digital Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0_55beead5-cac3-4720-ae2d-6186773e2070.jpg?v=1648372370","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90157.jpg","variantId":41603338567868},{"handle":"beoplay-beosound-a9-cover-fierce","name":"Fierce","colors":["White","Orange"],"mood":"Bold / Dramatic","style":"Digital Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/1_3849a9e0-dac3-41af-aaef-029a96d89b19.jpg?v=1648372334","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90156.jpg","variantId":41603337257148},{"handle":"beoplay-beosound-a9-cover-tiger-dream","name":"Tiger Dream","colors":["Green","Orange"],"mood":"Bold / Dramatic","style":"Digital Art","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0_0a7e945e-30c9-4591-8d37-2058d200284e.jpg?v=1648372408","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90155.jpg","variantId":41603331522748},{"handle":"beoplay-beosound-a9-cover-frida-x-aira","name":"Frida x Aira","colors":["Multicolour"],"mood":"Bold / Dramatic","style":"Storybook Illustration","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/e45a6328dbc4382e612c906fa46f85cf_2b0104f0-cbd5-4a35-a54d-5603687f2ded.jpg?v=1631581556","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90151.jpg?v=1781622449","variantId":40816704061628},{"handle":"beoplay-beosound-a9-cover-the-tree-of-love","name":"The Tree of Love","colors":["Green","Brown / Earth"],"mood":"Dreamy / Ethereal","style":"Storybook Illustration","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/e45a6328dbc4382e612c906fa46f85cf_f6485230-2802-4d11-94da-27eff869972c.jpg?v=1631581499","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-the-tree-of-love.jpg","variantId":40816683319484},{"handle":"beoplay-beosound-a9-cover-towards-paradise","name":"Towards Paradise","colors":["Multicolour"],"mood":"Dreamy / Ethereal","style":"Storybook Illustration","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/e45a6328dbc4382e612c906fa46f85cf.jpg?v=1631581431","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-towards-paradise.jpg?v=1781622449","variantId":40816644292796},{"handle":"beoplay-beosound-a9-cover-rest","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90148.jpg?v=1781613153","name":"Rest","colors":["White","Pink"],"mood":"Calm / Serene","style":"Chinese Brush Painting","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0_7406c561-7527-4bf6-8203-9f557d4b721f.jpg?v=1623566220","variantId":40006326124732},{"handle":"beoplay-beosound-a9-cover-tracing-back","name":"Tracing Back","colors":["Pink","White"],"mood":"Dreamy / Ethereal","style":"Chinese Brush Painting","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0_f37a98b9-91b1-4267-9963-e6403af88644.jpg?v=1623566446","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90147.jpg?v=1781622449","variantId":40006321045692},{"handle":"beoplay-beosound-a9-cover-daydreaming","name":"Daydreaming","colors":["Red","White"],"mood":"Dreamy / Ethereal","style":"Chinese Brush Painting","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0_5c19dfd4-0b38-4dde-9424-c6dacbbf0a36.jpg?v=1623566169","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90146.jpg?v=1781622449","variantId":40006316359868},{"handle":"beoplay-beosound-a9-cover-free-clouds","name":"Free Clouds","colors":["Blue","White"],"mood":"Calm / Serene","style":"Chinese Brush Painting","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0_88a88673-6ea2-411e-a344-ef4296970c28.jpg?v=1623566262","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90145.jpg?v=1781622449","variantId":40006308528316},{"handle":"beoplay-beosound-a9-cover-catching-stars","name":"Catching stars","colors":["Blue","White"],"mood":"Dreamy / Ethereal","style":"Chinese Brush Painting","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0_ac908ac1-0f19-422d-8f75-831cac8d70bc.jpg?v=1623566124","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90144.jpg?v=1781622449","variantId":40006289785020},{"handle":"beoplay-beosound-a9-cover-be-happy","name":"Be Happy","colors":["Yellow","Black"],"mood":"Warm / Joyful","style":"Pop Art","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/1_d9d252bf-3ea7-4ede-b822-da0f07e6943d.jpg?v=1609651111","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90142.jpg?v=1781622449","variantId":37758314381500},{"handle":"beoplay-beosound-a9-cover-a-fantasia-of-colour","name":"A Fantasia of Colour","colors":["Multicolour"],"mood":"Fresh / Vibrant","style":"Pop Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/1_036823b4-81ff-41f4-b511-44554d04743b.jpg?v=1609651085","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90141.jpg","variantId":37758309400764},{"handle":"beoplay-beosound-a9-cover-here-comes-santa-claus","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90139.jpg?v=1781613153","name":"Here comes Santa Claus","colors":["Red","White","Brown / Earth"],"mood":"Festive / Celebratory","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/Here-comes-Santa-Clause.jpg?v=1605714911","variantId":37522174181564},{"handle":"beoplay-beosound-a9-cover-testing-123","name":"Testing... 123.","colors":["Multicolour"],"mood":"Nostalgic / Retro","style":"Digital Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/5_d04043d6-c76d-4b32-8d49-d25b9a74a3fc.jpg?v=1606386557","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90131.jpg","variantId":36945599758503},{"handle":"beoplay-beosound-a9-cover-shangri-la","name":"Shangri-La","colors":["Multicolour"],"mood":"Dreamy / Ethereal","style":"Storybook Illustration","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0-2.jpg?v=1626516278","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90135.jpg?v=1781634592","variantId":36945543594151},{"handle":"beoplay-beosound-a9-cover-trip-to-shangri-la","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90136.jpg?v=1781634592","name":"Trip to Shangri-La","colors":["Multicolour"],"mood":"Dreamy / Ethereal","style":"Storybook Illustration","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0-1.jpg?v=1611414095","variantId":36945511547047},{"handle":"beoplay-beosound-a9-cover-lunar-purple","name":"Lunar Purple","colors":["Purple"],"mood":"Dark / Mysterious","style":"Photography","category":"Space & Cosmos","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/737bdba7c66626828ede4877a9a6d9ef.jpg?v=1606386724","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90137.jpg","variantId":36945492213927},{"handle":"beoplay-beosound-a9-cover-moon","name":"Moon","colors":["Grey","Black"],"mood":"Calm / Serene","style":"Photography","category":"Space & Cosmos","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90001.jpg?v=1734075365","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90001.jpg?v=1781773584","variantId":36079156789415},{"handle":"beoplay-beosound-a9-cover-stardust-blue","name":"Stardust Blue","colors":["Blue"],"mood":"Dreamy / Ethereal","style":"Abstract Art","category":"Space & Cosmos","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90123.jpg?v=1734399838","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90123.jpg?v=1781622449","variantId":35511002595495},{"handle":"beoplay-beosound-a9-cover-stardust-black","name":"Stardust Black","colors":["Black"],"mood":"Dark / Mysterious","style":"Abstract Art","category":"Space & Cosmos","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90122.jpg?v=1734399833","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90122.jpg?v=1781622449","variantId":35510978216103},{"handle":"beoplay-beosound-a9-cover-diffusion","name":"Diffusion","colors":["White"],"mood":"Calm / Serene","style":"Minimalist","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/manshe.jpg?v=1631527769","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90129.jpg","variantId":33931380817965},{"handle":"beoplay-beosound-a9-cover-wobble","name":"Wobble","colors":["Black"],"mood":"Calm / Serene","style":"Minimalist","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/yinbo_9226b374-2cdd-4c9f-a8a6-f55a2bccc633.jpg?v=1631527822","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90128.jpg","variantId":33931311939629},{"handle":"beoplay-beosound-a9-cover-crescent-blue","name":"Crescent Blue","colors":["Blue"],"mood":"Calm / Serene","style":"Minimalist","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/85e729a95ec2c968157fbc4a585e1c62_b29523e7-e051-46f4-a55c-d7dc7b0b89e1.jpg?v=1753927394","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90124.jpg","variantId":33705442541613},{"handle":"beoplay-beosound-a9-cover-mermaid","name":"Mermaid","colors":["Multicolour"],"mood":"Playful / Fun","style":"Digital Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/6_e091cd86-19b0-44d0-be1a-99d893d07b82.jpg?v=1626943791","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-mermaid.jpg?v=1781772985","variantId":32973182795821},{"handle":"beoplay-beosound-a9-cover-cheese","name":"Cheese","colors":["Yellow"],"mood":"Playful / Fun","style":"Digital Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90120.jpg?v=1734399830","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90120.jpg","variantId":32960524222509},{"handle":"beoplay-beosound-a9-cover-red-crowned-crane","name":"Red-Crowned Crane","colors":["White","Red"],"mood":"Elegant / Refined","style":"Japanese Ink Art","category":"Nature & Botanical","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90118.jpg?v=1734399828","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90118.jpg?v=1781622449","variantId":32960502497325},{"handle":"beoplay-beosound-a9-cover-wabi-sabi","name":"Wabi-Sabi","colors":["Grey","Brown / Earth"],"mood":"Calm / Serene","style":"Minimalist","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90117.jpg?v=1734399798","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-wabi-sabi.jpg","variantId":32960497418285},{"handle":"beoplay-beosound-a9-cover-midnight-green","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-midnight-green.jpg?v=1781613153","name":"Midnight Green","colors":["Green"],"mood":"Elegant / Refined","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/00_c33fdb77-75d3-4cc8-84bb-cf3d0c9c63c6.jpg?v=1625492187","variantId":32960476610605},{"handle":"beoplay-beosound-a9-cover-emerald-city","name":"Emerald City","colors":["Green"],"mood":"Fresh / Vibrant","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/48ac66ba367aed0c7f66f07e868166c3.jpg?v=1583505538","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-emerald-city.jpg","variantId":32960473923629},{"handle":"beoplay-beosound-a9-cover-twilight","name":"Twilight","colors":["Green"],"mood":"Calm / Serene","style":"Minimalist","category":"Minimalist & Abstract","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90110.jpg?v=1734162582","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-twilight.jpg?v=1781772985","variantId":32960462553133},{"handle":"beoplay-beosound-a9-cover-midsummer-blue","name":"Midsummer Blue","colors":["Blue"],"mood":"Calm / Serene","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90109.jpg?v=1734162584","variantId":32960457375789,"preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90109.jpg?v=1781772985"},{"handle":"beoplay-beosound-a9-cover-coral-pink","name":"Coral Pink","colors":["Pink"],"mood":"Warm / Peaceful","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90108.jpg?v=1734162588","variantId":32960437551149,"preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90108.jpg?v=1781772985"},{"handle":"beoplay-beosound-a9-cover-neon-christmas","name":"Neon Christmas","colors":["Green","Red"],"mood":"Festive / Celebratory","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/3_f207357c-4a87-462a-93c7-124598ac1983.jpg?v=1583556008","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-neon-christmas.jpg?v=1781772985","variantId":32960392527917},{"handle":"beoplay-beosound-a9-cover-green-stache","name":"Green Stache","colors":["Green"],"mood":"Playful / Fun","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/5_4fc4ddae-57cc-4151-8312-d09023377493.jpg?v=1583511880","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-green-stache.jpg?v=1781772985","variantId":32960378732589},{"handle":"beoplay-beosound-a9-cover-paradise-fog","name":"Paradise Fog","colors":["Green"],"mood":"Calm / Serene","style":"Photography","category":"Nature & Botanical","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90097.jpg?v=1734162514","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-paradise-fog.jpg?v=1781772985","variantId":32960340426797},{"handle":"beoplay-beosound-a9-cover-reach","name":"Reach","colors":["Black","White"],"mood":"Bold / Dramatic","style":"Minimalist","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90096.jpg?v=1734162515","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-reach.jpg?v=1781772985","variantId":32960335380525},{"handle":"beoplay-beosound-a9-cover-mandolin","name":"Mandolin","colors":["Brown / Earth","Yellow"],"mood":"Elegant / Refined","style":"Cubist / Collage","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90094.jpg?v=1734162521","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90094.jpg?v=1781622449","variantId":32960323059757},{"handle":"beoplay-beosound-a9-cover-violin","name":"Violin","colors":["Multicolour"],"mood":"Elegant / Refined","style":"Cubist / Collage","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90093.jpg?v=1734162523","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-violin.jpg?v=1781769617","variantId":32960318668845},{"handle":"beoplay-beosound-a9-cover-guernica","name":"Guernica","colors":["Black","White"],"mood":"Bold / Dramatic","style":"Cubist / Collage","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90092.jpg?v=1734162309","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-guernica.jpg?v=1781769617","variantId":32960310313005},{"handle":"beoplay-beosound-a9-cover-the-studio","name":"The Studio","colors":["Multicolour"],"mood":"Bold / Dramatic","style":"Cubist / Collage","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90091.jpg?v=1734162305","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-the-studio.jpg?v=1781769617","variantId":32960305594413},{"handle":"beoplay-beosound-a9-cover-white","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-white.jpg?v=1781613153","name":"White","colors":["White"],"mood":"Calm / Serene","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90090.jpg?v=1734149805","variantId":32960302579757},{"handle":"beoplay-beosound-a9-cover-grey","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-grey.jpg?v=1781613153","name":"Grey","colors":["Grey"],"mood":"Calm / Serene","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90089.jpg?v=1734149774","variantId":32960300515373},{"handle":"beoplay-beosound-a9-cover-black","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-black.jpg?v=1781613153","name":"Black","colors":["Black"],"mood":"Dark / Mysterious","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90088.jpg?v=1734149733","variantId":32960298483757},{"handle":"beoplay-beosound-a9-cover-blue","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-blue.jpg?v=1781613153","name":"Blue","colors":["Blue"],"mood":"Calm / Serene","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90087.jpg?v=1734149702","variantId":32960295010349},{"handle":"beoplay-beosound-a9-cover-yellow","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-yellow.jpg?v=1781613153","name":"Yellow","colors":["Yellow"],"mood":"Warm / Joyful","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90086.jpg?v=1734149678","variantId":32960284983341},{"handle":"beoplay-beosound-a9-cover-northern-lights","name":"Northern Lights","colors":["Green","Blue"],"mood":"Dreamy / Ethereal","style":"Photography","category":"Space & Cosmos","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90084.jpg?v=1734149633","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-northern-lights.jpg?v=1781772985","variantId":32960268337197},{"handle":"beoplay-beosound-a9-cover-slate-black","name":"Slate Black","colors":["Black"],"mood":"Dark / Mysterious","style":"Minimalist","category":"Solid Color","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90080.jpg?v=1734149510","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-slate-black.jpg?v=1781772985","variantId":32960254476333},{"handle":"beoplay-beosound-a9-cover-throwback-red","name":"Throwback Red","colors":["Red"],"mood":"Bold / Dramatic","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90078.jpg?v=1734149475","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-throwback-red.jpg?v=1781772985","variantId":32960242188333},{"handle":"beoplay-beosound-a9-cover-rouge-kiss","name":"Rouge Kiss","colors":["Red"],"mood":"Bold / Dramatic","style":"Pop Art","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90077.jpg?v=1734149457","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-rouge-kiss.jpg?v=1781772985","variantId":32960225280045},{"handle":"beoplay-beosound-a9-cover-moss","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90076.jpg?v=1781613153","name":"Moss","colors":["Green"],"mood":"Fresh / Vibrant","style":"Photography","category":"Nature & Botanical","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90076.jpg?v=1734149445","variantId":32960219775021},{"handle":"beoplay-beosound-a9-cover-wood","name":"Wood","colors":["Grey"],"mood":"Calm / Serene","style":"Photography","category":"Nature & Botanical","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90075.jpg?v=1734149408","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90075.jpg?v=1781616235","variantId":32960215679021},{"handle":"beoplay-beosound-a9-cover-colour","name":"Colour","colors":["Green","Brown / Earth"],"mood":"Fresh / Vibrant","style":"Abstract Art","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/3_c7bde43d-77f8-45f2-8422-c8a8f1c0d87a.jpg?v=1583553756","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90069.jpg?v=1781613153","variantId":32960193069101},{"handle":"beoplay-beosound-a9-cover-palm","name":"Palm","colors":["Green"],"mood":"Fresh / Vibrant","style":"Botanical Illustration","category":"Nature & Botanical","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90066.jpg?v=1734149353","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-palm.jpg?v=1781769617","variantId":32960185729069},{"handle":"beoplay-beosound-a9-cover-rainforest","name":"Rainforest","colors":["Green"],"mood":"Fresh / Vibrant","style":"Botanical Illustration","category":"Nature & Botanical","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90062.jpg?v=1734141179","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-rainforest.jpg?v=1781772985","variantId":32960160792621},{"handle":"beoplay-beosound-a9-cover-delta","name":"Delta","colors":["White","Brown / Earth"],"mood":"Dreamy / Ethereal","style":"Abstract Art","category":"Nature & Botanical","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90061.jpg?v=1734141149","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-delta.jpg?v=1781772985","variantId":32960148668461},{"handle":"beoplay-beosound-a9-cover-hills","name":"Hills","colors":["Green"],"mood":"Calm / Serene","style":"Abstract Art","category":"Nature & Botanical","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90060.jpg?v=1734141127","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-hills.jpg?v=1781772985","variantId":32960139460653},{"handle":"beoplay-beosound-a9-cover-lucid-dreams","name":"Lucid Dreams","colors":["Blue","White"],"mood":"Dreamy / Ethereal","style":"Abstract Art","category":"Minimalist & Abstract","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/Lucid-Dreams.jpg?v=1583554188","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90059.jpg?v=1781622449","variantId":32960085557293},{"handle":"beoplay-beosound-a9-cover-midnight","name":"Midnight","colors":["Blue","White"],"mood":"Dark / Mysterious","style":"Abstract Art","category":"Space & Cosmos","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90058.jpg?v=1734141086","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90058.jpg","variantId":32960082542637},{"handle":"beoplay-beosound-a9-cover-bricks","name":"Bricks","colors":["Red","Brown / Earth"],"mood":"Edgy / Urban","style":"Photography","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90054.jpg?v=1734140923","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-bricks.jpg?v=1781772985","variantId":32960049610797},{"handle":"beoplay-beosound-a9-cover-orange","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-orange.jpg?v=1781613153","name":"Orange","colors":["Orange"],"mood":"Fresh / Vibrant","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/1_0e2e8681-03b6-44b9-81ce-da48d3acaa89.jpg?v=1583555448","variantId":32960045350957},{"handle":"beoplay-beosound-a9-cover-snake","name":"Snake","colors":["Black"],"mood":"Calm / Serene","style":"Digital Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90052.jpg?v=1734140904","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90052.jpg?v=1781622449","variantId":32960038764589},{"handle":"beoplay-beosound-a9-cover-flame","name":"Flame","colors":["Red","Orange"],"mood":"Bold / Dramatic","style":"Abstract Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90051.jpg?v=1734140901","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-flame.jpg?v=1781772985","variantId":32960035913773},{"handle":"beoplay-beosound-a9-cover-timespace","name":"Timespace","colors":["Black","Brown / Earth"],"mood":"Dreamy / Ethereal","style":"Abstract Art","category":"Minimalist & Abstract","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90050.jpg?v=1734140898","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-timespace.jpg?v=1781772985","variantId":32960032079917},{"handle":"beoplay-beosound-a9-cover-siberian-cat","name":"Siberian Cat","colors":["Brown / Earth","White"],"mood":"Warm / Peaceful","style":"Anime / Manga","category":"Artist Collaboration","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/2.jpg?v=1583503996","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-cat.jpg?v=1781769617","variantId":32959984140333},{"handle":"beoplay-beosound-a9-cover-crimson","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-crimson.jpg?v=1781613153","name":"Crimson","colors":["Red"],"mood":"Bold / Dramatic","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/0_590a5dd6-b26a-43cb-baeb-e3d807a6e515.jpg?v=1627462870","variantId":32959981846573},{"handle":"beoplay-beosound-a9-cover-the-scream-daylight-edition","name":"The Scream / Daylight Edition","colors":["Multicolour"],"mood":"Bold / Dramatic","style":"Pop Art","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90045.jpg?v=1734075296","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90045.jpg?v=1781614855","variantId":32959977193517},{"handle":"beoplay-beosound-a9-cover-the-scream-night-edition","name":"The Scream / Night Edition","colors":["Multicolour"],"mood":"Dark / Mysterious","style":"Pop Art","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90044.jpg?v=1734075256","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90044.jpg","variantId":32959971295277},{"handle":"beoplay-beosound-a9-cover-time-immemorial-grey","name":"Time Immemorial - Grey","colors":["Black","Brown / Earth"],"mood":"Elegant / Refined","style":"Photography","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/11.jpg?v=1583512695","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90042.jpg?v=1781772985","variantId":32959957401645},{"handle":"beoplay-beosound-a9-cover-graffiti-pink","name":"Graffiti - Pink","colors":["Multicolour"],"mood":"Edgy / Urban","style":"Street Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90041.jpg?v=1734075146","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90041.jpg?v=1781622449","variantId":32959955566637},{"handle":"beoplay-beosound-a9-cover-time-immemorial-red","name":"Time Immemorial - Red","colors":["Red","Brown / Earth"],"mood":"Bold / Dramatic","style":"Photography","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/10_4b9c2e3f-2bea-4eaa-939c-92727fe4b4fa.jpg?v=1583556155","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90040.jpg?v=1781772985","variantId":32959952617517},{"handle":"beoplay-beosound-a9-cover-cow","name":"Cow","colors":["Brown / Earth","White"],"mood":"Playful / Fun","style":"Photography","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90038.jpg?v=1734075098","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-cow.jpg?v=1781769617","variantId":32959939608621},{"handle":"beoplay-beosound-a9-cover-brown","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-brown.jpg?v=1781613153","name":"Brown","colors":["Brown / Earth"],"mood":"Warm / Peaceful","style":"Minimalist","category":"Solid Color","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/Brown-0.jpg?v=1627006470","variantId":32959896846381},{"handle":"beoplay-beosound-a9-cover-graffiti","name":"Graffiti","colors":["Multicolour"],"mood":"Edgy / Urban","style":"Street Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90025.jpg?v=1734075039","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90025.jpg?v=1781622449","variantId":32959865782317},{"handle":"beoplay-beosound-a9-cover-christmas-tree","name":"Christmas Tree","colors":["Black","Brown / Earth"],"mood":"Festive / Celebratory","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90024.jpg?v=1734075028","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90024.jpg?v=1781772985","variantId":32959861555245},{"handle":"beoplay-beosound-a9-cover-flakes","name":"Flakes","colors":["Red","Brown / Earth"],"mood":"Festive / Celebratory","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/00_31e570be-9d7b-492c-9405-00b6053fa098.jpg?v=1699969520","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90023.jpg?v=1781622449","variantId":32959855001645},{"handle":"beoplay-beosound-a9-cover-vinyl","name":"Vinyl","colors":["Black"],"mood":"Nostalgic / Retro","style":"Digital Art","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90022.jpg?v=1734075004","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-vinyl.jpg?v=1781769617","variantId":32959848611885},{"handle":"beoplay-beosound-a9-cover-best-wishes","name":"Best Wishes","colors":["Red","White"],"mood":"Festive / Celebratory","style":"Digital Art","category":"Festive & Seasonal","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90021.jpg?v=1734074958","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-best-wishes.jpg?v=1781772985","variantId":32959839305773},{"handle":"beoplay-beosound-a9-cover-dawn","name":"Dawn","colors":["Blue","Pink"],"mood":"Warm / Peaceful","style":"Minimalist","category":"Minimalist & Abstract","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90020.jpg?v=1734074182","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-dawn.jpg?v=1781772985","variantId":32959833669677},{"handle":"beoplay-beosound-a9-cover-radiation","name":"Radiation","colors":["Grey","White"],"mood":"Bold / Dramatic","style":"Digital Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/2_d34ca74d-2bef-4d63-bef1-f9b59e27cd0e.jpg?v=1583554393","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-radiation.jpg?v=1781772985","variantId":32959830065197},{"handle":"beoplay-beosound-a9-cover-fascination","name":"Fascination","colors":["Black"],"mood":"Dark / Mysterious","style":"Abstract Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90018.jpg?v=1734074129","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90018.jpg?v=1781622449","variantId":32959824986157},{"handle":"beoplay-beosound-a9-cover-gold-mine","name":"Gold Mine","colors":["Brown / Earth","Yellow"],"mood":"Elegant / Refined","style":"Digital Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90017.jpg?v=1734074107","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90017.jpg?v=1781622449","variantId":32959815254061},{"handle":"beoplay-beosound-a9-cover-geometry","name":"Geometry","colors":["Black"],"mood":"Bold / Dramatic","style":"Geometric","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90016.jpg?v=1734074066","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-geometry.jpg?v=1781772985","variantId":32959812010029},{"handle":"beoplay-beosound-a9-cover-siberian","name":"Siberian","colors":["Grey","White"],"mood":"Warm / Peaceful","style":"Photography","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/products/4_addd0ee9-9823-426a-bc3d-d0230be7d019.jpg?v=1583553613","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-siberian.jpg?v=1781772985","variantId":32959800967213},{"handle":"beoplay-beosound-a9-cover-golden-marble","name":"Golden Marble","colors":["Black","Brown / Earth"],"mood":"Elegant / Refined","style":"Photography","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90012.jpg?v=1734073992","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-golden-marble.jpg?v=1781772985","variantId":32959788679213},{"handle":"beoplay-beosound-a9-cover-space","name":"Space","colors":["Blue","Pink"],"mood":"Dark / Mysterious","style":"Photography","category":"Space & Cosmos","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90011.jpg?v=1734073947","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-space.jpg?v=1781772985","variantId":32959774851117},{"handle":"beoplay-beosound-a9-cover-cube-red","name":"Cube Red","colors":["Red"],"mood":"Bold / Dramatic","style":"Geometric","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90010.jpg?v=1734074942","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90010.jpg?v=1781622449","variantId":32959772098605},{"handle":"beoplay-beosound-a9-cover-cube-black","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90009.jpg?v=1781613153","name":"Cube Black","colors":["Black"],"mood":"Dark / Mysterious","style":"Geometric","category":"Artist Collaboration","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90009.jpg?v=1734074940","variantId":32959766069293},{"handle":"beoplay-beosound-a9-cover-goddess","name":"Goddess","colors":["Multicolour"],"mood":"Dreamy / Ethereal","style":"Watercolour","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90007.jpg?v=1734073868","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-goddess.jpg?v=1781772985","variantId":32959740903469},{"handle":"beoplay-beosound-a9-cover-chaos","name":"Chaos","colors":["Blue","Pink"],"mood":"Bold / Dramatic","style":"Digital Art","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90006.jpg?v=1734073839","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90006.jpg?v=1781622449","variantId":32959738282029},{"handle":"beoplay-beosound-a9-cover-galaxy","name":"Galaxy","colors":["Blue","Purple"],"mood":"Dark / Mysterious","style":"Photography","category":"Space & Cosmos","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90004.jpg?v=1734073809","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-galaxy.jpg?v=1781772985","variantId":32959727337517},{"handle":"beoplay-beosound-a9-cover-stellar","name":"Stellar","colors":["Purple","Blue"],"mood":"Dreamy / Ethereal","style":"Photography","category":"Space & Cosmos","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90003.jpg?v=1734073777","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-stellar.jpg?v=1781769617","variantId":32959699779629},{"handle":"beoplay-beosound-a9-cover-earth","name":"Earth","colors":["Blue","Green"],"mood":"Calm / Serene","style":"Photography","category":"Space & Cosmos","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90002.jpg?v=1734073742","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-earth.jpg?v=1781772985","variantId":32959687131181},{"handle":"beoplay-beosound-a9-cover-coal-barges","name":"Coal Barges","colors":["Yellow","Black"],"mood":"Nostalgic / Retro","style":"Oil Painting","category":"Graphic & Pattern","price":55.3,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90071.jpg?v=1734140818","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90071.jpg?v=1781622449","variantId":32953222725677},{"handle":"beoplay-beosound-a9-cover-almond-blossom","name":"Almond Blossom","colors":["Blue","White"],"mood":"Calm / Serene","style":"Oil Painting","category":"Nature & Botanical","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90072.jpg?v=1734140791","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-almond-blossom.jpg?v=1781769617","variantId":32951378903085},{"handle":"beoplay-beosound-a9-cover-acacia-blossom","name":"Acacia Blossom","colors":["Green","Blue"],"mood":"Fresh / Vibrant","style":"Oil Painting","category":"Nature & Botanical","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/A90070.jpg?v=1734140770","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-acacia-blossom.jpg?v=1781769617","variantId":32938946854957},{"handle":"beoplay-beosound-a9-cover-soleil","name":"Soleil","colors":["Yellow","Orange"],"mood":"Warm / Joyful","style":"Abstract Art","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beoplay-beosound-a9-cover-soleil.jpg?v=1778914788","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90241.jpg?v=1781613153","variantId":46216926757052},{"handle":"beoplay-beosound-a9-cover-prism","name":"Prism","colors":["Multicolour","Blue"],"mood":"Fresh / Vibrant","style":"Abstract Art","category":"Graphic & Pattern","price":79,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beoplay-beosound-a9-cover-prism.jpg?v=1780290256","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90242.jpg?v=1781613153","variantId":46216942354620},{"handle":"beoplay-beosound-a9-cover-laureate","name":"Laureate","colors":["White","Grey"],"mood":"Elegant / Refined","style":"Oil Painting","category":"Art","price":89,"img":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/beoplay-beosound-a9-cover-nike.jpg?v=1781177315","preview":"https://cdn.shopify.com/s/files/1/0351/1359/9021/files/a9-preview-a90246.jpg?v=1781614855","variantId":46942242111676}];


/* ── end cover-catalog.js (bundled) ── */


/* Splash — [UX 2026-06-10 #6, per Yang] FIRST visit only: hold 2.5s then fade.
   Returning visitors: remove instantly (no splash at all). Flag persists in
   localStorage; private-mode / quota errors fall back to first-visit behavior. */
(function(){
  var seen = false;
  try { seen = !!localStorage.getItem('tg_seen_splash'); } catch (e) {}
  try { localStorage.setItem('tg_seen_splash', '1'); } catch (e) {}
  var sp = document.getElementById('variationSplash');
  if (!sp) return;
  if (seen) { sp.remove(); return; }
  setTimeout(function() {
    sp.style.opacity = '0';
    setTimeout(function(){ sp.remove(); }, 900);
  }, 2500);
})();
/* FOUC safety net — if JS init hasn't revealed the app within 2s, force it */
setTimeout(function(){var a=document.querySelector('.studio-app');if(a)a.classList.add('is-ready')},2000);


// ── next extracted block ──


'use strict';

/* =====================================================================
   FINAL §6 — postMessage bridge (parent → iframe)
   ===================================================================== */
const a9Frame = document.getElementById('a9Viewer');

const _matSpinnerTypes = new Set([
  'a9:setPreset','a9:applyPreset','a9:setBody','a9:setRim','a9:setCover',
  'a9:setWood','a9:setCustomCoverPantone','a9:setCustomCoverUpload',
  'a9:setLegsCustom','a9:setStand','a9:resetCover']);
let _matSpinTimer = 0;
const a9Bridge = {
  ready: false,
  queue: [],
  send(msg) {
    if (!this.ready) { this.queue.push(msg); return; }
    a9Frame.contentWindow.postMessage(msg, '*');
    // Show material spinner for texture-related messages
    if (msg && _matSpinnerTypes.has(msg.type)) {
      const sp = document.getElementById('tgMatSpinner');
      if (sp) {
        clearTimeout(_matSpinTimer);
        sp.classList.add('is-active');
        _matSpinTimer = setTimeout(() => sp.classList.remove('is-active'), 650);
      }
    }
  },
  setPreset(name)         { this.send({ type: 'a9:setPreset', preset: name }); },
  /* Phase 4 — atomic preset apply with explicit body tint + cover/rim/wood JSON keys.
     payload: { bodyTint: {color, metalness, roughness}, cover, rim, wood } */
  applyPreset(payload)    { this.send({ type: 'a9:applyPreset', ...payload }); },
  setBody(name)           { this.send({ type: 'a9:setBody', name }); },
  setRim(name)            { this.send({ type: 'a9:setRim', name }); },
  setCover(name)          { this.send({ type: 'a9:setCover', name }); },
  setWood(name)           { this.send({ type: 'a9:setWood', name }); },
  setCustomPantone(hex)   { this.send({ type: 'a9:setCustomCoverPantone', hex }); },
  setCustomUpload(dataUrl, applyTrim){ this.send({ type: 'a9:setCustomCoverUpload', dataUrl, applyTrim: applyTrim === true }); },  // applyTrim: 仅客户上传(全出血74设计)传 true→viewer 收到70cm可见;现有设计预览(catalog/collection/批量导出)不传→对齐详情页首图
  /* Phase 4.21 — apply a single Pantone hex to all three leg shafts. payload:
     { hex, tpg?, name?, mode? }. Iframe only needs hex; tpg/name/mode are tracked
     parent-side for the footer summary + selected preview. */
  setLegsCustom(payload)  { this.send({ type: 'a9:setLegsCustom', ...payload }); },
  resetCover()            { this.send({ type: 'a9:resetCover' }); },
  setRotation(enabled)    { this.send({ type: 'a9:setRotation', enabled: !!enabled }); },
  setZoom(enabled)        { this.send({ type: 'a9:setZoom', enabled: !!enabled }); },
  setDayNight(mode)       { this.send({ type: 'a9:setDayNight', mode }); },
  /* Render-mode: 'select' (configurator → neutral light, true colour) |
     'reveal' (result page → warm HDRI). See codex-render-warmth-spec.md §5. */
  setRenderMode(mode)     { this.send({ type: 'a9:setRenderMode', mode }); },
  /* v9 §A3 — drive the iframe's named camera views ('speaker' | 'cover' | 'legs')
     with a 0.9s smooth fly-to. Called from step-bar + parts-nav + boot. */
  setView(name, zoomed)   { this.send({ type: 'a9:setView', view: name, zoomed: !!zoomed }); },

  /* Phase 4.38 — request a PNG dataURL of the current 3D scene. The iframe
     forces renderer.render() before toDataURL so the WebGL drawing buffer
     is fresh (Three.js defaults preserveDrawingBuffer=false, otherwise
     toDataURL returns blank). 2 s timeout; rejects if iframe is missing
     or unresponsive. Bypasses the usual queue because the queue only
     drains after a9:ready, and captureSnapshot is only called from the
     keepsake render which can only happen long after ready. */
  captureSnapshot() {
    return new Promise((resolve, reject) => {
      const iframe = document.getElementById('a9Viewer');
      if (!iframe || !iframe.contentWindow) {
        return reject(new Error('a9 viewer iframe not ready'));
      }
      const id = 'cap_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
      const handler = (ev) => {
        if (ev.source !== iframe.contentWindow) return;
        const d = ev.data;
        if (!d || d.type !== 'a9:captureResponse' || d.id !== id) return;
        window.removeEventListener('message', handler);
        clearTimeout(timeoutId);
        if (d.error) { reject(new Error(d.error)); return; }
        // Validate before resolving — a degenerate snapshot ("", "data:,",
        // undefined) must NOT propagate to the OSS/atob path. Reject so the
        // caller's catch falls back to composedDataUrl with a clear log.
        var snap = d.dataUrl;
        if (typeof snap !== 'string' || !/^data:image\/[a-z0-9.+-]+;base64,[A-Za-z0-9+/]/i.test(snap)) {
          reject(new Error('captureSnapshot returned an invalid data URL (len=' + (snap ? String(snap).length : 0) + ')'));
          return;
        }
        resolve(snap);
      };
      window.addEventListener('message', handler);
      const timeoutId = setTimeout(() => {
        window.removeEventListener('message', handler);
        reject(new Error('captureSnapshot timeout (2 s)'));
      }, 2000);
      iframe.contentWindow.postMessage({ type: 'a9:captureRequest', id }, '*');
    });
  },

  /* Phase 5.2 — request a USDZ binary of the current composition. Same
     round-trip shape as captureSnapshot: viewer receives
     a9:exportUSDZRequest, replies with
     { type: 'a9:exportUSDZResponse', id, arrayBuffer, size } or
     { type: 'a9:exportUSDZResponse', id, error }. Timeout 5 s — USDZ
     export is heavier than PNG capture (model traversal + KTX2 + zip).
     Resolves with { arrayBuffer, size } so the caller can size-check
     and build a Blob without re-fetching anything. */
  exportUSDZ() {
    return new Promise((resolve, reject) => {
      const iframe = document.getElementById('a9Viewer');
      if (!iframe || !iframe.contentWindow) {
        return reject(new Error('a9 viewer iframe not ready'));
      }
      const id = 'usdz_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
      const handler = (ev) => {
        if (ev.source !== iframe.contentWindow) return;
        const d = ev.data;
        if (!d || d.type !== 'a9:exportUSDZResponse' || d.id !== id) return;
        window.removeEventListener('message', handler);
        clearTimeout(timeoutId);
        if (d.error) reject(new Error(d.error));
        else resolve({ arrayBuffer: d.arrayBuffer, size: d.size });
      };
      window.addEventListener('message', handler);
      const timeoutId = setTimeout(() => {
        window.removeEventListener('message', handler);
        reject(new Error('exportUSDZ timeout (5 s)'));
      }, 5000);
      iframe.contentWindow.postMessage({ type: 'a9:exportUSDZRequest', id }, '*');
    });
  },

  exportGLB() {
    return new Promise((resolve, reject) => {
      const iframe = document.getElementById('a9Viewer');
      if (!iframe || !iframe.contentWindow) {
        return reject(new Error('a9 viewer iframe not ready'));
      }
      const id = 'glb_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
      const handler = (ev) => {
        if (ev.source !== iframe.contentWindow) return;
        const d = ev.data;
        if (!d || d.type !== 'a9:exportGLBResponse' || d.id !== id) return;
        window.removeEventListener('message', handler);
        clearTimeout(timeoutId);
        if (d.error) reject(new Error(d.error));
        else resolve({ arrayBuffer: d.arrayBuffer, size: d.size });
      };
      window.addEventListener('message', handler);
      const timeoutId = setTimeout(() => {
        window.removeEventListener('message', handler);
        reject(new Error('exportGLB timeout (15 s)'));
      }, 15000);
      iframe.contentWindow.postMessage({ type: 'a9:exportGLBRequest', id }, '*');
    });
  }
};

/* =====================================================================
   Batch GLB export — dev-only tool, gated by ?batchexport=1.
   Uses COVER_CATALOG.preview and the checked 108-handle allowlist only.
   ===================================================================== */
(function initA9BatchGlbExport() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('batchexport') !== '1') return;

  const FALLBACK_ALLOWLIST = ["beoplay-beosound-a9-cover-verve","beoplay-beosound-a9-cover-eclat","beoplay-beosound-a9-cover-ivory-pine","beoplay-beosound-a9-cover-lucky-trot","beoplay-beosound-a9-cover-silent-pine","beoplay-beosound-a9-cover-festive-rebel","beoplay-beosound-a9-cover-carnival-mosaic","beoplay-beosound-a9-cover-the-wave","beoplay-beosound-a9-cover-radiant-horizon","beoplay-beosound-a9-cover-blue-reverie","beoplay-beosound-a9-cover-solid-white","beoplay-beosound-a9-cover-solid-black","beoplay-beosound-a9-cover-lunar-snake","beoplay-beosound-a9-golden-blossom","beoplay-beosound-a9-cover-pine-joy","beoplay-beosound-a9-cover-david-noel","beoplay-beosound-a9-cover-venus-noel","beoplay-beosound-a9-cover-frosty-joy","beoplay-beosound-a9-cover-hohoho","beoplay-beosound-a9-cover-nordic-ice","beoplay-beosound-a9-cover-pastel-chill","beoplay-beosound-a9-cover-luminous-dusk","beoplay-beosound-a9-cover-goldtone","beoplay-beosound-a9-cover-purple-haze","beoplay-beosound-a9-cover-english-garden","beoplay-beosound-a9-cover-lemon-lush","beoplay-beosound-a9-cover-tranquil-blaze","beoplay-beosound-a9-cover-serene-ember","beoplay-beosound-a9-cover-velocity-checkered","beoplay-beosound-a9-cover-seasons-enchantment","beoplay-beosound-a9-cover-sapphire-drama","beoplay-beosound-a9-cover-caracalla","beoplay-beosound-a9-cover-barbie-pink","beoplay-beosound-a9-cover-summer-bliss","beoplay-beosound-a9-cover-polka-dots","beoplay-beosound-a9-cover-emerald-ears","beoplay-beosound-a9-cover-garden-bunny","beoplay-beosound-a9-cover-christmas-wonderland","beoplay-beosound-a9-cover-rudolph","beoplay-beosound-a9-cover-astronaut-x-yuya-hashizume","beoplay-beosound-a9-cover-neon-spacesuit-x-yuya-hashizume","beoplay-beosound-a9-cover-cat-x-yuya-hashizume","beoplay-beosound-a9-cover-at-dawn-x-subin-lim","beoplay-beosound-a9-cover-meeting-place-x-subin-lim","beoplay-beosound-a9-cover-companion-x-subin-lim","beoplay-beosound-a9-cover-tiger-print","beoplay-beosound-a9-cover-in-the-wild","beoplay-beosound-a9-cover-fierce","beoplay-beosound-a9-cover-tiger-dream","beoplay-beosound-a9-cover-frida-x-aira","beoplay-beosound-a9-cover-the-tree-of-love","beoplay-beosound-a9-cover-towards-paradise","beoplay-beosound-a9-cover-rest","beoplay-beosound-a9-cover-tracing-back","beoplay-beosound-a9-cover-daydreaming","beoplay-beosound-a9-cover-free-clouds","beoplay-beosound-a9-cover-catching-stars","beoplay-beosound-a9-cover-be-happy","beoplay-beosound-a9-cover-a-fantasia-of-colour","beoplay-beosound-a9-cover-here-comes-santa-claus","beoplay-beosound-a9-cover-testing-123","beoplay-beosound-a9-cover-shangri-la","beoplay-beosound-a9-cover-trip-to-shangri-la","beoplay-beosound-a9-cover-lunar-purple","beoplay-beosound-a9-cover-moon","beoplay-beosound-a9-cover-stardust-blue","beoplay-beosound-a9-cover-stardust-black","beoplay-beosound-a9-cover-diffusion","beoplay-beosound-a9-cover-wobble","beoplay-beosound-a9-cover-crescent-blue","beoplay-beosound-a9-cover-cheese","beoplay-beosound-a9-cover-red-crowned-crane","beoplay-beosound-a9-cover-wabi-sabi","beoplay-beosound-a9-cover-midnight-green","beoplay-beosound-a9-cover-emerald-city","beoplay-beosound-a9-cover-twilight","beoplay-beosound-a9-cover-mandolin","beoplay-beosound-a9-cover-white","beoplay-beosound-a9-cover-grey","beoplay-beosound-a9-cover-black","beoplay-beosound-a9-cover-blue","beoplay-beosound-a9-cover-yellow","beoplay-beosound-a9-cover-moss","beoplay-beosound-a9-cover-wood","beoplay-beosound-a9-cover-colour","beoplay-beosound-a9-cover-lucid-dreams","beoplay-beosound-a9-cover-midnight","beoplay-beosound-a9-cover-orange","beoplay-beosound-a9-cover-snake","beoplay-beosound-a9-cover-crimson","beoplay-beosound-a9-cover-the-scream-daylight-edition","beoplay-beosound-a9-cover-the-scream-night-edition","beoplay-beosound-a9-cover-time-immemorial-grey","beoplay-beosound-a9-cover-graffiti-pink","beoplay-beosound-a9-cover-time-immemorial-red","beoplay-beosound-a9-cover-brown","beoplay-beosound-a9-cover-graffiti","beoplay-beosound-a9-cover-christmas-tree","beoplay-beosound-a9-cover-flakes","beoplay-beosound-a9-cover-fascination","beoplay-beosound-a9-cover-gold-mine","beoplay-beosound-a9-cover-cube-red","beoplay-beosound-a9-cover-cube-black","beoplay-beosound-a9-cover-chaos","beoplay-beosound-a9-cover-coal-barges","beoplay-beosound-a9-cover-soleil","beoplay-beosound-a9-cover-prism","beoplay-beosound-a9-cover-laureate"];

  let started = false;
  let pickedDirectory = null;

  const panel = document.createElement('div');
  panel.style.cssText = 'position:fixed;left:16px;bottom:16px;z-index:99999;width:min(420px,calc(100vw - 32px));padding:14px 16px;border:1px solid rgba(0,0,0,.12);border-radius:10px;background:rgba(255,255,255,.96);box-shadow:0 18px 48px rgba(0,0,0,.18);font:13px/1.45 system-ui,-apple-system,BlinkMacSystemFont,sans-serif;color:#191817';
  panel.innerHTML = '<strong>A9 GLB batch export</strong><div data-batch-status style="margin-top:6px">Waiting for viewer...</div><button data-batch-start type="button" style="display:none;margin-top:10px;padding:8px 12px;border:1px solid #191817;background:#191817;color:#fff;border-radius:6px;cursor:pointer">Choose export folder</button><pre data-batch-log style="margin:10px 0 0;max-height:180px;overflow:auto;white-space:pre-wrap;font:11px/1.35 ui-monospace,SFMono-Regular,Menlo,monospace;color:#444"></pre>';
  document.body.appendChild(panel);

  const statusEl = panel.querySelector('[data-batch-status]');
  const logEl = panel.querySelector('[data-batch-log]');
  const startBtn = panel.querySelector('[data-batch-start]');

  function setStatus(text) {
    statusEl.textContent = text;
    console.log('[A9 GLB batch]', text);
  }

  function addLog(text) {
    logEl.textContent += text + '\n';
    logEl.scrollTop = logEl.scrollHeight;
    console.log('[A9 GLB batch]', text);
  }

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function nextFrame() {
    return new Promise((resolve) => requestAnimationFrame(() => resolve()));
  }

  function waitForViewerReady() {
    if (a9Bridge.ready) return Promise.resolve();
    return new Promise((resolve) => {
      const poll = setInterval(() => {
        if (!a9Bridge.ready) return;
        clearInterval(poll);
        window.removeEventListener('message', handler);
        resolve();
      }, 100);
      const handler = (event) => {
        if (event.source !== a9Frame.contentWindow) return;
        if (!event.data || event.data.type !== 'a9:ready') return;
        clearInterval(poll);
        window.removeEventListener('message', handler);
        resolve();
      };
      window.addEventListener('message', handler);
    });
  }

  async function loadAllowlist() {
    try {
      const res = await fetch('./a9-glb-allowlist.json?v=1', { cache: 'no-store' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const handles = await res.json();
      if (!Array.isArray(handles) || !handles.length) throw new Error('allowlist is empty');
      return handles;
    } catch (err) {
      addLog('Using embedded allowlist fallback: ' + (err && err.message ? err.message : String(err)));
      return FALLBACK_ALLOWLIST.slice();
    }
  }

  function preloadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve();
      img.onerror = () => reject(new Error('preview image failed to load'));
      img.src = url;
    });
  }

  async function waitForViewerTextureReady(cover) {
    await preloadImage(cover.preview);
    a9Bridge.setCustomUpload(cover.preview);
    await nextFrame();
    await nextFrame();
    await wait(900);
  }

  async function getDirectoryHandle() {
    if (pickedDirectory) return pickedDirectory;
    if (!window.showDirectoryPicker) {
      throw new Error('File System Access API is unavailable in this browser');
    }
    pickedDirectory = await window.showDirectoryPicker({ mode: 'readwrite' });
    return pickedDirectory;
  }

  async function saveFile(dir, name, arrayBuffer) {
    const file = await dir.getFileHandle(name, { create: true });
    const writable = await file.createWritable();
    await writable.write(new Blob([arrayBuffer], { type: 'model/gltf-binary' }));
    await writable.close();
  }

  async function runBatch() {
    if (started) return;
    started = true;
    startBtn.style.display = 'none';

    try {
      await waitForViewerReady();
      setStatus('Choose a folder for the 108 GLB files...');
      const dir = await getDirectoryHandle();
      const allowlist = await loadAllowlist();
      const allow = new Set(allowlist);
      const catalog = Array.isArray(window.COVER_CATALOG) ? window.COVER_CATALOG : (typeof COVER_CATALOG !== 'undefined' ? COVER_CATALOG : []);
      const covers = catalog.filter((cover) => cover && allow.has(cover.handle) && cover.preview);
      const missing = allowlist.filter((handle) => !covers.some((cover) => cover.handle === handle));
      const failures = [];

      if (!covers.length) throw new Error('No allowlisted covers found in COVER_CATALOG');
      addLog('Allowlist: ' + allowlist.length + ', exportable: ' + covers.length);
      if (missing.length) addLog('Missing/skipped from catalog: ' + missing.join(', '));

      for (let i = 0; i < covers.length; i++) {
        const cover = covers[i];
        const label = (i + 1) + '/' + covers.length + ' ' + cover.handle;
        try {
          setStatus(label);
          await waitForViewerTextureReady(cover);
          const { arrayBuffer, size } = await a9Bridge.exportGLB();
          await saveFile(dir, cover.handle + '.glb', arrayBuffer);
          addLog(label + ' saved (' + (size / 1024 / 1024).toFixed(1) + ' MB)');
        } catch (err) {
          const message = cover.handle + ': ' + (err && err.message ? err.message : String(err));
          failures.push(message);
          addLog('FAILED ' + message);
        }
      }

      if (failures.length) {
        setStatus('Done with ' + failures.length + ' failure(s). See log.');
        console.warn('[A9 GLB batch] failures', failures);
      } else {
        setStatus('Done: ' + covers.length + '/' + covers.length + ' GLB files saved.');
      }
    } catch (err) {
      started = false;
      startBtn.style.display = '';
      setStatus('Paused: ' + (err && err.message ? err.message : String(err)));
    }
  }

  startBtn.addEventListener('click', runBatch);
  waitForViewerReady().then(() => runBatch());
})();

/* =====================================================================
   tgOssUpload — Aliyun OSS direct-upload helper
   Browser → /api/sign-oss-upload (Vercel) → PostObject to OSS.
   Large files (PSD up to 400 MB) bypass Vercel's 4.5 MB body limit.
   ===================================================================== */
window.tgOssUpload = (function () {
  const SIGN_ENDPOINT  = 'https://variation.tegrino.co/api/sign-oss-upload';
  const SESSION_KEY    = 'tg_oss_session_id';
  const RETRY_DELAYS   = [1000, 3000];

  function _sessionId() {
    try {
      let s = sessionStorage.getItem(SESSION_KEY);
      if (!s) {
        const buf = new Uint8Array(16);
        (window.crypto || window.msCrypto).getRandomValues(buf);
        s = Array.from(buf, (b) => b.toString(16).padStart(2, '0')).join('');
        sessionStorage.setItem(SESSION_KEY, s);
      }
      return s;
    } catch (e) {
      return 'nostorage-' + Date.now().toString(36);
    }
  }

  function _sanitizeName(name) {
    return String(name || 'file').replace(/[^A-Za-z0-9._-]/g, '_').slice(0, 200);
  }

  // 2026-06-06 FIX: checkout was throwing "The string did not match the
  // expected pattern" — that is WebKit's atob() error on base64 that contains
  // whitespace/newlines or is otherwise off-alphabet (large composed/snapshot
  // data URLs can wrap). Primary path now uses the browser's native data-URL
  // decoder via fetch().blob() (bulletproof, handles any size/format); the
  // manual atob path is kept as a fallback and now strips whitespace first.
  async function _dataUrlToBlob(dataUrl) {
    // Only ever process real data: URLs. A bare string ("Tainted canvas…",
    // a relative path) must NOT be fetched — fetch() would resolve it as a
    // URL and return the wrong bytes (e.g. the page HTML). Self-test guards this.
    if (!dataUrl || typeof dataUrl !== 'string' || !/^data:/i.test(dataUrl)) return null;
    try {
      const r = await fetch(dataUrl);
      const b = await r.blob();
      if (b && b.size > 0) return b;   // size 0 (e.g. "data:,") → fall through → null
    } catch (e) {
      // fall through to manual parse (e.g. if CSP blocks data: in connect-src)
    }
    const m = /^data:([^;,]+)?(?:;base64)?,([\s\S]*)$/.exec(dataUrl);
    if (!m) return null;
    const mime = m[1] || 'application/octet-stream';
    const isB64 = /;base64,/.test(dataUrl);
    if (isB64) {
      const clean = (m[2] || '').replace(/\s/g, '');   // strip newlines/spaces
      if (!clean) return null;
      let bin;
      try { bin = atob(clean); } catch (e) { return null; }   // never let atob throw out
      const arr = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
      return arr.length ? new Blob([arr], { type: mime }) : null;
    }
    const body = decodeURIComponent(m[2] || '');
    return body.length ? new Blob([body], { type: mime }) : null;   // "data:," → null
  }

  async function _sign(filename, contentType) {
    const r = await fetch(SIGN_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename, contentType })
    });
    if (!r.ok) {
      const t = await r.text().catch(() => '');
      throw new Error('sign failed (' + r.status + '): ' + t.slice(0, 200));
    }
    return r.json();
  }

  function _postToOss(sig, blob, onProgress) {
    return new Promise((resolve, reject) => {
      const form = new FormData();
      form.append('key', sig.key);
      form.append('policy', sig.policy);
      form.append('OSSAccessKeyId', sig.ossAccessKeyId);
      form.append('signature', sig.signature);
      form.append('Content-Type', blob.type || 'application/octet-stream');
      form.append('success_action_status', '200');
      // OSS requires file field LAST.
      form.append('file', blob);

      const xhr = new XMLHttpRequest();
      xhr.open('POST', sig.uploadUrl, true);
      if (typeof onProgress === 'function' && xhr.upload) {
        xhr.upload.onprogress = (ev) => {
          if (ev.lengthComputable) onProgress(ev.loaded / ev.total);
        };
      }
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) resolve();
        else reject(new Error('OSS upload failed (' + xhr.status + '): ' + (xhr.responseText || '').slice(0, 200)));
      };
      xhr.onerror  = () => reject(new Error('OSS upload network error'));
      xhr.ontimeout = () => reject(new Error('OSS upload timeout'));
      xhr.send(form);
    });
  }

  async function upload(blob, opts) {
    opts = opts || {};
    const prefix   = String(opts.keyPrefix || ('tg/temp/' + _sessionId() + '/'));
    const rawName  = opts.filename || (blob && blob.name) || 'file';
    const filename = prefix + _sanitizeName(rawName);
    const contentType = (blob && blob.type) || opts.contentType || 'application/octet-stream';

    let lastErr;
    for (let attempt = 0; attempt <= RETRY_DELAYS.length; attempt++) {
      try {
        const sig = await _sign(filename, contentType);
        await _postToOss(sig, blob, opts.onProgress);
        return { publicUrl: sig.publicUrl, key: sig.key };
      } catch (e) {
        lastErr = e;
        if (attempt < RETRY_DELAYS.length) {
          await new Promise((r) => setTimeout(r, RETRY_DELAYS[attempt]));
        }
      }
    }
    throw lastErr;
  }

  async function uploadDataUrl(dataUrl, filename, opts) {
    const blob = await _dataUrlToBlob(dataUrl);
    if (!blob) throw new Error('uploadDataUrl: invalid dataUrl');
    return upload(blob, Object.assign({}, opts || {}, { filename }));
  }

  // Cheap structural guard for a usable image data URL. Used at every
  // boundary that consumes snapshot/composed output so a degenerate value
  // (empty, "data:,", a blob: URL, an error string) is caught with a clear
  // message instead of surfacing as atob's cryptic "did not match pattern".
  function _isValidImageDataUrl(s) {
    return typeof s === 'string' && /^data:image\/[a-z0-9.+-]+;base64,[A-Za-z0-9+/]/i.test(s);
  }

  // _dataUrlToBlob + _isValidImageDataUrl exposed for the data-layer self-test
  // (?selftest=1) and for callers that want to pre-validate before upload.
  return { upload, uploadDataUrl, sessionId: _sessionId, _dataUrlToBlob, _isValidImageDataUrl };
})();

/* 3D loading skeleton — timeout + ready handler */
const _viewerLoadEl = document.getElementById('viewerLoading');
const _viewerTimeout = setTimeout(() => {
  if (!a9Bridge.ready && _viewerLoadEl) {
    _viewerLoadEl.classList.add('is-timeout');
  }
}, 5000);

document.getElementById('viewerRetry')?.addEventListener('click', () => {
  _viewerLoadEl.classList.remove('is-timeout');
  const f = document.getElementById('a9Viewer');
  if (f) f.src = f.src; // force iframe reload
  setTimeout(() => {
    if (!a9Bridge.ready && _viewerLoadEl) {
      _viewerLoadEl.classList.add('is-timeout');
    }
  }, 5000);
});

window.addEventListener('message', (event) => {
  if (event.source !== a9Frame.contentWindow) return;
  if (event.data && event.data.type === 'a9:ready') {
    clearTimeout(_viewerTimeout);
    /* Hide loading skeleton */
    if (_viewerLoadEl) _viewerLoadEl.classList.add('is-hidden');
    materialConfig = event.data.config;
    a9Bridge.ready = true;
    a9Bridge.queue.forEach(m => a9Frame.contentWindow.postMessage(m, '*'));
    a9Bridge.queue.length = 0;
    renderAll();
    renderPantoneGrid();
  }
});

/* =====================================================================
   FINAL §5 — State
   ===================================================================== */
let materialConfig = null;
let currentPresetName = 'Gold Tone / Golden / Light Oak';

const state = {
  body: 'Warm White',
  rim: 'Gold Tone',
  cover: 'Golden',
  wood: 'Light Oak',
  customCover: null
};

const BODY_TO_RIM = {
  'Warm White':         'Gold Tone',
  'Natural Aluminium':  'Natural Aluminium',
  'Matte Black':        'Black',
  'Pure White':         'Silver',
  'Warm Taupe':         'Bronze'
};

/* =====================================================================
   Mobile Preview-then-Add (B&O double-ring)
   Touch devices: 1st tap = preview (thin ring), 2nd tap same = add (thick ring).
   Desktop: instant add on click (unchanged).
   ===================================================================== */
var _tgIsTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
/* Track which swatch is currently in "preview" state on mobile.
   { type: 'match'|'mood'|'catalog'|'stand', key: string, el: HTMLElement } or null */
window._tgMobilePreview = null;

/**
 * Set a swatch to "preview" ring state (thin light ring).
 */
function _setPreviewRing(el, type, key) {
  _clearPreviewRing();
  window._tgMobilePreview = { type: type, key: key, el: el };
  el.classList.add('tg-ring-preview');
  // Inject "+" cross overlay — color adapts to swatch brightness
  var hex = el.getAttribute('data-hex') || el.style.backgroundColor || '';
  var strokeColor = _isLightHex(hex) ? 'rgba(0,0,0,0.25)' : 'rgba(255,255,255,0.35)';
  var overlay = document.createElement('span');
  overlay.className = 'tg-plus-overlay';
  overlay.innerHTML = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none">' +
    '<line x1="14" y1="6" x2="14" y2="22" stroke="' + strokeColor + '" stroke-width="2.2" stroke-linecap="round"/>' +
    '<line x1="6" y1="14" x2="22" y2="14" stroke="' + strokeColor + '" stroke-width="2.2" stroke-linecap="round"/>' +
    '</svg>';
  el.appendChild(overlay);
}

/** Is a hex color "light" (perceived luminance > 0.55)? */
function _isLightHex(hex) {
  if (!hex || hex.charAt(0) !== '#') return true;
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.55;
}

/**
 * Clear the current preview ring.
 */
function _clearPreviewRing() {
  if (window._tgMobilePreview && window._tgMobilePreview.el) {
    window._tgMobilePreview.el.classList.remove('tg-ring-preview');
    var oldOverlay = window._tgMobilePreview.el.querySelector('.tg-plus-overlay');
    if (oldOverlay) oldOverlay.remove();
  }
  window._tgMobilePreview = null;
}

/**
 * Promote a swatch from preview to "added" ring (thick dark ring).
 * Ring stays visible until the swatch is removed from cart.
 */
function _setAddedRing(el) {
  el.classList.remove('tg-ring-preview');
  var plusEl = el.querySelector('.tg-plus-overlay');
  if (plusEl) plusEl.remove();
  el.classList.add('tg-ring-added');
  window._tgMobilePreview = null;
}

/**
 * Check if user tapped the same swatch that's currently previewing.
 */
function _isSamePreview(type, key) {
  var p = window._tgMobilePreview;
  return p && p.type === type && p.key === key;
}

/* =====================================================================
   FINAL §5 — Renderers
   ===================================================================== */
function _texPath(rel) { return './a9-visual-preview/a9-material-pack/' + rel; }

function _swatchBg(def) {
  if (def && def.baseColorTexture) {
    /* Use background-image (NOT shorthand) so the swatch's CSS-driven
       background-color (var(--bg-panel)) stays underneath — fixes the
       NIGHT leak detector flagging near-white default button bg. */
    return "background-image:url('" + _texPath(def.baseColorTexture) + "');";
  }
  /* Solid colour: set background-color explicitly (NOT shorthand) so
     this overrides the CSS fallback. */
  return 'background-color:' + ((def && def.color) || '#222') + ';';
}

/* v9 §B3 fix — was named renderLegs() but collided with the Step-3
   product renderer below (function-declaration hoisting made that one
   win, leaving the Speaker wood swatches empty). Renamed to
   renderSpeakerLegsRow() to disambiguate. */
function renderSpeakerLegsRow() {
  if (!materialConfig) return;
  const keys = Object.keys(materialConfig.woodMaterials);   // 6 entries
  const html = keys.map(name => {
    const def = materialConfig.woodMaterials[name];
    const active = state.wood === name ? 'is-active' : '';
    return '<button class="swatch ' + active + '" data-wood="' + name + '" style="' + _swatchBg(def) + '" aria-label="' + name + '"></button>';
  }).join('');
  const host = document.getElementById('legsSwatches');
  if (!host) return;  // Phase 3.5: step-1 LEGS row removed.
  host.innerHTML = html;
  /* Speaker step's LEGS row shows the WOOD selection on the original
     B&O legs. The Step-3 pane has its own row-head + active-name id
     `legsActiveName` for the legs PRODUCT (Original / Aluminium / etc). */
  const woodEl = document.getElementById('speakerWoodActiveName');
  if (woodEl) woodEl.textContent = state.wood;
}

function renderCover() {
  if (!materialConfig) return;
  const keys = ['Golden', 'Light Grey', 'Black'];
  const html = keys.map(name => {
    const def = materialConfig.coverMaterials[name];
    const isActive = !state.customCover && state.cover === name;
    return '<button class="swatch ' + (isActive ? 'is-active' : '') + '" data-cover="' + name + '" style="' + _swatchBg(def) + '" aria-label="' + name + '"></button>';
  }).join('');
  const host = document.getElementById('coverSwatches');
  if (!host) return;  // Phase 3.5: step-1 COVER row removed; new custom-section uses #coverFaceSwatches.
  host.innerHTML = html;
  const nameEl = document.getElementById('coverActiveName');
  if (nameEl) fadeUpdate(nameEl, state.customCover ? 'Custom' : state.cover);
}

function renderAll() {
  // Phase 3.5 cleanup — renderSets() / renderBody() removed; their DOM hosts
  // (#setsList, #bodySwatches) are gone. Step-1 only renders the WOOD swatch
  // row + the custom-section cover swatches now.
  renderSpeakerLegsRow();   // Speaker step's WOOD swatch grid (6 swatches)
  renderCover();
  renderLegs();             // Step-3 LEGS-product row (Original / Aluminium / Covers)
  recomputeTotal();
  // Refresh footer summary whenever swatch state changes
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
}

/* =====================================================================
   v7 §3 — Stand selector. Visual stand-fabric / stand-aluminium swap on
   the 3D model is a follow-up; for now the picker drives state.legs,
   the active ring, the right-side label, and the additive total. */
/* v8.1 §3 / v9 §B3 — Real Tegrino catalogue keys + prices. The existing
   click handler reads data-legs and looks up these maps; no handler
   change required. */
/* V1 SCOPE: 8 legs products with code-only material rendering
 * (solid colors, metals, multi-leg-color via perLeg).
 *
 * V2 (codex 5/11): 5 partial-design covers will return after codex
 * delivers UV-mapped texture maps. See spec at codex-legs-textures.md.
 *   - cover-frost-white      vertical BLACK→WHITE gradient
 *   - cover-coral-pink       wood + pink knit caps top/bottom
 *   - cover-twilight         wood + mint knit caps top/bottom
 *   - cover-midsummer-blue   wood + pale-blue knit caps top/bottom
 *   - cover-santa-claus      white caps + red middle + bands
 *
 * Material params live on the configurator side (single source of truth) and
 * ride along in the postMessage payload as `material:` so the iframe doesn't
 * need its own per-ID mapping table. Adding a new product = one HTML <button> +
 * one row here. Colors verified against tegrino.co product photos. */
// Codex 5/11: HDRI environment active — true PBR metal values.
const LEG_MATERIALS = {
  'original':         { kind: 'wood' },
  'aluminium-chrome': { kind: 'metal',  color: '#E8EBED', roughness: 0.08, metalness: 0.95, envMapIntensity: 2.15 },
  'aluminium-amber':  { kind: 'metal',  color: '#D4C091', roughness: 0.18, metalness: 0.92, envMapIntensity: 2.08 },
  'cover-black':      { kind: 'fabric', color: '#1F1F1F', roughness: 0.95, metalness: 0 },
  'cover-white':      { kind: 'fabric', color: '#F5F1EA', roughness: 0.95, metalness: 0 },
  'cover-red':        { kind: 'fabric', color: '#620513', roughness: 0.95, metalness: 0 },
  'cover-colorplay':  { kind: 'fabric', color: '#620513', roughness: 0.95, metalness: 0,
                        perLeg: ['#620513', '#123412', '#083060'] },
  'cover-frost':      { kind: 'fabric', coverName: 'Frost White Cover',   roughness: 0.95, metalness: 0 },
  'cover-coral':      { kind: 'fabric', coverName: 'Coral Pink Cover',    roughness: 0.95, metalness: 0 },
  'cover-twilight':   { kind: 'fabric', coverName: 'Twilight Cover',      roughness: 0.95, metalness: 0 },
  'cover-midsummer':  { kind: 'fabric', coverName: 'Midsummer Blue Cover',roughness: 0.95, metalness: 0 },
  'cover-santa':      { kind: 'fabric', coverName: 'Santa Claus Cover',   roughness: 0.95, metalness: 0 },
};

state.legs = state.legs || 'original';
state.legsAccessory = state.legsAccessory || null;
// Phase 4.21 — mutual-exclusion sibling to state.legsAccessory. When set, all 3
// leg shafts render the chosen Pantone TPG color (€79). Picking an in-stock
// product or Original Legs clears this. Picking a Custom Pantone clears
// state.legsAccessory.
state.legsCustom = state.legsCustom || null;
// Phase 4.28 — Cover · Upload editor working state. Lifecycle:
//   null                                                          → EMPTY
//   { dataUrl, filename, zoom, offsetX, offsetY, rotation, filter } → EDITING
//   { ..., composedDataUrl }                                       → APPLIED
// state.customCover ({ type:'upload', dataUrl: composed }) is set on Apply
// so the existing pricing + summary + bridge paths continue to work.
state.coverUpload = state.coverUpload || null;
// Phase 6.1 — Multi-upload: array of completed upload objects.
// Each entry: { id, dataUrl, composedDataUrl, filename, zoom, offsetX, offsetY, rotation, levelDeg, filter }
state.uploadCovers = state.uploadCovers || [];
// _editingUploadIdx: index into uploadCovers[] when editing an existing item (-1 = new)
var _editingUploadIdx = -1;
// Phase 4.40 — customer's override for the keepsake composition name.
// `compositionName` holds the saved string; `compositionNameKey` snapshots
// the (style|legs|preset|filter) signature at save time so we can drop the
// override when the underlying composition changes (re-generates a fresh
// suggestion via the lexicon). Both null = use auto-generated name.
state.compositionName = state.compositionName || null;
state.compositionNameKey = state.compositionNameKey || null;
// Phase 4.30 — offsets switched from preview-pixel units to NORMALISED
// (≈ -1..+1, where 1 = full radius). Any pre-existing session with
// pixel-magnitude offsets gets clamped to centre — losing one session's
// framing beats rendering wrong silently.
if (state.coverUpload &&
    (Math.abs(state.coverUpload.offsetX) > 5 || Math.abs(state.coverUpload.offsetY) > 5)) {
  state.coverUpload.offsetX = 0;
  state.coverUpload.offsetY = 0;
}

function renderLegs() {
  // Phase 7 — Stock rows are now rendered by renderStandStockRows()
  if (typeof renderStandStockRows === 'function') renderStandStockRows();
  // Legacy compat — old #legsOptions may not exist anymore
  document.querySelectorAll('#legsOptions [data-legs]').forEach(el => {
    el.classList.toggle('is-active', el.dataset.legs === state.legs);
  });
}

const legsOptionsEl = document.getElementById('legsOptions');
if (legsOptionsEl) {
  legsOptionsEl.addEventListener('click', e => {
    const btn = e.target.closest('[data-legs]');
    if (!btn) return;

    state.legs = btn.dataset.legs;
    const def = LEG_MATERIALS[state.legs] || { kind: 'wood' };
    const price = parseInt(btn.dataset.price, 10) || 0;
    const name = btn.querySelector('.stand-name')?.textContent.trim() || state.legs;

    // Track accessory state separately from wood. Original Legs → null (wood from Step 1).
    state.legsAccessory = (def.kind === 'wood')
      ? null
      : { id: state.legs, name, price, kind: def.kind };

    // Phase 4.21 — In-stock and Custom are mutually exclusive. Picking any
    // in-stock product (including Original Legs) clears Custom Pantone.
    state.legsCustom = null;
    document.querySelectorAll('#standMoodRowsContainer .mood-swatch.is-selected, #standMatchRecsList .match-rec.is-active')
      .forEach(b => { b.classList.remove('is-selected'); b.classList.remove('is-active'); });

    // Micro-animation: pop the selected card
    btn.classList.add('is-selecting');
    btn.addEventListener('animationend', () => btn.classList.remove('is-selecting'), { once: true });

    renderLegs();
    recomputeTotal();

    // Phase 4.11 — material-aware payload. `def` carries kind/color/roughness/metalness
    // (and perLeg for ColorPlay Trio). The iframe's a9:setStand handler reads msg.material
    // directly, so adding products no longer requires touching iframe code.
    a9Bridge.send({ type: 'a9:setStand', stand: state.legs, material: def });

    // Phase 4.12 — when user picks Original Legs (kind: 'wood'), also re-dispatch the
    // current wood selection so the iframe rebuilds the wood material with textures
    // (belt-and-braces: setStand wood-kind also calls applyFinishes, but explicit
    // setWood guarantees state.wood is in sync iframe-side too).
    if (def.kind === 'wood') {
      a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
    }

    if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
    // Phase 4.31 FIX 2 — picking In-stock clears state.legsCustom; hide strip.
  });

  // Hover preview on in-stock leg options — live 3D update.
  let _legsHoverTimeout = null;
  let _legsIsHovering = false;
  legsOptionsEl.addEventListener('mouseover', (e) => {
    const btn = e.target.closest('[data-legs]');
    if (!btn) return;
    clearTimeout(_legsHoverTimeout);
    _legsHoverTimeout = setTimeout(() => {
      _legsIsHovering = true;
      const def = LEG_MATERIALS[btn.dataset.legs] || { kind: 'wood' };
      a9Bridge.send({ type: 'a9:setStand', stand: btn.dataset.legs, material: def });
      if (def.kind === 'wood') {
        a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
      }
    }, 60);
  });
  legsOptionsEl.addEventListener('mouseout', (e) => {
    const btn = e.target.closest('[data-legs]');
    if (!btn) return;
    const related = e.relatedTarget?.closest?.('[data-legs]');
    if (related) return;
    clearTimeout(_legsHoverTimeout);
    if (!_legsIsHovering) return;
    _legsIsHovering = false;
    // Revert to committed state
    if (state.legsCustom && state.legsCustom.hex) {
      a9Bridge.setLegsCustom({ hex: state.legsCustom.hex, tpg: state.legsCustom.tpg, name: state.legsCustom.name, mode: 'pantone' });
    } else {
      const def = LEG_MATERIALS[state.legs] || { kind: 'wood' };
      a9Bridge.send({ type: 'a9:setStand', stand: state.legs, material: def });
      if (def.kind === 'wood') a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
    }
  });
}

/* Total = cover-customisation charge + leg upcharge. Step 1 presets
   describe what the customer already owns (no charge). Step 2 cover
   customisation is the first paid line item. Updates bottom CTA bar +
   review card total in lockstep.

   Cover charge derives from state.customCover.type, which all 4 entry
   points (curated pantone click, search-result click, Match-a-Room rec,
   image upload) already set correctly — no extra state field needed.
   Reset to a Step 1 preset clears state.customCover → 0.

   V2 TODO: multi-currency via Shopify Storefront API
     - detect customer geo (or read Shopify currency code)
     - swap symbol + amount: €89 / $96 / £76 / ¥698 etc.
     - leg covers Step 3: TBD pricing once SKU mapping confirmed
     - bundle/preset upcharges: TBD */
let PRICE_COVER_PANTONE = 89;   // fallback — synced from Shopify at boot
let PRICE_COVER_UPLOAD  = 129;  // fallback — synced from Shopify at boot
const PRICE_LEGS_CUSTOM = 79;   // Phase 4.21 — flat charge for Custom Pantone TPG legs

/* Live-sync prices from Shopify product JSON endpoints.
   Same-origin on tegrino.co → works immediately.
   Dev (127.0.0.1) → CORS blocks, falls back to hardcoded values silently. */
const _SHOPIFY_PRICE_MAP = [
  { url: 'https://tegrino.co/products/beoplay-beosound-a9-cover-solid-colors.json',  target: 'pantone' },
  { url: 'https://tegrino.co/products/beoplay-beosound-a9-cover-custom-design.json', target: 'upload'  }
];
function _syncShopifyPrices() {
  _SHOPIFY_PRICE_MAP.forEach(({ url, target }) => {
    fetch(url, { mode: 'cors' })
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        const raw = data?.product?.variants?.[0]?.price;
        if (!raw) return;
        const price = Math.round(parseFloat(raw));
        if (isNaN(price) || price <= 0) return;
        if (target === 'pantone') PRICE_COVER_PANTONE = price;
        else                      PRICE_COVER_UPLOAD  = price;
        // Update any already-visible price tags
        _refreshPriceTags();
      })
      .catch(() => { /* CORS or network error — use fallback */ });
  });
}
function _refreshPriceTags() {
  const selPrice = document.getElementById('coverSelectedPrice');
  if (selPrice && !document.getElementById('coverSelectedStrip')?.hidden) {
    selPrice.textContent = '€' + PRICE_COVER_PANTONE;
  }
  // Phase 6.1 — update multi-upload list price
  const uplListPrice = document.getElementById('cuListPrice');
  if (uplListPrice && state.uploadCovers && state.uploadCovers.length > 0) {
    var c = state.uploadCovers.length;
    uplListPrice.textContent = c + ' cover' + (c > 1 ? 's' : '');
  }
  if (typeof recomputeTotal === 'function') recomputeTotal();
}

/* ═══════════════════════════════════════════════════════════════════
   tgCart — Shopify Ajax Cart API bridge
   Phase 5 · 2026-05-21
   ─────────────────────────────────────────────────────────────────
   Same-origin on tegrino.co → real /cart/add.js calls.
   Dev / Vercel (cross-origin) → logs to console, no real API calls.
   ═══════════════════════════════════════════════════════════════════ */
const tgCart = (function () {
  'use strict';

  /* ── Config ── */
  const SHOPIFY_DOMAIN = 'tegrino.co';
  const _isSameOrigin = (location.hostname === SHOPIFY_DOMAIN || location.hostname === 'www.' + SHOPIFY_DOMAIN);
  const _DEV = !_isSameOrigin; // true on localhost / Vercel

  /* Variant IDs — special products */
  const VID_PANTONE_COVER = 42865004052668;
  const VID_UPLOAD_COVER  = 32960468353069;
  const VID_LEGS_CUSTOM   = 46850431811772;

  /* Internal state: mirror of what we've added to the Shopify cart */
  let _cartItems = [];  // [{ key, variantId, qty, properties, type, ref }]
  let _ready = false;
  let _failures = [];   // [{ label, reason, variantId }] — item-level add failures during a checkout sync

  /* ── Helpers ── */
  function _log(action, data) {
    if (_DEV) console.log('[tgCart:DEV]', action, data);
  }

  async function _post(endpoint, body) {
    if (_DEV) {
      _log('POST ' + endpoint, body);
      return { ok: true, dev: true, items: body.items || [] };
    }
    const r = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!r.ok) {
      // Shopify returns a JSON body with the real reason (description/message).
      // Capture it so failures are actionable instead of a bare "→ 422".
      let reason = '';
      try { const j = await r.json(); reason = j.description || j.message || ''; } catch (e) {}
      const err = new Error('tgCart: ' + endpoint + ' → ' + r.status + (reason ? ' (' + reason + ')' : ''));
      err.status = r.status; err.reason = reason; err.endpoint = endpoint;
      throw err;
    }
    return r.json();
  }

  async function _get(endpoint) {
    if (_DEV) { _log('GET ' + endpoint); return { items: [] }; }
    const r = await fetch(endpoint, { headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('tgCart: ' + endpoint + ' → ' + r.status);
    return r.json();
  }

  /* ── Init: fetch current Shopify cart state ── */
  async function init() {
    try {
      const cart = await _get('/cart.js');
      _cartItems = (cart.items || []).map(it => ({
        key: it.key,
        variantId: it.variant_id || it.id,
        qty: it.quantity,
        properties: it.properties || {},
        type: _inferType(it),
        ref: it.key
      }));
      _ready = true;
      _log('init', { items: _cartItems.length, dev: _DEV });
    } catch (e) {
      _ready = true; // proceed even if fetch fails (dev mode)
      _log('init:error', e.message);
    }
  }

  function _inferType(shopifyItem) {
    const props = shopifyItem.properties || {};
    if (props._tpg_code && props._item_type === 'legs') return 'legs-pantone';
    if (props._tpg_code) return 'cover-pantone';
    if (props._config_url || props._original_url || props._preview_url) return 'cover-upload';
    if (props._catalog_handle) return 'cover-collection';
    if (props._item_type === 'legs-stock') return 'legs-stock';
    return 'unknown';
  }

  /* ── Add to Cart ── */

  /** Add a custom Pantone cover */
  async function addPantone(tpgCode, hex, name, qty) {
    qty = qty || 1;
    const props = {
      '_tpg_code': tpgCode,
      '_tpg_hex': hex,
      '_item_type': 'cover-pantone',
      'Color': name || tpgCode
    };
    return _addItem(VID_PANTONE_COVER, qty, props, 'cover-pantone');
  }

  /** Add an uploaded artwork cover. PR-A (OSS + worker): client ships the
   *  customer's editor config + original image + preview snapshot. The
   *  Aliyun FC worker (tegrino-worker) reads config + original from OSS,
   *  generates the production PSD, and writes the result back as an order
   *  metafield (tegrino.psd_url). No more client-side PSD encoding. */
  async function addUpload(args) {
    args = args || {};
    const qty = args.qty || 1;
    const props = {
      '_config_url':   args.configUrl   || '',
      '_original_url': args.originalUrl || '',
      '_preview_url':  args.previewUrl  || '',
      '_variation_no': args.variationNo || '',
      '_item_type':    'cover-upload',
      'Design':        'Custom Upload',
      'File':          args.fileName || 'artwork'
    };
    return _addItem(VID_UPLOAD_COVER, qty, props, 'cover-upload');
  }

  /** Add a collection cover by handle */
  async function addCollection(handle, qty) {
    qty = qty || 1;
    // Resolve variant ID from COVER_CATALOG
    let vid = null;
    if (typeof COVER_CATALOG !== 'undefined') {
      const entry = COVER_CATALOG.find(c => c.handle === handle);
      if (entry && entry.variantId) vid = entry.variantId;
    }
    if (!vid) {
      // Fallback: lazy-fetch from Shopify product JSON
      try {
        const data = await _get('/products/' + handle + '.json');
        vid = data.product?.variants?.[0]?.id;
      } catch (e) { _log('addCollection:resolve-fail', handle); }
    }
    if (!vid) {
      // Couldn't resolve a live variant for this catalog cover → record and skip.
      _failures.push({ label: handle.replace(/^beoplay-beosound-a9-cover-/, '').replace(/-/g, ' '), reason: 'product unavailable' });
      _log('resolve-fail', handle);
      return null;
    }
    const props = {
      '_catalog_handle': handle,
      '_item_type': 'cover-collection',
      'Design': handle.replace(/^beoplay-beosound-a9-cover-/, '').replace(/-/g, ' ')
    };
    return _addItem(vid, qty, props, 'cover-collection');
  }

  /** Add legs — stock (by variant ID) or custom Pantone */
  async function addLegs(type, data, qty) {
    qty = qty || 1;
    if (type === 'pantone') {
      const props = {
        '_tpg_code': data.tpgCode || '',
        '_tpg_hex': data.hex || '',
        '_item_type': 'legs',
        'Color': data.name || data.tpgCode || 'Custom Pantone'
      };
      return _addItem(VID_LEGS_CUSTOM, qty, props, 'legs-pantone');
    }
    // Stock legs — data.variantId must be provided
    if (!data.variantId) {
      _failures.push({ label: (data && data.name) || 'Legs', reason: 'variant unavailable' });
      return null;
    }
    const props = {
      '_item_type': 'legs-stock',
      'Style': data.name || 'Legs'
    };
    return _addItem(data.variantId, qty, props, 'legs-stock');
  }

  /** Core add — calls /cart/add.js */
  async function _addItem(variantId, qty, properties, type) {
    const label = (properties && (properties.Color || properties.Design || properties.Style || properties.File)) || type;
    const payload = { items: [{ id: variantId, quantity: qty, properties: properties }] };
    let result;
    try {
      result = await _post('/cart/add.js', payload);
    } catch (e) {
      // Item-level failure (e.g. a single sold-out/unavailable cover): record
      // WHICH item + WHY, but do NOT abort the whole checkout — let the rest
      // of the customer's selections proceed. Surfaced by _syncAllToShopifyCart.
      _failures.push({ label: label, reason: (e && e.reason) || (e && e.message) || 'unknown', variantId: variantId });
      _log('add-failed', { label: label, variantId: variantId, reason: e && e.message });
      return null;
    }

    // Track locally
    const key = result.items?.[0]?.key || ('dev-' + Date.now() + '-' + Math.random().toString(36).slice(2, 6));
    const item = { key, variantId, qty, properties, type, ref: key };
    _cartItems.push(item);
    _log('added', { type, variantId, qty });
    return item;
  }

  /* ── Modify Cart ── */

  /** Remove item by key */
  async function remove(key) {
    await _post('/cart/change.js', { id: key, quantity: 0 });
    _cartItems = _cartItems.filter(it => it.key !== key);
    _log('removed', key);
  }

  /** Update quantity */
  async function updateQty(key, qty) {
    if (qty <= 0) return remove(key);
    await _post('/cart/change.js', { id: key, quantity: qty });
    const item = _cartItems.find(it => it.key === key);
    if (item) item.qty = qty;
    _log('updateQty', { key, qty });
  }

  /** Clear all Variation items from cart */
  async function clear() {
    const updates = {};
    _cartItems.forEach(it => { updates[it.key] = 0; });
    if (Object.keys(updates).length > 0 && !_DEV) {
      await _post('/cart/update.js', { updates });
    }
    _cartItems = [];
    _log('cleared');
  }

  /** Redirect to Shopify checkout */
  function checkout() {
    if (_DEV) {
      _log('checkout', { items: _cartItems.length });
      alert('[DEV] Checkout would redirect to /checkout with ' + _cartItems.length + ' items.');
      return;
    }
    // Force-flush variation state to localStorage before navigating away.
    // The pagehide handler also covers this, but Safari has historically
    // skipped pagehide when location.href is set inside a click handler —
    // explicit redundancy ensures the user's selections survive the
    // round-trip back from Shopify checkout.
    try { if (typeof window._flushPersistState === 'function') window._flushPersistState(); } catch (e) {}
    window.location.href = '/checkout';
  }

  /* ── Getters ── */
  function getState()  { return { items: [..._cartItems], ready: _ready, dev: _DEV }; }
  function getItems()  { return [..._cartItems]; }
  function getFailures()   { return [..._failures]; }
  function clearFailures() { _failures = []; }
  function isDev()     { return _DEV; }
  function isReady()   { return _ready; }

  /* ── Public API ── */
  return {
    init, addPantone, addUpload, addCollection, addLegs,
    remove, updateQty, clear, checkout,
    getState, getItems, getFailures, clearFailures, isDev, isReady
  };
})();

/* ── Legs variant ID lookup ──
   Maps internal legsId (e.g. 'cover-black') to Shopify variant IDs.
   Source: variant-map.json legs section. */
const LEGS_VARIANT_MAP = {
  'cover-colorplay':  44421197627580,
  'aluminium-amber':  44376220598460,
  'cover-red':        43164052324540,
  'aluminium-chrome': 37644761563324,
  'cover-white':      33705488678957,
  'cover-black':      33705481535533,
  'cover-twilight':   33316935630893,
  'cover-midsummer':  32960589594669,
  'cover-coral':      32960573177901,
  'cover-frost':      32932219420717,
  'cover-santa':      37550283555004
};

/* ── _uploadCoverToOss ──
   PR-A: ship the editor config JSON + customer's original image + a 3D
   preview snapshot to Aliyun OSS in parallel. The FC worker
   (tegrino-worker) reads config + original from OSS post-checkout and
   generates the production PSD server-side, writing the result to the
   order metafield tegrino.psd_url. Browser no longer encodes PSDs.
   Falls back to composedDataUrl if the customer's original is missing. */
async function _uploadCoverToOss(uc, idx, totalCovers) {
  const sessPrefix = 'tg/temp/' + window.tgOssUpload.sessionId() + '/' + Date.now().toString(36) + '-' + idx + '-';

  // --- 1. Build editor config JSON (everything the worker needs to regenerate the PSD) ---
  const config = {
    schema:      'tegrino-cover-upload/v1',
    canvas:      { size: 8268, artRadius: 4088, bleedRadius: 3905, dpi: 300 },
    transform: {
      zoom:     typeof uc.zoom     === 'number' ? uc.zoom     : 1,
      offsetX:  typeof uc.offsetX  === 'number' ? uc.offsetX  : 0,
      offsetY:  typeof uc.offsetY  === 'number' ? uc.offsetY  : 0,
      rotation: typeof uc.rotation === 'number' ? uc.rotation : 0,
      levelDeg: typeof uc.levelDeg === 'number' ? uc.levelDeg : 0
    },
    filter:           uc.filter || 'none',
    originalFilename: uc.filename || uc.name || 'artwork'
  };
  const configBlob = new Blob([JSON.stringify(config)], { type: 'application/json' });

  // --- 2. Capture 3D preview snapshot (best-effort) ---
  // Order matters: camera command FIRST so its rAF tween isn't starved by the
  // iframe main thread decoding a large composedDataUrl image. Entering Step 4
  // leaves the camera at speaker+zoomed=true (3/4 angle, tripod showing), so
  // setView('cover', false) + setZoom(false) are required to reframe to the
  // face-on circle the back-office preview expects. 1500 ms wait = 2.5× the
  // 600 ms tween, headroom for image-decode contention and slow devices.
  let previewDataUrl = uc.composedDataUrl || '';
  try {
    if (uc.composedDataUrl && a9Bridge && a9Bridge.ready) {
      a9Bridge.setView('cover', false);
      a9Bridge.setZoom(false);
      a9Bridge.setCustomUpload(uc.composedDataUrl, true);  // 客户上传(结账快照)→trim 到70cm可见
      await new Promise((r) => setTimeout(r, 1500));
      const snap = await a9Bridge.captureSnapshot();
      if (snap) previewDataUrl = snap;
    }
  } catch (e) {
    console.warn('[checkout] snapshot fell back to composedDataUrl:', e.message);
  }

  // --- 3. Resolve original image (uc.dataUrl per state.uploadCovers schema) ---
  const originalDataUrl = uc.dataUrl || uc.composedDataUrl || '';

  // --- 4. Parallel upload to OSS (config + original + preview) ---
  const tasks = [];
  let cfgShare = null, origShare = null, prevShare = null;

  tasks.push(window.tgOssUpload.upload(configBlob, {
    keyPrefix:   sessPrefix,
    filename:    'config.json',
    contentType: 'application/json'
  }).then((r) => { cfgShare = r; }));

  // Validate each data URL before handing it to the uploader. A malformed
  // value (empty, blob:, error string) is skipped with a warning instead of
  // throwing mid-checkout — config + whatever's valid still ships, and the
  // worker can regenerate the PSD from config + original.
  var _validDataUrl = window.tgOssUpload._isValidImageDataUrl ||
    function (s) { return typeof s === 'string' && /^data:image\/[a-z0-9.+-]+;base64,[A-Za-z0-9+/]/i.test(s); };

  if (originalDataUrl) {
    if (_validDataUrl(originalDataUrl)) {
      const origName = (uc.filename || uc.name || 'original').replace(/\.[^.]+$/, '') + '.jpg';
      tasks.push(window.tgOssUpload.uploadDataUrl(originalDataUrl, origName, {
        keyPrefix: sessPrefix
      }).then((r) => { origShare = r; }));
    } else {
      console.warn('[checkout] skipping original — not a valid image data URL (len=' + String(originalDataUrl).length + ')');
    }
  }
  if (previewDataUrl) {
    if (_validDataUrl(previewDataUrl)) {
      // Preview is a non-essential thumbnail — the worker regenerates the PSD
      // (and a preview) from config + original. Never let a preview upload
      // failure block checkout.
      tasks.push(window.tgOssUpload.uploadDataUrl(previewDataUrl, 'preview.jpg', {
        keyPrefix: sessPrefix
      }).then((r) => { prevShare = r; })
        .catch((e) => { console.warn('[checkout] preview upload skipped (non-fatal):', e && e.message); }));
    } else {
      console.warn('[checkout] skipping preview — not a valid image data URL (len=' + String(previewDataUrl).length + ')');
    }
  }

  await Promise.all(tasks);

  return {
    configUrl:   cfgShare  ? cfgShare.publicUrl  : '',
    originalUrl: origShare ? origShare.publicUrl : '',
    previewUrl:  prevShare ? prevShare.publicUrl : ''
  };
}

/* ── _syncAllToShopifyCart ──
   Called at checkout: reads Variation internal cart state and pushes
   everything into the real Shopify cart via tgCart.
   Clears previous Variation items first to avoid duplicates. */
async function _syncAllToShopifyCart() {
  // 0. Reset the item-level failure log for this checkout attempt
  tgCart.clearFailures();
  // 1. Clear any previous Variation items from Shopify cart
  await tgCart.clear();

  // 2. Pantone covers (match room + mood)
  if (typeof _pantoneCartQty === 'object') {
    for (var pk in _pantoneCartQty) {
      if (_pantoneCartQty[pk] > 0) {
        var prec = MATCH_RECOMMENDATIONS[parseInt(pk, 10)];
        if (prec) await tgCart.addPantone(prec.tpg || prec.code || '', prec.hex || '', prec.name || '', _pantoneCartQty[pk]);
      }
    }
  }
  if (typeof _moodCartQty === 'object') {
    for (var mdk in _moodCartQty) {
      if (_moodCartQty[mdk] && _moodCartQty[mdk].qty > 0) {
        await tgCart.addPantone(_moodCartQty[mdk].tpg || '', _moodCartQty[mdk].hex || '', _moodCartQty[mdk].name || '', _moodCartQty[mdk].qty);
      }
    }
  }

  // 3. Upload covers — PR-A (OSS + worker): ship config + original +
  //    preview to OSS, write the https URLs into line item properties. The
  //    FC worker generates the production PSD post-checkout.
  if (state.uploadCovers && state.uploadCovers.length > 0) {
    var vNo = '';
    try { vNo = sessionStorage.getItem('tg_variation_no_v2') || ''; } catch (e) {}
    var totalCovers = state.uploadCovers.length;
    for (var ui = 0; ui < totalCovers; ui++) {
      var uc = state.uploadCovers[ui];
      var urls = await _uploadCoverToOss(uc, ui, totalCovers);
      await tgCart.addUpload({
        configUrl:   urls.configUrl,
        originalUrl: urls.originalUrl,
        previewUrl:  urls.previewUrl,
        fileName:    uc.filename || uc.name || ('upload-' + (ui + 1)),
        variationNo: vNo,
        qty:         uc.qty || 1
      });
    }
  }

  // 4. Collection covers
  if (typeof _catalogCartQty === 'object' && typeof _matchCatalogResults === 'object') {
    for (var ck in _catalogCartQty) {
      if (_catalogCartQty[ck] > 0 && _matchCatalogResults[ck]) {
        await tgCart.addCollection(_matchCatalogResults[ck].cover.handle, _catalogCartQty[ck]);
      }
    }
  }

  // 5. Fallback single covers
  if (!_hasMultiCoverItems() && state.customCover) {
    if (state.customCover.type === 'pantone') {
      await tgCart.addPantone(state.customCover.tpg || '', state.customCover.hex || '', state.customCover.name || '', 1);
    } else if (state.customCover.type === 'upload') {
      var vNo2 = '';
      try { vNo2 = sessionStorage.getItem('tg_variation_no_v2') || ''; } catch (e) {}
      // PR-A: same 3-URL pipeline for the single-cover fallback.
      // Source the full-res ORIGINAL + the live transform from state.coverUpload
      // — the same record the multi-cover path copies into uploadCovers[]
      // (_enterAppliedState). NOT state.customCover: for an upload it only holds
      // { type, filename } plus a dataUrl that live-preview overwrites with the
      // 1024 composite (and it carries no zoom/offset). Using it made the worker
      // upscale a 1024 preview at DEFAULT framing instead of the customer's
      // full-res original at their chosen crop → soft 70cm print. Falls back to
      // customCover only if coverUpload is somehow gone.
      var srcUc = state.coverUpload || {};
      var fakeUc = {
        dataUrl:          srcUc.dataUrl || state.customCover.dataUrl || '',
        composedDataUrl:  srcUc.composedDataUrl || state.customCover.composedDataUrl || state.customCover.dataUrl || '',
        filename:         srcUc.filename || state.customCover.name || 'custom-upload',
        zoom:             srcUc.zoom,
        offsetX:          srcUc.offsetX,
        offsetY:          srcUc.offsetY,
        rotation:         srcUc.rotation,
        levelDeg:         srcUc.levelDeg,
        filter:           srcUc.filter
      };
      var urlsSingle = await _uploadCoverToOss(fakeUc, 0, 1);
      await tgCart.addUpload({
        configUrl:   urlsSingle.configUrl,
        originalUrl: urlsSingle.originalUrl,
        previewUrl:  urlsSingle.previewUrl,
        fileName:    state.customCover.name || 'Custom Upload',
        variationNo: vNo2,
        qty:         1
      });
    }
  }

  // 6. Legs — stock multi-select
  if (typeof _standCartQty === 'object') {
    for (var sk in _standCartQty) {
      if (_standCartQty[sk] && _standCartQty[sk].qty > 0) {
        await tgCart.addLegs('stock', {
          variantId: LEGS_VARIANT_MAP[sk] || null,
          name: _standCartQty[sk].name || sk
        }, _standCartQty[sk].qty);
      }
    }
  }

  // 7. Legs — Pantone (mood + match)
  if (typeof _standMoodCartQty === 'object') {
    for (var smk in _standMoodCartQty) {
      if (_standMoodCartQty[smk] && _standMoodCartQty[smk].qty > 0) {
        await tgCart.addLegs('pantone', {
          tpgCode: _standMoodCartQty[smk].tpg || '',
          hex: _standMoodCartQty[smk].hex || '',
          name: _standMoodCartQty[smk].name || ''
        }, _standMoodCartQty[smk].qty);
      }
    }
  }
  if (typeof _standMatchCartQty === 'object') {
    for (var smtk in _standMatchCartQty) {
      if (_standMatchCartQty[smtk] > 0) {
        var smtRec = STAND_MATCH_RECS[parseInt(smtk, 10)];
        if (smtRec) {
          await tgCart.addLegs('pantone', {
            tpgCode: smtRec.tpg || smtRec.code || '',
            hex: smtRec.hex || '',
            name: smtRec.name || ''
          }, _standMatchCartQty[smtk]);
        }
      }
    }
  }

  // 8. Fallback single Pantone legs
  if (!_hasMultiLegItems() && state.legsCustom && state.legsCustom.name) {
    await tgCart.addLegs('pantone', {
      tpgCode: state.legsCustom.tpg || '',
      hex: state.legsCustom.hex || '',
      name: state.legsCustom.name || ''
    }, 1);
  }
}

/* Helpers for _syncAllToShopifyCart */
function _hasMultiCoverItems() {
  if (typeof _pantoneCartQty === 'object') { for (var k in _pantoneCartQty) { if (_pantoneCartQty[k] > 0) return true; } }
  if (typeof _moodCartQty === 'object') { for (var k in _moodCartQty) { if (_moodCartQty[k] && _moodCartQty[k].qty > 0) return true; } }
  if (state.uploadCovers && state.uploadCovers.length > 0) return true;
  if (typeof _catalogCartQty === 'object') { for (var k in _catalogCartQty) { if (_catalogCartQty[k] > 0) return true; } }
  return false;
}
function _hasMultiLegItems() {
  if (typeof _standCartQty === 'object') { for (var k in _standCartQty) { if (_standCartQty[k] && _standCartQty[k].qty > 0) return true; } }
  if (typeof _standMoodCartQty === 'object') { for (var k in _standMoodCartQty) { if (_standMoodCartQty[k] && _standMoodCartQty[k].qty > 0) return true; } }
  if (typeof _standMatchCartQty === 'object') { for (var k in _standMatchCartQty) { if (_standMatchCartQty[k] > 0) return true; } }
  return false;
}

/* Strip TPG/TCX codes from Pantone names for display (v10.2) */
function _stripTPG(name) {
  if (!name) return name;
  return name.replace(/\s*\d{2}-\d{4}\s*(TPG|TCX|TPX)\s*/gi, '').trim() || name;
}

/* Cart detail drawer — builds full breakdown of current configuration (v10 full-width) */
function _updateCartPopover() {
  var popover = document.getElementById('upCartPopover');
  if (!popover) return;
  var html = '';
  var totalPrice = 0;
  var itemCount = 0;

  // --- Speaker ---
  var speakerName = '—';
  var speakerSw = document.querySelector('#speakerSwatches .swatch.is-active');
  if (speakerSw) speakerName = speakerSw.getAttribute('aria-label') || 'Speaker';
  else {
    var preset = document.querySelector('#presetList .preset-row.is-active');
    if (preset) speakerName = preset.dataset.rim || 'Gold';
  }
  // Speaker rendered as a "base strip" banner — visually distinct from the
  // sellable Cover/Stand sections below. We don't sell the A9 itself.
  // Matches the reveal headline voice: sans base + italic editorial em only
  // on the preset name.
  html += '<div class="up-cart-base-strip">';
  html += '<div class="up-cart-base-strip__name">on a <em>' + speakerName + '</em> BeoSound A9</div>';
  html += '</div>';
  // Speaker is base — not counted in badge (only covers + stands count)

  // --- Covers ---
  var coverItems = [];
  // Pantone selections
  if (typeof _pantoneCartQty === 'object') {
    for (var pk in _pantoneCartQty) {
      if (_pantoneCartQty[pk] > 0) {
        var prec = MATCH_RECOMMENDATIONS[parseInt(pk, 10)];
        if (prec) {
          var pCost = PRICE_COVER_PANTONE * _pantoneCartQty[pk];
          totalPrice += pCost;
          coverItems.push({ name: _stripTPG(prec.name) + (_pantoneCartQty[pk] > 1 ? ' ×' + _pantoneCartQty[pk] : ''), price: '€' + pCost, del: 'pantone', delKey: pk, hex: prec.hex });
        }
      }
    }
  }
  // Mood Pantone selections
  if (typeof _moodCartQty === 'object') {
    for (var mdk in _moodCartQty) {
      if (_moodCartQty[mdk] && _moodCartQty[mdk].qty > 0) {
        var mCost = PRICE_COVER_PANTONE * _moodCartQty[mdk].qty;
        totalPrice += mCost;
        coverItems.push({ name: _stripTPG(_moodCartQty[mdk].name || 'Pantone') + (_moodCartQty[mdk].qty > 1 ? ' ×' + _moodCartQty[mdk].qty : ''), price: '€' + mCost, del: 'mood', delKey: mdk, hex: _moodCartQty[mdk].hex });
      }
    }
  }
  // Uploads — each as separate item with thumbnail. uc.qty drives the
  // stepper; the "×N" suffix on name is reverse-parsed downstream (L7036)
  // so the stepper UI picks up the count without a separate field.
  if (state.uploadCovers && state.uploadCovers.length > 0) {
    for (var ui = 0; ui < state.uploadCovers.length; ui++) {
      var uc = state.uploadCovers[ui];
      var uQty = uc.qty || 1;
      var uCost = PRICE_COVER_UPLOAD * uQty;
      totalPrice += uCost;
      var uBase = uc.name || ('Upload ' + (ui + 1));
      var uName = uBase + (uQty > 1 ? ' ×' + uQty : '');
      coverItems.push({ name: uName, price: '€' + uCost, del: 'upload-single', delKey: '' + ui, isUpload: true, thumb: uc.composedDataUrl || uc.enhanced || uc.dataUrl || uc.preview || uc.original || null });
    }
  }
  // Collection
  if (typeof _catalogCartQty === 'object' && typeof _matchCatalogResults === 'object') {
    for (var ck in _catalogCartQty) {
      if (_catalogCartQty[ck] > 0 && _matchCatalogResults[ck]) {
        var cc = _matchCatalogResults[ck].cover;
        var cCost = (cc.price || 0) * _catalogCartQty[ck];
        totalPrice += cCost;
        coverItems.push({ name: cc.name + (_catalogCartQty[ck] > 1 ? ' ×' + _catalogCartQty[ck] : ''), price: '€' + cCost, del: 'catalog', delKey: ck, img: cc.preview || cc.img || null, previewUrl: cc.preview || cc.img || null });
      }
    }
  }
  // Fallback single Pantone (no multi-select active)
  if (coverItems.length === 0 && state.customCover && state.customCover.type === 'pantone') {
    totalPrice += PRICE_COVER_PANTONE;
    coverItems.push({ name: state.customCover.name || 'Custom Pantone', price: '€' + PRICE_COVER_PANTONE, del: 'single-pantone', delKey: '' });
  }
  if (coverItems.length === 0 && state.customCover && state.customCover.type === 'upload') {
    totalPrice += PRICE_COVER_UPLOAD;
    coverItems.push({ name: 'Custom upload', price: '€' + PRICE_COVER_UPLOAD, del: 'single-upload', delKey: '', isUpload: true, thumb: state.customCover.composedDataUrl || state.customCover.dataUrl || state.coverUpload && (state.coverUpload.composedDataUrl || state.coverUpload.dataUrl) || null });
  }

  if (coverItems.length > 0) {
    // Count total cover quantities (not line items) — e.g. "×2" = 2 covers
    var _coverQtyTotal = 0;
    for (var _cqi = 0; _cqi < coverItems.length; _cqi++) {
      var _cqMatch = coverItems[_cqi].name.match(/×(\d+)/);
      _coverQtyTotal += _cqMatch ? parseInt(_cqMatch[1], 10) : 1;
    }
    itemCount += _coverQtyTotal;
    var coverLabel = _coverQtyTotal + ' Speaker Cover' + (_coverQtyTotal > 1 ? 's' : '') + ' · Printed Fabric';
    html += '<div class="up-cart-section"><div class="up-cart-section-label">' + coverLabel + '</div>';
    for (var ci = 0; ci < coverItems.length; ci++) {
      var it = coverItems[ci];
      var dotHtml = it.thumb ? '<img class="up-cart-item-dot" src="' + it.thumb + '" alt="" />'
        : it.hex ? '<span class="up-cart-item-dot" style="background:' + it.hex + '"></span>'
        : it.img ? '<img class="up-cart-item-dot" src="' + it.img + '" alt="" />' : '';
      var _itQtyMatch = it.name.match(/×(\d+)/);
      var _itQty = _itQtyMatch ? parseInt(_itQtyMatch[1], 10) : 1;
      var _itDisplayName = it.name.replace(/\s*×\d+$/, '');
      // Stepper for multi-qty cart types. upload-single now carries a qty
      // field on state.uploadCovers[i] so it joins the stepper club; truly
      // single-occurrence types (single-pantone, single-upload, plain upload)
      // still fall through to the legacy × delete button below.
      var _itIsMulti = it.del === 'pantone' || it.del === 'mood' || it.del === 'catalog' || it.del === 'upload-single';
      var stepperHtml = '';
      if (it.del && _itIsMulti) {
        stepperHtml = '<div class="up-cart-item-stepper">'
          + '<button data-stepper="minus" data-del-type="' + it.del + '" data-del-key="' + it.delKey + '" type="button" aria-label="Decrease quantity">−</button>'
          + '<span class="stepper-qty">' + _itQty + '</span>'
          + '<button data-stepper="plus" data-del-type="' + it.del + '" data-del-key="' + it.delKey + '" type="button" aria-label="Increase quantity">+</button>'
          + '</div>';
      } else if (it.del) {
        stepperHtml = '<button class="up-cart-item-del" data-del-type="' + it.del + '" data-del-key="' + it.delKey + '" type="button" aria-label="Remove">×</button>';
      }
      var psdLink = ''; /* PSD link removed — production file handled post-checkout */
      var previewAttr = it.hex ? ' data-preview-type="cover" data-preview-hex="' + it.hex + '" data-preview-name="' + (it.name || '').replace(/"/g,'&quot;') + '"'
        : (it.thumb ? ' data-preview-type="cover-upload"'
        : (it.img ? ' data-preview-type="cover-collection" data-preview-img="' + it.img.replace(/"/g,'&quot;') + '"' : ''));
      html += '<div class="up-cart-item"' + previewAttr + '>' + dotHtml + '<span class="up-cart-item-name">' + _itDisplayName + '</span>' + psdLink + stepperHtml + '<span class="up-cart-item-price">' + it.price + '</span></div>';
    }
    html += '</div>';
  }

  // --- Stand (multi-select from _standCartQty + custom Pantone legs) ---
  var standItems = [];
  // Multi-select metal/fabric stands
  if (typeof _standCartQty === 'object') {
    for (var sk in _standCartQty) {
      if (_standCartQty[sk] && _standCartQty[sk].qty > 0) {
        var sCost = _standCartQty[sk].price * _standCartQty[sk].qty;
        totalPrice += sCost;
        standItems.push({ name: _standCartQty[sk].name + (_standCartQty[sk].qty > 1 ? ' ×' + _standCartQty[sk].qty : ''), price: '€' + sCost, del: 'stand', delKey: sk, hex: _standCartQty[sk].hex || null, gradient: _standCartQty[sk].gradient || null, legsId: sk });
      }
    }
  }
  // Custom Pantone legs — multi-select from stand mood
  if (typeof _standMoodCartQty === 'object') {
    for (var smk in _standMoodCartQty) {
      if (_standMoodCartQty[smk] && _standMoodCartQty[smk].qty > 0) {
        var smCost = PRICE_LEGS_CUSTOM * _standMoodCartQty[smk].qty;
        totalPrice += smCost;
        standItems.push({ name: _stripTPG(_standMoodCartQty[smk].name || 'Pantone') + (_standMoodCartQty[smk].qty > 1 ? ' ×' + _standMoodCartQty[smk].qty : ''), price: '€' + smCost, del: 'stand-mood', delKey: smk, hex: _standMoodCartQty[smk].hex });
      }
    }
  }
  // Custom Pantone legs — multi-select from stand match
  if (typeof _standMatchCartQty === 'object') {
    for (var smtk in _standMatchCartQty) {
      if (_standMatchCartQty[smtk] > 0) {
        var smtRec = STAND_MATCH_RECS[parseInt(smtk, 10)];
        if (smtRec) {
          var smtCost = PRICE_LEGS_CUSTOM * _standMatchCartQty[smtk];
          totalPrice += smtCost;
          standItems.push({ name: _stripTPG(smtRec.name || 'Pantone') + (_standMatchCartQty[smtk] > 1 ? ' ×' + _standMatchCartQty[smtk] : ''), price: '€' + smtCost, del: 'stand-match', delKey: smtk, hex: smtRec.hex });
        }
      }
    }
  }
  // Fallback single custom Pantone legs. Condition must match _computeTotal()
  // exactly — that function is the source of truth for the CTA bar total, so
  // any divergence here leaves the panel total ≠ CTA total. Earlier versions
  // gated this on `state.legsCustom.name`, but legsCustom can be set without
  // a name (e.g. when a Pantone is picked before its label resolves) and
  // _computeTotal will still charge €79, producing a silent mismatch.
  var _hasStockLegs = false;
  var _hasStandMoodItems = false;
  var _hasStandMatchItems = false;
  if (typeof _standCartQty === 'object') { for (var _slck in _standCartQty) { if (_standCartQty[_slck] && _standCartQty[_slck].qty > 0) { _hasStockLegs = true; break; } } }
  if (typeof _standMoodCartQty === 'object') { for (var _smck in _standMoodCartQty) { if (_standMoodCartQty[_smck] && _standMoodCartQty[_smck].qty > 0) { _hasStandMoodItems = true; break; } } }
  if (typeof _standMatchCartQty === 'object') { for (var _smtck in _standMatchCartQty) { if (_standMatchCartQty[_smtck] > 0) { _hasStandMatchItems = true; break; } } }
  if (!_hasStockLegs && !_hasStandMoodItems && !_hasStandMatchItems && state.legsCustom) {
    totalPrice += PRICE_LEGS_CUSTOM;
    standItems.push({ name: state.legsCustom.name || 'Custom Pantone Leg', price: '€' + PRICE_LEGS_CUSTOM, del: 'stand-custom', delKey: '', hex: state.legsCustom.hex || null });
  }
  if (standItems.length > 0) {
    // Count total stand quantities (not line items)
    var _standQtyTotal = 0;
    for (var _sqi = 0; _sqi < standItems.length; _sqi++) {
      var _sqMatch = standItems[_sqi].name.match(/×(\d+)/);
      _standQtyTotal += _sqMatch ? parseInt(_sqMatch[1], 10) : 1;
    }
    itemCount += _standQtyTotal;
    // Derive material descriptor from actual stand items
    var _slHasMetal = false, _slHasFabric = false, _slHasPantone = false;
    for (var _sli = 0; _sli < standItems.length; _sli++) {
      var _slIt = standItems[_sli];
      if (_slIt.del === 'stand' && _slIt.legsId) {
        var _slMat = (typeof LEG_MATERIALS !== 'undefined' && LEG_MATERIALS[_slIt.legsId]) || { kind: 'fabric' };
        if (_slMat.kind === 'metal') _slHasMetal = true; else _slHasFabric = true;
      } else { _slHasPantone = true; }
    }
    var _slParts = [];
    if (_slHasMetal) _slParts.push('Aluminium');
    if (_slHasFabric || _slHasPantone) _slParts.push('Printed Fabric');
    var standLabel = _standQtyTotal + ' Leg Cover' + (_standQtyTotal > 1 ? 's' : '') + ' · ' + (_slParts.length > 0 ? _slParts.join(' + ') : 'Custom');
    html += '<div class="up-cart-section"><div class="up-cart-section-label">' + standLabel + '</div>';
    for (var si = 0; si < standItems.length; si++) {
      var sit = standItems[si];
      var sDotBg = sit.hex || sit.gradient || '';
      var sDotHtml = sDotBg ? '<span class="up-cart-item-dot" style="background:' + sDotBg + '"></span>' : '';
      var _sitQtyMatch = sit.name.match(/×(\d+)/);
      var _sitQty = _sitQtyMatch ? parseInt(_sitQtyMatch[1], 10) : 1;
      var _sitDisplayName = sit.name.replace(/\s*×\d+$/, '');
      // Multi-qty stand types get the stepper; stand-custom (single Pantone
      // selection without qty tracking) keeps the legacy × button.
      var _sitIsMulti = sit.del === 'stand' || sit.del === 'stand-mood' || sit.del === 'stand-match';
      var sStepperHtml = '';
      if (sit.del && _sitIsMulti) {
        sStepperHtml = '<div class="up-cart-item-stepper">'
          + '<button data-stepper="minus" data-del-type="' + sit.del + '" data-del-key="' + sit.delKey + '" type="button" aria-label="Decrease quantity">−</button>'
          + '<span class="stepper-qty">' + _sitQty + '</span>'
          + '<button data-stepper="plus" data-del-type="' + sit.del + '" data-del-key="' + sit.delKey + '" type="button" aria-label="Increase quantity">+</button>'
          + '</div>';
      } else if (sit.del) {
        sStepperHtml = '<button class="up-cart-item-del" data-del-type="' + sit.del + '" data-del-key="' + sit.delKey + '" type="button" aria-label="Remove">×</button>';
      }
      var sPreviewAttr = sit.hex
        ? ' data-preview-type="stand-pantone" data-preview-hex="' + sit.hex + '"'
        : (sit.legsId ? ' data-preview-type="stand-stock" data-preview-legs="' + sit.legsId + '"' : '');
      html += '<div class="up-cart-item"' + sPreviewAttr + '>' + sDotHtml + '<span class="up-cart-item-name">' + _sitDisplayName + '</span>' + sStepperHtml + '<span class="up-cart-item-price">' + sit.price + '</span></div>';
    }
    html += '</div>';
  }

  // --- Total ---
  if (totalPrice > 0) {
    html += '<div class="up-cart-total"><span>Total</span><span>€' + totalPrice + '</span></div>';
  } else {
    html += '<div class="up-cart-total"><span>No selections yet</span><span>—</span></div>';
  }

  // Two-region layout: a non-scrolling top strip (grip + "Your Composition"
  // header) and a separate scrollable region for the selections. On mobile
  // the popover is a flex column — .up-cart-stickytop is fixed at the top
  // and .up-cart-scroll owns the only scroll context. This avoids the
  // iOS Safari position:sticky momentum-scroll drift that made the grip
  // appear to shift between detents.
  var gripHtml = '<div class="up-cart-grip" aria-hidden="true"></div>';
  var headerHtml = '<div class="up-cart-list-header"><span class="up-cart-list-title">Your Composition</span><button class="up-cart-close" id="upCartClose" type="button" aria-label="Close">×</button></div>';
  popover.innerHTML = '<div class="up-cart-stickytop">' + gripHtml + headerHtml + '</div><div class="up-cart-scroll">' + html + '</div>';

  // Update badge
  var badge = document.getElementById('ctaBadge');
  if (badge) {
    var prev = parseInt(badge.textContent, 10) || 0;
    badge.textContent = itemCount > 0 ? itemCount : '';
    if (itemCount !== prev && itemCount > 0) {
      badge.classList.add('is-bounce');
      setTimeout(function() { badge.classList.remove('is-bounce'); }, 250);
    }
  }
}

// --- Legs ⇄ viewer reconcile ----------------------------------------------
// Fix: removing all leg/stand selections SOMETIMES left the coloured stand on
// the 3D model, because each removal path (stock stepper, Pantone mood, Match,
// review-page delete) ran its OWN "any stands left?" check and some only looked
// at their own map. This is a single transition-guarded safety net: after every
// cart recompute, if NO leg selection remains across ALL sources, revert the
// model to default wood legs exactly once. Additive — doesn't touch the existing
// per-path logic, just guarantees the viewer ends up correct.
var _legsWasEmpty = true;
function _reconcileLegsWithViewer() {
  var any = false;
  if (typeof _standCartQty === 'object') { for (var _rk in _standCartQty) { if (_standCartQty[_rk] && _standCartQty[_rk].qty > 0) { any = true; break; } } }
  if (!any && typeof _standMoodCartQty === 'object') { for (var _rk2 in _standMoodCartQty) { if (_standMoodCartQty[_rk2] && _standMoodCartQty[_rk2].qty > 0) { any = true; break; } } }
  if (!any && typeof _standMatchCartQty === 'object') { for (var _rk3 in _standMatchCartQty) { if (_standMatchCartQty[_rk3] > 0) { any = true; break; } } }
  if (!any && state.legsCustom && state.legsCustom.name) any = true;
  if (!any && state.legsAccessory) any = true;
  if (any) { _legsWasEmpty = false; return; }
  if (_legsWasEmpty) return;            // already at default — don't re-send
  _legsWasEmpty = true;
  state.legs = 'original';
  state.legsAccessory = null;
  state.legsCustom = null;
  if (typeof a9Bridge !== 'undefined') {
    a9Bridge.send({ type: 'a9:setStand', stand: 'original',
      material: (typeof LEG_MATERIALS !== 'undefined' && LEG_MATERIALS['original']) || { kind: 'wood' } });
    if (state.wood) a9Bridge.send({ type: 'a9:setWood', name: state.wood });
  }
}

function recomputeTotal() {
  // Use unified _computeTotal() — single source of truth for pricing
  const total = _computeTotal();
  // Break out cover vs legs for per-step display
  var coverCharge = 0;
  var pantoneTotal = 0;
  if (typeof _pantoneCartQty === 'object') {
    for (var pk in _pantoneCartQty) { if (_pantoneCartQty[pk] > 0) pantoneTotal += _pantoneCartQty[pk]; }
  }
  if (typeof _moodCartQty === 'object') {
    for (var mk in _moodCartQty) { if (_moodCartQty[mk] && _moodCartQty[mk].qty > 0) pantoneTotal += _moodCartQty[mk].qty; }
  }
  if (pantoneTotal > 0) coverCharge += PRICE_COVER_PANTONE * pantoneTotal;
  if (coverCharge === 0 && state.customCover && state.customCover.type === 'pantone') {
    coverCharge += PRICE_COVER_PANTONE;
  }
  if (state.uploadCovers && state.uploadCovers.length > 0) {
    coverCharge += PRICE_COVER_UPLOAD * state.uploadCovers.length;
  } else if (state.customCover && state.customCover.type === 'upload') {
    coverCharge += PRICE_COVER_UPLOAD;
  }
  if (typeof _catalogCartQty === 'object' && typeof _matchCatalogResults === 'object') {
    for (var ck in _catalogCartQty) {
      if (_catalogCartQty[ck] > 0 && _matchCatalogResults[ck]) {
        coverCharge += (_matchCatalogResults[ck].cover.price || 0) * _catalogCartQty[ck];
      }
    }
  }
  var legsCharge = total - coverCharge; // derive legs from total minus cover
  // Phase 5.1 — TOTAL display moved to the REVIEW step slot in the
  // unified bottom bar (#upValTotal). Legacy #totalAmount still written
  // for any old shopper-side script that may read it; harmless if its
  // host element doesn't exist.
  // REVEAL slot — show "—" (count is in the badge, price in CTA area)
  const upTotalEl = document.getElementById('upValTotal');
  if (upTotalEl && upTotalEl.textContent !== '—') fadeUpdate(upTotalEl, '—');
  // Inline total next to CTA button
  // Price inside CTA pill (方案A — divider split)
  const ctaPriceEl = document.getElementById('ctaPrice');
  if (ctaPriceEl) {
    const priceText = total > 0 ? '€' + total : '';
    if (ctaPriceEl.textContent !== priceText) {
      ctaPriceEl.style.opacity = '0';
      setTimeout(() => { ctaPriceEl.textContent = priceText; ctaPriceEl.style.opacity = ''; }, 150);
    }
  }
  // Hide price chip entirely when no charge
  const ctaPriceArea = document.getElementById('ctaPriceArea');
  if (ctaPriceArea) {
    ctaPriceArea.style.display = total > 0 ? '' : 'none';
  }
  const ctaEl = document.getElementById('totalAmount');
  if (ctaEl) fadeUpdate(ctaEl, total > 0 ? '€' + total : '—');
  const revEl = document.getElementById('reviewTotal');
  if (revEl) fadeUpdate(revEl, '€' + total);
  // Per-step price lines removed — total in status bar is sufficient (Nike/B&O pattern)
  // Phase 4.27 FIX 2 — Step 1 Legs custom-row inline price tag. Mirrors
  // legsCharge so the user sees price impact without needing to scroll to
  // the bottom CTA bar. "Free" reads warmer than "€0" for the no-charge case.
  // legsRowPrice element removed — price shown only in CTA total
  _reconcileLegsWithViewer();
}

/* =====================================================================
   Phase 4.34 SECTION 1 — DATA: keepsake variation No. + lead-time logic
   ===================================================================== */
// Pseudo-sequential variation number: HOURS since 2026-01-01 + 4000 offset.
// Phase 4.34 used minutes, which had already overflowed to ~189000 by 9 May.
// Hours keep the number plausibly 4-digit through the entire launch window
// (4000 + ~3100 = ~7100 on 9 May 2026; +1 per hour). Two customers must
// compose in the same hour to collide — acceptable for the Phase 1 stub.
// Replace with a backend KV counter post-launch.
function _generateVariationNumber() {
  const epoch = new Date('2026-01-01T00:00:00Z').getTime();
  const hours = Math.floor((Date.now() - epoch) / 3600000);
  return 4000 + hours;
}

// Phase 4.37 FIX B — single source of truth for "the customer's variation
// number". Generates once per session, persists in sessionStorage so the
// same number paints in #compNumber (top-of-page composition title) AND
// #kpNumber (Step 4 keepsake) AND the document.title — no drift.
function _getOrCreateVariationNumber() {
  let n = null;
  try { n = sessionStorage.getItem('tg_variation_no_v2'); } catch (e) { /* private mode */ }
  if (!n) {
    n = String(_generateVariationNumber());
    try { sessionStorage.setItem('tg_variation_no_v2', n); } catch (e) { /* ignore */ }
  }
  return n;
}

// Back-compat shim — earlier rounds inlined a hash-based _compositionNumber()
// for document title + share text. Now delegates to the canonical variation
// helper so every surface stays in lockstep.
function _compositionNumber() {
  return _getOrCreateVariationNumber();
}

function _computeLeadTime() {
  const customCover = !!(state.customCover && (state.customCover.type === 'pantone'
                                            || state.customCover.type === 'upload'));
  const customLegs  = !!state.legsCustom;
  return (customCover || customLegs) ? '5–10 working days' : 'Ships from stock';
}

// Numeric variant of recomputeTotal's math. recomputeTotal writes to the
// DOM; the keepsake just needs the integer to format "€XXX" / "Free".
function _computePriceBreakdown() {
  var t = _computeTotal();
  // Recompute cover vs legs split (mirrors _computeTotal logic)
  var coverCharge = 0;
  var pantoneTotal = 0;
  if (typeof _pantoneCartQty === 'object') { for (var pk in _pantoneCartQty) { if (_pantoneCartQty[pk] > 0) pantoneTotal += _pantoneCartQty[pk]; } }
  if (typeof _moodCartQty === 'object') { for (var mk in _moodCartQty) { if (_moodCartQty[mk] && _moodCartQty[mk].qty > 0) pantoneTotal += _moodCartQty[mk].qty; } }
  if (pantoneTotal > 0) coverCharge += PRICE_COVER_PANTONE * pantoneTotal;
  if (coverCharge === 0 && state.customCover && state.customCover.type === 'pantone') coverCharge += PRICE_COVER_PANTONE;
  if (state.uploadCovers && state.uploadCovers.length > 0) coverCharge += PRICE_COVER_UPLOAD * state.uploadCovers.length;
  else if (state.customCover && state.customCover.type === 'upload') coverCharge += PRICE_COVER_UPLOAD;
  if (typeof _catalogCartQty === 'object' && typeof _matchCatalogResults === 'object') {
    for (var ck in _catalogCartQty) { if (_catalogCartQty[ck] > 0 && _matchCatalogResults[ck]) coverCharge += (_matchCatalogResults[ck].cover.price || 0) * _catalogCartQty[ck]; }
  }
  return { cover: coverCharge, stand: t - coverCharge, total: t };
}

function _computeTotal() {
  // Unified total: sums ALL multi-select covers, uploads, catalog, stands
  var coverCharge = 0;
  // Pantone multi-select (Match + Mood)
  var pantoneTotal = 0;
  if (typeof _pantoneCartQty === 'object') {
    for (var pk in _pantoneCartQty) { if (_pantoneCartQty[pk] > 0) pantoneTotal += _pantoneCartQty[pk]; }
  }
  if (typeof _moodCartQty === 'object') {
    for (var mk in _moodCartQty) { if (_moodCartQty[mk] && _moodCartQty[mk].qty > 0) pantoneTotal += _moodCartQty[mk].qty; }
  }
  if (pantoneTotal > 0) coverCharge += PRICE_COVER_PANTONE * pantoneTotal;
  // Fallback single Pantone (no multi-select active)
  if (coverCharge === 0 && state.customCover && state.customCover.type === 'pantone') {
    coverCharge += PRICE_COVER_PANTONE;
  }
  // Upload covers — check array directly, not state.customCover.type
  // (state.customCover.type may be 'pantone' if user last picked a Pantone)
  if (state.uploadCovers && state.uploadCovers.length > 0) {
    coverCharge += PRICE_COVER_UPLOAD * state.uploadCovers.length;
  } else if (state.customCover && state.customCover.type === 'upload') {
    // Legacy single upload fallback
    coverCharge += PRICE_COVER_UPLOAD;
  }
  // Catalog covers
  if (typeof _catalogCartQty === 'object' && typeof _matchCatalogResults === 'object') {
    for (var ck in _catalogCartQty) {
      if (_catalogCartQty[ck] > 0 && _matchCatalogResults[ck]) {
        coverCharge += (_matchCatalogResults[ck].cover.price || 0) * _catalogCartQty[ck];
      }
    }
  }
  // Legs: stock multi-select
  var legsCharge = 0;
  if (typeof _standCartQty === 'object') {
    for (var slk in _standCartQty) {
      if (_standCartQty[slk] && _standCartQty[slk].qty > 0) {
        legsCharge += _standCartQty[slk].price * _standCartQty[slk].qty;
      }
    }
  }
  // Legs: mood + match Pantone multi-select
  var standCustomTotal = 0;
  if (typeof _standMoodCartQty === 'object') {
    for (var smk in _standMoodCartQty) { if (_standMoodCartQty[smk] && _standMoodCartQty[smk].qty > 0) standCustomTotal += _standMoodCartQty[smk].qty; }
  }
  if (typeof _standMatchCartQty === 'object') {
    for (var smtk in _standMatchCartQty) { if (_standMatchCartQty[smtk] > 0) standCustomTotal += _standMatchCartQty[smtk]; }
  }
  if (standCustomTotal > 0) {
    legsCharge += PRICE_LEGS_CUSTOM * standCustomTotal;
  } else if (legsCharge === 0 && state.legsCustom) {
    legsCharge += PRICE_LEGS_CUSTOM;
  }
  return coverCharge + legsCharge;
}

/* =====================================================================
   Phase 4.34 SECTION 2 — HELPERS: spec-card line variations
   ===================================================================== */
// Each variation reads `state` and returns a single string. Falls back
// gracefully to an em-dash when a slot is empty so the keepsake never
// renders the literal "undefined".
function _composeCoverLine() {
  // Phase 6.3 — Unified cover summary line with Pantone quantities
  var uplCount = (state.uploadCovers && state.uploadCovers.length) || 0;
  var collCount = 0;
  if (typeof _catalogCartQty === 'object') {
    for (var ck in _catalogCartQty) { if (_catalogCartQty[ck] > 0) collCount += _catalogCartQty[ck]; }
  }
  var pantCount = 0;
  if (typeof _pantoneCartQty === 'object') {
    for (var pk in _pantoneCartQty) { if (_pantoneCartQty[pk] > 0) pantCount += _pantoneCartQty[pk]; }
  }
  var moodCount = 0;
  if (typeof _moodCartQty === 'object') {
    for (var mk in _moodCartQty) { if (_moodCartQty[mk] && _moodCartQty[mk].qty > 0) moodCount += _moodCartQty[mk].qty; }
  }
  var totalCovers = uplCount + collCount + pantCount + moodCount;

  if (totalCovers > 1) {
    return totalCovers + ' Speaker Covers · Printed Fabric';
  }
  if (pantCount === 1) {
    // Single Pantone — show name
    for (var pi in _pantoneCartQty) {
      if (_pantoneCartQty[pi] > 0) {
        var rec = MATCH_RECOMMENDATIONS[parseInt(pi, 10)];
        return (rec ? rec.name : 'Custom') + ' · Printed Fabric';
      }
    }
  }
  var cc = state.customCover;
  if (cc && cc.type === 'pantone') {
    return (cc.name || 'Custom') + ' · Printed Fabric';
  }
  if (cc && cc.type === 'upload') {
    if (uplCount > 1) return uplCount + ' Speaker Covers · Printed Fabric';
    return 'Custom Upload · Printed Fabric';
  }
  if (collCount > 0) {
    return collCount + (collCount === 1 ? ' Cover' : ' Covers') + ' · Collection';
  }
  return (state.cover || '—') + ' · Bang & Olufsen';
}

/* =====================================================================
   Phase 4.40 — Composition Name Lexicon. Auto-generates two-word
   evocative names (e.g. "Amber Dunes", "Glacier Blade") from the
   customer's choices. [Atmosphere] (driven by Pantone style / preset /
   filter) + [Element] (driven by legs material). Deterministic on the
   variation No. seed → same config always produces the same name across
   sessions. Customer can override inline; the override is held in
   state.compositionName until the underlying composition changes.
   ===================================================================== */
const COMPOSITION_LEXICON = {
  atmosphere: {
    NORDIC:  ['Frost','Arctic','Hygge','Solstice','Fjord','Aurora','Glacier','Haze','Birch','Still','Drift','Mist','Pearl','Ether','Whisper','Chalk','Linen','Cloud','Porcelain','Breeze'],
    EARTHY:  ['Amber','Sienna','Terra','Dune','Clay','Ember','Savanna','Ochre','Spice','Canyon','Rust','Desert','Saffron','Copper','Harvest','Umber','Cinnamon','Brick','Sandstone','Terracotta'],
    JAPANDI: ['Wabi','Kintsugi','Zen','Matcha','Tatami','Sumi','Ryō','Fuji','Shibui','Kaze','Muji','Tsubaki','Kumo','Shizuka','Nara','Hinoki','Bamboo','Lichen','Moss','Sage'],
    STONE:   ['Basalt','Obsidian','Slate','Graphite','Flint','Granite','Cobalt','Tempest','Iron','Charcoal','Shadow','Eclipse','Anvil','Onyx','Carbon','Dusk','Mineral','Quarry','Tide','Storm'],
    BOLD:    ['Vivid','Blaze','Signal','Pulse','Neon','Electric','Flame','Solar','Nova','Rebel','Clash','Volt','Radiant','Fierce','Strike','Prism','Riot','Flash','Ignite','Surge'],
    UPLOAD:  ['Beloved','Darling','Snuggle','Adore','Cherish','Wink','Bliss','Joy','Cuddle','Dimple','Frolic','Charm','Muse','Giggle','Treasure','Bloom','Nuzzle','Honeybee','Stardust','Velvet'],
  },
  element: {
    'original':          ['Origin','Foundation','Canvas','Frame','Ground','Base','Core','Root','Stance','Form'],
    'aluminium-chrome':  ['Mirror','Mercury','Sterling','Platinum','Blade','Chrome','Reflect','Glacier','Prism','Silver'],
    'aluminium-amber':   ['Dunes','Nectar','Glow','Aureate','Soleil','Horizon','Gilded','Warmth','Lantern','Halo'],
    'cover-black':       ['Void','Depth','Night','Monolith','Raven','Abyss','Ink','Velvet','Shade','Eclipse'],
    'cover-white':       ['Cloud','Snow','Blanc','Silk','Ivory','Feather','Petal','Frost','Light','Pure'],
    'cover-red':         ['Ember','Crimson','Flame','Mars','Scarlet','Cardinal','Ruby','Blaze','Vermillion','Flare'],
    'cover-colorplay':   ['Spectrum','Kaleid','Mosaic','Fusion','Remix','Shift','Palette','Fragment','Collage','Blend'],
    'upload':            ['Portrait','Story','Keepsake','Memory','Moment','Chapter','Cameo','Imprint','Snapshot','Token'],
  },
  presetBias: {
    'Gold Tone': 'EARTHY', 'Natural Aluminium': 'NORDIC', 'Black': 'STONE',
    'Silver': 'STONE', 'Brass': 'EARTHY', 'Bronze': 'JAPANDI',
  },
  filterBias: {
    'natural': null, 'monochrome': 'STONE', 'heritage': 'EARTHY', 'tonal': 'NORDIC',
  },
};

// Recover the Pantone style for the active customCover, if any. PANTONE_LIBRARY
// entries carry .style ('NORDIC' | 'EARTHY' | …); curated grid + Match-a-Room
// recs both source from there. Search results from full TPG_DATABASE may not.
function _activePantoneStyle() {
  const cc = state.customCover;
  if (!cc || cc.type !== 'pantone') return null;
  if (typeof PANTONE_LIBRARY === 'undefined') return null;
  const target = (cc.code || '').toUpperCase();
  for (const p of PANTONE_LIBRARY) {
    if ((p.pantone || '').toUpperCase() === target || (p.hex || '').toLowerCase() === (cc.hex || '').toLowerCase()) {
      return p.style || null;
    }
  }
  return null;
}

function generateCompositionName(opts) {
  const style    = opts && opts.style;
  const legs     = opts && opts.legs;
  const preset   = opts && opts.preset;
  const filter   = opts && opts.filter;
  const seedRaw  = (opts && opts.seed) || 0;

  let atmosphereKey = style;
  if (!atmosphereKey && filter && COMPOSITION_LEXICON.filterBias[filter]) atmosphereKey = COMPOSITION_LEXICON.filterBias[filter];
  if (!atmosphereKey && preset && COMPOSITION_LEXICON.presetBias[preset]) atmosphereKey = COMPOSITION_LEXICON.presetBias[preset];
  if (!atmosphereKey) atmosphereKey = 'NORDIC';

  const aPool = COMPOSITION_LEXICON.atmosphere[atmosphereKey] || COMPOSITION_LEXICON.atmosphere.NORDIC;
  const ePool = COMPOSITION_LEXICON.element[legs] || COMPOSITION_LEXICON.element.original;

  // Deterministic pick — same config + seed = same name.
  const s = parseInt(seedRaw, 10) || Math.floor(Math.random() * 9999);
  const aIdx = ((s * 7  + 13) % aPool.length + aPool.length) % aPool.length;
  let   eIdx = ((s * 11 + 3)  % ePool.length + ePool.length) % ePool.length;

  const atmosphere = aPool[aIdx];
  let   element    = ePool[eIdx];
  if (atmosphere.toLowerCase() === element.toLowerCase()) {
    eIdx = (eIdx + 1) % ePool.length;
    element = ePool[eIdx];
  }
  return atmosphere + ' ' + element;
}

// Build the signature key for the current composition. Used to invalidate
// state.compositionName when the underlying inputs change — so a customer
// who edits the auto-name, then revises a Pantone or legs choice, sees a
// fresh suggestion instead of a stale custom string.
function _compositionKey() {
  const isUpload = state.customCover && state.customCover.type === 'upload';
  const style  = isUpload ? 'UPLOAD' : (_activePantoneStyle() || (typeof window !== 'undefined' && window._activeStyleTab) || '');
  const legs   = isUpload ? 'upload' : ((state.legsAccessory && state.legsAccessory.id) || state.legs || 'original');
  const preset = state.rim || '';
  var _lastUplF = (state.uploadCovers && state.uploadCovers.length > 0) ? state.uploadCovers[state.uploadCovers.length - 1] : state.coverUpload;
  const filter = (_lastUplF && _lastUplF.filter) || '';
  return [style, legs, preset, filter].join('|');
}

// Phase 4.40 — single source of truth for the keepsake's composition name.
// Returns the customer's saved override if it's still valid for the current
// composition; otherwise auto-generates from the lexicon. Side effect:
// invalidates a stale override (key mismatch).
function _composeCompositionName() {
  const key = _compositionKey();
  if (state.compositionName && state.compositionNameKey === key) {
    return state.compositionName;
  }
  if (state.compositionName && state.compositionNameKey !== key) {
    // Underlying inputs changed → drop the stale custom name.
    state.compositionName = null;
    state.compositionNameKey = null;
  }
  const seed = (typeof _getOrCreateVariationNumber === 'function')
    ? parseInt(_getOrCreateVariationNumber(), 10) || 0
    : 0;
  const isUpload = state.customCover && state.customCover.type === 'upload';
  return generateCompositionName({
    style:  isUpload ? 'UPLOAD' : (_activePantoneStyle() || (typeof window !== 'undefined' && window._activeStyleTab) || null),
    legs:   isUpload ? 'upload' : ((state.legsAccessory && state.legsAccessory.id) || state.legs || 'original'),
    preset: state.rim || null,
    filter: (function(){ var _lu = (state.uploadCovers && state.uploadCovers.length > 0) ? state.uploadCovers[state.uploadCovers.length - 1] : state.coverUpload; return (_lu && _lu.filter) || null; })(),
    seed:   seed,
  });
}

function _composeLegsLine() {
  // Count multi-select stands by material category
  var totalStands = 0;
  var metalCount = 0, fabricCount = 0, pantoneCount = 0;
  if (typeof _standCartQty === 'object') {
    for (var sk in _standCartQty) {
      if (_standCartQty[sk] && _standCartQty[sk].qty > 0) {
        var _clDef = (typeof LEG_MATERIALS !== 'undefined' && LEG_MATERIALS[sk]) || { kind: 'fabric' };
        totalStands += _standCartQty[sk].qty;
        if (_clDef.kind === 'metal') metalCount += _standCartQty[sk].qty;
        else fabricCount += _standCartQty[sk].qty;
      }
    }
  }
  if (typeof _standMoodCartQty === 'object') {
    for (var smk in _standMoodCartQty) { if (_standMoodCartQty[smk] && _standMoodCartQty[smk].qty > 0) { totalStands += _standMoodCartQty[smk].qty; pantoneCount += _standMoodCartQty[smk].qty; } }
  }
  if (typeof _standMatchCartQty === 'object') {
    for (var smtk in _standMatchCartQty) { if (_standMatchCartQty[smtk] > 0) { totalStands += _standMatchCartQty[smtk]; pantoneCount += _standMatchCartQty[smtk]; } }
  }
  if (totalStands > 1) {
    // Build material descriptor from what's actually in the cart
    var parts = [];
    if (metalCount > 0) parts.push('Aluminium');
    if (fabricCount > 0 || pantoneCount > 0) parts.push('Printed Fabric');
    var matDesc = parts.length > 0 ? parts.join(' + ') : 'Custom';
    return totalStands + ' Leg Covers · ' + matDesc;
  }
  // Single stock stand from multi-select
  if (totalStands === 1 && typeof _standCartQty === 'object') {
    for (var ssk in _standCartQty) {
      if (_standCartQty[ssk] && _standCartQty[ssk].qty > 0) {
        var _slDef = (typeof LEG_MATERIALS !== 'undefined' && LEG_MATERIALS[ssk]) || { kind: 'fabric' };
        var matLabel = _slDef.kind === 'metal' ? 'Aluminium' : 'Printed Fabric';
        return (_standCartQty[ssk].name || 'Legs') + ' · ' + matLabel;
      }
    }
  }
  if (totalStands === 1) {
    // Single pantone stand from mood or match
    if (typeof _standMoodCartQty === 'object') {
      for (var smsk in _standMoodCartQty) {
        if (_standMoodCartQty[smsk] && _standMoodCartQty[smsk].qty > 0) {
          return (_standMoodCartQty[smsk].name || 'Pantone') + ' · Printed Fabric';
        }
      }
    }
    if (typeof _standMatchCartQty === 'object') {
      for (var smtsk in _standMatchCartQty) {
        if (_standMatchCartQty[smtsk] > 0) {
          var _smtRec = (typeof STAND_MATCH_RECS !== 'undefined') ? STAND_MATCH_RECS[parseInt(smtsk, 10)] : null;
          return (_smtRec ? _smtRec.name : 'Pantone') + ' · Printed Fabric';
        }
      }
    }
  }
  if (state.legsCustom) {
    const code = state.legsCustom.tpg || '';
    const name = state.legsCustom.name || code || 'Custom';
    return (code ? code + ' · ' : '') + name + ' · all three legs';
  }
  if (state.legsAccessory && state.legsAccessory.name) return state.legsAccessory.name;
  return 'Standard · ' + (state.wood || 'Light Oak');
}

/* =====================================================================
   Phase 4.34 SECTION 3 — RENDER: state → keepsake
   ===================================================================== */
function _renderKeepsake() {
  // Phase 5.0 — Review v2: populate the floating overlay inside
  // .viewport-shell. The legacy #pane-review keepsake card is now
  // display:none, so its #kp* targets aren't queried. The live 3D
  // model IS the hero; no snapshot capture on entry.
  const variationNo = _getOrCreateVariationNumber();
  const numEl = document.getElementById('reviewNumber');
  if (numEl) numEl.textContent = 'No. ' + variationNo;

  const nameEl = document.getElementById('reviewName');
  if (nameEl) {
    // [UX 2026-06-10 #5] Don't impose a random poetic name. The Variation No.
    // in the top-left headline is the real identity; the name is optional. Show
    // the customer's own name if they set one (and it still matches this
    // composition); otherwise show a gentle, tappable "name it" prompt.
    if (state.compositionName && typeof _compositionKey === 'function'
        && state.compositionNameKey !== _compositionKey()) {
      state.compositionName = null; state.compositionNameKey = null;  // composition changed → drop stale name
    }
    if (state.compositionName) {
      nameEl.textContent = state.compositionName;
      nameEl.classList.remove('is-unnamed');
    } else {
      nameEl.textContent = 'My Composition';
      nameEl.classList.add('is-unnamed');
    }
  }

  const spkEl = document.getElementById('reviewSpeaker');
  // Review overlay uses the short preset name (e.g. "Gold Tone") not
  // the full "BeoSound A9 · Warm White Body · Gold Tone Rim" spec line.
  if (spkEl) spkEl.textContent = state.preset || state.rim || 'A9';
  const covEl = document.getElementById('reviewCover');
  // Phase 7 — Show prices inline on spec lines
  var _priceBreak = _computePriceBreakdown();
  if (covEl) {
    var _covText = _composeCoverLine();
    if (_priceBreak.cover > 0) {
      covEl.innerHTML = _covText + '<span class="review-overlay__spec-price">€' + _priceBreak.cover + '</span>';
    } else {
      covEl.textContent = _covText;
    }
  }

  // Phase 6.3 — Unified Covers Gallery (Pantone + uploads + collection)
  const coversGalleryWrap = document.getElementById('reviewCoversGalleryWrap');
  const coversGallery = document.getElementById('reviewCoversGallery');
  if (coversGallery && coversGalleryWrap) {
    var allCovers = []; // { type, src, label, qty, hex, previewUrl, composedDataUrl }

    // 1) Pantone selections
    if (typeof _pantoneCartQty === 'object') {
      for (var pk in _pantoneCartQty) {
        if (_pantoneCartQty[pk] > 0) {
          var prec = MATCH_RECOMMENDATIONS[parseInt(pk, 10)];
          if (prec) {
            allCovers.push({
              type: 'pantone', src: '', hex: prec.hex,
              label: prec.name || 'Custom', qty: _pantoneCartQty[pk]
            });
          }
        }
      }
    }

    // 1b) Mood Pantone selections
    if (typeof _moodCartQty === 'object') {
      for (var mk in _moodCartQty) {
        if (_moodCartQty[mk] && _moodCartQty[mk].qty > 0) {
          allCovers.push({
            type: 'pantone', src: '', hex: _moodCartQty[mk].hex,
            label: _moodCartQty[mk].name || 'Pantone', qty: _moodCartQty[mk].qty
          });
        }
      }
    }

    // 2) Custom uploads
    if (state.uploadCovers && state.uploadCovers.length > 0) {
      for (var gi = 0; gi < state.uploadCovers.length; gi++) {
        var gItem = state.uploadCovers[gi];
        var gSrc = gItem.composedDataUrl || gItem.dataUrl || '';
        allCovers.push({
          type: 'upload', src: gSrc,
          label: gItem.filename ? gItem.filename.replace(/\.[^.]+$/, '').slice(0, 8) : 'Custom',
          qty: 1, composedDataUrl: gItem.composedDataUrl
        });
      }
    }

    // 3) Collection covers from catalog cart
    if (typeof _catalogCartQty === 'object' && typeof _matchCatalogResults === 'object') {
      for (var ck in _catalogCartQty) {
        if (_catalogCartQty[ck] > 0 && _matchCatalogResults[ck]) {
          var cc = _matchCatalogResults[ck].cover;
          allCovers.push({
            type: 'collection', src: cc.preview || cc.img || '',
            label: cc.name || 'Cover', qty: _catalogCartQty[ck],
            previewUrl: cc.preview || cc.img || ''
          });
        }
      }
    }

    if (allCovers.length > 1 || (allCovers.length === 1 && allCovers[0].type !== 'upload')) {
      coversGalleryWrap.hidden = false;
      // Determine which cover is currently active in viewer (state.customCover)
      var initialActiveIdx = -1;
      if (state.customCover) {
        if (state.customCover.type === 'pantone' && state.customCover.hex) {
          for (var fi = 0; fi < allCovers.length; fi++) {
            if (allCovers[fi].type === 'pantone' && allCovers[fi].hex === state.customCover.hex) {
              initialActiveIdx = fi; break;
            }
          }
        } else if (state.customCover.type === 'upload') {
          for (var fj = allCovers.length - 1; fj >= 0; fj--) {
            if (allCovers[fj].type === 'upload') { initialActiveIdx = fj; break; }
          }
        }
      }
      if (initialActiveIdx < 0 && allCovers.length > 0) initialActiveIdx = 0;
      var galHTML = '';
      for (var ai = 0; ai < allCovers.length; ai++) {
        var item = allCovers[ai];
        var qtyBadge = item.qty > 1 ? '<span class="review-covers-gallery__qty"> ×' + item.qty + '</span>' : '';
        var thumbHTML = item.type === 'pantone'
          ? '<span class="review-covers-gallery__thumb" style="background:' + item.hex + '"></span>'
          : '<img class="review-covers-gallery__thumb" src="' + item.src + '" alt="' + item.label + '" />';
        var activeCls = (ai === initialActiveIdx) ? ' is-active' : '';
        galHTML += '<div class="review-covers-gallery__item' + activeCls + '" data-cover-idx="' + ai + '">' +
          thumbHTML +
          '<span class="review-covers-gallery__label">' + item.label + qtyBadge + '</span>' +
          '</div>';
      }
      coversGallery.innerHTML = galHTML;
      // Detect overflow → show fade indicator
      requestAnimationFrame(function() {
        coversGalleryWrap.classList.toggle('has-overflow', coversGallery.scrollWidth > coversGallery.clientWidth);
      });
      // [fix 2026-06-10] Bind the scroll listener once. _renderKeepsake runs on
      // every Reveal entry; without this guard the listener stacked on the
      // persistent gallery container each time (slow leak over a long session).
      if (!coversGallery.dataset.scrollBound) {
        coversGallery.dataset.scrollBound = '1';
        coversGallery.addEventListener('scroll', function() {
          var atEnd = coversGallery.scrollLeft + coversGallery.clientWidth >= coversGallery.scrollWidth - 4;
          coversGalleryWrap.classList.toggle('has-overflow', !atEnd);
        });
      }

      // Bind hover-to-preview + click-to-select
      var _revGalleryLocked = initialActiveIdx; // index of clicked/locked item (-1 = none)
      function _revPreviewCover(cov) {
        if (!cov) return;
        if (cov.type === 'pantone' && cov.hex) {
          a9Bridge.setCustomPantone(cov.hex);
        } else if (cov.type === 'upload' && cov.composedDataUrl) {
          a9Bridge.setCustomUpload(cov.composedDataUrl, true);  // 客户上传(画廊重选)→trim
        } else if (cov.type === 'collection' && cov.previewUrl && typeof _loadPreviewAsDataUrl === 'function') {
          _loadPreviewAsDataUrl(cov.previewUrl, function(dataUrl) {
            if (typeof a9Bridge !== 'undefined' && typeof a9Bridge.setCustomUpload === 'function') {
              a9Bridge.setCustomUpload(dataUrl);
            }
          });
        }
      }
      function _revRestoreDefault() {
        if (state.customCover && state.customCover.type === 'upload' && state.uploadCovers && state.uploadCovers.length > 0) {
          var _lastUpl = state.uploadCovers[state.uploadCovers.length - 1];
          if (_lastUpl && _lastUpl.composedDataUrl) a9Bridge.setCustomUpload(_lastUpl.composedDataUrl, true);  // 上传→trim(原 a9:setCoverImage 死消息,viewer 无 handler)
        } else if (state.customCover && state.customCover.type === 'pantone') {
          if (typeof a9Bridge !== 'undefined' && typeof a9Bridge.setCover === 'function') {
            a9Bridge.setCover(state.customCover.name || 'Soft Sage');
          }
        } else if (allCovers.length > 0 && allCovers[0].type === 'collection' && allCovers[0].previewUrl) {
          _loadPreviewAsDataUrl(allCovers[0].previewUrl, function(dataUrl) {
            if (typeof a9Bridge !== 'undefined' && typeof a9Bridge.setCustomUpload === 'function') {
              a9Bridge.setCustomUpload(dataUrl);
            }
          });
        }
      }
      coversGallery.querySelectorAll('.review-covers-gallery__item').forEach(function(el) {
        el.addEventListener('mouseenter', function() {
          var idx = parseInt(el.dataset.coverIdx, 10);
          _revPreviewCover(allCovers[idx]);
        });
        el.addEventListener('mouseleave', function() {
          // If an item is locked via click, restore to that; otherwise restore default
          if (_revGalleryLocked >= 0) {
            _revPreviewCover(allCovers[_revGalleryLocked]);
          } else {
            _revRestoreDefault();
          }
        });
        el.addEventListener('click', function() {
          var idx = parseInt(el.dataset.coverIdx, 10);
          // Toggle: click same item again to deselect
          if (_revGalleryLocked === idx) {
            _revGalleryLocked = -1;
            el.classList.remove('is-active');
            _revRestoreDefault();
          } else {
            _revGalleryLocked = idx;
            // Clear all active, set this one
            coversGallery.querySelectorAll('.review-covers-gallery__item').forEach(function(e) { e.classList.remove('is-active'); });
            el.classList.add('is-active');
            _revPreviewCover(allCovers[idx]);
            if (typeof showViewportToast === 'function') showViewportToast(allCovers[idx].hex, allCovers[idx].label);
          }
        });
      });

      // Bugfix — push the active cover to the 3D viewer on Reveal entry.
      // The gallery is built and the active item highlighted, but _revPreviewCover
      // was only wired to hover/click — so a selected catalog/collection (or
      // pantone) cover never previewed on the last page until the user hovered a
      // swatch. Apply the locked/active cover once on render so the chosen design
      // shows immediately.
      if (_revGalleryLocked >= 0 && allCovers[_revGalleryLocked]) {
        _revPreviewCover(allCovers[_revGalleryLocked]);
      }
    } else {
      coversGalleryWrap.hidden = true;
      coversGallery.innerHTML = '';
    }
  }

  const legEl = document.getElementById('reviewLegs');
  if (legEl) {
    var _legText = _composeLegsLine();
    if (_priceBreak.stand > 0) {
      legEl.innerHTML = _legText + '<span class="review-overlay__spec-price">€' + _priceBreak.stand + '</span>';
    } else {
      legEl.textContent = _legText;
    }
  }

  // Phase 6.4 — Stand gallery (multi-select metal/fabric stands)
  const standsGalleryWrap = document.getElementById('reviewStandsGalleryWrap');
  const standsGallery = document.getElementById('reviewStandsGallery');
  if (standsGallery && standsGalleryWrap) {
    var allStands = [];
    if (typeof _standCartQty === 'object') {
      for (var stk in _standCartQty) {
        if (_standCartQty[stk] && _standCartQty[stk].qty > 0) {
          var _stkDef = (typeof LEG_MATERIALS !== 'undefined' && LEG_MATERIALS[stk]) || { kind: 'fabric' };
          allStands.push({
            type: 'stand', hex: _standCartQty[stk].hex || null,
            gradient: _standCartQty[stk].gradient || null,
            legsId: stk, kind: _stkDef.kind,
            label: _standCartQty[stk].name || 'Legs', qty: _standCartQty[stk].qty
          });
        }
      }
    }
    // Stand mood multi-select
    if (typeof _standMoodCartQty === 'object') {
      for (var smrk in _standMoodCartQty) {
        if (_standMoodCartQty[smrk] && _standMoodCartQty[smrk].qty > 0) {
          allStands.push({
            type: 'stand-mood', hex: _standMoodCartQty[smrk].hex || null,
            label: _standMoodCartQty[smrk].name || 'Pantone', qty: _standMoodCartQty[smrk].qty
          });
        }
      }
    }
    // Stand match multi-select
    if (typeof _standMatchCartQty === 'object') {
      for (var smtrk in _standMatchCartQty) {
        if (_standMatchCartQty[smtrk] > 0) {
          var smtRec = STAND_MATCH_RECS[parseInt(smtrk, 10)];
          if (smtRec) {
            allStands.push({
              type: 'stand-match', hex: smtRec.hex || null,
              label: smtRec.name || 'Pantone', qty: _standMatchCartQty[smtrk]
            });
          }
        }
      }
    }
    // Fallback single custom legs
    var _hasSmGal = false;
    var _hasSmtGal = false;
    for (var _sgk in _standMoodCartQty) { if (_standMoodCartQty[_sgk] && _standMoodCartQty[_sgk].qty > 0) { _hasSmGal = true; break; } }
    for (var _sgtk in _standMatchCartQty) { if (_standMatchCartQty[_sgtk] > 0) { _hasSmtGal = true; break; } }
    if (!_hasSmGal && !_hasSmtGal && state.legsCustom && state.legsCustom.name) {
      allStands.push({
        type: 'stand-custom', hex: state.legsCustom.hex || null,
        label: state.legsCustom.name, qty: 1
      });
    }
    if (allStands.length > 0) {
      standsGalleryWrap.hidden = false;
      // Determine which stand is currently active on the 3D model
      var initialStandIdx = -1;
      if (state.legsCustom && state.legsCustom.hex) {
        for (var sfi = 0; sfi < allStands.length; sfi++) {
          if (allStands[sfi].hex === state.legsCustom.hex) { initialStandIdx = sfi; break; }
        }
      } else if (state.legs) {
        for (var sfj = 0; sfj < allStands.length; sfj++) {
          if (allStands[sfj].type === 'stand' && allStands[sfj].legsId === state.legs) {
            initialStandIdx = sfj; break;
          }
        }
      }
      if (initialStandIdx < 0 && allStands.length > 0) initialStandIdx = 0;
      var sgHTML = '';
      for (var sti = 0; sti < allStands.length; sti++) {
        var stItem = allStands[sti];
        var stQty = stItem.qty > 1 ? '<span class="review-covers-gallery__qty"> ×' + stItem.qty + '</span>' : '';
        var stThumb = stItem.gradient
          ? '<span class="review-covers-gallery__thumb" style="background:' + stItem.gradient + '"></span>'
          : (stItem.hex
            ? '<span class="review-covers-gallery__thumb" style="background:' + stItem.hex + '"></span>'
            : '<span class="review-covers-gallery__thumb" style="background:#888"></span>');
        var stActiveCls = (sti === initialStandIdx) ? ' is-active' : '';
        sgHTML += '<div class="review-covers-gallery__item' + stActiveCls + '" data-stand-idx="' + sti + '">' + stThumb +
          '<span class="review-covers-gallery__label">' + stItem.label + stQty + '</span></div>';
      }
      standsGallery.innerHTML = sgHTML;
      requestAnimationFrame(function() {
        standsGalleryWrap.classList.toggle('has-overflow', standsGallery.scrollWidth > standsGallery.clientWidth);
      });
      // [fix 2026-06-10] Bind scroll listener once (see covers gallery note above).
      if (!standsGallery.dataset.scrollBound) {
        standsGallery.dataset.scrollBound = '1';
        standsGallery.addEventListener('scroll', function() {
          var atEnd = standsGallery.scrollLeft + standsGallery.clientWidth >= standsGallery.scrollWidth - 4;
          standsGalleryWrap.classList.toggle('has-overflow', !atEnd);
        });
      }
      // Bind hover + click preview for stands
      var _revStandLocked = initialStandIdx;
      // Helper: preview a stand on 3D model
      function _revPreviewStand(st) {
        if (!st || typeof a9Bridge === 'undefined') return;
        // Stock stands (metal/wood/fabric with legsId) → a9:setStand
        if (st.legsId && st.type === 'stand') {
          var mat = (typeof LEG_MATERIALS !== 'undefined' && LEG_MATERIALS[st.legsId]) || { kind: 'fabric' };
          a9Bridge.send({ type: 'a9:setStand', stand: st.legsId, material: mat });
        } else if (st.hex && typeof a9Bridge.setLegsCustom === 'function') {
          // Pantone custom stands (mood/match)
          a9Bridge.setLegsCustom({ hex: st.hex, mode: 'pantone' });
        }
      }
      standsGallery.querySelectorAll('.review-covers-gallery__item').forEach(function(el) {
        el.addEventListener('mouseenter', function() {
          var idx = parseInt(el.dataset.standIdx, 10);
          _revPreviewStand(allStands[idx]);
        });
        el.addEventListener('mouseleave', function() {
          if (_revStandLocked >= 0) {
            _revPreviewStand(allStands[_revStandLocked]);
          }
        });
        el.addEventListener('click', function() {
          var idx = parseInt(el.dataset.standIdx, 10);
          if (_revStandLocked === idx) {
            _revStandLocked = -1;
            el.classList.remove('is-active');
          } else {
            _revStandLocked = idx;
            standsGallery.querySelectorAll('.review-covers-gallery__item').forEach(function(e) { e.classList.remove('is-active'); });
            el.classList.add('is-active');
            _revPreviewStand(allStands[idx]);
            if (typeof showViewportToast === 'function') showViewportToast(allStands[idx].hex, allStands[idx].label);
          }
        });
      });
    } else {
      standsGalleryWrap.hidden = true;
      standsGallery.innerHTML = '';
      // BUG FIX 2026-06-06: nothing committed for legs → reset the 3D model to
      // the default wood legs. Tapping a leg swatch on Step 3 PREVIEWS a colour
      // on the viewer without committing it; without this reset the reveal page
      // kept showing that stale preview while the spec card correctly read
      // "Standard · <wood>". Reveal must mirror the cart, not the preview.
      if (typeof a9Bridge !== 'undefined') {
        try {
          a9Bridge.send({ type: 'a9:setStand', stand: 'original',
            material: (typeof LEG_MATERIALS !== 'undefined' && LEG_MATERIALS['original']) || { kind: 'wood' } });
          a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
        } catch (e) { console.warn('[reveal] legs reset failed:', e); }
      }
    }
  }

  // Phase 6.0 — Price shown separately; CTA is always "Add to Cart" or
  // "Compose yours now" (when nothing customised yet).
  const total = _computeTotal();
  const orderBtn = document.getElementById('reviewOrder');
  if (orderBtn) {
    if (total === 0) {
      orderBtn.innerHTML = 'Compose yours now';
      orderBtn.dataset.action = 'compose';
    } else {
      orderBtn.innerHTML = 'Add to Cart — €' + total.toLocaleString('en-IE');
      orderBtn.dataset.action = 'order';
    }
  }

  // Trust signal lead time — dynamic based on customisation
  const lt = _computeLeadTime();
  const trustLeadEl = document.getElementById('kpTrustLeadTime');
  if (trustLeadEl) {
    trustLeadEl.textContent = lt === 'Ships from stock'
      ? 'Ships from stock — typically 2–3 working days.'
      : 'Made to order in 5–10 working days.';
  }
  const reviewTrustLead = document.getElementById('reviewTrustLeadTime');
  if (reviewTrustLead) {
    reviewTrustLead.textContent = lt === 'Ships from stock' ? 'Ships from stock' : 'Made to order';
  }

  // Camera: cover (dead-front) at default zoom — product-photo composition.
  // Phase 5.2 timing: iframe frozen 0–550 ms, snaps to 100% at 550 ms,
  // canvas settles for ~150 ms, camera tween fires at 700 ms.
  setTimeout(() => {
    if (a9Bridge && typeof a9Bridge.setView === 'function') a9Bridge.setView('cover', false);
    if (a9Bridge && typeof a9Bridge.setZoom === 'function') a9Bridge.setZoom(false);
  }, 700);

  // (Removed: auto-toast on review page entry — was showing "3 Covers" etc.
  //  Colour preview is now triggered only by tapping individual swatches.)
}
window._renderKeepsake = _renderKeepsake;

// Phase 4.38 — capture the live composition into the keepsake hero. Forces
// the iframe camera to a clean dead-front speaker framing first so the
// snapshot reads like a product photograph regardless of where the user
// left the camera mid-composition. Each Step 4 entry re-captures so changes
// flow through. Caller must not await — keepsake text content paints first.
async function _captureKeepsakeStage() {
  const stage = document.getElementById('kpStage');
  if (!stage) return;
  try {
    // Existing setView API: ('speaker' | 'cover' | 'legs', zoomed: boolean).
    // Phase 4.41 — reverted from Phase 4.39's dead-front 'cover' to
    // 'speaker' (3/4 angle, ~37° azimuth). Product-photography standard:
    // more dimensional than dead-on, reads as a curated shot rather than
    // a flat catalogue thumbnail.
    // Phase 5.x — Yang reverted back to 'cover' for product-photo dead-front
    // composition. Trade-off: cover view has slight residual ellipse (~6%)
    // due to 10° tilt approximation in app.js, acceptable to Yang per ref image.
    a9Bridge.setView('cover', false);
    a9Bridge.setZoom(false);
    // Camera tween takes 600 ms (CAMERA_VIEW_DURATION in app.js).
    // Wait 700 ms so the tween fully completes and the final frame
    // renders before we capture. A single rAF (~16 ms) was far too
    // early — the snapshot would fire mid-tween, catching whatever
    // random angle the user left the camera at.
    await new Promise((r) => setTimeout(r, 700));
    const dataUrl = await a9Bridge.captureSnapshot();
    // Replace the placeholder gradient with the actual snapshot. The
    // .kp-snapshot CSS handles object-fit + the 280 ms fade-in.
    stage.innerHTML = '<img class="kp-snapshot" alt="" src="' + dataUrl + '" />';
  } catch (err) {
    console.warn('[keepsake] snapshot failed; keeping placeholder:', err);
    // No re-throw — keepsake render must continue. Placeholder gradient
    // remains visible as the fallback.
  }
}

// Backward-compat shim — anything that still calls renderReview() routes
// through the new keepsake renderer.
function renderReview() { _renderKeepsake(); }

/* =====================================================================
   Phase 4.34 SECTION 3 — keepsake bindings (back link, order CTA stub)
   ===================================================================== */
function bindKeepsakeBack() {
  const back = document.getElementById('kpBack');
  if (!back) return;
  back.addEventListener('click', (e) => {
    e.preventDefault();
    // Return to Step 3 (legs) — the last interactive step before the keepsake.
    // goToStep is exposed on window from inside bootConfigurator.
    if (typeof window.goToStep === 'function') window.goToStep(3);
  });
}

/* Phase 5.0 — Review v2 overlay bindings. Mirrors the keepsake binders
   above but targets the new #review* IDs inside .viewport-shell. The
   old #kp* binders stay alive (they're harmless no-ops since their
   targets are inside the now display:none #pane-review). */
function bindReviewOverlay() {
  // Back: route to Step 3 (last interactive step). goToStep is exposed
  // on window from inside bootConfigurator.
  const backGroup = document.getElementById('reviewBackGroup');
  if (backGroup) {
    backGroup.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof window.goToStep === 'function') window.goToStep(3);
    });
  }

  // Order CTA: dataset.action drives behaviour (set in _renderKeepsake).
  // 'compose' → jump to Step 2 (Cover) so the customer can start
  // customising; 'order' → Phase 5 Shopify checkout via tgCart.
  const order = document.getElementById('reviewOrder');
  if (order) {
    order.addEventListener('click', async () => {
      if (order.dataset.action === 'compose') {
        // [fix 2026-06-10] Route to Step 2 (Cover) via the canonical navigator.
        // The old selector .step[data-step="2"] was retired in Phase 5.1 → it
        // matched nothing, so "Compose yours now" fell through to checkout with
        // an empty cart. goToStep is the single source of truth for navigation.
        if (typeof window.goToStep === 'function') { window.goToStep(2); return; }
      }
      // Phase 5: sync all current selections to Shopify cart, then checkout.
      // PR-A: _syncAllToShopifyCart ships config + original + preview per
      // upload cover to Aliyun OSS (small files, a few seconds). The PSD
      // is generated server-side by tegrino-worker post-checkout, so the
      // customer is sent straight to Shopify checkout without a wait.
      try {
        order.disabled = true;
        order.textContent = 'Preparing…';
        await _syncAllToShopifyCart();
        // Item-level failures (e.g. a single unavailable cover) no longer abort
        // the whole checkout — they're collected here. Tell the customer exactly
        // which selection(s) couldn't be added and why, then proceed with the rest.
        const _fails = tgCart.getFailures();
        if (_fails.length) {
          const _lines = _fails.map(function (f) { return '• ' + f.label + (f.reason ? '：' + f.reason : ''); }).join('\n');
          if (tgCart.getItems().length > 0) {
            const _go = window.confirm('Some selections couldn’t be added and will be skipped:\n\n' + _lines + '\n\nContinue to checkout with the rest?');
            if (!_go) { order.disabled = false; order.textContent = 'Place Order'; return; }
          } else {
            throw new Error('Nothing could be added to the cart:\n\n' + _lines);
          }
        }
        tgCart.checkout();
      } catch (e) {
        console.error('[tgCart] checkout error:', e);
        order.disabled = false;
        order.textContent = 'Place Order';
        try {
          alert('Could not prepare your design files for checkout. Please try again.\n\nDetails: ' + (e && e.message ? e.message : e));
        } catch (_) {}
      }
    });
  }

  // Download: capture the live 3D scene on demand and trigger a PNG
  // download. _captureKeepsakeStage() is no longer auto-called by
  // _renderKeepsake; the snapshot pipeline lives here exclusively now.
  const dl = document.getElementById('reviewDownload');
  if (dl) {
    dl.addEventListener('click', async () => {
      try {
        // Re-frame to the canonical pose first so the saved PNG matches
        // what the customer sees on the keepsake page.
        if (a9Bridge && typeof a9Bridge.setView === 'function') a9Bridge.setView('cover', false);
        if (a9Bridge && typeof a9Bridge.setZoom === 'function') a9Bridge.setZoom(false);
        await new Promise((r) => requestAnimationFrame(r));
        const dataUrl = await a9Bridge.captureSnapshot();
        const rawName = (typeof _composeCompositionName === 'function')
          ? _composeCompositionName()
          : (state.compositionName || 'composition');
        const slug = String(rawName).replace(/\s+/g, '-').toLowerCase().replace(/[^a-z0-9-]/g, '');
        const num = _getOrCreateVariationNumber();
        const filename = 'tegrino-' + (slug || 'composition') + '-no' + num + '.png';
        const a = document.createElement('a');
        a.href = dataUrl;
        a.download = filename;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
      } catch (err) {
        console.warn('[review] download failed:', err);
      }
    });
  }

  // Share: build URL from state → Web Share API or clipboard fallback.
  const share = document.getElementById('reviewShare');
  if (share) {
    share.addEventListener('click', async () => {
      const name = (typeof _composeCompositionName === 'function')
        ? _composeCompositionName()
        : (state.compositionName || 'My Composition');
      const num = _getOrCreateVariationNumber();
      const shareUrl = (typeof window._buildShareUrl === 'function')
        ? window._buildShareUrl(true)
        : window.location.href;

      if (typeof showViewportToast === 'function') showViewportToast(null, 'Generating share card…', '');

      try {
        const cardBlob = await _generateShareCard({
          name: name,
          num: num,
          url: shareUrl,
          speaker: state.preset || state.rim || 'A9',
          cover: (typeof _composeCoverLine === 'function') ? _composeCoverLine() : 'Cover',
          legs: (typeof _composeLegsLine === 'function') ? _composeLegsLine() : 'Legs'
        });

        const cardFile = new File([cardBlob], name.replace(/[^a-zA-Z0-9]/g, '-') + '.png', { type: 'image/png' });

        if (navigator.share && navigator.canShare && navigator.canShare({ files: [cardFile] })) {
          await navigator.share({
            title: name + ' · No. ' + num,
            text: '"' + name + '" — Composed at Tegrino Studio.',
            files: [cardFile]
          });
        } else {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(cardBlob);
          a.download = cardFile.name;
          a.click();
          URL.revokeObjectURL(a.href);
          if (typeof showViewportToast === 'function') showViewportToast(null, 'Card saved', '');
        }
      } catch (err) {
        if (err && err.name !== 'AbortError') {
          try { await navigator.clipboard.writeText(shareUrl); } catch (e2) {}
          if (typeof showViewportToast === 'function') showViewportToast(null, 'Link copied', '');
          console.warn('[share card]', err);
        }
      }
    });
  }

  async function _generateShareCard(opts) {
    var W = 1080, H = 1350;
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var ctx = c.getContext('2d');

    await document.fonts.ready;

    var fontSans = '"GT America", "Helvetica Neue", sans-serif';
    var fontCond = '"GT America Condensed", "Helvetica Neue", sans-serif';
    var fontEditorial = '"GT Super Display", Georgia, serif';
    var PAD = 80;

    ctx.fillStyle = '#F5F2ED';
    ctx.fillRect(0, 0, W, H);

    ctx.fillStyle = '#191817';
    ctx.font = '700 26px ' + fontSans;
    ctx.letterSpacing = '5.2px';
    ctx.fillText('TEGRINO', PAD, 68);
    var tw = ctx.measureText('TEGRINO').width;
    ctx.font = '400 26px ' + fontSans;
    ctx.fillText('STUDIO', PAD + tw + 8, 68);
    ctx.letterSpacing = '0px';

    var renderImg = null;
    try {
      a9Bridge.setView('speaker', false);
      await new Promise(function(r) { setTimeout(r, 800); });
      var dataUrl = await a9Bridge.captureSnapshot();
      renderImg = await _loadImg(dataUrl);
    } catch (e) { console.warn('[share] capture failed:', e); }

    var renderY = 100, renderH = 780;
    if (renderImg) {
      var aspect = renderImg.width / renderImg.height;
      var drawW = Math.min(W - PAD, renderH * aspect);
      var drawH = drawW / aspect;
      var drawX = (W - drawW) / 2;
      var drawY = renderY + (renderH - drawH) / 2;
      ctx.drawImage(renderImg, drawX, drawY, drawW, drawH);
    }

    var textY = renderY + renderH + 20;

    ctx.fillStyle = '#191817';
    ctx.font = 'italic 64px ' + fontEditorial;
    ctx.fillText(opts.name, PAD, textY);
    textY += 14;

    ctx.strokeStyle = '#E5E5E5';
    ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(PAD, textY); ctx.lineTo(W - PAD, textY); ctx.stroke();
    textY += 36;

    ctx.fillStyle = '#555555';
    ctx.font = '500 20px ' + fontCond;
    ctx.letterSpacing = '3px';
    ctx.fillText('VARIATION NO. ' + opts.num, PAD, textY);
    ctx.letterSpacing = '0px';
    textY += 36;

    var specLine = opts.speaker + '  ·  ' + opts.cover + '  ·  ' + opts.legs;
    ctx.fillStyle = '#555555';
    ctx.font = '400 24px ' + fontSans;
    ctx.fillText(specLine, PAD, textY);

    var qrSize = 100;
    var qrX = W - PAD - qrSize;
    var qrY = H - PAD - qrSize;

    ctx.fillStyle = '#555555';
    ctx.font = '500 18px ' + fontCond;
    ctx.letterSpacing = '2.7px';
    ctx.fillText('VARIATION.TEGRINO.CO', PAD, qrY + qrSize - 4);
    ctx.letterSpacing = '0px';

    try {
      var qrUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&margin=0&format=png&data=' + encodeURIComponent(opts.url);
      var qrImg = await _loadImg(qrUrl);
      ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);
    } catch (e) { console.warn('[share] QR failed:', e); }

    return new Promise(function(resolve) { c.toBlob(resolve, 'image/png'); });
  }

  function _loadImg(src) {
    return new Promise(function(resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function _wrapText(ctx, text, maxW) {
    var words = text.split(/\s+/);
    var lines = []; var line = '';
    words.forEach(function(w) {
      var test = line ? line + ' ' + w : w;
      if (ctx.measureText(test).width > maxW && line) {
        lines.push(line); line = w;
      } else { line = test; }
    });
    if (line) lines.push(line);
    return lines;
  }

  function _roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y); ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r); ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h); ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r); ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  }

  // Inline name edit: pencil click → input + auto-select; Enter saves,
  // Esc cancels, blur saves. Pairs with the .review-overlay__name-row
  // hover rule (pencil opacity 0 → 1) for a quiet affordance.
  const nameEl   = document.getElementById('reviewName');
  const editBtn  = document.getElementById('reviewNameEdit');
  const nameInput = document.getElementById('reviewNameInput');
  if (nameEl && editBtn && nameInput) {
    const startEdit = () => {
      // [UX #5] Prefill with the customer's saved name (or empty) — never the
      // "Name your composition" prompt text.
      nameInput.value = state.compositionName || '';
      nameEl.hidden = true;
      editBtn.hidden = true;
      nameInput.hidden = false;
      nameInput.focus();
      try { nameInput.select(); } catch (e) { /* ignore */ }
    };
    const saveEdit = () => {
      const v = nameInput.value.trim();
      if (v) {
        nameEl.textContent = v;
        nameEl.classList.remove('is-unnamed');
        state.compositionName = v;
        if (typeof _compositionKey === 'function') {
          state.compositionNameKey = _compositionKey();
        }
      }
      nameInput.hidden = true;
      nameEl.hidden = false;
      editBtn.hidden = false;
    };
    editBtn.addEventListener('click', startEdit);
    // [UX #5] Single click on the name (or the prompt) opens the editor on all
    // devices — naming is opt-in and should feel one-tap easy.
    nameEl.addEventListener('click', startEdit);
    nameInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); saveEdit(); }
      else if (e.key === 'Escape') {
        e.preventDefault();
        nameInput.hidden = true;
        nameEl.hidden = false;
        editBtn.hidden = false;
      }
    });
    nameInput.addEventListener('blur', saveEdit);
  }

  // AR: proxy click to the existing arTrigger handler.
  const reviewAR = document.getElementById('reviewAR');
  const arTrigger = document.getElementById('arTrigger');
  if (reviewAR && arTrigger) {
    reviewAR.addEventListener('click', () => arTrigger.click());
  }

  // Rotation toggle removed (v9 cleanup).

}

function bindKeepsakeOrder() {
  const order = document.getElementById('kpOrder');
  if (!order) return;
  order.addEventListener('click', () => {
    // Phase 4.42 — when no customisation has been made yet, the CTA reads
    // "Compose yours now" and routes back to Step 2 (Cover) so the
    // customer can start composing instead of being shown a "Free" cart.
    if (order.dataset.action === 'compose') {
      // [fix 2026-06-10] Route via canonical navigator (old .step selector retired).
      if (typeof window.goToStep === 'function') { window.goToStep(2); return; }
    }
    // Phase 5 will replace this with proper Shopify multi-add cart routing.
    let v = '';
    try { v = sessionStorage.getItem('tg_variation_no_v2') || ''; } catch (e) { /* ignore */ }
    alert('Checkout routing will be wired in Phase 5. Variation No. ' + v + ' captured.');
  });
}

// Phase 4.41 — Download keepsake. Reuses the dataUrl already painted into
// #kpStage's <img class="kp-snapshot"> on entry to Step 4; falls back to
// re-capturing on demand if the user clicks before _captureKeepsakeStage
// resolved (rare but possible on slow first paint). Filename includes the
// composition name + variation No. so files self-identify on disk.
function bindKeepsakeDownload() {
  const btn = document.getElementById('kpDownload');
  if (!btn) return;
  btn.addEventListener('click', async () => {
    try {
      const img = document.querySelector('#kpStage .kp-snapshot');
      let dataUrl;
      if (img && img.src && img.src.indexOf('data:') === 0) {
        dataUrl = img.src;
      } else {
        // Snapshot not ready yet — re-frame and capture on demand.
        a9Bridge.setView('cover', false);
        a9Bridge.setZoom(false);
        await new Promise((r) => requestAnimationFrame(r));
        dataUrl = await a9Bridge.captureSnapshot();
      }
      const rawName = (typeof _composeCompositionName === 'function')
        ? _composeCompositionName()
        : (state.compositionName || 'composition');
      const slug = String(rawName).replace(/\s+/g, '-').toLowerCase().replace(/[^a-z0-9-]/g, '');
      const num = (typeof _getOrCreateVariationNumber === 'function') ? _getOrCreateVariationNumber() : '';
      const filename = 'tegrino-' + (slug || 'composition') + '-no' + num + '.png';
      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.warn('[keepsake] download failed:', err);
    }
  });
}

// Phase 4.41 — Share composition. Web Share API on supported browsers
// (mobile Safari + Chrome, desktop Safari, recent Chromium); falls back
// to clipboard copy + toast on others. Tries to attach the snapshot as
// a File when navigator.canShare({ files }) returns true.
function bindKeepsakeShare() {
  const btn = document.getElementById('kpShare');
  if (!btn) return;
  btn.addEventListener('click', async () => {
    const name = (typeof _composeCompositionName === 'function')
      ? _composeCompositionName()
      : (state.compositionName || 'My Composition');
    const num = (typeof _getOrCreateVariationNumber === 'function') ? _getOrCreateVariationNumber() : '';
    const shareUrl = (typeof window._buildShareUrl === 'function')
      ? window._buildShareUrl(true)
      : window.location.href;
    const text = '"' + name + '" — Variation No. ' + num + '. Composed at Tegrino Studio Munich.';
    try {
      if (navigator.share) {
        const shareData = { title: name + ' · No. ' + num, text: text, url: shareUrl };
        const img = document.querySelector('#kpStage .kp-snapshot');
        if (img && img.src && img.src.indexOf('data:') === 0 && navigator.canShare) {
          try {
            const res = await fetch(img.src);
            const blob = await res.blob();
            const file = new File([blob], 'tegrino-composition-' + num + '.png', { type: 'image/png' });
            const withFile = Object.assign({}, shareData, { files: [file] });
            if (navigator.canShare(withFile)) {
              await navigator.share(withFile);
              return;
            }
          } catch (e) { /* fall through to text-only share */ }
        }
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(shareUrl);
        _showShareToast();
      }
    } catch (err) {
      // AbortError fires when the user dismisses the share sheet — not a real failure.
      if (err && err.name !== 'AbortError') {
        console.warn('[keepsake] share failed:', err);
        try {
          await navigator.clipboard.writeText('"' + name + '" — Variation No. ' + num + ' · Tegrino Studio Munich · Bang & Olufsen BeoSound A9');
          _showShareToast();
        } catch (e) { /* clipboard unavailable too — give up silently */ }
      }
    }
  });
}

// Minimal toast for clipboard-fallback share. Single-instance: any prior
// toast is removed before showing a new one. Auto-dismisses after 2.2 s.
function _showShareToast() {
  const existing = document.querySelector('.kp-toast');
  if (existing) existing.remove();
  const toast = document.createElement('div');
  toast.className = 'kp-toast';
  toast.textContent = 'Copied to clipboard';
  document.body.appendChild(toast);
  setTimeout(() => { toast.classList.add('kp-toast--visible'); }, 10);
  setTimeout(() => {
    toast.classList.remove('kp-toast--visible');
    setTimeout(() => toast.remove(), 300);
  }, 2200);
}

// Phase 4.40 — inline edit for the composition name. Pencil + click-name
// → editing mode (input populated, focused, text selected). Enter or
// click ✓ → save (validates non-empty, snapshots key, updates display).
// Esc → cancel without saving. Once-only listener wiring; the binder is
// idempotent against the elements existing.
function bindKeepsakeNameEditor() {
  const wrap     = document.getElementById('kpName');
  const display  = document.getElementById('kpCompositionName');
  const editBtn  = document.getElementById('kpNameEdit');
  const input    = document.getElementById('kpNameInput');
  const saveBtn  = document.getElementById('kpNameSave');
  if (!wrap || !display || !editBtn || !input || !saveBtn) return;

  const enterEdit = () => {
    input.value = display.textContent;
    input.hidden = false;
    saveBtn.hidden = false;
    wrap.classList.add('is-editing');
    // Focus + select on the next frame so the input is visible first.
    requestAnimationFrame(() => {
      input.focus();
      try { input.select(); } catch (e) { /* ignore */ }
    });
  };

  const exitEdit = () => {
    input.hidden = true;
    saveBtn.hidden = true;
    wrap.classList.remove('is-editing');
  };

  const commit = () => {
    const next = (input.value || '').trim();
    if (!next) { exitEdit(); return; }   // empty → cancel silently
    state.compositionName = next;
    state.compositionNameKey = (typeof _compositionKey === 'function') ? _compositionKey() : null;
    display.textContent = next;
    exitEdit();
  };

  display.addEventListener('click', enterEdit);
  editBtn.addEventListener('click', enterEdit);
  saveBtn.addEventListener('click', commit);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter')      { e.preventDefault(); commit();   }
    else if (e.key === 'Escape'){ e.preventDefault(); exitEdit(); }
  });
}

/* [removed 2026-06-10] Legacy "Download as PDF" handler retired. It opened a
   blank window and read #reviewCard.outerHTML — but #reviewCard was deleted in
   the Phase 5 reveal redesign, so this threw a TypeError and left a blank popup
   on every Download click. The canonical Download handler (PNG snapshot) lives
   in bindReviewOverlay() above. */

// [removed] duplicate #reviewShare handler — canonical handler is in the reveal IIFE above

/* =====================================================================
   FINAL §5 — Click handlers
   ===================================================================== */
function syncPresetState() {
  if (!materialConfig) { currentPresetName = null; return; }
  if (state.customCover) { currentPresetName = null; return; }
  const match = materialConfig.officialPresets.find(p =>
    p.body === state.body && p.rim === state.rim &&
    p.cover === state.cover && p.wood === state.wood
  );
  currentPresetName = match ? match.name : null;
}

function pickPreset(name) {
  const preset = materialConfig.officialPresets.find(p => p.name === name);
  if (!preset) return;
  state.body  = preset.body;
  state.rim   = preset.rim;
  state.cover = preset.cover;
  state.wood  = preset.wood;
  state.customCover = null;
  currentPresetName = name;
  a9Bridge.setPreset(name);
  renderAll();
}

function pickBody(name) {
  state.body = name;
  state.rim  = BODY_TO_RIM[name];   // rim auto-couples to body
  syncPresetState();
  a9Bridge.setBody(name);
  a9Bridge.setRim(state.rim);
  renderAll();
}

function pickWood(name) {
  state.wood = name;
  syncPresetState();
  a9Bridge.setWood(name);
  renderAll();
}

function pickCover(name) {
  state.cover = name;
  state.customCover = null;
  syncPresetState();
  a9Bridge.setCover(name);
  renderAll();
}

/* Phase 3.6 — Step 1 click handlers: state mutation + a9Bridge dispatch + renderAll.
   Phase 3.5 mistakenly used window.a9Bridge?.setX?.() (a9Bridge is module-scoped, not on
   window) so optional chaining silently no-op'd. Bare a9Bridge.setX(...) works because
   handlers run in the same scope as `const a9Bridge`. */

// Helper: sync custom-section swatch active states from current state.
// Used by preset clicks (sync visuals after preset apply) + boot.
function _syncCustomSwatchesFromState() {
  const speakerSw = document.querySelector('#speakerSwatches .swatch[data-rim="' + state.rim + '"]');
  document.querySelectorAll('#speakerSwatches .swatch').forEach(s =>
    s.classList.toggle('is-active', s === speakerSw));
  const speakerName = document.getElementById('speakerActiveName');
  if (speakerName && speakerSw) fadeUpdate(speakerName, speakerSw.getAttribute('aria-label'));

  const coverSw = document.querySelector('#coverFaceSwatches .swatch[data-cover="' + state.cover + '"]');
  document.querySelectorAll('#coverFaceSwatches .swatch').forEach(s =>
    s.classList.toggle('is-active', s === coverSw));
  const coverName = document.getElementById('coverActiveName');
  if (coverName && coverSw) fadeUpdate(coverName, coverSw.getAttribute('aria-label'));

  const legSw = document.querySelector('#legsCustomSwatches .swatch[data-wood="' + state.wood + '"]');
  document.querySelectorAll('#legsCustomSwatches .swatch').forEach(s =>
    s.classList.toggle('is-active', s === legSw));
  const legName = document.getElementById('legsActiveName');
  if (legName && legSw) fadeUpdate(legName, legSw.getAttribute('aria-label'));
}

/* =====================================================================
   Phase 4.28 SECTION 1 — DATA: Cover · Upload editor presets + constants
   ===================================================================== */
// Fabric-printing-tuned filter presets. Editorial naming.
// Values are CSS filter strings; same syntax works for canvas filter.
const COVER_UPLOAD_FILTERS = {
  natural:    { label: 'Natural',    css: 'none' },
  monochrome: { label: 'Monochrome', css: 'grayscale(1) contrast(1.05)' },
  heritage:   { label: 'Heritage',   css: 'sepia(0.85) saturate(0.85) brightness(0.95)' },
  tonal:      { label: 'Tonal',      css: 'grayscale(1) contrast(1.1) sepia(0.35) hue-rotate(190deg)' },
  fade:       { label: 'Fade',       css: 'saturate(0.4) brightness(1.08) contrast(0.9)' },
};
const COVER_UPLOAD_DEFAULTS = {
  zoom: 1.0, offsetX: 0, offsetY: 0, rotation: 0, levelDeg: 0, filter: 'natural',
};
const COVER_UPLOAD_ZOOM_MIN = 0.5;
const COVER_UPLOAD_ZOOM_MAX = 3.0;
const COVER_UPLOAD_COMPOSITE_SIZE = 1024;
const COVER_UPLOAD_MAX_BYTES = 12 * 1024 * 1024;

/* =====================================================================
   Phase 4.28 SECTION 2 — HELPERS: decode (async) + compose (sync) + rAF push
   Phase 4.29 split: decode happens ONCE on file drop; compose runs every
   frame off the cached HTMLImageElement; live push to the viewer is
   rAF-coalesced so multiple parameter changes within 16 ms collapse to
   one canvas redraw + one postMessage.
   ===================================================================== */

// (1) Decode once, cache the HTMLImageElement on state.coverUpload._image.
// Idempotent — no-op if the cache is already populated.
async function _decodeAndCacheUploadImage() {
  if (!state.coverUpload || state.coverUpload._image) return;
  const img = new Image();
  img.decoding = 'async';
  img.src = state.coverUpload.dataUrl;
  await img.decode();
  state.coverUpload._image = img;   // private field; never persist this
}

// (2) Synchronous compose using the cached image. Safe to call every frame.
// Returns null if the image isn't decoded yet (caller should bail).
// === Cross-browser filter baking (iOS Safari fix) ===
// The cover filter MUST be baked into the composited pixels so it shows on the
// 3D model. We used to rely on canvas `ctx.filter`, but iOS Safari's ctx.filter
// is unreliable → the editor preview (CSS img.style.filter) showed the filter
// while the MODEL stayed unfiltered. Each CSS filter primitive is a linear/
// affine colour transform, so we fold each filter chain into ONE 3x3 matrix +
// offset (precomputed once) and apply it per-pixel via getImageData — works on
// every browser incl. iOS Safari. Formulas match the CSS/SVG filter spec, so
// the result matches the editor's CSS preview.
const _FILTER_MATRICES = (function () {
  const I = { m: [1,0,0, 0,1,0, 0,0,1], o: [0,0,0] };
  // mul(a, b) = apply b first, then a  →  out = a*(b*x + b.o) + a.o
  function mul(a, b) {
    const A = a.m, B = b.m;
    const m = [
      A[0]*B[0]+A[1]*B[3]+A[2]*B[6], A[0]*B[1]+A[1]*B[4]+A[2]*B[7], A[0]*B[2]+A[1]*B[5]+A[2]*B[8],
      A[3]*B[0]+A[4]*B[3]+A[5]*B[6], A[3]*B[1]+A[4]*B[4]+A[5]*B[7], A[3]*B[2]+A[4]*B[5]+A[5]*B[8],
      A[6]*B[0]+A[7]*B[3]+A[8]*B[6], A[6]*B[1]+A[7]*B[4]+A[8]*B[7], A[6]*B[2]+A[7]*B[5]+A[8]*B[8],
    ];
    const o = [
      A[0]*b.o[0]+A[1]*b.o[1]+A[2]*b.o[2]+a.o[0],
      A[3]*b.o[0]+A[4]*b.o[1]+A[5]*b.o[2]+a.o[1],
      A[6]*b.o[0]+A[7]*b.o[1]+A[8]*b.o[2]+a.o[2],
    ];
    return { m, o };
  }
  const chain = (ops) => ops.reduce((acc, op) => mul(op, acc), I); // first listed applied first
  const grayscale = (a) => { const r=0.2126, g=0.7152, b=0.0722, k=1-a; return { m:[
    k+a*r, a*g, a*b,  a*r, k+a*g, a*b,  a*r, a*g, k+a*b ], o:[0,0,0] }; };
  const contrast = (c) => ({ m:[c,0,0, 0,c,0, 0,0,c], o:[0.5*(1-c),0.5*(1-c),0.5*(1-c)] });
  const brightness = (b) => ({ m:[b,0,0, 0,b,0, 0,0,b], o:[0,0,0] });
  const sepia = (a) => { const k=1-a; return { m:[
    k+a*0.393, a*0.769, a*0.189,
    a*0.349, k+a*0.686, a*0.168,
    a*0.272, a*0.534, k+a*0.131 ], o:[0,0,0] }; };
  const saturate = (s) => ({ m:[
    0.213+0.787*s, 0.715-0.715*s, 0.072-0.072*s,
    0.213-0.213*s, 0.715+0.285*s, 0.072-0.072*s,
    0.213-0.213*s, 0.715-0.715*s, 0.072+0.928*s ], o:[0,0,0] });
  const hueRotate = (deg) => { const a=deg*Math.PI/180, c=Math.cos(a), s=Math.sin(a); return { m:[
    0.213+c*0.787-s*0.213, 0.715-c*0.715-s*0.715, 0.072-c*0.072+s*0.928,
    0.213-c*0.213+s*0.143, 0.715+c*0.285+s*0.140, 0.072-c*0.072-s*0.283,
    0.213-c*0.213-s*0.787, 0.715-c*0.715+s*0.715, 0.072+c*0.928+s*0.072 ], o:[0,0,0] }; };
  return {
    natural:    null,
    monochrome: chain([grayscale(1), contrast(1.05)]),
    heritage:   chain([sepia(0.85), saturate(0.85), brightness(0.95)]),
    tonal:      chain([grayscale(1), contrast(1.1), sepia(0.35), hueRotate(190)]),
    fade:       chain([saturate(0.4), brightness(1.08), contrast(0.9)]),
  };
})();

function _applyColorMatrix(layerCtx, w, h, M) {
  if (!M) return;
  const id = layerCtx.getImageData(0, 0, w, h), d = id.data;
  const m = M.m, o0 = M.o[0]*255, o1 = M.o[1]*255, o2 = M.o[2]*255;
  for (let i = 0; i < d.length; i += 4) {
    if (d[i+3] === 0) continue; // skip fully-transparent (letterbox) pixels
    const r = d[i], g = d[i+1], b = d[i+2];
    let nr = m[0]*r + m[1]*g + m[2]*b + o0;
    let ng = m[3]*r + m[4]*g + m[5]*b + o1;
    let nb = m[6]*r + m[7]*g + m[8]*b + o2;
    d[i]   = nr < 0 ? 0 : nr > 255 ? 255 : nr;
    d[i+1] = ng < 0 ? 0 : ng > 255 ? 255 : ng;
    d[i+2] = nb < 0 ? 0 : nb > 255 ? 255 : nb;
  }
  layerCtx.putImageData(id, 0, 0);
}

function composeCoverUploadSync(params) {
  const img = params && params._image;
  if (!img) {
    // Surface the silent failure: an applied upload cover with no decoded
    // _image yields no composedDataUrl → no preview at checkout. Worth a log.
    console.warn('[compose] no cached _image — composedDataUrl will be empty', params && params.filename);
    return null;
  }

  const size = COVER_UPLOAD_COMPOSITE_SIZE;
  const c = document.createElement('canvas');
  c.width = c.height = size;
  const ctx = c.getContext('2d');
  if (!ctx) return null;

  // Phase 4.40 — COVER-fit base scale: fill the round face, cropping overflow.
  // (Was contain Math.min, which letterboxed non-square uploads with #FAFAF8
  // bands and DIVERGED from the production PSD for landscape/square. Verified
  // 2026-06-22 via aspect-test images.) Matches psd-generator.js cover-fit so
  // the confirmed 3D preview == the printed cover for ALL aspect ratios.
  // NOTE: zoom=1 now FILLS (was: whole image visible). app.js applyTrim
  // (repeat 0.9446) stays unchanged — cover-fill + 94.46% trim == the PSD.
  const ratio = Math.max(size / img.width, size / img.height);
  const scale = ratio * params.zoom;
  const drawW = img.width  * scale;
  const drawH = img.height * scale;
  const r = size / 2;

  // 1) Draw the transformed image onto a transparent offscreen layer (no white
  //    fill here, so the filter only touches image pixels, not the fabric fill).
  const layer = document.createElement('canvas');
  layer.width = layer.height = size;
  const lx = layer.getContext('2d');
  if (!lx) return null;
  lx.save();
  // Phase 4.30 — offsets are NORMALISED (≈ -1..+1, where 1 = full radius).
  lx.translate(size / 2 + params.offsetX * r,
               size / 2 + params.offsetY * r);
  lx.rotate(((params.rotation + (params.levelDeg || 0)) * Math.PI) / 180);
  lx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
  lx.restore();

  // 2) Bake the filter as a per-pixel colour matrix (iOS-safe replacement for
  //    ctx.filter, which Safari ignores → the model showed no filter).
  _applyColorMatrix(lx, size, size, _FILTER_MATRICES[params.filter]);

  // 3) Composite: clip the print circle, lay down the unfiltered fabric-white
  //    fill, then draw the filtered image layer over it.
  ctx.save();
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
  ctx.clip();
  ctx.fillStyle = '#FAFAF8';
  ctx.fillRect(0, 0, size, size);
  ctx.drawImage(layer, 0, 0);
  ctx.restore();

  return c.toDataURL('image/png');
}

// Phase 4.35 fix B — module-level mutable state for the upload editor
// hoisted ABOVE every function that reads/writes it. _enterEmptyState() runs
// at boot via _safeBoot('syncCoverUploadInitialState'); it touches
// _coverUploadEditSnapshot, which previously sat lower in the file and threw
// a TDZ ReferenceError on first paint.
//
// Audit rule: any new `let _coverUpload…` or `let _cu…` belongs HERE, not
// next to its consuming function further down.
let _coverUploadEditSnapshot = null;   // captured on entry to EDITING; restored on Cancel

// (3) rAF-throttled live push. Multiple parameter changes within a single
// frame coalesce into ONE compose-and-send.
let _coverLiveRafId = null;
function _scheduleCoverLivePreview() {
  if (_coverLiveRafId !== null) return;
  _coverLiveRafId = requestAnimationFrame(() => {
    _coverLiveRafId = null;
    if (!state.coverUpload || !state.coverUpload._image) return;
    const composed = composeCoverUploadSync(state.coverUpload);
    if (!composed) return;
    state.coverUpload.composedDataUrl = composed;
    if (state.customCover && state.customCover.type === 'upload') {
      state.customCover.dataUrl = composed;
    }
    _sendUploadToViewer(composed);
  });
}

function clampZoom(z) {
  return Math.max(COVER_UPLOAD_ZOOM_MIN, Math.min(COVER_UPLOAD_ZOOM_MAX, z));
}

// Viewport colour toast — shows selected color name briefly on 3D canvas
var _viewportToastTimer = null;
function showViewportToast(hex, name, price) {
  var toast = document.getElementById('viewportColorToast');
  var dot = document.getElementById('viewportColorToastDot');
  var nameEl = document.getElementById('viewportColorToastName');
  var sepEl = document.getElementById('viewportColorToastSep');
  var priceEl = document.getElementById('viewportColorToastPrice');
  if (!toast || !nameEl) return;
  clearTimeout(_viewportToastTimer);
  if (dot) dot.style.background = hex || 'transparent';
  nameEl.textContent = name || '';
  if (priceEl) priceEl.textContent = price || '';
  toast.classList.toggle('has-price', !!price);
  toast.classList.add('is-visible');
  _viewportToastTimer = setTimeout(function() {
    toast.classList.remove('is-visible');
  }, 2200);
}

// Phase 4.27 FIX 1 — Smoothly swap text content (or `style[prop]`) on an
// element. Toggles .is-fading-out, swaps the value at ~140 ms, then removes
// the class on the next frame so opacity transitions back to 1. Call sites
// pass any falsy value as empty string. CSS handles prefers-reduced-motion.
function fadeUpdate(el, value, prop = 'text') {
  if (!el) return;
  const apply = () => {
    if (prop === 'text') el.textContent = value == null ? '' : value;
    else el.style[prop] = value == null ? '' : value;
  };
  if (!el.isConnected) { apply(); return; }
  // If reduced motion is preferred, skip the fade dance entirely.
  if (typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    apply();
    return;
  }
  el.classList.add('is-fading-out');
  setTimeout(() => {
    apply();
    requestAnimationFrame(() => el.classList.remove('is-fading-out'));
  }, 140);
}

// Phase 4.27 FIX 3 — Cover pane "selected" strip syncer. Single source of
// truth for the strip; called from every cover commit path (curated swatch,
// search result, Match-a-Room rec, reset, tab switch, boot). Adapts the
// user-spec's `state.coverPantone` to this codebase's `state.customCover`
// (only the .type === 'pantone' branch drives the strip).
// Global helper: visually turn OFF the Rotation toggle pill whenever
// setRotation(false) is called programmatically (color pick, upload, etc.).
function _syncRotationPillOff() {
  const pill = document.querySelector('[data-toggle="rotation"]');
  if (pill) {
    pill.classList.remove('is-active');
    pill.setAttribute('aria-pressed', 'false');
  }
  // Sync mobile rotation icon
  const mobBtn = document.getElementById('mobRotationBtn');
  if (mobBtn) {
    mobBtn.classList.remove('is-active');
    mobBtn.setAttribute('aria-pressed', 'false');
  }
}

function _syncCoverSelectedStrip() {
  const strip = document.getElementById('coverSelectedStrip');
  if (!strip) return;
  const swatch = document.getElementById('coverSelectedSwatch');
  const name   = document.getElementById('coverSelectedName');

  // Phase 4.31 — TPG code element retired; strip now reads name + hex only.
  const sel = (state.customCover && state.customCover.type === 'pantone')
    ? { hex: state.customCover.hex,
        name: state.customCover.name || '' }
    : null;

  // Hide strip when UPLOAD sub-tab is active, regardless of selection. The
  // strip lives outside the tab panels, so it must mirror the panel switch.
  const uploadActive = !!document.querySelector('.cover-tab.is-active[data-tab="upload"]');
  if (!sel || uploadActive) {
    strip.hidden = true;
    return;
  }
  strip.hidden = false;
  fadeUpdate(swatch, sel.hex, 'background');
  fadeUpdate(name,   sel.name);
}

window._syncCoverSelectedStrip = _syncCoverSelectedStrip;

// Helper: highlight the preset row whose data-* fields match current state.
function _syncPresetFromState() {
  document.querySelectorAll('#presetList .preset-row').forEach(r => {
    const isMatch = r.dataset.rim === state.rim &&
                    r.dataset.body === state.body &&
                    r.dataset.cover === state.cover &&
                    r.dataset.wood === state.wood;
    const wasActive = r.classList.contains('is-active');
    r.classList.toggle('is-active', isMatch);
    r.setAttribute('aria-checked', isMatch ? 'true' : 'false');
  });
}

// Preset row click — apply all 4 fields + reset to official combination.
document.querySelectorAll('#presetList .preset-row').forEach(row => {
  row.addEventListener('click', () => {
    state.rim   = row.dataset.rim;
    state.body  = row.dataset.body;
    state.cover = row.dataset.cover;
    state.wood  = row.dataset.wood;
    state.customCover = null;
    state.legs = 'original';
    state.legsAccessory = null;
    state.legsCustom = null;

    document.querySelectorAll('#presetList .preset-row').forEach(r => {
      const isThis = r === row;
      r.classList.toggle('is-active', isThis);
      r.setAttribute('aria-checked', isThis ? 'true' : 'false');
    });

    // Force iOS Safari repaint — without this, is-active background
    // change is invisible until the next scroll event.
    // Toggle a transform to kick the GPU compositing layer.
    row.style.transform = 'translateZ(1px)';
    void row.offsetHeight;
    requestAnimationFrame(function() { row.style.transform = ''; });

    a9Bridge.setRim(state.rim);
    a9Bridge.setBody(state.body);
    a9Bridge.setCover(state.cover);
    a9Bridge.setWood(state.wood);
    a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: LEG_MATERIALS['original'] || { kind: 'wood' } });
    a9Bridge.send({ type: 'a9:setWood', name: state.wood });

    _syncCustomSwatchesFromState();
    renderAll();
    if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
  });
});

// Custom toggle: reveal/hide entire custom section at once
const _customToggle = document.getElementById('customToggle');
const _customSection = document.getElementById('customSection');
if (_customToggle && _customSection) {
  _customToggle.addEventListener('click', () => {
    const isHidden = _customSection.hasAttribute('hidden');
    if (isHidden) {
      _customSection.removeAttribute('hidden');
      _customToggle.setAttribute('aria-expanded', 'true');
      _customToggle.classList.add('is-open');
    } else {
      _customSection.setAttribute('hidden', '');
      _customToggle.setAttribute('aria-expanded', 'false');
      _customToggle.classList.remove('is-open');
    }
  });
}

// SPEAKER swatch click — sets rim + body, deactivates preset radio
document.querySelectorAll('#speakerSwatches .swatch').forEach(sw => {
  sw.addEventListener('click', () => {
    state.rim  = sw.dataset.rim;
    state.body = sw.dataset.body;

    document.querySelectorAll('#speakerSwatches .swatch').forEach(s =>
      s.classList.toggle('is-active', s === sw));
    const nameEl = document.getElementById('speakerActiveName');
    if (nameEl) fadeUpdate(nameEl, sw.getAttribute('aria-label'));

    document.querySelectorAll('#presetList .preset-row').forEach(r => {
      r.classList.remove('is-active');
      r.setAttribute('aria-checked', 'false');
    });

    a9Bridge.setRim(state.rim);
    a9Bridge.setBody(state.body);
    showViewportToast(sw.style.background || sw.style.backgroundImage, sw.getAttribute('aria-label'));
    renderAll();
    if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
  });

  // Hover preview — push rim+body to viewer instantly; mouseleave reverts to committed state.
  // is-active early-return avoids redundant postMessage round-trips on the already-selected swatch.
  sw.addEventListener('mouseenter', () => {
    if (sw.classList.contains('is-active')) return;
    a9Bridge.setRim(sw.dataset.rim);
    a9Bridge.setBody(sw.dataset.body);
  });
  sw.addEventListener('mouseleave', () => {
    if (sw.classList.contains('is-active')) return;
    a9Bridge.setRim(state.rim);
    a9Bridge.setBody(state.body);
  });
});

// COVER (face) swatch click
document.querySelectorAll('#coverFaceSwatches .swatch').forEach(sw => {
  sw.addEventListener('click', () => {
    state.cover = sw.dataset.cover;
    state.customCover = null;
    window._committedCatalogPreview = null; // switching to a solid cover clears the catalog selection

    document.querySelectorAll('#coverFaceSwatches .swatch').forEach(s =>
      s.classList.toggle('is-active', s === sw));
    const nameEl = document.getElementById('coverActiveName');
    if (nameEl) fadeUpdate(nameEl, sw.getAttribute('aria-label'));

    document.querySelectorAll('#presetList .preset-row').forEach(r => {
      r.classList.remove('is-active');
      r.setAttribute('aria-checked', 'false');
    });

    a9Bridge.setCover(state.cover);
    showViewportToast(sw.style.background || sw.style.backgroundImage, sw.getAttribute('aria-label'));
    renderAll();
    if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
  });

  // Hover preview — push cover to viewer instantly. mouseleave mirrors the revert logic
  // in the Pantone grid handler (~L11606) so that a Pantone/upload customCover isn't washed
  // away when the user hovers a mood swatch and leaves without clicking.
  sw.addEventListener('mouseenter', () => {
    if (sw.classList.contains('is-active')) return;
    a9Bridge.setCover(sw.dataset.cover);
  });
  sw.addEventListener('mouseleave', () => {
    if (sw.classList.contains('is-active')) return;
    if (state.customCover && state.customCover.type === 'pantone') {
      a9Bridge.setCustomPantone(state.customCover.hex);
    } else if (state.customCover && state.customCover.type === 'upload') {
      const _lU = (state.uploadCovers && state.uploadCovers.length > 0)
        ? state.uploadCovers[state.uploadCovers.length - 1]
        : state.coverUpload;
      if (_lU && _lU.composedDataUrl) {
        a9Bridge.setCustomUpload(_lU.composedDataUrl, true);  // 上传→trim(原死消息)
      }
    } else {
      a9Bridge.setCover(state.cover || 'Warm White');
    }
  });
});

// LEGS (custom) swatch click
document.querySelectorAll('#legsCustomSwatches .swatch').forEach(sw => {
  sw.addEventListener('click', () => {
    state.wood = sw.dataset.wood;

    document.querySelectorAll('#legsCustomSwatches .swatch').forEach(s =>
      s.classList.toggle('is-active', s === sw));
    const nameEl = document.getElementById('legsActiveName');
    if (nameEl) fadeUpdate(nameEl, sw.getAttribute('aria-label'));

    document.querySelectorAll('#presetList .preset-row').forEach(r => {
      r.classList.remove('is-active');
      r.setAttribute('aria-checked', 'false');
    });

    a9Bridge.setWood(state.wood);
    showViewportToast(sw.style.background || sw.style.backgroundImage, sw.getAttribute('aria-label'));
    renderAll();
    if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
  });

  // Hover preview — push wood to viewer instantly; mouseleave reverts.
  sw.addEventListener('mouseenter', () => {
    if (sw.classList.contains('is-active')) return;
    a9Bridge.setWood(sw.dataset.wood);
  });
  sw.addEventListener('mouseleave', () => {
    if (sw.classList.contains('is-active')) return;
    a9Bridge.setWood(state.wood);
  });
});

/* =====================================================================
   Phase 4.21 — Step 3 LEGS Custom Pantone wiring
   ===================================================================== */

/* =====================================================================
   Phase 7 — Stand 3-mode system: Stock / Mood / Match
   Mirrors Face's setCoverMode / mood-row pattern.
   ===================================================================== */

// Context-aware price label
function _updateLegsStepPriceLabel(mode) {
  const lbl = document.querySelector('.legs-step-price-label');
  if (!lbl) return;
  fadeUpdate(lbl, (mode === 'mood' || mode === 'match') ? 'Custom Legs' : 'LEGS ADD');
}

// Stand stock category data — maps to LEG_MATERIALS
const STAND_STOCK_CATEGORIES = [
  {
    id: 'aluminium', name: 'Solid Aluminium', tags: 'metallic, modern, refined',
    items: [
      { legs: 'aluminium-chrome', name: 'Chrome',     price: 290, hex: null, gradient: 'linear-gradient(135deg, #f0f2f5 0%, #b8bcc2 30%, #e8eaed 50%, #8d9199 75%, #d0d3d7 100%)' },
      { legs: 'aluminium-amber',  name: 'Amber Gold', price: 290, hex: null, gradient: 'linear-gradient(135deg, #e8d4a8 0%, #c9a55c 30%, #ddc88a 50%, #a07b3a 75%, #d1b06a 100%)' }
    ]
  },
  {
    id: 'fabric', name: 'Fabric Covers', tags: 'soft, textile, versatile',
    items: [
      { legs: 'cover-black',     name: 'Black',          price: 59, hex: '#1F1F1F' },
      { legs: 'cover-white',     name: 'White',          price: 59, hex: '#F5F1EA' },
      { legs: 'cover-red',       name: 'Red',            price: 59, hex: '#B5302E' },
      { legs: 'cover-colorplay', name: 'ColorPlay Trio', price: 59, hex: null, gradient: 'linear-gradient(to right, #B5302E 0% 33.3%, #2D6A2E 33.3% 66.6%, #1565C0 66.6% 100%)' },
      { legs: 'cover-frost',     name: 'Frost White',    price: 59, hex: null, gradient: 'linear-gradient(180deg, #1a1a1a 0%, #f4f1ea 100%)' },
      { legs: 'cover-coral',     name: 'Coral Pink',     price: 47, hex: null, texture: 'https://cdn.shopify.com/s/files/1/0351/1359/9021/files/thumb-coral-pink.jpg' },
      { legs: 'cover-twilight',  name: 'Twilight',       price: 59, hex: null, texture: 'https://cdn.shopify.com/s/files/1/0351/1359/9021/files/thumb-twilight.jpg' },
      { legs: 'cover-midsummer', name: 'Midsummer Blue', price: 59, hex: null, texture: 'https://cdn.shopify.com/s/files/1/0351/1359/9021/files/thumb-midsummer-blue.jpg' },
      { legs: 'cover-santa',     name: 'Santa Claus',    price: 59, hex: null, texture: 'https://cdn.shopify.com/s/files/1/0351/1359/9021/files/thumb-santa-claus.jpg' }
    ]
  },
];

/** Which stand stock row is currently expanded (null = none) */
window._expandedStandCategory = null;

/** Stand multi-select cart: { 'legsId': { qty, name, price, hex } } — metal/fabric only */
var _standCartQty = {};

function setStandMode(mode) {
  if (!['stock', 'mood', 'match'].includes(mode)) return;
  window._standMode = mode;

  // 1. Update pill switch
  document.querySelectorAll('#standModeSwitch .cover-mode-btn').forEach(btn => {
    btn.classList.toggle('is-active', btn.dataset.mode === mode);
  });

  // 2. Show/hide mode panes
  document.querySelectorAll('.stand-mode-pane').forEach(pane => {
    const isTarget = pane.dataset.standMode === mode;
    pane.classList.toggle('is-active', isTarget);
    if (!isTarget) pane.setAttribute('hidden', '');
    else pane.removeAttribute('hidden');
  });

  // 3. Update panel header copy
  const copy = STAND_MODE_COPY[mode];
  const titleEl = document.getElementById('standTitle');
  const descEl  = document.getElementById('standDesc');
  if (titleEl && copy) titleEl.innerHTML = copy.title;
  if (descEl  && copy) descEl.textContent = copy.desc;

  // 4. Render mode-specific content
  if (mode === 'mood' && typeof renderStandMoodRows === 'function') {
    try { renderStandMoodRows(); } catch(e) { console.error('[setStandMode:mood]', e); }
  }

  // 5. Slide indicator
  if (typeof _updateModeSlider === 'function') _updateModeSlider(document.getElementById('standModeSwitch'));

  // 6. Update header path + price label
  _updateHeaderPath();
  _updateLegsStepPriceLabel(mode);

  // 7. Mobile: auto-expand sheet for content-heavy modes (mood/match)
  if (typeof window._expandBottomSheet === 'function') window._expandBottomSheet();

  // 8. Persist
  if (typeof _persistState === 'function') _persistState();
}

// Bind stand pill switch clicks
(function _bindStandModeSwitch() {
  const sw = document.getElementById('standModeSwitch');
  if (!sw) return;
  sw.addEventListener('click', function(e) {
    const btn = e.target.closest('.cover-mode-btn');
    if (!btn || !btn.dataset.mode) return;
    setStandMode(btn.dataset.mode);
  });
})();

/**
 * Render Stand Stock collapsible category rows (mirrors Face mood rows).
 */
function renderStandStockRows() {
  const host = document.getElementById('standStockRows');
  if (!host) return;

  host.innerHTML = STAND_STOCK_CATEGORIES.map(cat => {
    const isExpanded = true; // always expanded — no accordion
    const isActive = cat.items.some(it => {
      if (state.legsCustom) return false;
      if (it.wood) return it.legs === state.legs && it.wood === state.wood;
      return it.legs === state.legs;
    });

    // Phase UX polish #46 — dot indicator for stock rows
    const accentHexes = cat.items.map(it => {
      if (it.hex) return it.hex;
      if (it.gradient) {
        const stops = it.gradient.match(/#[0-9a-fA-F]{6}/g);
        if (stops && stops.length >= 3) return stops[Math.floor(stops.length / 2)];
        if (stops && stops.length >= 1) return stops[0];
      }
      return '#ccc';
    });
    // Pick up to 6 evenly-spaced
    var _stockStops = [];
    if (accentHexes.length <= 6) { _stockStops = accentHexes; }
    else { for (var _si = 0; _si < 6; _si++) _stockStops.push(accentHexes[Math.round(_si * (accentHexes.length - 1) / 5)]); }
    const accentDots = _stockStops.map(function(hex) {
      return '<span class="stand-stock-row-accent-dot" style="background:' + hex + '"></span>';
    }).join('');

    // Swatch grid
    const swatchesHtml = cat.items.map(it => {
      const bgStyle = it.texture
        ? 'background-image:url(\'' + it.texture + '\');background-size:cover;background-position:center'
        : 'background:' + (it.gradient || (it.hex || '#ccc'));
      const isWood = !!it.wood;
      const isSelected = !state.legsCustom && (isWood
        ? (it.legs === state.legs && it.wood === state.wood)
        : (it.legs === state.legs));
      const sel = isSelected ? ' is-selected' : '';
      const woodAttr = isWood ? ' data-wood="' + it.wood + '"' : '';
      // Multi-select qty badge + minus (non-wood only)
      var sqty = _standCartQty[it.legs];
      var sHasQ = !isWood && sqty && sqty.qty > 0;
      var sQCls = sHasQ ? ' has-qty' : '';
      var sQBadge = (sHasQ && sqty.qty >= 1) ? '<span class="stand-stock-swatch-qty">' + sqty.qty + '</span>' : '';
      var sQMinus = sHasQ ? '<span class="stand-stock-swatch-minus" data-action="stand-minus" data-legs="' + it.legs + '">−</span>' : '';
      return '<button class="stand-stock-swatch' + sel + sQCls + '" ' +
             'data-legs="' + it.legs + '" data-price="' + it.price + '" data-name="' + it.name + '"' + woodAttr + ' ' +
             'style="' + bgStyle + '" aria-label="' + it.name + '">' + sQBadge + sQMinus + '</button>';
    }).join('');

    const chevronSvg = '<svg class="stand-stock-row-chevron" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 6l4 4 4-4"/></svg>';

    return '<div class="stand-stock-row' + (isExpanded ? ' is-expanded' : '') + (isActive ? ' is-active' : '') + '" data-category="' + cat.id + '">' +
           '  <div class="stand-stock-row-header" data-category="' + cat.id + '">' +
           '    <div class="stand-stock-row-info">' +
           '      <div class="stand-stock-row-meta">' +
           '        <div class="stand-stock-row-name">' + cat.name + '</div>' +
           '        <div class="stand-stock-row-tags">' + cat.tags + '</div>' +
           '      </div>' +
           '      ' + chevronSvg +
           '    </div>' +
           '    <div class="stand-stock-row-accent">' + accentDots + '</div>' +
           '  </div>' +
           '  <div class="stand-stock-row-body">' +
           '    <div class="stand-stock-row-body-inner">' +
           '    <div class="stand-stock-grid">' + swatchesHtml + '</div>' +
           '    </div>' +
           '  </div>' +
           '</div>';
  }).join('');
}

/* Swatch entrance animation plays only on expand (not on selection
   re-renders). Marks the freshly rendered expanded row with a transient
   .is-entering class — see CSS swatchIn rules. */
function _markRowEntering(selector) {
  var row = document.querySelector(selector);
  if (!row) return;
  row.classList.add('is-entering');
  setTimeout(function () { row.classList.remove('is-entering'); }, 700);
}

function expandStandStockRow(catId) {
  if (window._expandedStandCategory === catId) return;
  window._expandedStandCategory = catId;
  renderStandStockRows();
  _markRowEntering('.stand-stock-row.is-expanded');
}
function collapseStandStockRow() {
  if (!window._expandedStandCategory) return;
  window._expandedStandCategory = null;
  renderStandStockRows();
}

/**
 * Select a stand stock material.
 * Wood items → preview only (no purchase).
 * Metal/Fabric → multi-select with qty.
 */
function selectStandStockItem(legsId, price, woodName, forceAdd) {
  const def = LEG_MATERIALS[legsId] || { kind: 'wood' };
  const cat = STAND_STOCK_CATEGORIES.find(c => c.items.some(it => it.legs === legsId));
  const item = cat ? (woodName
    ? cat.items.find(it => it.legs === legsId && it.wood === woodName)
    : cat.items.find(it => it.legs === legsId)) : null;
  const name = item ? item.name : legsId;

  // Always update 3D preview
  state.legs = legsId;
  a9Bridge.send({ type: 'a9:setStand', stand: legsId, material: def });
  showViewportToast((item && item.hex) || (item && item.gradient) || '', name, price > 0 ? '€' + price : '');

  if (def.kind === 'wood') {
    // Wood = preview only, no purchase
    state.wood = woodName || (item && item.wood) || 'Light Oak';
    if (typeof pickWood === 'function') pickWood(state.wood);
    a9Bridge.send({ type: 'a9:setWood', name: state.wood });
    // Don't add to cart — just update preview
    state.legsAccessory = null;
    state.legsCustom = null;
  } else {
    // Metal or Fabric — multi-select with qty
    var standSwEl = document.querySelector('.stand-stock-swatch[data-legs="' + legsId + '"]');
    if (!standSwEl) standSwEl = document.querySelector('[data-legs="' + legsId + '"]');

    // Mobile: 1st tap = preview, 2nd tap = add. Already-in-cart → skip preview, direct +1.
    if (_tgIsTouchDevice && !forceAdd) {
      // Already in cart → direct increment
      if (_standCartQty[legsId] && _standCartQty[legsId].qty > 0) {
        selectStandStockItem(legsId, price, woodName, true);
        return;
      }
      if (_isSamePreview('stand', legsId)) {
        selectStandStockItem(legsId, price, woodName, true);
        return;
      }
      // 1st tap on new item → preview only
      if (standSwEl) _setPreviewRing(standSwEl, 'stand', legsId);
      return;
    }

    var key = legsId;
    if (!_standCartQty[key]) {
      _standCartQty[key] = { qty: 0, name: name, price: parseInt(price, 10) || 0, hex: (item && item.hex) || '', gradient: (item && item.gradient) || '' };
    }
    _standCartQty[key].qty++;
    state.legsAccessory = { id: legsId, name: name, price: parseInt(price, 10) || 0, kind: def.kind };
    state.legsCustom = null;
  }

  renderStandStockRows();
  if (typeof renderLegs === 'function') renderLegs();
  // Set added ring AFTER render (innerHTML destroyed old element reference)
  if (_tgIsTouchDevice && def.kind !== 'wood') {
    var freshAddedEl = document.querySelector('.stand-stock-swatch[data-legs="' + legsId + '"]');
    if (freshAddedEl) _setAddedRing(freshAddedEl);
  }
  recomputeTotal();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
}

function _standMinusItem(legsId) {
  if (!_standCartQty[legsId]) return;
  _standCartQty[legsId].qty--;
  if (_standCartQty[legsId].qty <= 0) delete _standCartQty[legsId];
  // Update legsAccessory to last remaining or clear
  var anyStand = false;
  for (var sk in _standCartQty) { if (_standCartQty[sk].qty > 0) { anyStand = true; break; } }
  if (!anyStand) {
    state.legsAccessory = null;
    state.legs = 'original';
    state.legsCustom = null;
    a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } });
    a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
    if (typeof _persistState === 'function') _persistState();
  }
  renderStandStockRows();
  recomputeTotal();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
}

// Event delegation on #standStockRows
(function _bindStandStockRows() {
  const host = document.getElementById('standStockRows');
  if (!host) return;

  /* ---- Hover-to-expand rows ---- */
  let _hoverExpandTimer = null;
  let _hoverCollapseTimer = null;
  let _clickCollapsedAt = 0;

  host.addEventListener('mouseenter', function(e) {
    const row = e.target.closest('.stand-stock-row');
    if (!row) return;
    const catId = row.dataset.category;
    clearTimeout(_hoverCollapseTimer);
    clearTimeout(_hoverExpandTimer);
    if (Date.now() - _clickCollapsedAt < 600) return;
    _hoverExpandTimer = setTimeout(function() {
      expandStandStockRow(catId);
    }, 120);
  }, true);

  host.addEventListener('mouseleave', function(e) {
    clearTimeout(_hoverExpandTimer);
  }, true);

  /* ---- Click handler — swatch select, minus, header toggle ---- */
  host.addEventListener('click', function(e) {
    // Minus badge → decrement stand qty
    var minusEl = e.target.closest('.stand-stock-swatch-minus');
    if (minusEl) {
      e.stopPropagation();
      _standMinusItem(minusEl.dataset.legs);
      return;
    }
    const swatch = e.target.closest('.stand-stock-swatch');
    if (swatch) {
      selectStandStockItem(swatch.dataset.legs, swatch.dataset.price, swatch.dataset.wood || null);
      return;
    }
    // Header click — no-op (stock always expanded)
    const header = e.target.closest('.stand-stock-row-header');
    if (header) return;
  });

  /* ---- Hover preview on swatches — live 3D update ---- */
  let standHoverTimeout = null;
  let standIsHovering = false;

  host.addEventListener('mouseover', function(e) {
    const swatch = e.target.closest('.stand-stock-swatch');
    if (!swatch) return;
    clearTimeout(standHoverTimeout);
    standHoverTimeout = setTimeout(function() {
      standIsHovering = true;
      const def = LEG_MATERIALS[swatch.dataset.legs] || { kind: 'wood' };
      a9Bridge.send({ type: 'a9:setStand', stand: swatch.dataset.legs, material: def });
      if (def.kind === 'wood') {
        a9Bridge.send({ type: 'a9:setWood', name: swatch.dataset.wood || state.wood || 'Light Oak' });
      }
    }, 60);
  });

  host.addEventListener('mouseout', function(e) {
    const swatch = e.target.closest('.stand-stock-swatch');
    if (!swatch) return;
    const related = e.relatedTarget?.closest?.('.stand-stock-swatch');
    if (related) return;
    clearTimeout(standHoverTimeout);
    if (!standIsHovering) return;
    standIsHovering = false;
    if (state.legsCustom && state.legsCustom.hex) {
      a9Bridge.setLegsCustom({ hex: state.legsCustom.hex, tpg: state.legsCustom.tpg, name: state.legsCustom.name, mode: 'pantone' });
    } else {
      const def = LEG_MATERIALS[state.legs] || { kind: 'wood' };
      a9Bridge.send({ type: 'a9:setStand', stand: state.legs, material: def });
      if (def.kind === 'wood') a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
    }
  });
})();

// Initial render of stand stock rows
try { renderStandStockRows(); }
catch (err) { console.error('[init:renderStandStockRows]', err); }

/* =====================================================================
   v9 §C2 — Nearest-Pantone helpers (data layer). The 2310-entry
   TPG_DATABASE + TPG_NAMES globals come from <script src="tpg-database.js">
   in head. We cache an indexed array form once on first call (~200µs);
   each nearest-match then runs in single-digit ms.

   Phase 4.21 fix — hoisted ABOVE _renderLegsCustomPantoneGrid because
   that function's bootstrap call (`_renderLegsCustomPantoneGrid('')` at
   module-load time) reads _tpgArray. With `let`, accessing the binding
   before declaration throws ReferenceError, aborting the rest of the
   script body and killing every event listener after it.
   ===================================================================== */
/* Phase 5.1 — classify the full 2310-entry TPG database into the five
   style buckets used by .cover-substab. Each test runs HSL on the cached
   {r,g,b} fields from _tpgList(); boundary colours (s ≈ 0.13–0.15) may
   fall into the gaps between buckets — that's acceptable since the
   search input still covers every TPG name/code/hex regardless of
   classification. Returns [] when _tpgList is empty (TPG_DATABASE not
   loaded yet, e.g. pre-boot). */
function _classifyTPGByStyle(targetStyle) {
  const list = (typeof _tpgList === 'function') ? _tpgList() : [];
  if (!list.length) return [];
  return list.filter(p => {
    const r = p.r || 0, g = p.g || 0, b = p.b || 0;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    const l = (max + min) / 510;
    const d = max - min;
    const s = d === 0 ? 0 : d / (l > 0.5 ? (510 - max - min) : (max + min));
    let h = 0;
    if (d !== 0) {
      if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) * 60;
      else if (max === g) h = ((b - r) / d + 2) * 60;
      else h = ((r - g) / d + 4) * 60;
    }
    switch (targetStyle) {
      case 'NORDIC':  return l > 0.65 && s < 0.35;
      case 'EARTHY':  return (h >= 15 && h <= 55) && s > 0.15 && l > 0.25 && l < 0.75;
      case 'JAPANDI': return (h >= 60 && h <= 170) || (s < 0.12 && l > 0.35 && l < 0.65);
      case 'STONE':   return s < 0.12 && l < 0.55;
      case 'BOLD':    return s > 0.45 && l > 0.2 && l < 0.65;
      case 'COTY':    return false;  // COTY is curated-only, no TPG expansion
      case 'TREND26': return false;  // 2026 Interiors — curated-only, ditto
      default:        return false;
    }
  });
}

let _tpgArray = null;
function _tpgList() {
  if (_tpgArray) return _tpgArray;
  if (typeof TPG_DATABASE !== 'object' || !TPG_DATABASE) { _tpgArray = []; return _tpgArray; }
  _tpgArray = Object.entries(TPG_DATABASE).map(([code, hex]) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return { code, hex, name: (typeof TPG_NAMES === 'object' && TPG_NAMES) ? (TPG_NAMES[code] || '') : '', r, g, b };
  });
  return _tpgArray;
}

/* ── INIT-ORDER RULES — DO NOT VIOLATE ────────────────────────────────────
   1. All `let` / `const` data tables live near the TOP of the script.
   2. All render / handler functions are DEFINED only — never INVOKED at the
      top level.
   3. Every first-time invocation goes inside `init()` (or a try/catch wrapper)
      so a failure in one render doesn't kill every downstream listener.
   4. Adding a new render function?  Define it where the others are, then add
      ONE bootstrap line — wrapped in try/catch — to the init() block.
   5. Never call a render function from a data-section file site.

   Phase 4.23 — PANTONE_LIBRARY hoisted here from line ~3892 because the legs
   Custom render below reads it at module-load time. With `const` / `let`,
   accessing the binding before its declaration throws ReferenceError, which
   aborts the rest of the script body and kills every event listener after
   the throw point. Same shape as the `_tpgArray` TDZ bug from Phase 4.22.
   ──────────────────────────────────────────────────────────────────────── */
const PANTONE_LIBRARY = [
  // ── Colour of the Year 2000–2026 (all hex from tpg-database.js) ──
  { pantone: '15-4020 TPG', hex: '#98B2D1', name: '2000 · Cerulean',         style: 'COTY' },
  { pantone: '17-2031 TPG', hex: '#C34E7C', name: '2001 · Fuchsia Rose',     style: 'COTY' },
  { pantone: '19-1664 TPG', hex: '#BD3645', name: '2002 · True Red',         style: 'COTY' },
  { pantone: '14-4811 TPG', hex: '#7FC9CB', name: '2003 · Aqua Sky',         style: 'COTY' },
  { pantone: '17-1456 TPG', hex: '#E2654D', name: '2004 · Tigerlily',        style: 'COTY' },
  { pantone: '15-5217 TPG', hex: '#5BB3B0', name: '2005 · Blue Turquoise',   style: 'COTY' },
  { pantone: '13-1106 TPG', hex: '#DECEBB', name: '2006 · Sand Dollar',      style: 'COTY' },
  { pantone: '19-1557 TPG', hex: '#9D363F', name: '2007 · Chili Pepper',     style: 'COTY' },
  { pantone: '18-3943 TPG', hex: '#6364A5', name: '2008 · Blue Iris',        style: 'COTY' },
  { pantone: '14-0848 TPG', hex: '#EBBF57', name: '2009 · Mimosa',           style: 'COTY' },
  { pantone: '15-5519 TPG', hex: '#4DB6AD', name: '2010 · Turquoise',        style: 'COTY' },
  { pantone: '18-2120 TPG', hex: '#D85A7B', name: '2011 · Honeysuckle',      style: 'COTY' },
  { pantone: '17-1463 TPG', hex: '#E34F33', name: '2012 · Tangerine Tango',  style: 'COTY' },
  { pantone: '17-5641 TPG', hex: '#00997B', name: '2013 · Emerald',          style: 'COTY' },
  { pantone: '18-3224 TPG', hex: '#B067A1', name: '2014 · Radiant Orchid',   style: 'COTY' },
  { pantone: '18-1438 TPG', hex: '#975A58', name: '2015 · Marsala',          style: 'COTY' },
  { pantone: '13-1520 TPG', hex: '#F8CDCD', name: '2016 · Rose Quartz',      style: 'COTY' },
  { pantone: '15-3919 TPG', hex: '#95AAD3', name: '2016 · Serenity',         style: 'COTY' },
  { pantone: '15-0343 TPG', hex: '#92B558', name: '2017 · Greenery',         style: 'COTY' },
  { pantone: '18-3838 TPG', hex: '#6B5B95', name: '2018 · Ultra Violet',     style: 'COTY' },
  { pantone: '16-1546 TPG', hex: '#FC766A', name: '2019 · Living Coral',     style: 'COTY' },
  { pantone: '19-4052 TPG', hex: '#34558B', name: '2020 · Classic Blue',     style: 'COTY' },
  { pantone: '16-5101 TPG', hex: '#969393', name: '2021 · Ultimate Gray',    style: 'COTY' },  // nearest TPG: Wet Weather
  { pantone: '13-0644 TPG', hex: '#F7E14A', name: '2021 · Illuminating',     style: 'COTY' },  // nearest TPG: Golden Kiwi
  { pantone: '17-3940 TPG', hex: '#757EB9', name: '2022 · Very Peri',        style: 'COTY' },  // nearest TPG (was 18-3943 = same hex as 2008 Blue Iris → hex-keyed selection linked the two swatches)
  { pantone: '18-1653 TPG', hex: '#BA2B42', name: '2023 · Viva Magenta',     style: 'COTY' },  // nearest TPG: Toreador
  { pantone: '13-1023 TPG', hex: '#FFC196', name: '2024 · Peach Fuzz',       style: 'COTY' },
  { pantone: '17-1230 TPG', hex: '#A47B67', name: '2025 · Mocha Mousse',     style: 'COTY' },
  { pantone: '11-4201 TPG', hex: '#F1F0EC', name: '2026 · Cloud Dancer',     style: 'COTY' },

  // ── 2026 Interiors — curated 2026-06 from paint-house Colour-of-the-Year
  //    forecasts (BM Silhouette / SW Universal Khaki / Behr Hidden Gem /
  //    Dulux Slow Swing / F&B bestsellers) + Pinterest Palette 2026.
  //    Mapped to nearest TPG (d ≤ 14). Curated-only, no Show-all expansion. ──
  { pantone: '19-3316 TPG', hex: '#524550', name: 'Plum Perfect',  style: 'TREND26' },
  { pantone: '16-1212 TPG', hex: '#B2A08A', name: 'Nomad',         style: 'TREND26' },
  { pantone: '18-5616 TPG', hex: '#3E625B', name: 'Posy Green',    style: 'TREND26' },
  { pantone: '19-4038 TPG', hex: '#30475E', name: 'Gibraltar Sea', style: 'TREND26' },
  { pantone: '17-1312 TPG', hex: '#988B79', name: 'Silver Mink',   style: 'TREND26' },
  { pantone: '14-0936 TPG', hex: '#E1C289', name: 'Sahara Sun',    style: 'TREND26' },
  { pantone: '15-0523 TPG', hex: '#AEB385', name: 'Winter Pear',   style: 'TREND26' },
  { pantone: '14-1310 TPG', hex: '#D6B6A9', name: 'Cameo Rose',    style: 'TREND26' },
  { pantone: '19-1627 TPG', hex: '#5F3E45', name: 'Port Royale',   style: 'TREND26' },
  { pantone: '18-2109 TPG', hex: '#8A6F79', name: 'Grape Shake',   style: 'TREND26' },
  { pantone: '18-5621 TPG', hex: '#467768', name: 'Fir',           style: 'TREND26' },
  { pantone: '16-1454 TPG', hex: '#DB7344', name: 'Jaffa Orange',  style: 'TREND26' },
  { pantone: '13-5305 TPG', hex: '#C0CDC4', name: 'Pale Aqua', style: 'NORDIC' },
  { pantone: '12-0110 TPG', hex: '#DAD1BB', name: 'Pistachio Shell', style: 'NORDIC' },
  { pantone: '14-4201 TPG', hex: '#C7C8CA', name: 'Lunar Rock', style: 'NORDIC' },
  { pantone: '13-6008 TPG', hex: '#BDDACA', name: 'Misty Jade', style: 'NORDIC' },
  { pantone: '12-0106 TPG', hex: '#D4DDC4', name: 'Meadow Mist', style: 'NORDIC' },
  { pantone: '13-3803 TPG', hex: '#D5CCCC', name: 'Lilac Ash', style: 'NORDIC' },
  { pantone: '12-0703 TPG', hex: '#E3DAC2', name: 'Seedpearl', style: 'NORDIC' },
  { pantone: '13-1504 TPG', hex: '#E6CDC5', name: 'Peach Blush', style: 'NORDIC' },
  { pantone: '12-1006 TPG', hex: '#EBD9C6', name: 'Mother of Pearl', style: 'NORDIC' },
  { pantone: '12-5209 TPG', hex: '#C7E9E3', name: 'Soothing Sea', style: 'NORDIC' },
  { pantone: '12-4305 TPG', hex: '#D5E1DF', name: 'Spa Blue', style: 'NORDIC' },
  { pantone: '12-6207 TPG', hex: '#DDE5D9', name: 'Frost', style: 'NORDIC' },
  { pantone: '11-0110 TPG', hex: '#F0E3CE', name: 'Buttercream', style: 'NORDIC' },
  { pantone: '12-5508 TPG', hex: '#D9E9E3', name: 'Hushed Green', style: 'NORDIC' },
  { pantone: '12-2906 TPG', hex: '#F1D7DD', name: 'Barely Pink', style: 'NORDIC' },
  { pantone: '11-0701 TPG', hex: '#EFECDE', name: 'Whisper White', style: 'NORDIC' },
  { pantone: '11-2409 TPG', hex: '#F0E3E0', name: 'Delicacy', style: 'NORDIC' },
  { pantone: '18-1027 TPG', hex: '#6B5445', name: 'Bison', style: 'EARTHY' },
  { pantone: '18-1033 TPG', hex: '#795C46', name: 'Dachshund', style: 'EARTHY' },
  { pantone: '18-1148 TPG', hex: '#8B5A3D', name: 'Caramel Café', style: 'EARTHY' },
  { pantone: '19-1333 TPG', hex: '#835347', name: 'Sequoia', style: 'EARTHY' },
  { pantone: '19-1250 TPG', hex: '#924A3D', name: 'Picante', style: 'EARTHY' },
  { pantone: '18-1242 TPG', hex: '#8A5B4C', name: 'Brown Patina', style: 'EARTHY' },
  { pantone: '18-1345 TPG', hex: '#A2553A', name: 'Cinnamon Stick', style: 'EARTHY' },
  { pantone: '17-0840 TPG', hex: '#9D884A', name: 'Amber Green', style: 'EARTHY' },
  { pantone: '18-1433 TPG', hex: '#965E53', name: 'Chutney', style: 'EARTHY' },
  { pantone: '18-1441 TPG', hex: '#A15E4F', name: 'Baked Clay', style: 'EARTHY' },
  { pantone: '16-1438 TPG', hex: '#A9754F', name: 'Meerkat', style: 'EARTHY' },
  { pantone: '17-1430 TPG', hex: '#A67459', name: 'Pecan Brown', style: 'EARTHY' },
  { pantone: '18-1451 TPG', hex: '#B26150', name: 'Autumn Glaze', style: 'EARTHY' },
  { pantone: '17-1322 TPG', hex: '#A0826B', name: 'Burro', style: 'EARTHY' },
  { pantone: '17-1532 TPG', hex: '#AE6C60', name: 'Aragon', style: 'EARTHY' },
  { pantone: '17-1436 TPG', hex: '#B9745A', name: 'Raw Sienna', style: 'EARTHY' },
  { pantone: '17-1224 TPG', hex: '#AD846B', name: 'Camel', style: 'EARTHY' },
  { pantone: '17-1225 TPG', hex: '#AF8971', name: 'Tawny Birch', style: 'EARTHY' },
  { pantone: '16-1440 TPG', hex: '#C76C5A', name: 'Langoustino', style: 'EARTHY' },
  { pantone: '16-0940 TPG', hex: '#C49D69', name: 'Taffy', style: 'EARTHY' },
  { pantone: '19-0912 TPG', hex: '#4D433E', name: 'Chocolate Brown', style: 'JAPANDI' },
  { pantone: '19-1116 TPG', hex: '#5C4D43', name: 'Carafe', style: 'JAPANDI' },
  { pantone: '19-1623 TPG', hex: '#60474D', name: 'Vineyard Wine', style: 'JAPANDI' },
  { pantone: '19-1431 TPG', hex: '#6A4C48', name: 'Fudgesickle', style: 'JAPANDI' },
  { pantone: '18-0130 TPG', hex: '#5C7547', name: 'Cactus', style: 'JAPANDI' },
  { pantone: '19-1334 TPG', hex: '#835049', name: 'Henna', style: 'JAPANDI' },
  { pantone: '18-1326 TPG', hex: '#7F625A', name: 'Nutmeg', style: 'JAPANDI' },
  { pantone: '18-1612 TPG', hex: '#826567', name: 'Rose Taupe', style: 'JAPANDI' },
  { pantone: '18-0110 TPG', hex: '#688863', name: 'English Ivy', style: 'JAPANDI' },
  { pantone: '16-0632 TPG', hex: '#9D905A', name: 'Willow', style: 'JAPANDI' },
  { pantone: '18-1321 TPG', hex: '#8F7466', name: 'Brownie', style: 'JAPANDI' },
  { pantone: '16-0526 TPG', hex: '#979269', name: 'Cedar', style: 'JAPANDI' },
  { pantone: '16-1107 TPG', hex: '#9C9789', name: 'Aluminum', style: 'JAPANDI' },
  { pantone: '16-1324 TPG', hex: '#B49C73', name: 'Lark', style: 'JAPANDI' },
  { pantone: '16-0906 TPG', hex: '#ABA093', name: 'Simply Taupe', style: 'JAPANDI' },
  { pantone: '16-1305 TPG', hex: '#ACA49B', name: 'String', style: 'JAPANDI' },
  { pantone: '15-1314 TPG', hex: '#C3A990', name: 'Cuban Sand', style: 'JAPANDI' },
  { pantone: '15-1217 TPG', hex: '#C7B795', name: 'Mojave Desert', style: 'JAPANDI' },
  { pantone: '19-5320 TPG', hex: '#324D4D', name: 'Ponderosa Pine', style: 'STONE' },
  { pantone: '19-5230 TPG', hex: '#345654', name: 'Forest Biome', style: 'STONE' },
  { pantone: '19-4028 TPG', hex: '#414C60', name: 'Insignia Blue', style: 'STONE' },
  { pantone: '19-1322 TPG', hex: '#604B4B', name: 'Brown Stone', style: 'STONE' },
  { pantone: '19-0309 TPG', hex: '#596258', name: 'Thyme', style: 'STONE' },
  { pantone: '18-5606 TPG', hex: '#5A686A', name: 'Balsam Green', style: 'STONE' },
  { pantone: '18-3921 TPG', hex: '#4D6080', name: 'Bijou Blue', style: 'STONE' },
  { pantone: '18-3715 TPG', hex: '#6E6276', name: 'Montana Grape', style: 'STONE' },
  { pantone: '18-5610 TPG', hex: '#55828A', name: 'Brittany Blue', style: 'STONE' },
  { pantone: '18-5102 TPG', hex: '#7B7674', name: 'Brushed Nickel', style: 'STONE' },
  { pantone: '17-4412 TPG', hex: '#6A8B95', name: 'Smoke Blue', style: 'STONE' },
  { pantone: '17-3911 TPG', hex: '#868387', name: 'Silver Filigree', style: 'STONE' },
  { pantone: '16-5109 TPG', hex: '#74A59E', name: 'Wasabi', style: 'STONE' },
  { pantone: '17-3826 TPG', hex: '#8278A9', name: 'Aster Purple', style: 'STONE' },
  { pantone: '16-4402 TPG', hex: '#989998', name: 'Drizzle', style: 'STONE' },
  { pantone: '16-3803 TPG', hex: '#A6A0A6', name: 'Gull Gray', style: 'STONE' },
  { pantone: '15-4502 TPG', hex: '#B7B1AB', name: 'Silver Cloud', style: 'STONE' },
  { pantone: '18-4430 TPG', hex: '#007493', name: 'Fjord Blue', style: 'BOLD' },
  { pantone: '17-5937 TPG', hex: '#00A376', name: 'Deep Mint', style: 'BOLD' },
  { pantone: '16-4834 TPG', hex: '#00A1B4', name: 'Bluebird', style: 'BOLD' },
  { pantone: '17-4724 TPG', hex: '#2F8293', name: 'Pagoda Blue', style: 'BOLD' },
  { pantone: '19-1860 TPG', hex: '#A23550', name: 'Persian Red', style: 'BOLD' },
  { pantone: '18-1950 TPG', hex: '#B53359', name: 'Jazzy', style: 'BOLD' },
  { pantone: '18-3839 TPG', hex: '#625593', name: 'Purple Corallites', style: 'BOLD' },
  { pantone: '16-0953 TPG', hex: '#C59632', name: 'Tawny Olive', style: 'BOLD' },
  { pantone: '18-1655 TPG', hex: '#BF3A45', name: 'Mars Red', style: 'BOLD' },
  { pantone: '14-0760 TPG', hex: '#FDD20E', name: 'Cyber Yellow', style: 'BOLD' },
  { pantone: '18-1662 TPG', hex: '#D13B40', name: 'Flame Scarlet', style: 'BOLD' },
  { pantone: '13-0758 TPG', hex: '#FFD31A', name: 'Dandelion', style: 'BOLD' },
  { pantone: '17-2034 TPG', hex: '#CE4A7E', name: 'Pink Yarrow', style: 'BOLD' },
  { pantone: '14-0446 TPG', hex: '#BBCF51', name: 'Tender Shoots', style: 'BOLD' },
  { pantone: '14-0952 TPG', hex: '#DBAE49', name: 'Spicy Mustard', style: 'BOLD' },
  { pantone: '14-0852 TPG', hex: '#F3C336', name: 'Freesia', style: 'BOLD' },
  { pantone: '17-1664 TPG', hex: '#DF484F', name: 'Poppy Red', style: 'BOLD' },
  { pantone: '16-1358 TPG', hex: '#FD7133', name: 'Orange Tiger', style: 'BOLD' },
];
// Guard — selection & cart state are keyed by hex, so duplicate hexes link
// swatches together (2008 Blue Iris ↔ 2022 Very Peri bug, fixed 2026-06).
// Warn loudly in dev if a duplicate ever creeps back in.
(function _checkDuplicateHexes() {
  var seen = {};
  PANTONE_LIBRARY.forEach(function (p) {
    var k = p.hex.toLowerCase();
    if (seen[k]) console.warn('[PANTONE_LIBRARY] duplicate hex ' + p.hex + ': "' + seen[k] + '" and "' + p.name + '" — selection state will link these swatches!');
    else seen[k] = p.name;
  });
})();

// ─── Stand Mood — 5 collapsible mood rows (mirrors Face Mood design) ────────
// Reuses MOOD_ROW_META, PANTONE_LIBRARY, _classifyTPGByStyle from Face.
// Applies colour to legs via a9Bridge.setLegsCustom (not setCustomPantone).

/** Which stand mood row is currently expanded (null = none) */
window._standMoodExpandedStyle = null;
/** Which stand mood row has full library open */
window._standMoodShowAllStyle = null;
/** Global search query for stand mood */
window._standMoodGlobalSearchQuery = '';

function renderStandMoodRows() {
  const host = document.getElementById('standMoodRowsContainer');
  if (!host) return;

  const selectedHex = state.legsCustom?.hex?.toLowerCase() || null;

  host.innerHTML = MOOD_ROW_META.map(meta => {
    const style = meta.style;
    const curated = PANTONE_LIBRARY.filter(p => p.style === style);
    const isExpanded = window._standMoodExpandedStyle === style;
    const isShowAll = isExpanded && window._standMoodShowAllStyle === style;
    const isActive = selectedHex && curated.some(p => p.hex.toLowerCase() === selectedHex);

    // Phase UX polish #46 — dot indicator (max 6 evenly-spaced colors)
    var _acStops = [];
    if (curated.length <= 6) {
      _acStops = curated.map(function(c) { return c.hex; });
    } else {
      for (var _ai = 0; _ai < 6; _ai++) {
        _acStops.push(curated[Math.round(_ai * (curated.length - 1) / 5)].hex);
      }
    }
    const accentDots = _acStops.map(function(hex) {
      return '<span class="mood-row-accent-dot" style="background:' + hex + '"></span>';
    }).join('');

    // Swatch grid
    let gridHtml = '';
    const allForStyle = _classifyTPGByStyle(style);
    const plusLabel = allForStyle.length + '+ colours';
    const plusBtn = '<button class="mood-swatch-more" data-style="' + style + '" data-action="stand-show-all" type="button" aria-label="' + plusLabel + '">' +
                    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3v10M3 8h10"/></svg></button>';

    if (isShowAll) {
      gridHtml = allForStyle.map(p => {
        var _pk = p.hex.toLowerCase();
        var _smq = _standMoodCartQty[_pk];
        var _hasSmq = _smq && _smq.qty > 0;
        var _smSel = _hasSmq ? ' is-selected' : (selectedHex && selectedHex === _pk ? ' is-selected' : '');
        var _smQcls = _hasSmq ? ' has-qty' : '';
        var _smBadge = _hasSmq ? '<span class="mood-swatch-qty">' + _smq.qty + '</span>' : '';
        var _smMinus = _hasSmq ? '<span class="mood-swatch-minus" data-action="stand-mood-minus" data-hex="' + p.hex + '">−</span>' : '';
        return '<button class="mood-swatch' + _smSel + _smQcls + '" data-hex="' + p.hex + '" ' +
               'data-code="' + (p.code || p.pantone) + '" data-name="' + (p.name || p.code) + '" ' +
               'data-style="' + style + '" data-target="legs" ' +
               'style="background:' + p.hex + '" aria-label="' + (p.name || p.code) + '">' + _smBadge + _smMinus + '</button>';
      }).join('');
    } else {
      gridHtml = curated.map(p => {
        var _pk = p.hex.toLowerCase();
        var _smq = _standMoodCartQty[_pk];
        var _hasSmq = _smq && _smq.qty > 0;
        var _smSel = _hasSmq ? ' is-selected' : (selectedHex && selectedHex === _pk ? ' is-selected' : '');
        var _smQcls = _hasSmq ? ' has-qty' : '';
        var _smBadge = _hasSmq ? '<span class="mood-swatch-qty">' + _smq.qty + '</span>' : '';
        var _smMinus = _hasSmq ? '<span class="mood-swatch-minus" data-action="stand-mood-minus" data-hex="' + p.hex + '">−</span>' : '';
        return '<button class="mood-swatch' + _smSel + _smQcls + '" data-hex="' + p.hex + '" ' +
               'data-code="' + p.pantone + '" data-name="' + p.name + '" ' +
               'data-style="' + style + '" data-target="legs" ' +
               'style="background:' + p.hex + '" aria-label="' + p.name + '">' + _smBadge + _smMinus + '</button>';
      }).join('');
      if (allForStyle.length > curated.length) {
        gridHtml += plusBtn;
      }
    }

    const chevronSvg = '<svg class="mood-row-chevron" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 6l4 4 4-4"/></svg>';

    return '<div class="mood-row' + (isExpanded ? ' is-expanded' : '') + (isActive ? ' is-active' : '') + '" data-style="' + style + '" data-target="legs">' +
           '  <div class="mood-row-header" data-style="' + style + '" data-target="legs">' +
           '    <div class="mood-row-info">' +
           '      <div class="mood-row-meta">' +
           '        <div class="mood-row-name">' + meta.name + '</div>' +
           '        <div class="mood-row-tags">' + meta.tags + '</div>' +
           '      </div>' +
           '      ' + chevronSvg +
           '    </div>' +
           '    <div class="mood-row-accent">' + accentDots + '</div>' +
           '  </div>' +
           '  <div class="mood-row-body">' +
           '    <div class="mood-row-body-inner">' +
           '    <div class="mood-row-grid">' + gridHtml + '</div>' +
           '    </div>' +
           '  </div>' +
           '</div>';
  }).join('');

  // Global search pill
  const globalQ = (window._standMoodGlobalSearchQuery || '').trim();
  const searchIcon = '<svg class="mood-global-search-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="7" cy="7" r="4.5"/><path d="M10.5 10.5L14 14"/></svg>';
  var _smClearVis = globalQ ? ' is-visible' : '';
  host.innerHTML += '<div class="mood-global-search">' +
    searchIcon +
    '<input class="mood-global-search-input stand-mood-search" type="search" enterkeyhint="search" autocomplete="off" autocorrect="off" spellcheck="false" ' +
    'placeholder="Search by name, hex or Pantone." ' +
    'value="' + (globalQ || '').replace(/"/g, '&quot;') + '" />' +
    '<button class="mood-global-search-clear' + _smClearVis + '" data-action="stand-mood-clear-search" type="button" aria-label="Clear search">×</button>' +
    '</div>';

  // Search results
  if (globalQ) {
    const q = globalQ.toLowerCase();
    const list = (typeof _tpgList === 'function') ? _tpgList() : [];
    const matches = list.filter(p =>
      (p.name || '').toLowerCase().includes(q) ||
      (p.code || '').toLowerCase().includes(q) ||
      (p.hex  || '').toLowerCase().includes(q)
    );
    const selectedHexLower = selectedHex || '';
    let resultsHtml = '';
    if (matches.length === 0) {
      resultsHtml = '<p style="text-align:center;font:400 12px/1.4 var(--font-sans);color:var(--fg-secondary);padding:16px 0">No colours match “' + globalQ + '”.</p>';
    } else {
      const shown = matches.slice(0, 80);
      resultsHtml = '<div class="mood-row-grid" style="padding-top:10px">' +
        shown.map(p => {
          var _pk = p.hex.toLowerCase();
          var _smq = _standMoodCartQty[_pk];
          var _hasSmq = _smq && _smq.qty > 0;
          var _smSel = _hasSmq ? ' is-selected' : (selectedHexLower && selectedHexLower === _pk ? ' is-selected' : '');
          var _smQcls = _hasSmq ? ' has-qty' : '';
          var _smBadge = _hasSmq ? '<span class="mood-swatch-qty">' + _smq.qty + '</span>' : '';
          var _smMinus = _hasSmq ? '<span class="mood-swatch-minus" data-action="stand-mood-minus" data-hex="' + p.hex + '">−</span>' : '';
          return '<button class="mood-swatch' + _smSel + _smQcls + '" data-hex="' + p.hex + '" ' +
                 'data-code="' + p.code + '" data-name="' + (p.name || p.code) + '" ' +
                 'data-target="legs" ' +
                 'style="background:' + p.hex + '" aria-label="' + (p.name || p.code) + '">' + _smBadge + _smMinus + '</button>';
        }).join('') +
        '</div>';
      if (matches.length > 80) {
        resultsHtml += '<p style="text-align:center;font:400 12px/1.4 var(--font-sans);color:var(--fg-secondary);margin:6px 0 0">Showing 80 of ' + matches.length + '. Refine your search.</p>';
      }
    }
    host.innerHTML += '<div style="padding:0 4px 8px">' + resultsHtml + '</div>';
  }
}

function expandStandMoodRow(style) {
  if (window._standMoodExpandedStyle === style) return;
  window._standMoodExpandedStyle = style;
  window._standMoodShowAllStyle = null;
  renderStandMoodRows();
  _markRowEntering('.mood-row.is-expanded[data-target="legs"]');
}

var _standMoodCartQty = {};

function selectStandMoodSwatch(hex, code, name, forceAdd) {
  // Strip COTY year prefix for cart/order
  name = name ? name.replace(/^\d{4}\s*[·]\s*/, '') : name;
  var key = hex.toLowerCase();
  var p = (typeof nearestPantone === 'function') ? nearestPantone(hex) : null;
  var swEl = document.querySelector('.mood-swatch[data-target="legs"][data-hex="' + hex + '"]');

  // Mobile: 1st tap = preview, 2nd tap = add. Already-in-cart → skip preview, direct +1.
  if (_tgIsTouchDevice && !forceAdd) {
    // Already in cart → direct increment, no re-preview needed
    if (_standMoodCartQty[key] && _standMoodCartQty[key].qty > 0) {
      selectStandMoodSwatch(hex, code, name, true);
      return;
    }
    if (_isSamePreview('stand-mood', key)) {
      // 2nd tap on previewed swatch → commit
      selectStandMoodSwatch(hex, code, name, true);
      return;
    }
    // 1st tap on new swatch → preview only
    state.legsCustom = { mode: 'pantone', hex: hex, tpg: code, name: name };
    a9Bridge.setLegsCustom({ hex: hex, tpg: code, name: name, mode: 'pantone' });
    a9Bridge.setRotation(false);
    _syncRotationPillOff();
    showViewportToast(hex, name || (p ? p.name : code), '€' + PRICE_LEGS_CUSTOM);
    if (swEl) _setPreviewRing(swEl, 'stand-mood', key);
    return;
  }

  if (!_standMoodCartQty[key]) {
    var _tpgCodeS = code || (p ? p.code : '');
    _standMoodCartQty[key] = { qty: 0, hex: hex, code: _tpgCodeS, tpg: _tpgCodeS, name: name || (p ? p.name : '') };
  }
  _standMoodCartQty[key].qty++;

  state.legsCustom = { mode: 'pantone', hex: hex, tpg: code, name: name };
  // Mutual exclusion: clear in-stock selection
  state.legsAccessory = null;
  state.legs = 'original';
  if (typeof renderStandStockRows === 'function') renderStandStockRows();

  showViewportToast(hex, name || (p ? p.name : code), '€' + PRICE_LEGS_CUSTOM);

  // Dispatch to 3D
  a9Bridge.setLegsCustom({ hex: hex, tpg: code, name: name, mode: 'pantone' });
  a9Bridge.setRotation(false);
  _syncRotationPillOff();

  recomputeTotal();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();

  // Re-render to show selection ring + qty badge
  renderStandMoodRows();

  // Set added ring AFTER render (innerHTML destroyed old element)
  if (_tgIsTouchDevice) {
    var freshMoodEl = document.querySelector('.mood-swatch[data-target="legs"][data-hex="' + hex + '"]');
    if (freshMoodEl) _setAddedRing(freshMoodEl);
  }
}

function _standMoodMinusSwatch(hex) {
  var key = hex.toLowerCase();
  if (!_standMoodCartQty[key]) return;
  _standMoodCartQty[key].qty--;
  if (_standMoodCartQty[key].qty <= 0) delete _standMoodCartQty[key];
  // If no stand mood selections left, clear custom legs
  var anyLeft = false;
  for (var k in _standMoodCartQty) { if (_standMoodCartQty[k].qty > 0) { anyLeft = true; break; } }
  if (!anyLeft && state.legsCustom && state.legsCustom.mode === 'pantone') {
    state.legsCustom = null;
    state.legs = 'original';
    a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } });
    a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
    if (typeof _persistState === 'function') _persistState();
  }
  renderStandMoodRows();
  if (typeof _updateCartPopover === 'function') _updateCartPopover();
  recomputeTotal();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
}

// Event delegation for stand mood rows
(function _wireStandMoodRows() {
  const container = document.getElementById('standMoodRowsContainer');
  if (!container) return;

  // Hover-to-expand rows
  let _standMoodHoverExpandTimer = null;
  let _standMoodClickCollapsedAt = 0;

  container.addEventListener('mouseenter', function(e) {
    const row = e.target.closest('.mood-row[data-target="legs"]');
    if (!row) return;
    const style = row.dataset.style;
    clearTimeout(_standMoodHoverExpandTimer);
    if (Date.now() - _standMoodClickCollapsedAt < 600) return;
    _standMoodHoverExpandTimer = setTimeout(function() {
      expandStandMoodRow(style);
    }, 120);
  }, true);

  container.addEventListener('mouseleave', function(e) {
    clearTimeout(_standMoodHoverExpandTimer);
  }, true);

  // Header click to expand/collapse
  container.addEventListener('click', function(e) {
    const header = e.target.closest('.mood-row-header[data-target="legs"]');
    if (header) {
      const style = header.dataset.style;
      if (window._standMoodExpandedStyle === style) {
        _standMoodClickCollapsedAt = Date.now();
        window._standMoodExpandedStyle = null;
        renderStandMoodRows();
      } else {
        expandStandMoodRow(style);
      }
      return;
    }
    // Show-all "+" button
    const moreBtn = e.target.closest('[data-action="stand-show-all"]');
    if (moreBtn) {
      window._standMoodShowAllStyle = moreBtn.dataset.style;
      renderStandMoodRows();
      return;
    }
    // Minus button click
    const minusBtn = e.target.closest('[data-action="stand-mood-minus"]');
    if (minusBtn) {
      e.stopPropagation();
      _standMoodMinusSwatch(minusBtn.dataset.hex);
      return;
    }
    // Swatch click
    const swatch = e.target.closest('.mood-swatch[data-target="legs"]');
    if (swatch) {
      selectStandMoodSwatch(swatch.dataset.hex, swatch.dataset.code || '', swatch.dataset.name || '');
      return;
    }
  });

  // Hover auto-preview on 3D model
  let _standMoodHoverTimeout = null;
  let _standMoodHovering = false;
  container.addEventListener('mouseover', function(e) {
    const swatch = e.target.closest('.mood-swatch[data-target="legs"]');
    if (!swatch) return;
    clearTimeout(_standMoodHoverTimeout);
    _standMoodHoverTimeout = setTimeout(function() {
      _standMoodHovering = true;
      a9Bridge.setLegsCustom({ hex: swatch.dataset.hex, mode: 'pantone' });
    }, 60);
  });
  container.addEventListener('mouseout', function(e) {
    const swatch = e.target.closest('.mood-swatch[data-target="legs"]');
    if (!swatch) return;
    const related = e.relatedTarget ? e.relatedTarget.closest('.mood-swatch[data-target="legs"]') : null;
    if (related) return;
    clearTimeout(_standMoodHoverTimeout);
    if (!_standMoodHovering) return;
    _standMoodHovering = false;
    // Revert to committed state
    if (state.legsCustom && state.legsCustom.hex) {
      a9Bridge.setLegsCustom({ hex: state.legsCustom.hex, tpg: state.legsCustom.tpg, name: state.legsCustom.name, mode: 'pantone' });
    } else {
      var def = LEG_MATERIALS[state.legs] || { kind: 'wood' };
      a9Bridge.send({ type: 'a9:setStand', stand: state.legs, material: def });
      if (def.kind === 'wood') a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
    }
  });

  // Global search input
  container.addEventListener('input', function(e) {
    if (!e.target.classList.contains('stand-mood-search')) return;
    window._standMoodGlobalSearchQuery = e.target.value;
    renderStandMoodRows();
    // Re-focus the search input after re-render
    var newInput = container.querySelector('.stand-mood-search');
    if (newInput) {
      newInput.focus();
      newInput.setSelectionRange(newInput.value.length, newInput.value.length);
      _scrollPanelToStandSearch(newInput);
    }
  });

  // Clear search button
  container.addEventListener('click', function(e) {
    if (e.target.dataset.action !== 'stand-mood-clear-search') return;
    window._standMoodGlobalSearchQuery = '';
    renderStandMoodRows();
  });

  // Mobile: scroll panel when search input focused
  container.addEventListener('focus', function(e) {
    if (!e.target.classList.contains('stand-mood-search')) return;
    setTimeout(function() { _scrollPanelToStandSearch(e.target); }, 350);
  }, true);

  function _scrollPanelToStandSearch(input) {
    if (window.matchMedia('(min-width: 481px)').matches) return;
    var panel = input.closest('.side-panel');
    if (!panel) return;
    var searchBox = input.closest('.mood-global-search');
    if (!searchBox) return;
    var panelRect = panel.getBoundingClientRect();
    var searchRect = searchBox.getBoundingClientRect();
    var offset = searchRect.top - panelRect.top + panel.scrollTop - 8;
    panel.scrollTo({ top: offset, behavior: 'smooth' });
  }
})();

// Initial render of stand mood rows — deferred because MOOD_ROW_META
// is a const defined later in the script body (not hoisted).
// Actual render triggered by setStandMode('mood') or boot sequence.

// ─── Stand Match — card-style results matching Face Match design ──────────
// Same MATCH_ENDPOINT, same _resizeImageToJpeg, same nearestPantone.
// Renders .match-rec cards instead of bare swatch circles. Applies to legs.

// Stand match recommendations state
var STAND_MATCH_RECS = [];
var STAND_MATCH_RECS_MORE = [];
window._standMatchActiveIdx = null;
window._standMatchMoreIdx = 0;
var _standMatchCartQty = {};  // { idx: qty } for Stand Match multi-select

function renderStandMatchRecs() {
  var host = document.getElementById('standMatchRecsList');
  if (!host) return;
  host.innerHTML = STAND_MATCH_RECS.map(function(rec, i) {
    var qty = _standMatchCartQty[i] || 0;
    var hasQty = qty > 0;
    var cardCls = 'match-rec' + (hasQty ? ' is-active has-qty' : '');
    var swatchHTML = '<span class="match-rec-swatch" style="background:' + rec.hex + '" data-action="stand-match-add" data-idx="' + i + '">' +
      '<span class="match-rec-swatch-plus">' + (hasQty ? '+' : '+') + '</span>' +
      (qty >= 1 ? '<span class="match-rec-swatch-qty">' + qty + '</span>' : '') +
    '</span>';
    var minusHTML = hasQty
      ? '<button class="match-rec-minus" data-action="stand-match-minus" data-idx="' + i + '" type="button">−</button>'
      : '';
    return '<div class="' + cardCls + '" data-idx="' + i + '" data-target="legs">' +
           swatchHTML +
           '  <span class="match-rec-text">' +
           '    <span class="match-rec-name">' + rec.name + '</span>' +
           '    <span class="match-rec-reason">' + (rec.reason || '') + '</span>' +
                      '  </span>' +
           minusHTML +
           '</div>';
  }).join('');
}

function selectStandMatchRec(idx, forceAdd) {
  var rec = STAND_MATCH_RECS[idx];
  if (!rec) return;

  var cardEl = document.querySelector('.match-rec[data-target="legs"][data-idx="' + idx + '"]');

  // Mobile double-tap: 1st tap = preview (gray card border), 2nd tap = add (black card border)
  if (_tgIsTouchDevice && !forceAdd) {
    if (_isSamePreview('stand-match', String(idx))) {
      // 2nd tap → commit
      selectStandMatchRec(idx, true);
      return;
    }
    // 1st tap → preview only
    window._standMatchActiveIdx = idx;
    state.legsCustom = { mode: 'room', hex: rec.hex, tpg: rec.code || '', name: rec.name };
    a9Bridge.setLegsCustom({ hex: rec.hex, tpg: rec.code || '', name: rec.name, mode: 'room' });
    a9Bridge.setRotation(false);
    _syncRotationPillOff();
    showViewportToast(rec.hex, rec.name, '€' + PRICE_LEGS_CUSTOM);
    if (cardEl) _setPreviewRing(cardEl, 'stand-match', String(idx));
    return;
  }

  _standMatchCartQty[idx] = (_standMatchCartQty[idx] || 0) + 1;
  window._standMatchActiveIdx = idx;

  state.legsCustom = { mode: 'room', hex: rec.hex, tpg: rec.code || '', name: rec.name };
  // Mutual exclusion
  state.legsAccessory = null;
  state.legs = 'original';
  if (typeof renderStandStockRows === 'function') renderStandStockRows();

  // 3D preview
  showViewportToast(rec.hex, rec.name, '€' + PRICE_LEGS_CUSTOM);
  a9Bridge.setLegsCustom({ hex: rec.hex, tpg: rec.code || '', name: rec.name, mode: 'room' });
  a9Bridge.setRotation(false);
  _syncRotationPillOff();

  renderStandMatchRecs();
  recomputeTotal();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();

  // Card-level: .is-active from render handles black border; clear preview state
  if (_tgIsTouchDevice) {
    _clearPreviewRing();
  }
}

function _standMatchMinusRec(idx) {
  if (!_standMatchCartQty[idx]) return;
  _standMatchCartQty[idx]--;
  if (_standMatchCartQty[idx] <= 0) delete _standMatchCartQty[idx];

  // If no match selections left, clear custom legs
  var anyLeft = false;
  for (var k in _standMatchCartQty) { if (_standMatchCartQty[k] > 0) { anyLeft = true; break; } }
  if (!anyLeft && state.legsCustom && state.legsCustom.mode === 'room') {
    state.legsCustom = null;
    state.legs = 'original';
    a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } });
    a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
    if (typeof _persistState === 'function') _persistState();
  }
  renderStandMatchRecs();
  if (typeof _updateCartPopover === 'function') _updateCartPopover();
  recomputeTotal();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
}

// Bind Stand Match interactions
(function _bindStandMatch() {
  var fileInput = document.getElementById('standMatchRoomFile');
  var uploadState = document.getElementById('standMatchUploadState');
  var resultsState = document.getElementById('standMatchResultsState');
  var photoImg = document.getElementById('standMatchPhotoImg');
  var analyzing = document.getElementById('standMatchAnalyzing');
  var recsList = document.getElementById('standMatchRecsList');

  if (fileInput) {
    fileInput.addEventListener('change', function(e) {
      var file = e.target.files && e.target.files[0];
      if (!file) return;
      fileInput.value = '';

      var reader = new FileReader();
      reader.onload = function() {
        // Show results state with photo preview
        if (uploadState) uploadState.hidden = true;
        if (resultsState) resultsState.hidden = false;
        if (photoImg) photoImg.src = reader.result;

        // Show analyzing spinner
        if (analyzing) analyzing.hidden = false;
        if (recsList) recsList.hidden = true;

        // Resize and send to API
        _resizeImageToJpeg(file, 1280, 0.85).then(function(resized) {
          var base64 = resized.b64;
          window._standMatchThumbDataUrl = reader.result;

          return fetch(MATCH_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ image: base64, mediaType: 'image/jpeg' })
          });
        }).then(function(response) {
          return response.text().then(function(text) {
            if (!response.ok) throw new Error('Server ' + response.status);
            var data;
            try { data = JSON.parse(text); } catch(e) { throw new Error('Invalid JSON'); }
            if (data.error) throw new Error(data.error);
            return data;
          });
        }).then(function(data) {
          // Process results — snap to nearest TPG and build match-rec cards
          var recs = (data.dominant_colors || []).slice(0, 3).map(function(targetHex) {
            var m = (typeof nearestPantone === 'function') ? nearestPantone(targetHex) : null;
            return m
              ? { hex: m.hex, code: m.code, name: m.name || m.code, reason: 'Complements your room palette' }
              : { hex: targetHex, code: '', name: targetHex, reason: 'Extracted from your photo' };
          });
          // Build more pool from remaining colors
          var morePool = (data.dominant_colors || []).slice(3).map(function(targetHex) {
            var m = (typeof nearestPantone === 'function') ? nearestPantone(targetHex) : null;
            return m
              ? { hex: m.hex, code: m.code, name: m.name || m.code, reason: 'Additional room accent' }
              : { hex: targetHex, code: '', name: targetHex, reason: 'From your room photo' };
          });

          STAND_MATCH_RECS = recs;
          STAND_MATCH_RECS_MORE = morePool;
          window._standMatchActiveIdx = null;
          window._standMatchMoreIdx = 0;

          if (analyzing) analyzing.hidden = true;
          if (recsList) recsList.hidden = false;
          renderStandMatchRecs();

          // Auto-select first recommendation
          if (recs.length > 0) selectStandMatchRec(0);
        }).catch(function(err) {
          console.error('[stand-match]', err);
          if (analyzing) analyzing.hidden = true;
          if (recsList) {
            recsList.hidden = false;
            recsList.innerHTML = '<p style="text-align:center;color:var(--fg-secondary);font:400 14px/1.4 var(--font-sans);padding:16px 0">' +
              'Analysis failed. Please try again.</p>';
          }
        });
      };
      reader.readAsDataURL(file);
    });
  }

  // Recommendation clicks (event delegation) — multi-select pattern matching Cover Match
  if (recsList) {
    recsList.addEventListener('click', function(e) {
      // Swatch or + overlay click → add/increment
      var addEl = e.target.closest('[data-action="stand-match-add"]');
      if (addEl) {
        e.stopPropagation();
        selectStandMatchRec(parseInt(addEl.dataset.idx, 10));
        return;
      }
      // Minus button click → decrement
      var minusEl = e.target.closest('[data-action="stand-match-minus"]');
      if (minusEl) {
        e.stopPropagation();
        _standMatchMinusRec(parseInt(minusEl.dataset.idx, 10));
        return;
      }
      // Card body click — add/increment
      var rec = e.target.closest('.match-rec[data-target="legs"]');
      if (!rec) return;
      selectStandMatchRec(parseInt(rec.dataset.idx, 10));
    });

    // Hover auto-preview on 3D
    var _standMatchHoverPrev = null;
    var _standMatchHovering = false;
    recsList.addEventListener('mouseover', function(e) {
      var card = e.target.closest('.match-rec[data-target="legs"]');
      if (!card) return;
      var idx = parseInt(card.dataset.idx, 10);
      var data = STAND_MATCH_RECS[idx];
      if (!data) return;
      if (!_standMatchHovering) {
        _standMatchHoverPrev = state.legsCustom ? state.legsCustom.hex : null;
        _standMatchHovering = true;
      }
      a9Bridge.setLegsCustom({ hex: data.hex, mode: 'room' });
    });
    recsList.addEventListener('mouseleave', function() {
      if (!_standMatchHovering) return;
      _standMatchHovering = false;
      if (state.legsCustom && state.legsCustom.hex) {
        a9Bridge.setLegsCustom({ hex: state.legsCustom.hex, tpg: state.legsCustom.tpg, name: state.legsCustom.name, mode: 'room' });
      } else {
        var def = LEG_MATERIALS[state.legs] || { kind: 'wood' };
        a9Bridge.send({ type: 'a9:setStand', stand: state.legs, material: def });
        if (def.kind === 'wood') a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
      }
    });
  }

  // More button
  var moreBtn = document.getElementById('standMatchMoreColours');
  if (moreBtn) {
    moreBtn.addEventListener('click', function() {
      var pool = STAND_MATCH_RECS_MORE;
      var count = Math.min(3, pool.length);
      if (count === 0) return;
      for (var k = 0; k < count; k++) {
        var pi = (window._standMatchMoreIdx + k) % pool.length;
        var rec = pool[pi];
        var isDupe = STAND_MATCH_RECS.some(function(r) { return r.hex === rec.hex; });
        if (!isDupe) STAND_MATCH_RECS.push(rec);
      }
      window._standMatchMoreIdx = (window._standMatchMoreIdx + count) % Math.max(pool.length, 1);
      renderStandMatchRecs();
      if (STAND_MATCH_RECS.length >= 3 + pool.length) moreBtn.style.display = 'none';
    });
  }

  // Reset button
  var resetBtn = document.getElementById('standMatchReset');
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      STAND_MATCH_RECS = [];
      STAND_MATCH_RECS_MORE = [];
      window._standMatchActiveIdx = null;
      window._standMatchMoreIdx = 0;
      if (resultsState) resultsState.hidden = true;
      if (uploadState) uploadState.hidden = false;
      if (moreBtn) moreBtn.style.display = '';
      // Revert legs to stock state
      state.legsCustom = null;
      var def = LEG_MATERIALS[state.legs] || { kind: 'wood' };
      a9Bridge.send({ type: 'a9:setStand', stand: state.legs, material: def });
      if (def.kind === 'wood') a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
      recomputeTotal();
      if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
    });
  }
})();

// Phase 3.6 boot — sync preset + custom section visuals from current state, refresh footer
// Phase 4.23 — each bootstrap call wrapped so a failure in one never aborts
// the rest of the IIFE / script body (preventing the cascade where every
// listener after the throw point silently dies).
function _safeBoot(label, fn) {
  try { fn(); } catch (err) { console.error('[init:' + label + ']', err); }
}
// Phase 4.37 FIX B — paint the composition title's variation No. before
// any other init runs. The HTML ships with a placeholder "333" so the
// customer would otherwise see that flash for one tick before
// bootConfigurator() reaches the same writer further down. Early seed +
// late re-write keeps both surfaces correct without ordering risk.
_safeBoot('syncShopifyPrices', _syncShopifyPrices);
_safeBoot('tgCartInit', () => tgCart.init());
_safeBoot('syncCompNumber', () => {
  const el = document.getElementById('compNumber');
  if (el) el.textContent = _getOrCreateVariationNumber();
});
_safeBoot('syncPresetFromState',         () => _syncPresetFromState());
_safeBoot('syncCustomSwatchesFromState', () => _syncCustomSwatchesFromState());
_safeBoot('syncCoverSelectedStrip',      () => _syncCoverSelectedStrip());
_safeBoot('renderKeepsake',              () => _renderKeepsake());
_safeBoot('bindKeepsakeBack',            () => bindKeepsakeBack());
_safeBoot('bindKeepsakeOrder',           () => bindKeepsakeOrder());
_safeBoot('bindKeepsakeDownload',        () => bindKeepsakeDownload());
_safeBoot('bindKeepsakeShare',           () => bindKeepsakeShare());
_safeBoot('bindKeepsakeNameEditor',      () => bindKeepsakeNameEditor());
_safeBoot('bindReviewOverlay',           () => bindReviewOverlay());

// Init sliding pill indicators (needs layout, so defer one frame; instant=true to skip animation)
requestAnimationFrame(function() {
  if (typeof _updateModeSlider === 'function') {
    _updateModeSlider(document.getElementById('coverModeSwitch'), true);
    _updateModeSlider(document.getElementById('standModeSwitch'), true);
  }
});

// Phase 5.1 D2 — search-toggle binder. Shows/hides the cover-search-row
// and focuses the input on open; clears any in-flight query on close so
// the curated grid returns when the magnifier collapses.
_safeBoot('bindCoverSearchToggle', () => {
  const toggle = document.getElementById('coverSearchToggle');
  const row = document.querySelector('.cover-search-row');
  if (!toggle || !row) return;
  toggle.addEventListener('click', () => {
    const showing = row.classList.toggle('is-visible');
    toggle.classList.toggle('is-active', showing);
    if (showing) {
      const input = document.getElementById('coverSearchInput');
      if (input) input.focus();
    } else {
      const input = document.getElementById('coverSearchInput');
      if (input && input.value) {
        input.value = '';
        window._coverSearchQuery = '';
        if (typeof renderPantoneGrid === 'function') renderPantoneGrid();
      }
    }
  });
});

// Phase 5.1 D7 — CTA entrance pulse. 1.5 s delay gives the customer time
// to orient; animation runs 3× per the keyframes; class auto-removes.
_safeBoot('ctaPulse', () => {
  setTimeout(() => {
    const ctaBtn = document.getElementById('ctaNext');
    if (!ctaBtn) return;
    ctaBtn.classList.add('is-pulsing');
    ctaBtn.addEventListener('animationend',
      () => ctaBtn.classList.remove('is-pulsing'),
      { once: true });
  }, 1500);
});
// Phase 4.36 — seed body[data-active-pane] so the Step 4 CSS rules have a
// no-op default while the customer is on Step 1/2/3. Subsequent goToStep /
// applyStep calls keep this attribute in sync.
_safeBoot('initActivePaneAttr', () => {
  document.body.setAttribute('data-active-pane', 'speaker');
});
// Tell the viewer which render mode to use, tracking the active pane via one
// observer (catches all setAttribute sites + future ones). review → 'reveal'
// (warm HDRI), everything else → 'select' (neutral light, true colour).
// Viewer side: codex-render-warmth-spec.md §5. Harmless until codex implements.
_safeBoot('initRenderModeBridge', () => {
  var emitRenderMode = function () {
    var pane = document.body.getAttribute('data-active-pane');
    if (typeof a9Bridge !== 'undefined' && a9Bridge.setRenderMode) {
      a9Bridge.setRenderMode(pane === 'review' ? 'reveal' : 'select');
    }
    if (typeof a9Bridge !== 'undefined' && a9Bridge.setDayNight) {
      a9Bridge.setDayNight(document.body.classList.contains('is-night') ? 'night' : 'day');
    }
  };
  emitRenderMode();
  new MutationObserver(emitRenderMode).observe(document.body, {
    attributes: true, attributeFilter: ['data-active-pane']
  });
});
_safeBoot('bindCoverUploadEditor',       () => bindCoverUploadEditor());
_safeBoot('syncCoverUploadInitialState', () => {
  // Phase 6.1 — multi-upload: if there are saved uploads, show the list.
  if (state.uploadCovers && state.uploadCovers.length > 0) _enterListState();
  else if (state.coverUpload && state.coverUpload.composedDataUrl) _enterAppliedState();
  else if (state.coverUpload && state.coverUpload.dataUrl)    _enterEditingState();
  else                                                        _enterEmptyState();
});
// Phase 4.29 — if a future persistence layer rehydrates state.coverUpload
// (dataUrl + scalar params) without the unsemantic _image cache, decode
// once and push the first live frame. No-op when nothing is persisted.
_safeBoot('rehydrateCoverUpload', () => {
  if (state.coverUpload && state.coverUpload.dataUrl && !state.coverUpload._image) {
    _decodeAndCacheUploadImage()
      .then(() => _scheduleCoverLivePreview())
      .catch((err) => console.error('[coverUpload.rehydrate]', err));
  }
});
_safeBoot('updateCtaSummary',            () => {
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
});

/* Phase 4 — custom-section three-state pattern: hover previews active-name, mouseleave reverts
   to the committed selection, click adds .has-selection (description locks visible). The
   existing click handlers (above) already mutate state + toggle is-active + commit active-name
   text; this just adds the hover/leave preview + has-selection persistence on top. Both listener
   sets fire on the same swatch click — order is fine because the existing handler has already
   set is-active before my mouseleave reads it. */
(function _wireCustomRowPreviewBehavior() {
  function wire(gridId, activeNameId) {
    const grid = document.getElementById(gridId);
    const activeNameEl = document.getElementById(activeNameId);
    if (!grid || !activeNameEl) return;
    grid.querySelectorAll('.swatch').forEach(sw => {
      sw.addEventListener('mouseenter', () => {
        const label = sw.getAttribute('aria-label');
        if (label) activeNameEl.textContent = label;
      });
      sw.addEventListener('mouseleave', () => {
        const selected = grid.querySelector('.swatch.is-active');
        if (selected) activeNameEl.textContent = selected.getAttribute('aria-label') || activeNameEl.textContent;
      });
      sw.addEventListener('click', () => {
        const row = sw.closest('.custom-row');
        if (row) row.classList.add('has-selection');
      });
    });
  }
  wire('speakerSwatches', 'speakerActiveName');
  wire('coverFaceSwatches', 'coverActiveName');
  wire('legsCustomSwatches', 'legsActiveName');
})();

/* =====================================================================
   Cover V2 — Mode switching, header path, and panel content updates.
   Three modes: mood (default) | upload | match.
   ===================================================================== */
const COVER_MODE_COPY = {
  mood:   { title: '<em>Colour directions.</em>',  desc: 'Each mood is a point of view on colour. Select one — the A9 updates live.' },
  upload: { title: '<em>Your image. On the A9.</em>',  desc: 'A photograph, a painting, a pattern — anything you bring becomes the face.' },
  match:  { title: '<em>Colours from your room.</em>', desc: 'Upload a room photo — we\'ll suggest covers to match.' }
};

const STEP_PATH_MAP = {
  '1': 'VARIATION',
  '2-mood':   'VARIATION',
  '2-upload': 'VARIATION',
  '2-match':  'VARIATION',
  '3-stock':  'VARIATION',
  '3-mood':   'VARIATION',
  '3-match':  'VARIATION',
  '3': 'VARIATION',
  '4': 'VARIATION'
};

const STAND_MODE_COPY = {
  stock: { title: '<em>The final layer.</em>',        desc: 'Even the legs are a choice. Match the room, or let them stand apart.' },
  mood:  { title: '<em>Colour directions.</em>',      desc: 'All three legs in one Pantone colour. Select one and the A9 updates live.' },
  match: { title: '<em>Colours from your room.</em>', desc: 'Upload a room photo — we\'ll suggest a stand finish.' }
};

/** Current cover mode — persisted via _persistState / _restoreState */
window._coverMode = 'mood';
/** Current stand mode */
window._standMode = 'mood';

/**
 * Update the header eyebrow path based on current step + cover/stand mode.
 * Each segment is clickable to navigate back to that step.
 */
function _updateHeaderPath() {
  const eyebrow = document.querySelector('.variation-eyebrow');
  if (!eyebrow) return;
  const step = window._currentStep
    || (document.querySelector('.step.is-active') || {}).dataset?.step
    || '1';
  let key = step;
  if (step === '2') key = '2-' + (window._coverMode || 'mood');
  if (step === '3') key = '3-' + (window._standMode || 'mood');
  const pathStr = STEP_PATH_MAP[key] || 'VARIATION';
  const parts = pathStr.split(' / ');
  // Map segment labels to step numbers
  const SEG_TO_STEP = { 'VARIATION': '1', 'SPEAKER': '1', 'INSTRUMENT': '1', 'COVER': '2', 'FACE': '2', 'MOOD': '2', 'UPLOAD': '2', 'MATCH': '2', 'LEGS': '3', 'STAND': '3', 'STOCK': '3', 'REVIEW': '4', 'REVEAL': '4' };
  eyebrow.innerHTML = parts.map(function(seg, i) {
    var sep = i > 0 ? '<span class="variation-eyebrow-sep">/</span>' : '';
    return sep + '<span class="variation-eyebrow-seg" data-nav-step="' + (SEG_TO_STEP[seg] || '1') + '">' + seg + '</span>';
  }).join('');
}

/* Breadcrumb click delegation — navigate to step */
(function() {
  var ey = document.querySelector('.variation-eyebrow');
  if (!ey) return;
  ey.addEventListener('click', function(e) {
    var seg = e.target.closest('.variation-eyebrow-seg');
    if (!seg) return;
    var step = seg.dataset.navStep;
    if (!step) return;
    e.preventDefault(); e.stopPropagation();
    if (typeof window.goToStep === 'function') {
      window.goToStep(parseInt(step, 10));
    } else if (typeof applyStep === 'function') {
      applyStep(step);
    }
  });
})();

/**
 * Switch cover mode — updates pills, panes, panel header, and header path.
 * Does NOT add Apply buttons for mood/match — selections update 3D immediately.
 */
function setCoverMode(mode) {
  if (!['mood', 'upload', 'match'].includes(mode)) return;
  window._coverMode = mode;

  // 1. Update pill switch
  document.querySelectorAll('#coverModeSwitch .cover-mode-btn').forEach(btn => {
    btn.classList.toggle('is-active', btn.dataset.mode === mode);
  });

  // 2. Show/hide mode panes
  document.querySelectorAll('.cover-mode-pane').forEach(pane => {
    const isTarget = pane.dataset.coverMode === mode;
    pane.classList.toggle('is-active', isTarget);
    // Also set hidden so screen readers skip inactive panes
    if (!isTarget) pane.setAttribute('hidden', '');
    else pane.removeAttribute('hidden');
  });

  // 3. Update panel header copy
  const copy = COVER_MODE_COPY[mode];
  const titleEl = document.getElementById('coverTitle');
  const descEl  = document.getElementById('coverDesc');
  if (titleEl && copy) titleEl.innerHTML = copy.title;
  if (descEl  && copy) descEl.textContent = copy.desc;
  var attrEl = document.getElementById('coverAttribution');
  if (attrEl) attrEl.textContent = (copy && copy.attribution) || '';

  // 4. Update header path
  _updateHeaderPath();

  // 5. Slide indicator
  _updateModeSlider(document.getElementById('coverModeSwitch'));

  // 6. Mobile: auto-expand sheet for content-heavy modes
  if (typeof window._expandBottomSheet === 'function') window._expandBottomSheet();

  // 7. Persist
  if (typeof _persistState === 'function') _persistState();
}

/**
 * Sliding pill indicator — measures the active button's position and
 * moves the `.cover-mode-slider` span to match via transform + width.
 * If instant=true, suppress the CSS transition (used on first render).
 */
function _updateModeSlider(switchEl, instant) {
  if (!switchEl) return;
  var slider = switchEl.querySelector('.cover-mode-slider');
  var active = switchEl.querySelector('.cover-mode-btn.is-active');
  if (!slider || !active) return;
  var swRect = switchEl.getBoundingClientRect();
  var btnRect = active.getBoundingClientRect();
  // If element is hidden (zero width), defer to next visibility
  if (btnRect.width === 0) {
    switchEl.dataset.sliderDirty = '1';
    return;
  }
  var offsetX = btnRect.left - swRect.left - 3; // 3 = padding
  if (instant) slider.style.transition = 'none';
  slider.style.width = btnRect.width + 'px';
  slider.style.transform = 'translateX(' + offsetX + 'px)';
  if (instant) {
    // Force reflow then restore transition
    slider.offsetHeight; // eslint-disable-line no-unused-expressions
    slider.style.transition = '';
  }
  delete switchEl.dataset.sliderDirty;
}

// Bind pill switch clicks
(function _bindCoverModeSwitch() {
  const sw = document.getElementById('coverModeSwitch');
  if (!sw) return;
  sw.addEventListener('click', function(e) {
    const btn = e.target.closest('.cover-mode-btn');
    if (!btn || !btn.dataset.mode) return;
    setCoverMode(btn.dataset.mode);
  });
})();

// Bind Browse full colour library / Back to moods
(function _bindMoodLibraryToggle() {
  const browseBtn = document.getElementById('moodBrowseBtn');
  const backBtn   = document.getElementById('moodLibraryBack');
  const wrap      = document.getElementById('moodLibraryWrap');
  const cardsWrap = document.getElementById('moodCards');
  const tagEl     = document.querySelector('.mood-curated-tag');

  if (browseBtn && wrap) {
    browseBtn.addEventListener('click', function() {
      wrap.classList.add('is-open');
      if (browseBtn) browseBtn.hidden = true;
      if (cardsWrap) cardsWrap.hidden = true;
      if (tagEl) tagEl.hidden = true;
      if (typeof renderPantoneGrid === 'function') renderPantoneGrid();
    });
  }
  if (backBtn && wrap) {
    backBtn.addEventListener('click', function() {
      wrap.classList.remove('is-open');
      if (browseBtn) browseBtn.hidden = false;
      if (cardsWrap) cardsWrap.hidden = false;
      if (tagEl) tagEl.hidden = false;
    });
  }
})();

/* =====================================================================
   Cover V2 — Mood mode: curated mood sets + rendering + click handlers.
   Each mood set is a small editorial grouping of 4-5 Pantone colors.
   Clicking a mood card selects the first color and updates 3D immediately.
   Clicking an individual swatch within a mood refines the selection.
   ===================================================================== */
/* =====================================================================
   Mood V2 — Collapsible mood rows backed by PANTONE_LIBRARY.
   6 rows (COTY / NORDIC / EARTHY / JAPANDI / STONE / BOLD).
   Collapsed: 5 preview dots + name + tags.
   Hover header → expand to circular swatch grid.
   Hover swatch → tooltip + live 3D preview.
   Click swatch → persistent selection.
   "SHOW ALL" → expand full TPG library for that style (with search).
   ===================================================================== */

const MOOD_ROW_META = [
  { style: 'COTY',    name: 'Colour of the Year', tags: 'Pantone archive' },
  { style: 'TREND26', name: '2026 Interiors', tags: 'paint-house picks' },
  { style: 'NORDIC',  name: 'Nordic',  tags: 'quiet, pale, soft' },
  { style: 'EARTHY',  name: 'Earthy',  tags: 'clay, wood, warmth' },
  { style: 'JAPANDI', name: 'Japandi', tags: 'zen, muted, nature' },
  { style: 'STONE',   name: 'Stone',   tags: 'cool, mineral, deep' },
  { style: 'BOLD',    name: 'Bold',    tags: 'vivid, graphic, pop' }
];

/** Which mood row is currently expanded (null = none) */
window._expandedMoodStyle = null;
/** Which mood row has its full library open (null = none) */
window._moodShowAllStyle = null;
/** Per-row search query for full-library mode */
window._moodSearchQuery = {};

/**
 * Render all 5 mood rows into #moodRowsContainer.
 * Collapsed: rectangular color strip + name + tags + chevron.
 * Expanded (on hover): circular swatch grid.
 * "+" circle at end of curated grid → expand full library.
 */
var _moodCartQty = {};  // Mood multi-select state (must be before renderMoodRows)
function renderMoodRows() {
  const host = document.getElementById('moodRowsContainer');
  if (!host) return;

  const selectedHex = window._coverSelectedHex || null;

  host.innerHTML = MOOD_ROW_META.map(meta => {
    const style = meta.style;
    const curated = PANTONE_LIBRARY.filter(p => p.style === style);
    const isExpanded = window._expandedMoodStyle === style;
    const isShowAll = window._moodShowAllStyle === style;
    const isActive = selectedHex && curated.some(p => p.hex.toLowerCase() === selectedHex.toLowerCase());

    // Phase UX polish #46 — dot indicator (max 6 evenly-spaced colors)
    var _acStops = [];
    if (curated.length <= 6) {
      _acStops = curated.map(function(c) { return c.hex; });
    } else {
      for (var _ai = 0; _ai < 6; _ai++) {
        _acStops.push(curated[Math.round(_ai * (curated.length - 1) / 5)].hex);
      }
    }
    const accentDots = _acStops.map(function(hex) {
      return '<span class="mood-row-accent-dot" style="background:' + hex + '"></span>';
    }).join('');

    // Build swatch grid (curated or full library)
    let gridHtml = '';
    let searchHtml = '';
    let toggleHtml = '';

    const allForStyle = _classifyTPGByStyle(style);
    const plusLabel = allForStyle.length + '+ colours';
    const plusBtn = '<button class="mood-swatch-more" data-style="' + style + '" data-action="show-all" type="button" aria-label="' + plusLabel + '">' +
                    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3v10M3 8h10"/></svg></button>';

    if (isShowAll) {
      gridHtml = allForStyle.map(p => {
        const sel = selectedHex && selectedHex.toLowerCase() === p.hex.toLowerCase() ? ' is-selected' : '';
        var _mqty = _moodCartQty[p.hex.toLowerCase()];
        var _hasQ = _mqty && _mqty.qty > 0;
        var _qCls = _hasQ ? ' has-qty' : '';
        var _qBadge = _hasQ ? '<span class="mood-swatch-qty">' + _mqty.qty + '</span>' : '';
        var _qMinus = _hasQ ? '<span class="mood-swatch-minus" data-action="mood-minus" data-hex="' + p.hex + '">−</span>' : '';
        return '<button class="mood-swatch' + sel + _qCls + '" data-hex="' + p.hex + '" ' +
               'data-code="' + (p.code || p.pantone) + '" data-name="' + (p.name || p.code) + '" ' +
               'data-style="' + style + '" ' +
               'style="background:' + p.hex + '" aria-label="' + (p.name || p.code) + '">' + _qBadge + _qMinus + '</button>';
      }).join('');
    } else {
      gridHtml = curated.map(p => {
        const sel = selectedHex && selectedHex.toLowerCase() === p.hex.toLowerCase() ? ' is-selected' : '';
        var _mqty = _moodCartQty[p.hex.toLowerCase()];
        var _hasQ = _mqty && _mqty.qty > 0;
        var _qCls = _hasQ ? ' has-qty' : '';
        var _qBadge = _hasQ ? '<span class="mood-swatch-qty">' + _mqty.qty + '</span>' : '';
        var _qMinus = _hasQ ? '<span class="mood-swatch-minus" data-action="mood-minus" data-hex="' + p.hex + '">−</span>' : '';
        return '<button class="mood-swatch' + sel + _qCls + '" data-hex="' + p.hex + '" ' +
               'data-code="' + p.pantone + '" data-name="' + p.name + '" ' +
               'data-style="' + style + '" ' +
               'style="background:' + p.hex + '" aria-label="' + p.name + '">' + _qBadge + _qMinus + '</button>';
      }).join('');
      const allCount = _classifyTPGByStyle(style).length;
      if (allCount > curated.length) {
        gridHtml += plusBtn;
      }
    }

    const chevronSvg = '<svg class="mood-row-chevron" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 6l4 4 4-4"/></svg>';

    return '<div class="mood-row' + (isExpanded ? ' is-expanded' : '') + (isActive ? ' is-active' : '') + '" data-style="' + style + '">' +
           '  <div class="mood-row-header" data-style="' + style + '">' +
           '    <div class="mood-row-info">' +
           '      <div class="mood-row-meta">' +
           '        <div class="mood-row-name">' + meta.name + '</div>' +
           '        <div class="mood-row-tags">' + meta.tags + '</div>' +
           '      </div>' +
           '      ' + chevronSvg +
           '    </div>' +
           '    <div class="mood-row-accent">' + accentDots + '</div>' +
           '  </div>' +
           '  <div class="mood-row-body">' +
           '    <div class="mood-row-body-inner">' +
           '    ' + searchHtml +
           '    <div class="mood-row-grid">' + gridHtml + '</div>' +
           '    ' + toggleHtml +
           '    </div>' +
           '  </div>' +
           '</div>';
  }).join('');

  // Global search pill — after all mood rows
  const globalQ = (window._moodGlobalSearchQuery || '').trim();
  const searchIcon = '<svg class="mood-global-search-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="7" cy="7" r="4.5"/><path d="M10.5 10.5L14 14"/></svg>';
  var _cmClearVis = globalQ ? ' is-visible' : '';
  host.innerHTML += '<div class="mood-global-search">' +
    searchIcon +
    '<input class="mood-global-search-input" type="search" enterkeyhint="search" autocomplete="off" autocorrect="off" spellcheck="false" ' +
    'placeholder="Search by name, hex or Pantone." ' +
    'value="' + (globalQ || '').replace(/"/g, '&quot;') + '" />' +
    '<button class="mood-global-search-clear' + _cmClearVis + '" data-action="mood-clear-search" type="button" aria-label="Clear search">×</button>' +
    '</div>';

  // If there's a global search query, render results below the search bar
  if (globalQ) {
    const q = globalQ.toLowerCase();
    const list = (typeof _tpgList === 'function') ? _tpgList() : [];
    const matches = list.filter(p =>
      (p.name || '').toLowerCase().includes(q) ||
      (p.code || '').toLowerCase().includes(q) ||
      (p.hex  || '').toLowerCase().includes(q)
    );
    const selectedHexLower = selectedHex ? selectedHex.toLowerCase() : '';
    let resultsHtml = '';
    if (matches.length === 0) {
      resultsHtml = '<p style="text-align:center;font:400 12px/1.4 var(--font-sans);color:var(--fg-secondary);padding:16px 0">No colours match "' + globalQ + '".</p>';
    } else {
      const shown = matches.slice(0, 80);
      resultsHtml = '<div class="mood-row-grid" style="padding-top:10px">' +
        shown.map(p => {
          const sel = selectedHexLower && selectedHexLower === p.hex.toLowerCase() ? ' is-selected' : '';
          var _srQ = _moodCartQty[p.hex.toLowerCase()];
          var _srHas = _srQ && _srQ.qty > 0;
          var _srCls = _srHas ? ' has-qty' : '';
          var _srBadge = _srHas ? '<span class="mood-swatch-qty">' + _srQ.qty + '</span>' : '';
          var _srMinus = _srHas ? '<span class="mood-swatch-minus" data-action="mood-minus" data-hex="' + p.hex + '">−</span>' : '';
          return '<button class="mood-swatch' + sel + _srCls + '" data-hex="' + p.hex + '" ' +
                 'data-code="' + p.code + '" data-name="' + (p.name || p.code) + '" ' +
                 'style="background:' + p.hex + '" aria-label="' + (p.name || p.code) + '">' + _srBadge + _srMinus + '</button>';
        }).join('') +
        '</div>';
      if (matches.length > 80) {
        resultsHtml += '<p style="text-align:center;font:400 12px/1.4 var(--font-sans);color:var(--fg-secondary);margin:6px 0 0">Showing 80 of ' + matches.length + '. Refine your search.</p>';
      }
    }
    host.innerHTML += '<div style="padding:0 4px 8px">' + resultsHtml + '</div>';
  }
}

/**
 * Expand a mood row (or collapse if already expanded).
 */
function expandMoodRow(style) {
  if (window._expandedMoodStyle === style) return; // already open
  window._expandedMoodStyle = style;
  window._moodShowAllStyle = null;
  renderMoodRows();
  _markRowEntering('.mood-row.is-expanded:not([data-target="legs"])');
}
function collapseMoodRow() {
  if (!window._expandedMoodStyle) return;
  window._expandedMoodStyle = null;
  window._moodShowAllStyle = null;
  renderMoodRows();
}

/**
 * Select a mood swatch — persistent commit.
 */
function selectMoodSwatch(hex, code, name, forceAdd) {
  // Strip COTY year prefix ("2025 · Mocha Mousse" → "Mocha Mousse") for cart/order
  name = name ? name.replace(/^\d{4}\s*[·]\s*/, '') : name;
  var key = hex.toLowerCase();
  var p = (typeof nearestPantone === 'function') ? nearestPantone(hex) : null;
  var swEl = document.querySelector('.mood-swatch[data-hex="' + hex + '"]');

  // Mobile: 1st tap = preview, 2nd tap = add. Already-in-cart → skip preview, direct +1.
  if (_tgIsTouchDevice && !forceAdd) {
    // Already in cart → direct increment, no re-preview needed
    if (_moodCartQty[key] && _moodCartQty[key].qty > 0) {
      selectMoodSwatch(hex, code, name, true);
      return;
    }
    if (_isSamePreview('mood', key)) {
      // 2nd tap on previewed swatch → commit
      selectMoodSwatch(hex, code, name, true);
      return;
    }
    // 1st tap on new swatch → preview only
    window._coverSelectedHex = hex;
    var _tpgCodeM = code || (p ? p.code : '');
    state.customCover = {
      type: 'pantone', hex: hex,
      code: _tpgCodeM, tpg: _tpgCodeM,
      name: name || (p ? p.name : '')
    };
    currentPresetName = null;
    a9Bridge.setCustomPantone(hex);
    a9Bridge.setRotation(false);
    _syncRotationPillOff();
    showViewportToast(hex, name || (p ? p.name : code), '€' + PRICE_COVER_PANTONE);
    if (swEl) _setPreviewRing(swEl, 'mood', key);
    return;
  }

  if (!_moodCartQty[key]) {
    var _tpgCode = code || (p ? p.code : '');
    _moodCartQty[key] = { qty: 0, hex: hex, code: _tpgCode, tpg: _tpgCode, name: name || (p ? p.name : '') };
  }
  _moodCartQty[key].qty++;

  // Always preview the last-clicked color on the 3D model
  window._coverSelectedHex = hex;
  state.customCover = {
    type: 'pantone',
    hex: hex,
    code: _moodCartQty[key].code,
    tpg: _moodCartQty[key].tpg,
    name: _moodCartQty[key].name
  };
  currentPresetName = null;
  a9Bridge.setCustomPantone(hex);
  a9Bridge.setRotation(false);
  _syncRotationPillOff();
  showViewportToast(hex, name || (p ? p.name : code), '€' + PRICE_COVER_PANTONE);

  renderMoodRows();
  if (typeof renderPantoneGrid === 'function') renderPantoneGrid();
  if (typeof renderAll === 'function') renderAll();
  if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
  if (typeof recomputeTotal === 'function') recomputeTotal();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();

  // Set added ring AFTER render (innerHTML destroyed old element)
  if (_tgIsTouchDevice) {
    var freshMoodEl2 = document.querySelector('.mood-swatch[data-hex="' + hex + '"]');
    if (freshMoodEl2) _setAddedRing(freshMoodEl2);
  }
}

function _moodMinusSwatch(hex) {
  var key = hex.toLowerCase();
  if (!_moodCartQty[key]) return;
  _moodCartQty[key].qty--;
  if (_moodCartQty[key].qty <= 0) delete _moodCartQty[key];
  // If no mood selections left, clear custom cover
  var anyMood = false;
  for (var k in _moodCartQty) { if (_moodCartQty[k].qty > 0) { anyMood = true; break; } }
  if (!anyMood && state.customCover && state.customCover.type === 'pantone') {
    state.customCover = null;
    window._coverSelectedHex = null;
    a9Bridge.setCover(state.cover || 'Warm White');
  }
  renderMoodRows();
  if (typeof _updateCartPopover === 'function') _updateCartPopover();
  if (typeof recomputeTotal === 'function') recomputeTotal();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
}

// Event delegation on #moodRowsContainer
(function _bindMoodRows() {
  const host = document.getElementById('moodRowsContainer');
  if (!host) return;

  /* ---- Hover-to-expand rows ---- */
  let _hoverExpandTimer = null;
  let _hoverCollapseTimer = null;
  let _clickCollapsedAt = 0;  // timestamp: suppress hover re-expand after click collapse

  host.addEventListener('mouseenter', function(e) {
    const row = e.target.closest('.mood-row');
    if (!row) return;
    const style = row.dataset.style;
    clearTimeout(_hoverCollapseTimer);
    clearTimeout(_hoverExpandTimer);
    // Suppress hover re-expand for 600ms after a click-collapse
    if (Date.now() - _clickCollapsedAt < 600) return;
    _hoverExpandTimer = setTimeout(function() {
      expandMoodRow(style);
    }, 120);
  }, true);

  host.addEventListener('mouseleave', function(e) {
    clearTimeout(_hoverExpandTimer);
  }, true);

  /* ---- Click handler — swatch select, "+" button, "show curated" toggle ---- */
  host.addEventListener('click', function(e) {
    // Minus badge click → decrement qty
    var minusEl = e.target.closest('.mood-swatch-minus');
    if (minusEl) {
      e.stopPropagation();
      _moodMinusSwatch(minusEl.dataset.hex);
      return;
    }
    // Swatch click → select (add/increment)
    const swatch = e.target.closest('.mood-swatch');
    if (swatch) {
      selectMoodSwatch(swatch.dataset.hex, swatch.dataset.code, swatch.dataset.name);
      return;
    }
    // "+" circle button → show all
    const moreBtn = e.target.closest('.mood-swatch-more');
    if (moreBtn) {
      window._moodShowAllStyle = moreBtn.dataset.style;
      renderMoodRows();
      return;
    }
    // Header click — toggle expand/collapse
    const header = e.target.closest('.mood-row-header');
    if (header) {
      const style = header.dataset.style;
      if (window._expandedMoodStyle === style) {
        _clickCollapsedAt = Date.now();  // suppress hover re-expand
        collapseMoodRow();
      } else {
        expandMoodRow(style);
      }
      return;
    }
  });

  /* ---- Hover preview on swatches — live 3D update ---- */
  let moodHoverTimeout = null;
  let moodIsHovering = false;

  host.addEventListener('mouseover', function(e) {
    const swatch = e.target.closest('.mood-swatch');
    if (!swatch) return;
    clearTimeout(moodHoverTimeout);
    moodHoverTimeout = setTimeout(function() {
      moodIsHovering = true;
      a9Bridge.setCustomPantone(swatch.dataset.hex);
    }, 60);
  });

  host.addEventListener('mouseout', function(e) {
    const swatch = e.target.closest('.mood-swatch');
    if (!swatch) return;
    const related = e.relatedTarget?.closest?.('.mood-swatch');
    if (related) return;
    clearTimeout(moodHoverTimeout);
    if (!moodIsHovering) return;
    moodIsHovering = false;
    if (state.customCover && state.customCover.type === 'pantone') {
      a9Bridge.setCustomPantone(state.customCover.hex);
    } else if (state.customCover && state.customCover.type === 'upload') {
      var _lastU = (state.uploadCovers && state.uploadCovers.length > 0) ? state.uploadCovers[state.uploadCovers.length - 1] : state.coverUpload;
      if (_lastU && _lastU.composedDataUrl) {
        a9Bridge.setCustomUpload(_lastU.composedDataUrl, true);  // 上传→trim(原死消息)
      }
    } else {
      a9Bridge.setCover(state.cover || 'Warm White');
    }
  });

  /* ---- Global search bar below all mood rows ---- */
  host.addEventListener('input', function(e) {
    if (!e.target.classList.contains('mood-global-search-input')) return;
    window._moodGlobalSearchQuery = e.target.value;
    clearTimeout(host._globalSearchDebounce);
    host._globalSearchDebounce = setTimeout(function() {
      renderMoodRows();
      var input = host.querySelector('.mood-global-search-input');
      if (input) {
        input.focus();
        input.selectionStart = input.selectionEnd = input.value.length;
        // Auto-scroll panel so search input + results are visible above keyboard
        _scrollPanelToSearch(input);
      }
    }, 200);
  });

  /* ---- Clear search button ---- */
  host.addEventListener('click', function(e) {
    if (e.target.dataset.action !== 'mood-clear-search') return;
    window._moodGlobalSearchQuery = '';
    renderMoodRows();
  });

  /* ---- Mobile: scroll panel to keep search bar + results visible above keyboard ---- */
  host.addEventListener('focus', function(e) {
    if (!e.target.classList.contains('mood-global-search-input')) return;
    // Small delay so iOS keyboard finishes layout shift
    setTimeout(function() { _scrollPanelToSearch(e.target); }, 350);
  }, true);

  function _scrollPanelToSearch(input) {
    if (window.matchMedia('(min-width: 481px)').matches) return;
    var panel = input.closest('.side-panel');
    if (!panel) return;
    var searchBox = input.closest('.mood-global-search');
    if (!searchBox) return;
    // Scroll the search bar to the very top of the panel's scrollable area
    // This leaves maximum space below for search results
    var panelRect = panel.getBoundingClientRect();
    var searchRect = searchBox.getBoundingClientRect();
    var offset = searchRect.top - panelRect.top + panel.scrollTop - 8;
    panel.scrollTo({ top: offset, behavior: 'smooth' });
  }
})();

// Initial render
renderMoodRows();

/* =====================================================================
   Cover V2 — Match mode: room photo upload → AI analysis → 3 recommendations.
   For the prototype, recommendations are simulated based on a curated palette.
   In production this would call a colour-analysis API.
   ===================================================================== */
const MATCH_RECOMMENDATIONS_BASE = [
  { hex: '#DAD1BB', code: '12-0110 TPG', name: 'Quiet Linen',  reason: 'Picks up the wall tone.' },
  { hex: '#BDDACA', code: '13-6008 TPG', name: 'Soft Sage',    reason: 'Bridges the plants and the oak.' },
  { hex: '#C89B69', code: '15-0927 TPG', name: 'Warm Accent',  reason: 'One degree of confident contrast.' }
];
const MATCH_RECOMMENDATIONS_MORE = [
  { hex: '#A4B8C4', code: '14-4106 TPG', name: 'Cloud Blue',    reason: 'Adds calm, airy depth.' },
  { hex: '#D4A88C', code: '15-1318 TPG', name: 'Blush Clay',    reason: 'Soft warmth, pairs with oak.' },
  { hex: '#8B9E82', code: '16-6116 TPG', name: 'Moss Olive',    reason: 'Earthy tone, echoes greenery.' },
  { hex: '#E8D5C4', code: '13-1012 TPG', name: 'Pale Sand',     reason: 'Neutral anchor, recedes gently.' },
  { hex: '#B6A0C8', code: '15-3507 TPG', name: 'Soft Lilac',    reason: 'Unexpected accent, lifts the space.' },
  { hex: '#C4CDB0', code: '13-0210 TPG', name: 'Celadon Mist',  reason: 'Bridges green and neutral.' },
];

// Active list — starts with base 3, More appends from pool
var MATCH_RECOMMENDATIONS = MATCH_RECOMMENDATIONS_BASE.slice();
window._matchActiveIdx = null;
window._matchMoreIdx = 0;  // tracks how many extras have been added
var _pantoneCartQty = {};  // Phase 6.3 — { idx: qty } for Pantone multi-select
// _moodCartQty declared earlier (before renderMoodRows)

function renderMatchRecs() {
  const host = document.getElementById('matchRecsList');
  if (!host) return;

  host.innerHTML = MATCH_RECOMMENDATIONS.map((rec, i) => {
    var qty = _pantoneCartQty[i] || 0;
    var hasQty = qty > 0;
    var cardCls = 'match-rec' + (hasQty ? ' is-active has-qty' : '');
    // Swatch with + overlay and qty badge
    var swatchHTML = '<span class="match-rec-swatch" style="background:' + rec.hex + '" data-action="pantone-add" data-idx="' + i + '">' +
      '<span class="match-rec-swatch-plus">' + (hasQty ? '+' : '+') + '</span>' +
      (qty >= 1 ? '<span class="match-rec-swatch-qty">' + qty + '</span>' : '') +
    '</span>';
    // Minus button (right side, hover-visible when has qty)
    var minusHTML = hasQty
      ? '<button class="match-rec-minus" data-action="pantone-minus" data-idx="' + i + '" type="button">−</button>'
      : '';
    return '<div class="' + cardCls + '" data-idx="' + i + '">' +
           swatchHTML +
           '  <span class="match-rec-text">' +
           '    <span class="match-rec-name">' + rec.name + '</span>' +
           '    <span class="match-rec-reason">' + rec.reason + '</span>' +
                      '  </span>' +
           minusHTML +
           '</div>';
  }).join('');
}

function appendMoreMatchRecs() {
  var host = document.getElementById('matchRecsList');
  if (!host) return;
  // Pick next 3 from pool (wraps infinitely)
  var pool = MATCH_RECOMMENDATIONS_MORE;
  var count = 3;
  if (pool.length === 0) return;
  var added = 0;
  for (var k = 0; k < count; k++) {
    var pi = (window._matchMoreIdx + k) % pool.length;
    var rec = pool[pi];
    MATCH_RECOMMENDATIONS.push(rec);
    var idx = MATCH_RECOMMENDATIONS.length - 1;
    var html = '<div class="match-rec is-new" data-idx="' + idx + '" style="animation-delay:' + (added * 80) + 'ms">' +
               '<span class="match-rec-swatch" style="background:' + rec.hex + '" data-action="pantone-add" data-idx="' + idx + '">' +
                 '<span class="match-rec-swatch-plus">+</span>' +
               '</span>' +
               '  <span class="match-rec-text">' +
               '    <span class="match-rec-name">' + rec.name + '</span>' +
               '    <span class="match-rec-reason">' + rec.reason + '</span>' +
                              '  </span>' +
               '</div>';
    host.insertAdjacentHTML('beforeend', html);
    added++;
  }
  window._matchMoreIdx = (window._matchMoreIdx + count) % pool.length;
}

function selectMatchRec(idx, forceAdd) {
  // Phase 6.3 — multi-select: increment quantity
  var rec = MATCH_RECOMMENDATIONS[idx];
  if (!rec) return;

  var cardEl = document.querySelector('.match-rec[data-idx="' + idx + '"]');

  // Mobile double-tap: 1st tap = preview (gray card border), 2nd tap = add (black card border)
  if (_tgIsTouchDevice && !forceAdd) {
    if (_isSamePreview('match', String(idx))) {
      // 2nd tap on same card → commit to cart
      selectMatchRec(idx, true);
      return;
    }
    // 1st tap → preview only
    window._matchActiveIdx = idx;
    state.customCover = { type: 'pantone', hex: rec.hex, code: rec.code, name: rec.name };
    window._coverSelectedHex = rec.hex;
    a9Bridge.setCustomPantone(rec.hex);
    showViewportToast(rec.hex, rec.name, '€' + PRICE_COVER_PANTONE);
    a9Bridge.setRotation(false);
    _syncRotationPillOff();
    if (cardEl) _setPreviewRing(cardEl, 'match', String(idx));
    return;
  }

  _pantoneCartQty[idx] = (_pantoneCartQty[idx] || 0) + 1;
  window._matchActiveIdx = idx;

  // Update state — use last-added Pantone as active cover for 3D preview
  state.customCover = {
    type: 'pantone',
    hex: rec.hex,
    code: rec.code,
    name: rec.name
  };
  window._coverSelectedHex = rec.hex;

  // Update 3D preview immediately
  a9Bridge.setCustomPantone(rec.hex);
  showViewportToast(rec.hex, rec.name, '€' + PRICE_COVER_PANTONE);
  a9Bridge.setRotation(false);
  _syncRotationPillOff();

  // Re-render recommendations to show stepper
  renderMatchRecs();
  _syncPantoneCart();

  // Card-level: .is-active from render handles black border; clear preview state
  if (_tgIsTouchDevice) {
    _clearPreviewRing();
  }
}

function _pantoneMinusRec(idx) {
  if (!_pantoneCartQty[idx]) return;
  _pantoneCartQty[idx]--;
  if (_pantoneCartQty[idx] <= 0) {
    delete _pantoneCartQty[idx];
  }

  // If no Pantone selections left, clear custom cover
  var anyPantone = false;
  for (var k in _pantoneCartQty) { if (_pantoneCartQty[k] > 0) { anyPantone = true; break; } }
  if (!anyPantone) {
    if (state.customCover && state.customCover.type === 'pantone') {
      state.customCover = null;
      window._coverSelectedHex = null;
      a9Bridge.setCover(state.cover || 'Warm White');
    }
  }

  renderMatchRecs();
  _syncPantoneCart();
}

function _syncPantoneCart() {
  if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
  if (typeof _updateCartPopover === 'function') _updateCartPopover();
  if (typeof recomputeTotal === 'function') recomputeTotal();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
}

// Bind Match mode interactions
(function _bindMatchMode() {
  // Room photo upload
  const fileInput = document.getElementById('matchRoomFileV2');
  const uploadZone = document.getElementById('matchUploadZone');
  const uploadState = document.getElementById('matchUploadState');
  const resultsState = document.getElementById('matchResultsState');
  const photoImg = document.getElementById('matchPhotoImg');
  const analyzing = document.getElementById('matchAnalyzing');
  const recsList = document.getElementById('matchRecsList');

  if (fileInput) {
    fileInput.addEventListener('change', function(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      // Reset input so re-picking the same file fires 'change' again
      fileInput.value = '';

      const reader = new FileReader();
      reader.onload = function() {
        // Show results state with photo preview
        if (uploadState) uploadState.hidden = true;
        if (resultsState) {
          resultsState.hidden = false;
          // Leaving any prior collection-browse mode → restore photo/rec view
          resultsState.classList.remove('is-collection-only');
          var _rsBack = document.getElementById('matchCollectionBack');
          if (_rsBack) _rsBack.hidden = true;
          var _rsDiv = resultsState.querySelector('.match-collection-divider');
          if (_rsDiv) _rsDiv.textContent = 'From our collection';
        }
        if (photoImg) photoImg.src = reader.result;

        // Show analyzing spinner
        if (analyzing) analyzing.hidden = false;
        if (recsList) recsList.hidden = true;

        // Simulate analysis delay (prototype)
        setTimeout(function() {
          if (analyzing) analyzing.hidden = true;
          if (recsList) recsList.hidden = false;
          renderMatchRecs();
          // Also render catalog cover recommendations
          var dominantHexes = MATCH_RECOMMENDATIONS_BASE.map(function(r) { return r.hex; });
          // Sync with live Shopify first so recommendations only include
          // currently-available designs (and use current variant IDs).
          _ensureCatalogLive().then(function() {
            var catalogResults = matchCatalogCovers(dominantHexes, 8);
            renderMatchCatalog(catalogResults);
          });
        }, 1800);
      };
      reader.readAsDataURL(file);
    });
  }

  // NOTE: uploadZone is a <label for="matchRoomFileV2"> so the browser
  // natively opens the file picker on click. No JS handler needed — adding
  // one would DOUBLE-trigger the picker (first open cancelled by second).

  // Recommendation clicks (event delegation) — Phase 6.4 swatch-overlay pattern
  if (recsList) {
    recsList.addEventListener('click', function(e) {
      // Swatch or + overlay click → add/increment
      var addEl = e.target.closest('[data-action="pantone-add"]');
      if (addEl) {
        e.stopPropagation();
        var idx = parseInt(addEl.dataset.idx, 10);
        selectMatchRec(idx);
        return;
      }
      // Minus button click → decrement
      var minusEl = e.target.closest('[data-action="pantone-minus"]');
      if (minusEl) {
        e.stopPropagation();
        _pantoneMinusRec(parseInt(minusEl.dataset.idx, 10));
        return;
      }
      // Card body click — add/increment (same as swatch click)
      var rec = e.target.closest('.match-rec');
      if (!rec) return;
      var idx2 = parseInt(rec.dataset.idx, 10);
      selectMatchRec(idx2);
    });

    // Hover auto-preview on 3D model
    let _matchHoverPrevHex = null;
    let _matchHovering = false;
    recsList.addEventListener('mouseover', function(e) {
      const card = e.target.closest('.match-rec');
      if (!card) return;
      const idx = parseInt(card.dataset.idx, 10);
      const data = MATCH_RECOMMENDATIONS[idx];
      if (!data) return;
      if (!_matchHovering) {
        _matchHoverPrevHex = window._coverSelectedHex || null;
        _matchHovering = true;
      }
      a9Bridge.setCustomPantone(data.hex);
    });
    recsList.addEventListener('mouseleave', function() {
      if (_matchHovering && _matchHoverPrevHex !== null) {
        a9Bridge.setCustomPantone(_matchHoverPrevHex);
      }
      _matchHoverPrevHex = null;
      _matchHovering = false;
    });
  }

  // Match action pills
  const moreColoursBtn = document.getElementById('matchMoreColours');
  const resetBtn = document.getElementById('matchReset');

  if (moreColoursBtn) moreColoursBtn.addEventListener('click', function() {
    appendMoreMatchRecs();
  });

  if (resetBtn) resetBtn.addEventListener('click', function() {
    // Clear room photo, return to upload state
    var uploadState = document.getElementById('matchUploadState');
    var resultsState = document.getElementById('matchResultsState');
    var photoImg = document.getElementById('matchPhotoImg');
    if (uploadState) uploadState.removeAttribute('hidden');
    if (resultsState) resultsState.setAttribute('hidden', '');
    if (photoImg) photoImg.src = '';
    window._matchActiveIdx = -1;
    // Reset recommendation list back to base 3
    MATCH_RECOMMENDATIONS = MATCH_RECOMMENDATIONS_BASE.slice();
    window._matchMoreIdx = 0;
    var moreBtn = document.getElementById('matchMoreColours');
    if (moreBtn) moreBtn.style.display = '';
    // Also clear catalog grid + cart + pantone selections
    _catalogCartQty = {};
    _pantoneCartQty = {};
    var catGrid = document.getElementById('matchCatalogGrid');
    if (catGrid) catGrid.innerHTML = '';
    var catMore = document.getElementById('matchCatalogMore');
    if (catMore) catMore.hidden = true;
    _updateCatalogCart();
  });
})();

/* =====================================================================
   Match Collection — recommend existing catalog covers by colour match.
   Maps room's dominant colours → 12 colour categories → filter/rank
   COVER_CATALOG → render top results as cards.
   ===================================================================== */

// Hex → colour category names matching COVER_CATALOG labels.
// Returns one or more categories (array) to allow fuzzy cross-matching.
function _hexToColorCategories(hex) {
  var r = parseInt(hex.slice(1,3),16)/255;
  var g = parseInt(hex.slice(3,5),16)/255;
  var b = parseInt(hex.slice(5,7),16)/255;
  var max = Math.max(r,g,b), min = Math.min(r,g,b);
  var l = (max+min)/2, s = 0, h = 0;
  if (max !== min) {
    var d = max - min;
    s = l > 0.5 ? d/(2-max-min) : d/(max+min);
    if (max===r) h = ((g-b)/d + (g<b?6:0))/6;
    else if (max===g) h = ((b-r)/d+2)/6;
    else h = ((r-g)/d+4)/6;
  }
  h *= 360;
  var cats = [];
  // Very low saturation → achromatic
  if (s < 0.12) {
    if (l > 0.85) cats.push('White');
    else if (l < 0.2) cats.push('Black');
    else cats.push('Grey');
    // Neutral tones also match Brown / Earth at mid-lightness
    if (l > 0.3 && l < 0.7) cats.push('Brown / Earth');
    return cats;
  }
  // Warm browns: hue 15-45, low-mid saturation, low-mid lightness
  if (h >= 15 && h < 45 && s < 0.55 && l < 0.6) {
    cats.push('Brown / Earth');
    cats.push('Orange');
    return cats;
  }
  // Chromatic categories by hue
  if (h < 15 || h >= 345) cats.push('Red');
  else if (h < 40) { cats.push('Orange'); if (l < 0.5) cats.push('Brown / Earth'); }
  else if (h < 65) { cats.push('Yellow'); if (s < 0.4) cats.push('Brown / Earth'); }
  else if (h < 160) cats.push('Green');
  else if (h < 250) cats.push('Blue');
  else if (h < 300) cats.push('Purple');
  else cats.push('Pink');
  return cats;
}

// Match catalog covers to room analysis — multi-dimensional:
//   1. Color overlap (dominant room colours vs cover colour tags)
//   2. Mood affinity (room ambience → cover mood)
//   3. Style preference (room décor style → cover art style)
// Returns sorted array of { cover, score, reason }
function matchCatalogCovers(dominantHexColors, limit) {
  if (typeof COVER_CATALOG === 'undefined' || !dominantHexColors || !dominantHexColors.length) return [];
  limit = limit || 8;

  // --- Colour dimension ---
  var roomCategories = {};
  dominantHexColors.forEach(function(hex) {
    var cats = _hexToColorCategories(hex);
    cats.forEach(function(cat) {
      roomCategories[cat] = (roomCategories[cat] || 0) + 1;
    });
  });

  // --- Mood dimension: derive room mood from colour temperature ---
  var warmCount = (roomCategories['Red']||0) + (roomCategories['Orange']||0) + (roomCategories['Yellow']||0) + (roomCategories['Brown / Earth']||0);
  var coolCount = (roomCategories['Blue']||0) + (roomCategories['Green']||0) + (roomCategories['Purple']||0);
  var neutralCount = (roomCategories['White']||0) + (roomCategories['Grey']||0) + (roomCategories['Black']||0);
  var roomMoodAffinity = {};
  if (warmCount >= coolCount && warmCount >= neutralCount) {
    roomMoodAffinity = { 'Warm / Peaceful': 1.0, 'Warm / Joyful': 0.8, 'Elegant / Refined': 0.6, 'Calm / Serene': 0.4 };
  } else if (coolCount >= warmCount) {
    roomMoodAffinity = { 'Calm / Serene': 1.0, 'Dreamy / Ethereal': 0.8, 'Elegant / Refined': 0.6, 'Fresh / Vibrant': 0.5 };
  } else {
    roomMoodAffinity = { 'Elegant / Refined': 1.0, 'Calm / Serene': 0.8, 'Bold / Dramatic': 0.5, 'Dark / Mysterious': 0.4 };
  }

  // --- Style dimension: warm rooms → natural/botanical; cool → minimalist; neutral → refined ---
  var roomStyleAffinity = {};
  if (warmCount >= coolCount) {
    roomStyleAffinity = { 'Botanical Illustration': 0.8, 'Oil Painting': 0.7, 'Textile / Fabric': 0.6, 'Japanese Ink Art': 0.5, 'Photography': 0.4 };
  } else {
    roomStyleAffinity = { 'Minimalist': 0.8, 'Abstract Art': 0.7, 'Photography': 0.5, 'Textile / Fabric': 0.6, 'Watercolour': 0.4 };
  }

  // --- Score each cover ---
  var scored = COVER_CATALOG.map(function(cover) {
    var colorScore = 0;
    var matchedColors = [];
    cover.colors.forEach(function(c) {
      if (c === 'Multicolour') {
        colorScore += 0.5;
        matchedColors.push('versatile palette');
      } else if (roomCategories[c]) {
        colorScore += roomCategories[c];
        matchedColors.push(c.toLowerCase());
      }
    });

    var moodScore = 0;
    if (cover.mood && roomMoodAffinity[cover.mood]) {
      moodScore = roomMoodAffinity[cover.mood];
    }

    var styleScore = 0;
    if (cover.style && roomStyleAffinity[cover.style]) {
      styleScore = roomStyleAffinity[cover.style];
    }

    // Weighted total: colour is primary, mood and style are secondary
    var total = colorScore * 2 + moodScore * 1.2 + styleScore * 0.8;

    // Build recommendation reason
    var reasons = [];
    if (matchedColors.length > 0) {
      reasons.push('Picks up the ' + matchedColors.slice(0,2).join(' and ') + ' tones');
    }
    if (moodScore >= 0.6 && cover.mood) {
      var moodWord = cover.mood.split(' / ')[0].toLowerCase();
      reasons.push(moodWord + ' mood suits the room');
    }
    if (styleScore >= 0.5 && cover.style) {
      reasons.push(cover.style.toLowerCase() + ' style complements the décor');
    }
    var reason = reasons.length > 0 ? reasons[0] + '.' : 'A curated match.';

    return { cover: cover, score: total, reason: reason };
  });

  // Filter meaningful matches, sort descending
  scored = scored.filter(function(s) { return s.score >= 1.0; });
  scored.sort(function(a,b) { return b.score - a.score; });

  return scored.slice(0, limit);
}

// Render catalog cards into the grid
var _matchCatalogVisible = 4; // show 4 initially, "Show more" reveals rest
var _matchCatalogResults = [];

function renderMatchCatalog(results) {
  _matchCatalogResults = results || [];
  window._catalogOriginalResults = _matchCatalogResults.slice();
  _matchCatalogVisible = 4;
  var grid = document.getElementById('matchCatalogGrid');
  var moreBtn = document.getElementById('matchCatalogMore');
  if (!grid) return;

  if (_matchCatalogResults.length === 0) {
    grid.innerHTML = '';
    if (moreBtn) moreBtn.hidden = true;
    return;
  }

  _renderCatalogCards();
  if (moreBtn) moreBtn.hidden = false; // always show — infinite discovery
  requestAnimationFrame(_fillCatalogUntilScrollable);
}

// Catalog cart state: { idx → qty }
var _catalogCartQty = {};

// Dynamic reason generator — builds a unique sentence from cover metadata + room context
function _generateCatalogReason(cover) {
  // Build short keyword tags from product metadata: "Warm · Botanical · Green"
  var tags = [];
  var c = cover;
  var mood = (c.mood || '').toLowerCase();
  var style = (c.style || '').toLowerCase();
  var colors = c.colors || [];

  // Mood tag — take first word before " / " (e.g. "Warm / Peaceful" → "Warm")
  if (mood) {
    var moodFirst = mood.split('/')[0].trim();
    var moodLabel = moodFirst.charAt(0).toUpperCase() + moodFirst.slice(1);
    tags.push(moodLabel);
  }
  // Style tag — take first word before " / " if present
  if (style) {
    var styleFirst = style.split('/')[0].trim();
    var styleLabel = styleFirst.charAt(0).toUpperCase() + styleFirst.slice(1);
    tags.push(styleLabel);
  }
  // Top 1-2 color tags
  for (var ci = 0; ci < colors.length && tags.length < 4; ci++) {
    var col = colors[ci].charAt(0).toUpperCase() + colors[ci].slice(1).toLowerCase();
    if (tags.indexOf(col) < 0) tags.push(col);
  }

  return tags.length > 0 ? tags.join(' · ') : 'Curated';
}

function _renderCatalogCards() {
  var grid = document.getElementById('matchCatalogGrid');
  if (!grid) return;
  var toShow = _matchCatalogResults.slice(0, _matchCatalogVisible);

  grid.innerHTML = toShow.map(function(item, i) {
    var c = item.cover;
    // Always use keyword-tag generator (ignores legacy sentence reasons)
    var reason = _generateCatalogReason(c);
    var price = c.price || 0;
    var priceStr = '€' + price.toFixed(0);
    var qty = _catalogCartQty[i] || 0;
    var hasQty = qty > 0;
    var has3d = c.preview ? ' data-preview="' + c.preview + '"' : '';
    var cardCls = 'match-catalog-card' + (c.preview ? ' has-3d' : '') + (hasQty ? ' has-qty' : '');

    return '<div class="' + cardCls + '" data-idx="' + i + '" data-handle="' + c.handle + '" data-img="' + c.img + '"' + has3d + '>' +
      '<div class="match-catalog-img-wrap">' +
        '<img class="match-catalog-img" src="' + c.img + '" alt="' + c.name + '" loading="lazy" />' +
        '<span class="match-catalog-reason"><span class="match-catalog-reason-inner">' + reason + '</span></span>' +
        '<span class="match-catalog-minus-hint" data-action="minus" data-idx="' + i + '">−</span>' +
        '<span class="match-catalog-add-hint" data-action="add" data-idx="' + i + '">+</span>' +
        '<span class="match-catalog-qty-dot">' + qty + '</span>' +
      '</div>' +
      '<div class="match-catalog-info">' +
        '<span class="match-catalog-name" data-action="link" data-handle="' + c.handle + '">' + c.name + '</span>' +
        '<span class="match-catalog-price">' + (hasQty ? priceStr + ' ×' + qty : priceStr) + '</span>' +
      '</div>' +
    '</div>';
  }).join('');

  _updateCatalogCart();

  // Measure reason text overflow for scroll animation
  requestAnimationFrame(function() {
    var inners = grid.querySelectorAll('.match-catalog-reason-inner');
    for (var ri = 0; ri < inners.length; ri++) {
      var inner = inners[ri];
      var container = inner.parentElement;
      if (inner.scrollWidth > container.clientWidth + 2) {
        inner.classList.add('is-overflowing');
        inner.style.setProperty('--scroll-distance', '-' + (inner.scrollWidth - container.clientWidth + 10) + 'px');
      } else {
        inner.classList.remove('is-overflowing');
      }
    }
  });
}

function _updateCatalogCart() {
  var totalQty = 0, totalPrice = 0;
  for (var k in _catalogCartQty) {
    if (_catalogCartQty[k] > 0 && _matchCatalogResults[k]) {
      totalQty += _catalogCartQty[k];
      totalPrice += (_matchCatalogResults[k].cover.price || 0) * _catalogCartQty[k];
    }
  }
  // Legacy cart bar elements (hidden now, kept for compat)
  var countEl = document.getElementById('catalogCartCount');
  var totalEl = document.getElementById('catalogCartTotal');
  if (countEl) countEl.textContent = totalQty;
  if (totalEl) totalEl.textContent = '€' + totalPrice.toFixed(0);

  // Sync bottom status bar + total price with catalog selections
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
  if (typeof recomputeTotal === 'function') recomputeTotal();
}

// --- Collection search ---
var _catalogSearchQuery = '';
var _catalogSearchTimer = null;

function _catalogSearchFilter(query) {
  _catalogSearchQuery = (query || '').trim().toLowerCase();
  var clearBtn = document.getElementById('catalogSearchClear');
  if (clearBtn) clearBtn.classList.toggle('is-visible', _catalogSearchQuery.length > 0);

  if (!_catalogSearchQuery) {
    // Restore original matched results
    if (window._catalogOriginalResults) {
      _matchCatalogResults = window._catalogOriginalResults.slice();
    }
    _matchCatalogVisible = 4;
    _catalogCartQty = {};
    _renderCatalogCards();
    requestAnimationFrame(_fillCatalogUntilScrollable);
    return;
  }

  // Search across all COVER_CATALOG
  var terms = _catalogSearchQuery.split(/\s+/);
  var results = [];
  if (typeof COVER_CATALOG === 'undefined') return;

  for (var i = 0; i < COVER_CATALOG.length; i++) {
    var c = COVER_CATALOG[i];
    var haystack = [
      c.name || '',
      (c.colors || []).join(' '),
      c.mood || '',
      c.style || '',
      c.category || ''
    ].join(' ').toLowerCase();

    var allMatch = true;
    for (var t = 0; t < terms.length; t++) {
      if (haystack.indexOf(terms[t]) < 0) { allMatch = false; break; }
    }
    if (allMatch) results.push({ cover: c, score: 1 });
  }

  _matchCatalogResults = results;
  _matchCatalogVisible = Math.max(results.length, 4);
  _catalogCartQty = {};
  _renderCatalogCards();
  requestAnimationFrame(_fillCatalogUntilScrollable);
}

(function() {
  var input = document.getElementById('catalogSearchInput');
  var clearBtn = document.getElementById('catalogSearchClear');
  if (!input) return;

  input.addEventListener('input', function() {
    clearTimeout(_catalogSearchTimer);
    _catalogSearchTimer = setTimeout(function() {
      _catalogSearchFilter(input.value);
    }, 200);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      input.value = '';
      _catalogSearchFilter('');
      input.focus();
    });
  }
})();

function _getStandCartSummary() {
  var parts = [];
  if (typeof _standCartQty === 'object') {
    for (var k in _standCartQty) {
      if (_standCartQty[k] && _standCartQty[k].qty > 0) {
        parts.push((_standCartQty[k].name || 'Legs') + (_standCartQty[k].qty > 1 ? ' ×' + _standCartQty[k].qty : ''));
      }
    }
  }
  if (state.legsCustom && state.legsCustom.name) {
    parts.push(state.legsCustom.name);
  }
  if (parts.length <= 2) return parts.join(' + ');
  return parts.slice(0, 2).join(' + ') + ' +' + (parts.length - 2) + ' more';
}

// Click delegation: image=add, badge=minus, name=link
(function() {
  var grid = document.getElementById('matchCatalogGrid');
  if (!grid) return;
  grid.addEventListener('click', function(e) {
    // 1) − button (top-left hover) → decrease
    var minusEl = e.target.closest('[data-action="minus"]');
    if (minusEl) {
      e.preventDefault(); e.stopPropagation();
      var idx = parseInt(minusEl.getAttribute('data-idx'), 10);
      if (!isNaN(idx)) {
        _catalogCartQty[idx] = Math.max((_catalogCartQty[idx] || 0) - 1, 0);
        if (_catalogCartQty[idx] === 0) delete _catalogCartQty[idx];
        var _anyCatLeft = false; for (var _ck in _catalogCartQty) { if (_catalogCartQty[_ck] > 0) { _anyCatLeft = true; break; } }
        if (!_anyCatLeft) {
          window._committedCatalogPreview = null; // no catalog items left → drop the locked preview
          if (!state.customCover || state.customCover.type !== 'pantone') { state.customCover = null; a9Bridge.setCover(state.cover || 'Warm White'); }
        }
        _renderCatalogCards();
      }
      return;
    }
    // 2) Name → open product page
    var linkEl = e.target.closest('[data-action="link"]');
    if (linkEl) {
      var handle = linkEl.getAttribute('data-handle');
      if (handle) window.open('https://tegrino.co/products/' + handle, '_blank');
      return;
    }
    // 3) Click anywhere on image area → preview (mobile) or +1 (desktop)
    var imgWrap = e.target.closest('.match-catalog-img-wrap');
    if (imgWrap) {
      var card = imgWrap.closest('.match-catalog-card');
      if (card) {
        var idx2 = parseInt(card.getAttribute('data-idx'), 10);
        if (!isNaN(idx2)) {
          if (_tgIsTouchDevice) {
            if (_isSamePreview('catalog', String(idx2))) {
              // 2nd tap → add to cart
              _catalogCartQty[idx2] = Math.min((_catalogCartQty[idx2] || 0) + 1, 99);
              _renderCatalogCards();
              // Card-level: .has-qty from render handles black border; clear preview
              _clearPreviewRing();
              return;
            }
            // 1st tap → preview only (ring on card, not img-wrap)
            var catItem = _matchCatalogResults[idx2];
            if (catItem && catItem.cover && catItem.cover.preview) {
              window._committedCatalogPreview = catItem.cover.preview; // lock as selected
              if (typeof window._loadPreviewAsDataUrl === 'function') {
                window._loadPreviewAsDataUrl(catItem.cover.preview, function(d) {
                  if (typeof a9Bridge !== 'undefined' && typeof a9Bridge.setCustomUpload === 'function') a9Bridge.setCustomUpload(d);  // 现有设计→不trim,对齐详情页首图(原死消息)
                });
              }
            }
            _setPreviewRing(card, 'catalog', String(idx2));
            return;
          }
          _catalogCartQty[idx2] = Math.min((_catalogCartQty[idx2] || 0) + 1, 99);
          // Desktop click = select: lock this design as the committed preview and show it,
          // so hovering other cards only previews transiently and the model reverts here.
          var _selCov = _matchCatalogResults[idx2] && _matchCatalogResults[idx2].cover;
          if (_selCov && _selCov.preview) {
            window._committedCatalogPreview = _selCov.preview;
            if (typeof window._loadPreviewAsDataUrl === 'function') {
              window._loadPreviewAsDataUrl(_selCov.preview, function(d) {
                if (typeof a9Bridge !== 'undefined' && typeof a9Bridge.setCustomUpload === 'function') a9Bridge.setCustomUpload(d);
              });
            }
          }
          _renderCatalogCards();
        }
      }
      return;
    }
  });
})();

// Cart "Add all" button → Shopify batch add via tgCart
(function() {
  var btn = document.getElementById('catalogCartBtn');
  if (!btn) return;
  btn.addEventListener('click', async function() {
    var items = [];
    for (var k in _catalogCartQty) {
      if (_catalogCartQty[k] > 0 && _matchCatalogResults[k]) {
        items.push({ handle: _matchCatalogResults[k].cover.handle, qty: _catalogCartQty[k] });
      }
    }
    if (items.length === 0) return;
    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = 'Adding…';
    try {
      for (var i = 0; i < items.length; i++) {
        await tgCart.addCollection(items[i].handle, items[i].qty);
      }
      btn.textContent = 'Added ✓';
      setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 1500);
    } catch (e) {
      console.error('[tgCart] catalog add error:', e);
      btn.textContent = origText;
      btn.disabled = false;
    }
  });
})();

// Infinite scroll for catalog — auto-load more when user scrolls near bottom
(function() {
  var _catalogMoreIdx = 0;
  function _loadMoreCatalog() {
    _matchCatalogVisible += 4;
    while (_matchCatalogResults.length < _matchCatalogVisible && typeof COVER_CATALOG !== 'undefined') {
      var found = false;
      for (var tries = 0; tries < COVER_CATALOG.length; tries++) {
        var ci = (_catalogMoreIdx + tries) % COVER_CATALOG.length;
        var candidate = COVER_CATALOG[ci];
        var isDupe = _matchCatalogResults.some(function(r) { return r.cover.handle === candidate.handle; });
        if (!isDupe) {
          _matchCatalogResults.push({ cover: candidate, score: 1 });
          _catalogMoreIdx = (ci + 1) % COVER_CATALOG.length;
          found = true;
          break;
        }
      }
      if (!found) break;
    }
    _renderCatalogCards();
  }
  // Infinite scroll via scroll event on .side-panel
  var grid = document.getElementById('matchCatalogGrid');
  var sidePanel = grid ? grid.closest('.side-panel') : null;
  var _catalogScrollThrottle = false;
  if (sidePanel) {
    sidePanel.addEventListener('scroll', function() {
      if (_catalogScrollThrottle) return;
      _catalogScrollThrottle = true;
      requestAnimationFrame(function() {
        _catalogScrollThrottle = false;
        var scrollBottom = sidePanel.scrollTop + sidePanel.clientHeight;
        var scrollHeight = sidePanel.scrollHeight;
        // Load more catalog when within 400px of bottom
        if (scrollHeight - scrollBottom < 400 && _matchCatalogResults.length > 0) {
          _loadMoreCatalog();
        }
      });
    });
  }
  // Expose so the collection-browse fill loop can top up until scrollable
  window._loadMoreCatalog = _loadMoreCatalog;
  // Keep old button handler for backwards compat (hidden but still in DOM)
  var moreBtn = document.getElementById('matchCatalogMore');
  if (moreBtn) moreBtn.addEventListener('click', _loadMoreCatalog);
})();

// Photo X close button — resets match analysis
(function() {
  var closeBtn = document.getElementById('matchPhotoClose');
  if (!closeBtn) return;
  closeBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var uploadState = document.getElementById('matchUploadState');
    var resultsState = document.getElementById('matchResultsState');
    var photoImg = document.getElementById('matchPhotoImg');
    if (uploadState) uploadState.removeAttribute('hidden');
    if (resultsState) resultsState.setAttribute('hidden', '');
    if (photoImg) photoImg.src = '';
    window._matchActiveIdx = -1;
    MATCH_RECOMMENDATIONS = MATCH_RECOMMENDATIONS_BASE.slice();
    window._matchMoreIdx = 0;
    _catalogCartQty = {};
    var catGrid = document.getElementById('matchCatalogGrid');
    if (catGrid) catGrid.innerHTML = '';
    _updateCatalogCart();
  });
})();

/* =====================================================================
   V3.3 — Discover-collection entry. Reuses the catalogue browse UI
   (search + cards + add-to-cart + infinite scroll) that already lives in
   #matchResultsState, but skips the room-photo / colour-rec parts via the
   .is-collection-only class — so users can browse all designs with no upload.
   ===================================================================== */
/* ── Live catalogue sync (runtime reconcile) ───────────────────────────────
   On first entry to a collection surface (Browse-all or Match-a-room), pull the
   CURRENT published A9 covers from Shopify and reconcile COVER_CATALOG: refresh
   variantId/price/img, DROP delisted, APPEND newly-published. Editorial fields
   (colours/mood/style/preview) come from the bundled catalogue. Source = the
   smart collection /collections/a9-covers-configurator (auto-updates by product
   type), so listing/delisting in Shopify reflects with NO redeploy.
   Safety: any failure keeps the bundled catalogue untouched (no-op fallback).
   Cached per session. */
var _catalogSyncDone = false;
var _catalogSyncInflight = null;
var _CATALOG_COLLECTION = 'a9-covers-configurator';
var _CATALOG_EXCLUDE = ['beoplay-beosound-a9-cover-solid-colors', 'beoplay-beosound-a9-cover-custom-design'];

function _applyLiveCatalog(live) {
  if (typeof COVER_CATALOG === 'undefined' || !live || !live.length) return;
  var bakedByHandle = {}, liveByHandle = {};
  COVER_CATALOG.forEach(function (c) { bakedByHandle[c.handle] = c; });
  live.forEach(function (l) { liveByHandle[l.handle] = l; });
  var out = [];
  // 1) keep bundled order; drop entries no longer live; refresh id/price/img
  COVER_CATALOG.forEach(function (c) {
    var l = liveByHandle[c.handle];
    if (!l) return; // delisted / unpublished → drop from configurator
    out.push({
      handle: c.handle, name: c.name, colors: c.colors || [], mood: c.mood || '',
      style: c.style || '', category: c.category || '',
      price: l.price || c.price, img: c.img || l.img, preview: c.preview || l.img,
      variantId: l.variantId
    });
  });
  // 2) append newly-published designs not in the bundle (no editorial yet —
  //    still browsable + buyable; add colours/mood/style later if desired)
  live.forEach(function (l) {
    if (bakedByHandle[l.handle]) return;
    out.push({
      handle: l.handle, name: (l.title || '').split(' - ').pop().trim(),
      colors: [], mood: '', style: '', category: '',
      price: l.price, img: l.img, preview: l.img, variantId: l.variantId
    });
  });
  if (out.length >= 20) COVER_CATALOG = out; // sanity guard before replacing global
}

function _syncCatalogFromShopify() {
  try {
    var cached = sessionStorage.getItem('tg_catalog_live_v1');
    if (cached) { _applyLiveCatalog(JSON.parse(cached)); return Promise.resolve(); }
  } catch (e) {}
  return fetch('/collections/' + _CATALOG_COLLECTION + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { if (!r.ok) throw new Error('products.json → ' + r.status); return r.json(); })
    .then(function (j) {
      var prods = (j && j.products) || [];
      var live = [];
      prods.forEach(function (p) {
        if (p.product_type !== 'BeoPlay / BeoSound A9 Cover') return;
        if (_CATALOG_EXCLUDE.indexOf(p.handle) >= 0) return;
        var v = (p.variants && p.variants[0]) || {};
        if (!v.id) return;
        var img = (p.images && p.images[0] && p.images[0].src) || '';
        live.push({ handle: p.handle, title: p.title, variantId: Number(v.id), price: parseFloat(v.price || '0') || 0, img: img });
      });
      if (live.length < 20) throw new Error('too few covers after filter (' + live.length + ')');
      _applyLiveCatalog(live);
      try { sessionStorage.setItem('tg_catalog_live_v1', JSON.stringify(live)); } catch (e) {}
    });
}

function _ensureCatalogLive() {
  if (_catalogSyncDone) return Promise.resolve();
  if (_catalogSyncInflight) return _catalogSyncInflight;
  _catalogSyncInflight = _syncCatalogFromShopify()
    .then(function () { _catalogSyncDone = true; _catalogSyncInflight = null; })
    .catch(function (e) {
      _catalogSyncInflight = null; // allow retry on next open; bundled catalogue used meanwhile
      try { console.warn('[catalog-sync] live sync failed, using bundled catalogue:', e && e.message); } catch (_) {}
    });
  return _catalogSyncInflight;
}

function _enterCollectionBrowse() {
  var uploadState = document.getElementById('matchUploadState');
  var resultsState = document.getElementById('matchResultsState');
  if (uploadState) uploadState.setAttribute('hidden', '');
  if (resultsState) {
    resultsState.removeAttribute('hidden');
    resultsState.classList.add('is-collection-only');
    var divider = resultsState.querySelector('.match-collection-divider');
    if (divider) divider.textContent = 'Our collection';
  }
  var backBtn = document.getElementById('matchCollectionBack');
  if (backBtn) backBtn.hidden = false;
  // Full catalogue → renderMatchCatalog shows the first few; the existing
  // scroll handler reveals the rest, and search filters across all of it.
  _catalogCartQty = {};
  // Brief loading state → sync catalogue with live Shopify (first open only,
  // cached after) → render. On failure the bundled catalogue is used unchanged.
  var _grid0 = document.getElementById('matchCatalogGrid');
  if (_grid0) _grid0.innerHTML = '<div style="grid-column:1/-1;padding:28px 12px;text-align:center;color:var(--ink-60,#8a8784);font-size:13px;letter-spacing:.02em;">Loading the latest designs…</div>';
  var _moreBtn0 = document.getElementById('matchCatalogMore');
  if (_moreBtn0) _moreBtn0.hidden = true;
  _ensureCatalogLive().then(function() {
    var all = (typeof COVER_CATALOG !== 'undefined')
      ? COVER_CATALOG.map(function(c) { return { cover: c, score: 1 }; })
      : [];
    renderMatchCatalog(all);
    var sp = resultsState ? resultsState.closest('.side-panel') : null;
    if (sp && sp.scrollTo) sp.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

function _exitCollectionBrowse() {
  var uploadState = document.getElementById('matchUploadState');
  var resultsState = document.getElementById('matchResultsState');
  if (resultsState) {
    resultsState.setAttribute('hidden', '');
    resultsState.classList.remove('is-collection-only');
    var divider = resultsState.querySelector('.match-collection-divider');
    if (divider) divider.textContent = 'From our collection';
  }
  if (uploadState) uploadState.removeAttribute('hidden');
  var backBtn = document.getElementById('matchCollectionBack');
  if (backBtn) backBtn.hidden = true;
  // Clear browse selections + grid (mirrors the photo-reset behaviour)
  _catalogCartQty = {};
  var catGrid = document.getElementById('matchCatalogGrid');
  if (catGrid) catGrid.innerHTML = '';
  _updateCatalogCart();
}

/* In collection-browse mode the first batch (4 cards) is often shorter than the
   panel, so the panel never scrolls and the scroll-driven loader never fires —
   leaving it stuck at 4. Keep loading batches until the panel is tall enough to
   scroll (then the existing scroll handler takes over) or everything is shown.
   No-ops in photo-match mode so that flow is untouched. */
function _fillCatalogUntilScrollable() {
  var results = document.getElementById('matchResultsState');
  if (!results || !results.classList.contains('is-collection-only')) return;
  var grid = document.getElementById('matchCatalogGrid');
  var sp = grid ? grid.closest('.side-panel') : null;
  if (!sp) return;
  var catLen = (typeof COVER_CATALOG !== 'undefined') ? COVER_CATALOG.length : 0;
  var guard = 0;
  (function step() {
    if (guard++ > 60) return;
    var canGrow = (_matchCatalogVisible < _matchCatalogResults.length) ||
                  (_matchCatalogResults.length < catLen);
    if (!canGrow) return;                          // everything is already shown
    if (sp.scrollHeight - sp.clientHeight > 120) return; // scrollable now → scroll handler continues
    if (typeof window._loadMoreCatalog !== 'function') return;
    window._loadMoreCatalog();
    requestAnimationFrame(step);
  })();
}

(function _initDiscoverTile() {
  var tile = document.getElementById('matchDiscoverTile');
  var collage = document.getElementById('matchDiscoverCollage');
  if (typeof COVER_CATALOG !== 'undefined' && collage && COVER_CATALOG.length) {
    // Prefer vivid covers so the collage reads as colour, not white product shots
    var vivid = COVER_CATALOG.filter(function(c) {
      var m = (c.mood || '').toLowerCase(), s = (c.style || '').toLowerCase();
      return m.indexOf('bold') >= 0 || m.indexOf('vibrant') >= 0 ||
             s.indexOf('abstract') >= 0 || s.indexOf('floral') >= 0 || s.indexOf('pattern') >= 0;
    });
    var pool = vivid.length >= 3 ? vivid : COVER_CATALOG;
    var n = 3, picks = [];
    for (var i = 0; i < n; i++) picks.push(pool[Math.floor(i * pool.length / n)]);
    collage.innerHTML = picks.map(function(c) {
      return '<img src="' + c.img + '" alt="" loading="lazy" />';
    }).join('');
    var sub = tile ? tile.querySelector('.match-discover-sub') : null;
    if (sub) sub.textContent = 'Browse all ' + COVER_CATALOG.length + ' designs';
  }
  if (tile) tile.addEventListener('click', _enterCollectionBrowse);
  var backBtn = document.getElementById('matchCollectionBack');
  if (backBtn) backBtn.addEventListener('click', _exitCollectionBrowse);
})();

// DEV TEST: force Pine Joy + extras into results
window._testPineJoy = function() {
  var pj = null;
  var extras = [];
  for (var i = 0; i < COVER_CATALOG.length; i++) {
    var h = COVER_CATALOG[i].handle;
    if (h === 'beoplay-beosound-a9-cover-pine-joy') pj = COVER_CATALOG[i];
    if (h === 'beoplay-beosound-a9-cover-silent-pine' ||
        h === 'beoplay-beosound-a9-cover-ivory-pine' ||
        h === 'beoplay-beosound-a9-cover-english-garden' ||
        h === 'beoplay-beosound-a9-cover-lemon-lush') {
      extras.push({ cover: COVER_CATALOG[i], score: 8 });
    }
  }
  if (!pj) { console.error('Pine Joy not found in catalog'); return; }
  // Reasons auto-generated from metadata — no manual strings needed
  _matchCatalogResults = [{ cover: pj, score: 10 }].concat(extras);
  _catalogCartQty = {};
  _matchCatalogVisible = 8;
  _renderCatalogCards();
  var grid = document.getElementById('matchCatalogGrid');
  if (grid && grid.parentElement) { grid.parentElement.hidden = false; grid.parentElement.style.display = ''; }
  console.log('5 cards rendered with auto-generated reasons. Click image = add, click badge = remove, hover name = link.');
};

// Catalog cards: 3D hover preview for cards with flat design textures.
// Uses document-level delegation so it works even if grid is created later.
// Fetches preview as blob → FileReader → data URL (preserves exact colours,
// no canvas colour-space conversion).
(function() {
  var _prevPreview = null;
  var _restoreTimer = null; // debounce mouseleave→restore so card-to-card slides don't flicker
  if (typeof window._committedCatalogPreview === 'undefined') window._committedCatalogPreview = null;
  var _previewCache = {}; // url → dataUrl cache

  function _loadPreviewAsDataUrl(url, cb) {
    if (_previewCache[url]) { cb(_previewCache[url]); return; }
    // Use fetch → blob → FileReader to avoid canvas colour-space shifts
    fetch(url)
      .then(function(r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
      .then(function(blob) {
        var reader = new FileReader();
        reader.onload = function() {
          _previewCache[url] = reader.result;
          cb(reader.result);
        };
        reader.readAsDataURL(blob);
      })
      .catch(function(err) { console.warn('[catalog-hover] failed to load', url, err); });
  }
  // Bugfix — expose globally so _renderKeepsake's reveal cover gallery
  // (_revPreviewCover / _revRestoreDefault) can use it. It lives in this IIFE,
  // so without this its `typeof _loadPreviewAsDataUrl === 'function'` guard was
  // always false out there → catalog/collection covers never previewed on the
  // Reveal page (initial, hover, or click all silently no-op'd).
  window._loadPreviewAsDataUrl = _loadPreviewAsDataUrl;

  document.addEventListener('mouseenter', function(e) {
    if (!e.target || !e.target.closest) return; // guard: text nodes etc.
    var card = e.target.closest('.match-catalog-card');
    if (!card) return;
    clearTimeout(_restoreTimer); // entering a card cancels any pending revert
    var idx = parseInt(card.getAttribute('data-idx'), 10);
    if (isNaN(idx) || !_matchCatalogResults || !_matchCatalogResults[idx]) return;
    var cover = _matchCatalogResults[idx].cover;
    if (!cover.preview) return;
    if (_prevPreview === cover.preview) return;
    _prevPreview = cover.preview;
    _loadPreviewAsDataUrl(cover.preview, function(dataUrl) {
      if (typeof a9Bridge !== 'undefined' && typeof a9Bridge.setCustomUpload === 'function') {
        a9Bridge.setCustomUpload(dataUrl);
      }
    });
  }, true);

  // Revert the model when the cursor leaves a card without selecting. Priority:
  // selected catalog design (window._committedCatalogPreview, set on click) →
  // Pantone / upload customCover → otherwise keep the last-hovered preview (nothing
  // selected yet). Debounced so sliding card-to-card doesn't flash between previews.
  function _revertCatalogPreview() {
    _prevPreview = null;
    if (window._committedCatalogPreview) {
      // A catalog design is the active selection → keep it on the model.
      _loadPreviewAsDataUrl(window._committedCatalogPreview, function(dataUrl) {
        if (typeof a9Bridge !== 'undefined' && typeof a9Bridge.setCustomUpload === 'function') a9Bridge.setCustomUpload(dataUrl);
      });
    } else if (state.customCover && state.customCover.type === 'pantone') {
      a9Bridge.setCustomPantone(state.customCover.hex);
    } else if (state.customCover && state.customCover.type === 'upload') {
      var _lU = (state.uploadCovers && state.uploadCovers.length > 0)
        ? state.uploadCovers[state.uploadCovers.length - 1] : state.coverUpload;
      if (_lU && _lU.composedDataUrl) a9Bridge.setCustomUpload(_lU.composedDataUrl, true);  // 上传→trim(原死消息)
    }
    // else: nothing selected yet → leave the last-hovered preview in place (no snap-back).
  }

  document.addEventListener('mouseleave', function(e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.match-catalog-card');
    if (!card) return;
    clearTimeout(_restoreTimer);
    _restoreTimer = setTimeout(_revertCatalogPreview, 60);
  }, true);
})();

/* =====================================================================
   FINAL §7 — Cover panel (Step 02): Pantone + Upload + Reset
   PANTONE_LIBRARY hoisted to data section above (Phase 4.23 TDZ fix);
   only renderers + handlers remain in this section.
   ===================================================================== */
function renderPantoneGrid() {
  const host = document.getElementById('pantoneGrid');
  if (!host) return;

  const selectedHex = window._coverSelectedHex || null;
  const swatchHtml = (hex, code, name, style) => {
    const isSelected = selectedHex && selectedHex.toLowerCase() === hex.toLowerCase();
    return '<button class="pantone-swatch' + (isSelected ? ' is-selected' : '') + '"' +
           ' data-hex="' + hex + '"' +
           ' data-pantone="' + code + '"' +
           ' data-name="' + name + '"' +
           ' data-style="' + (style || '') + '"' +
           ' aria-label="' + name + '"' +
           ' style="background:' + hex + '"></button>';
  };

  const q = (window._coverSearchQuery || '').trim().toLowerCase();
  if (q) {
    // Phase 3.2 — search mode: scan full TPG library (~2310 entries)
    const list = (typeof _tpgList === 'function') ? _tpgList() : [];
    const matches = list.filter(p =>
      (p.name || '').toLowerCase().includes(q) ||
      (p.code || '').toLowerCase().includes(q) ||
      (p.hex  || '').toLowerCase().includes(q)
    );
    if (matches.length === 0) {
      host.innerHTML = '<p class="cover-search-empty">No colors match "' + q + '". Try another name, code, or hex.</p>';
      return;
    }
    const total = matches.length;
    const shown = matches.slice(0, 100);
    let html = shown.map(p => swatchHtml(p.hex, p.code, p.name || p.code, '')).join('');
    if (total > 100) {
      html += '<p class="cover-search-overflow">Showing first 100 of ' + total + ' matches. Refine your search.</p>';
    }
    host.innerHTML = html;
    return;
  }

  // Browse mode — filter curated PANTONE_LIBRARY by active style sub-tab.
  // Phase 5.1 — when window._coverShowAll is on, swap the curated set for
  // the full _classifyTPGByStyle() match (~hundreds of swatches) and turn
  // the grid into a scroll container.
  const activeStyle = window._activeStyleTab || 'NORDIC';
  const curated = PANTONE_LIBRARY.filter(p => p.style === activeStyle);

  if (!window._coverShowAll) {
    const allForStyle = _classifyTPGByStyle(activeStyle);
    let html = curated.map(p => swatchHtml(p.hex, p.pantone, p.name, p.style)).join('');
    if (allForStyle.length > curated.length) {
      html += '<button class="pantone-show-all" type="button">Show all ' + allForStyle.length + ' colors ›</button>';
    }
    host.innerHTML = html;
    host.style.maxHeight = '';
    host.style.overflowY = '';
  } else {
    const allForStyle = _classifyTPGByStyle(activeStyle);
    let html = allForStyle.map(p => swatchHtml(p.hex, p.code || p.pantone, p.name || p.code, activeStyle)).join('');
    html += '<button class="pantone-show-less" type="button">Show curated selection ‹</button>';
    host.innerHTML = html;
    host.style.maxHeight = '360px';
    host.style.overflowY = 'auto';
  }
}

const _pantoneGridEl = document.getElementById('pantoneGrid');
if (_pantoneGridEl) _pantoneGridEl.addEventListener('click', e => {
  // Phase 5.1 — "Show all" / "Show less" toggle handled before the
  // swatch closest() check so the buttons can intercept first.
  if (e.target.classList.contains('pantone-show-all')) {
    window._coverShowAll = true;
    renderPantoneGrid();
    return;
  }
  if (e.target.classList.contains('pantone-show-less')) {
    window._coverShowAll = false;
    renderPantoneGrid();
    return;
  }
  const btn = e.target.closest('[data-hex]');
  if (!btn) return;
  // Phase 3.2 — selection state for is-selected ring (Phase 3.3 moved the
  // visible selection display from a local bar to the global footer cta).
  // Set _coverSelectedHex BEFORE onPantonePicked (which re-renders the grid;
  // renderPantoneGrid reads _coverSelectedHex to restore the ring). renderAll
  // (called by onPantonePicked) refreshes the footer via updateCtaSelection.
  window._coverSelectedHex = btn.dataset.hex;
  // Micro-animation: ring pulse on selected swatch
  btn.classList.add('is-selecting');
  btn.addEventListener('animationend', () => btn.classList.remove('is-selecting'), { once: true });
  onPantonePicked(btn.dataset.hex);
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
});

// Phase 4.28 — listener for #uploadInput is owned by bindCoverUploadEditor()
// (the dropzone change event now starts the editing state instead of pushing
// the raw image to the viewer).

function onPantonePicked(hex) {
  /* v9 §C3 — capture the Pantone TPG code on the customCover record so
     it can surface in the keepsake + active-name slots without a second
     library lookup later. */
  const p = (typeof nearestPantone === 'function') ? nearestPantone(hex) : null;
  state.customCover = p
    ? { type: 'pantone', hex, code: p.code, name: p.name }
    : { type: 'pantone', hex };
  currentPresetName = null;
  window._committedCatalogPreview = null; // picking a Pantone overrides any catalog selection
  a9Bridge.setCustomPantone(hex);
  a9Bridge.setRotation(false);
  _syncRotationPillOff();
  renderAll();
  renderPantoneGrid();
  /* Cover row label shows the Pantone code (e.g. "16-1546 TPG") instead
     of the generic "Custom" — more brand voice. */
  const lbl = document.getElementById('coverActiveName');
  if (lbl && p) fadeUpdate(lbl, p.code);
  // Phase 4.27 FIX 3 — sticky strip mirrors the new selection.
  if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
}

/* =====================================================================
   Hover Preview — 3D live preview on Pantone swatch hover.
   On mouseenter: send hovered hex to iframe for instant preview.
   On mouseleave: revert to currently committed cover state.
   Debounced at 60ms to avoid flooding the iframe with messages.
   ===================================================================== */
(function () {
  const grid = document.getElementById('pantoneGrid');
  if (!grid) return;
  let hoverTimeout = null;
  let isHovering = false;

  grid.addEventListener('mouseover', (e) => {
    const swatch = e.target.closest('[data-hex]');
    if (!swatch) return;
    clearTimeout(hoverTimeout);
    hoverTimeout = setTimeout(() => {
      isHovering = true;
      a9Bridge.setCustomPantone(swatch.dataset.hex);
    }, 60);
  });

  grid.addEventListener('mouseout', (e) => {
    const swatch = e.target.closest('[data-hex]');
    if (!swatch) return;
    // Only revert if we're not hovering another swatch
    const related = e.relatedTarget?.closest?.('[data-hex]');
    if (related) return; // moving to another swatch, mouseover will fire
    clearTimeout(hoverTimeout);
    if (!isHovering) return;
    isHovering = false;
    // Revert to committed state
    if (state.customCover && state.customCover.type === 'pantone') {
      a9Bridge.setCustomPantone(state.customCover.hex);
    } else if (state.customCover && state.customCover.type === 'upload') {
      // Upload cover — re-send the last composed image from uploadCovers[]
      var _lU = (state.uploadCovers && state.uploadCovers.length > 0) ? state.uploadCovers[state.uploadCovers.length - 1] : state.coverUpload;
      if (_lU && _lU.composedDataUrl) {
        a9Bridge.setCustomUpload(_lU.composedDataUrl, true);  // 上传→trim(原死消息)
      }
    } else {
      // Factory preset — revert to preset cover
      a9Bridge.setCover(state.cover || 'Warm White');
    }
  });
})();

/* =====================================================================
   Phase 4.28 SECTION 3 — Cover · Upload three-state editor
   EMPTY → EDITING → APPLIED, all driven from state.coverUpload.
   bindCoverUploadEditor() registers every listener once on init. The state
   machine functions live on top-level so they can be reached from
   coverReset, the cover-tab switch, and _safeBoot at boot.

   INIT-ORDER RULE — every module-level `let _` MUST be declared in
   SECTION 2 (HELPERS) above the boot calls in SECTION 4. Currently
   _coverUploadEditSnapshot + _coverLiveRafId + _tpgArray all sit upstream;
   audit with `grep -n '^let _' ` after any future hoist change.
   ===================================================================== */

function _enterEditingState() {
  _showUploadProgress(false);
  if (!state.coverUpload) return;
  // Auto-zoom to Cover closeup when entering upload editor
  try {
    a9Bridge.setView('cover', true);
    a9Bridge.setZoom(true);
    _syncZoomTogglePill(true);
  } catch(e) { console.warn('[upload] auto-zoom failed:', e); }
  _coverUploadEditSnapshot = Object.assign({}, state.coverUpload);
  delete _coverUploadEditSnapshot._image;
  const zone    = document.getElementById('coverUploadZone');
  const editor  = document.getElementById('coverUploadEditor');
  const list    = document.getElementById('coverUploadList');
  if (zone)    zone.hidden = true;
  if (list)    list.hidden = true;
  if (editor)  editor.hidden = false;
  const img = document.getElementById('cuImg');
  if (img) img.src = state.coverUpload.dataUrl;
  document.querySelectorAll('.cu-filter-chip').forEach((c) =>
    c.classList.toggle('is-active', c.dataset.filter === state.coverUpload.filter));
  _applyCoverUploadLivePreview();
}

// Phase 6.1 — "Applied" now means: push current edit into uploadCovers[] and show the list.
function _enterAppliedState() {
  if (!state.coverUpload) { _enterEmptyState(); return; }
  // Ensure composedDataUrl is set
  if (!state.coverUpload.composedDataUrl && state.coverUpload._image) {
    state.coverUpload.composedDataUrl = composeCoverUploadSync(state.coverUpload);
  }
  // Save into uploadCovers[] array
  var entry = Object.assign({}, state.coverUpload);
  delete entry._image;
  if (_editingUploadIdx >= 0 && _editingUploadIdx < state.uploadCovers.length) {
    // Editing existing — replace in-place, preserve qty so an "edit" doesn't
    // silently reset a stepper count the customer already adjusted.
    entry.id = state.uploadCovers[_editingUploadIdx].id;
    entry.qty = state.uploadCovers[_editingUploadIdx].qty || 1;
    state.uploadCovers[_editingUploadIdx] = entry;
  } else {
    // New upload — initialise qty so the cart stepper has a number to step.
    entry.id = 'upl_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6);
    entry.qty = 1;
    state.uploadCovers.push(entry);
  }
  _editingUploadIdx = -1;
  _coverUploadEditSnapshot = null;
  // Show the last uploaded cover on the 3D viewer
  var lastEntry = state.uploadCovers[state.uploadCovers.length - 1];
  if (lastEntry && lastEntry.composedDataUrl) {
    _sendUploadToViewer(lastEntry.composedDataUrl);
    state.customCover = { type: 'upload', filename: lastEntry.filename };
    window._committedCatalogPreview = null; // committing an upload overrides any catalog selection
  }
  // Clear working state and show list
  state.coverUpload = null;
  _enterListState();
  if (typeof renderAll === 'function') renderAll();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
  if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
}

// Phase 6.1 — Show the multi-upload list
function _enterListState() {
  const zone   = document.getElementById('coverUploadZone');
  const editor = document.getElementById('coverUploadEditor');
  const list   = document.getElementById('coverUploadList');
  const prog   = document.getElementById('cuUploading');
  if (prog)   prog.hidden = true;
  if (zone)   zone.hidden = true;
  if (editor) editor.hidden = true;
  if (list)   list.hidden = false;
  _renderUploadList();
}

function _enterEmptyState() {
  const zone    = document.getElementById('coverUploadZone');
  const editor  = document.getElementById('coverUploadEditor');
  const list    = document.getElementById('coverUploadList');
  const prog    = document.getElementById('cuUploading');
  if (prog)    prog.hidden = true;
  if (zone)    zone.hidden = false;
  if (editor)  editor.hidden = true;
  if (list)    list.hidden = true;
  _coverUploadEditSnapshot = null;
  _editingUploadIdx = -1;
  const u = document.getElementById('uploadInput'); if (u) u.value = '';
}

// Phase 6.1 — Render the upload list from state.uploadCovers[]
function _renderUploadList() {
  var container = document.getElementById('cuListItems');
  var priceEl   = document.getElementById('cuListPrice');
  if (!container) return;
  var html = '';
  for (var i = 0; i < state.uploadCovers.length; i++) {
    var item = state.uploadCovers[i];
    var src = item.composedDataUrl || item.dataUrl || '';
    var name = item.filename || ('Cover ' + (i + 1));
    html += '<div class="cu-list-item" data-upl-idx="' + i + '">' +
      '<img class="cu-list-item-thumb" src="' + src + '" alt="" data-action="preview" />' +
      '<div class="cu-list-item-meta" data-action="rename" title="Click to rename">' +
        '<span class="cu-list-item-name-text">' + name + '</span>' +
                '<span class="cu-list-item-edit-icon">&#x270E;</span>' +
      '</div>' +
      '<div class="cu-list-item-actions">' +
        '<button type="button" data-action="edit">Edit</button>' +
        '<button type="button" data-action="remove">Remove</button>' +
      '</div></div>';
  }
  container.innerHTML = html;
  if (priceEl) {
    var count = state.uploadCovers.length;
    priceEl.textContent = count > 0 ? (count + ' cover' + (count > 1 ? 's' : '')) : '';
  }
}

// Phase 6.1 — Edit an existing upload from the list
function _editUploadAtIndex(idx) {
  if (idx < 0 || idx >= state.uploadCovers.length) return;
  _editingUploadIdx = idx;
  var entry = state.uploadCovers[idx];
  state.coverUpload = Object.assign({}, COVER_UPLOAD_DEFAULTS, entry, { _image: null });
  // Decode the image for the editor
  _decodeAndCacheUploadImage().then(function() {
    _enterEditingState();
    _scheduleCoverLivePreview();
  }).catch(function(err) {
    console.error('[multiUpload] re-decode failed:', err);
    _editingUploadIdx = -1;
    state.coverUpload = null;
  });
}

// Phase 6.1 — Remove an upload from the list
function _removeUploadAtIndex(idx) {
  if (idx < 0 || idx >= state.uploadCovers.length) return;
  state.uploadCovers.splice(idx, 1);
  if (state.uploadCovers.length === 0) {
    state.customCover = null;
    _sendUploadToViewer(null);
    _enterEmptyState();
  } else {
    // Show last remaining cover on viewer
    var last = state.uploadCovers[state.uploadCovers.length - 1];
    if (last && last.composedDataUrl) _sendUploadToViewer(last.composedDataUrl);
    _renderUploadList();
  }
  if (typeof renderAll === 'function') renderAll();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
  if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
}

// Phase 6.5 — Inline rename: click name → editable input, blur/Enter saves
function _renameUploadAtIndex(idx, nameEl) {
  if (idx < 0 || idx >= state.uploadCovers.length) return;
  if (!nameEl || nameEl.querySelector('input')) return; // already editing
  var current = state.uploadCovers[idx].filename || ('Cover ' + (idx + 1));
  var baseName = current.replace(/\.[^.]+$/, ''); // strip extension
  var input = document.createElement('input');
  input.type = 'text';
  input.value = baseName;
  input.className = 'cu-list-rename-input';
  input.style.cssText = 'width:100%;font:inherit;border:0;border-bottom:1.5px solid var(--color-carbon,#191817);background:transparent;outline:none;padding:0 0 2px;';
  nameEl.textContent = '';
  nameEl.appendChild(input);
  input.focus();
  input.select();
  var committed = false;
  function commit() {
    if (committed) return;
    committed = true;
    var val = input.value.trim();
    if (val && val !== baseName) {
      state.uploadCovers[idx].filename = val;
    }
    _renderUploadList();
    if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
    if (typeof _updateCartPopover === 'function') _updateCartPopover();
  }
  input.addEventListener('blur', commit);
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); commit(); }
    if (e.key === 'Escape') { committed = true; _renderUploadList(); }
  });
}

function _applyCoverUploadLivePreview() {
  const p = state.coverUpload; if (!p) return;
  // Phase 4.30 — img is now inset:0 + width/height:100% + object-fit:cover,
  // so it's already centred and cover-fit. Transform applies normalised
  // offsets (×preview-radius), zoom, and rotation around the centre.
  const pv = document.getElementById('cuPreview');
  const img = document.getElementById('cuImg');
  if (img) {
    const r = pv ? pv.offsetWidth / 2 : 0;
    const totalRot = p.rotation + (p.levelDeg || 0);
    img.style.transform =
      'translate(' + (p.offsetX * r) + 'px, ' + (p.offsetY * r) + 'px) ' +
      'scale(' + p.zoom + ') ' +
      'rotate(' + totalRot + 'deg)';
    img.style.filter = (COVER_UPLOAD_FILTERS[p.filter] && COVER_UPLOAD_FILTERS[p.filter].css) || 'none';
  }
  const rotSl = document.getElementById('cuRotSlider');
  if (rotSl) rotSl.value = String(p.rotation || 0);
  const lvl = document.getElementById('cuLevelSlider');
  if (lvl) lvl.value = String(p.levelDeg || 0);
  const sl = document.getElementById('cuZoom');
  if (sl) sl.value = String(p.zoom);
}

// Single chokepoint for "send the user's upload to the 3D viewer". Pass null
// to clear the upload texture and revert to whatever Step 1's existing cover
// was (state.cover).
function _sendUploadToViewer(dataUrl) {
  if (dataUrl) {
    a9Bridge.setCustomUpload(dataUrl, true);  // 客户上传实时预览→trim 到70cm可见
    a9Bridge.setRotation(false);
    _syncRotationPillOff();
  } else {
    a9Bridge.setCover(state.cover || 'Warm White');
  }
}

// Show/hide the "Preparing your image…" progress block. Sits between the
// dropzone and the editor; covers the FileReader + image-decode gap.
function _showUploadProgress(on) {
  const zone = document.getElementById('coverUploadZone');
  const prog = document.getElementById('cuUploading');
  const list = document.getElementById('coverUploadList');
  if (prog) prog.hidden = !on;
  if (on && zone) zone.hidden = true;
  if (on && list) list.hidden = true;
}

function _ingestCoverUploadFile(file) {
  if (!file) return;
  if (file.size > COVER_UPLOAD_MAX_BYTES) {
    console.warn('[coverUpload] file exceeds 12 MB limit:', file.size);
    return;
  }
  if (!/^image\/(jpeg|png|webp)$/.test(file.type)) {
    console.warn('[coverUpload] unsupported MIME:', file.type);
    return;
  }
  _showUploadProgress(true);   // instant feedback — decode below can take seconds
  const reader = new FileReader();
  reader.onload = async () => {
    state.coverUpload = Object.assign({}, COVER_UPLOAD_DEFAULTS, {
      dataUrl: reader.result,
      filename: file.name || 'image.png',
      _image: null,
    });
    // Phase 4.29 — decode once, cache the HTMLImageElement, then stream
    // every parameter change to the viewer through composeCoverUploadSync().
    try {
      await _decodeAndCacheUploadImage();
    } catch (err) {
      console.error('[coverUpload] decode failed:', err);
      state.coverUpload = null;
      _enterEmptyState();
      return;
    }
    _enterEditingState();
    // Engage pricing immediately — user sees the image on the speaker AND
    // the +€129 line item the moment they drop. customCover.type === 'upload'
    // is what recomputeTotal + updateCtaSummary + _syncCoverSelectedStrip read.
    state.customCover = {
      type: 'upload',
      filename: state.coverUpload.filename,
    };
    currentPresetName = null;
    _scheduleCoverLivePreview();   // first paint to viewer
    if (typeof renderAll === 'function') renderAll();
    if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
    if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
  };
  reader.readAsDataURL(file);
}

function bindCoverUploadEditor() {
  // Dropzone — file picker (existing) + drag-and-drop (new).
  const zone  = document.getElementById('coverUploadZone');
  const input = document.getElementById('uploadInput');
  if (input) {
    input.addEventListener('change', (e) => {
      const f = e.target.files && e.target.files[0];
      if (f) {
        input.value = '';          // reset so same file re-triggers change
        _ingestCoverUploadFile(f);
      }
    });
  }
  if (zone) {
    ['dragenter', 'dragover'].forEach((evt) =>
      zone.addEventListener(evt, (e) => {
        e.preventDefault(); e.stopPropagation();
        zone.classList.add('is-drag-over');
      }));
    ['dragleave', 'drop'].forEach((evt) =>
      zone.addEventListener(evt, (e) => {
        e.preventDefault(); e.stopPropagation();
        zone.classList.remove('is-drag-over');
      }));
    zone.addEventListener('drop', (e) => {
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) _ingestCoverUploadFile(f);
    });
  }

  // Drag inside the preview to position the image.
  const pv = document.getElementById('cuPreview');
  if (pv) {
    // Phase 4.30 — offsets are normalised against half the preview width.
    // _dragR captures that radius once per drag so a window resize mid-drag
    // doesn't deform the gesture (also avoids per-frame layout reads).
    let active = false, sx = 0, sy = 0, ox = 0, oy = 0, _dragR = 1;

    // --- Pinch-to-zoom + two-finger level (mobile) -----------------------
    // Tracks the initial distance and angle between two touch points so we
    // can derive zoom-delta and level-delta per frame.
    let _pinchActive = false, _pinchDist0 = 0, _pinchAngle0 = 0;
    let _pinchZoom0 = 1, _pinchLevel0 = 0;
    // Two-finger midpoint for simultaneous pan
    let _pinchMidX0 = 0, _pinchMidY0 = 0, _pinchOx0 = 0, _pinchOy0 = 0;

    function _touchDist(t) {
      var dx = t[1].clientX - t[0].clientX;
      var dy = t[1].clientY - t[0].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function _touchAngle(t) {
      return Math.atan2(t[1].clientY - t[0].clientY,
                        t[1].clientX - t[0].clientX) * (180 / Math.PI);
    }
    function _touchMid(t) {
      return {
        x: (t[0].clientX + t[1].clientX) / 2,
        y: (t[0].clientY + t[1].clientY) / 2
      };
    }

    // Circle hit-test: only intercept gestures inside the visible mask.
    // The mask circle is inset 8% on each side → center = 50%, radius = 42%.
    function _isInsideCircle(clientX, clientY) {
      var rect = pv.getBoundingClientRect();
      var relX = (clientX - rect.left) / rect.width  - 0.5; // -0.5..+0.5
      var relY = (clientY - rect.top)  / rect.height - 0.5;
      return (relX * relX + relY * relY) <= (0.42 * 0.42);
    }

    const onDown = (e) => {
      if (!state.coverUpload) return;
      // Two-finger gesture: pinch-to-zoom + rotation level
      if (e.touches && e.touches.length >= 2) {
        // Check if at least one finger is inside the circle
        var anyInside = false;
        for (var i = 0; i < e.touches.length; i++) {
          if (_isInsideCircle(e.touches[i].clientX, e.touches[i].clientY)) { anyInside = true; break; }
        }
        if (!anyInside) return; // let panel scroll
        active = false; // cancel single-finger drag
        _pinchActive = true;
        _pinchDist0 = _touchDist(e.touches);
        _pinchAngle0 = _touchAngle(e.touches);
        _pinchZoom0 = state.coverUpload.zoom;
        _pinchLevel0 = state.coverUpload.levelDeg || 0;
        var mid = _touchMid(e.touches);
        _pinchMidX0 = mid.x; _pinchMidY0 = mid.y;
        _pinchOx0 = state.coverUpload.offsetX;
        _pinchOy0 = state.coverUpload.offsetY;
        _dragR = Math.max(1, pv.offsetWidth / 2);
        pv.style.touchAction = 'none'; // prevent scroll while gesturing
        e.preventDefault();
        return;
      }
      // Single-finger: pan only (ignore if 2+ fingers)
      if (e.touches && e.touches.length > 1) return;
      var pt0 = e.touches ? e.touches[0] : e;
      if (!_isInsideCircle(pt0.clientX, pt0.clientY)) return; // outside circle → let panel scroll
      active = true; pv.classList.add('is-dragging');
      const pt = pt0;
      sx = pt.clientX; sy = pt.clientY;
      ox = state.coverUpload.offsetX; oy = state.coverUpload.offsetY;
      _dragR = Math.max(1, pv.offsetWidth / 2);
      pv.style.touchAction = 'none'; // prevent scroll while dragging
      e.preventDefault();
    };
    const onMove = (e) => {
      if (!state.coverUpload) return;
      // Two-finger gesture in progress
      if (_pinchActive && e.touches && e.touches.length >= 2) {
        e.preventDefault();
        // Zoom from pinch distance
        var dist = _touchDist(e.touches);
        var scale = dist / Math.max(1, _pinchDist0);
        state.coverUpload.zoom = clampZoom(_pinchZoom0 * scale);
        // Level from rotation angle
        var angle = _touchAngle(e.touches);
        var deltaAngle = angle - _pinchAngle0;
        // Clamp level to ±15°
        state.coverUpload.levelDeg = Math.max(-15, Math.min(15, _pinchLevel0 + deltaAngle));
        // Pan from midpoint shift
        var mid = _touchMid(e.touches);
        state.coverUpload.offsetX = _pinchOx0 + (mid.x - _pinchMidX0) / _dragR;
        state.coverUpload.offsetY = _pinchOy0 + (mid.y - _pinchMidY0) / _dragR;
        // Sync sliders (desktop fallback)
        var zoomSl = document.getElementById('cuZoom');
        if (zoomSl) zoomSl.value = String(state.coverUpload.zoom);
        var lvlSl = document.getElementById('cuLevelSlider');
        if (lvlSl) lvlSl.value = String(state.coverUpload.levelDeg);
        _applyCoverUploadLivePreview();
        _scheduleCoverLivePreview();
        return;
      }
      // If a second finger arrives mid-drag, abort single-finger pan
      if (e.touches && e.touches.length >= 2) { active = false; return; }
      if (!active) return;
      // FIX 2026-06-06: preventDefault EVERY move frame, not just touchstart.
      // iOS Safari decides scroll intent per-frame for a passive:false
      // touchmove listener — without this, single-finger image panning also
      // scrolled the page, dragging the 3D preview card above. Guarded by
      // `active` so touches that began outside the circle still scroll the panel.
      if (e.cancelable) e.preventDefault();
      const pt = e.touches ? e.touches[0] : e;
      state.coverUpload.offsetX = ox + (pt.clientX - sx) / _dragR;
      state.coverUpload.offsetY = oy + (pt.clientY - sy) / _dragR;
      _applyCoverUploadLivePreview();
      _scheduleCoverLivePreview();
    };
    const onUp = (e) => {
      // End pinch when fewer than 2 fingers remain
      if (_pinchActive && (!e.touches || e.touches.length < 2)) {
        _pinchActive = false;
      }
      active = false; pv.classList.remove('is-dragging');
      pv.style.touchAction = 'auto'; // restore panel scrolling
    };
    pv.addEventListener('mousedown', onDown);
    pv.addEventListener('touchstart', onDown, { passive: false });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchend', onUp);

    // Wheel zoom — preventDefault scoped to the preview only.
    pv.addEventListener('wheel', (e) => {
      if (!state.coverUpload) return;
      e.preventDefault();
      state.coverUpload.zoom = clampZoom(
        state.coverUpload.zoom + (e.deltaY < 0 ? 0.05 : -0.05));
      _applyCoverUploadLivePreview();
      _scheduleCoverLivePreview();
    }, { passive: false });
  }

  // Phase 4.30 — preview transform multiplies by live preview radius, so
  // when the preview width changes (window resize, panel layout shift) we
  // must re-apply the transform with the new radius. 3D viewer is
  // size-independent, so no rAF push needed here.
  window.addEventListener('resize', () => {
    if (state.coverUpload && state.coverUpload._image) {
      _applyCoverUploadLivePreview();
    }
  });

  // Slider zoom.
  const slider = document.getElementById('cuZoom');
  if (slider) slider.addEventListener('input', (e) => {
    if (!state.coverUpload) return;
    state.coverUpload.zoom = clampZoom(parseFloat(e.target.value));
    _applyCoverUploadLivePreview();
    _scheduleCoverLivePreview();
  });

  // +/- zoom buttons.
  document.querySelectorAll('.cu-zoom-btn').forEach((b) =>
    b.addEventListener('click', () => {
      if (!state.coverUpload) return;
      const dir = b.dataset.zoom === 'in' ? 1 : -1;
      state.coverUpload.zoom = clampZoom(state.coverUpload.zoom + dir * 0.1);
      _applyCoverUploadLivePreview();
      _scheduleCoverLivePreview();
    }));

  // Filter chips — click to commit, hover to preview.
  let _filterBeforeHover = null;
  document.querySelectorAll('.cu-filter-chip').forEach((c) => {
    c.addEventListener('click', () => {
      if (!state.coverUpload) return;
      _filterBeforeHover = null; // committed
      document.querySelectorAll('.cu-filter-chip').forEach((x) =>
        x.classList.toggle('is-active', x === c));
      state.coverUpload.filter = c.dataset.filter;
      _applyCoverUploadLivePreview();
      _scheduleCoverLivePreview();
    });
    c.addEventListener('mouseenter', () => {
      if (!state.coverUpload) return;
      _filterBeforeHover = state.coverUpload.filter;
      state.coverUpload.filter = c.dataset.filter;
      _applyCoverUploadLivePreview();
      _scheduleCoverLivePreview();
    });
    c.addEventListener('mouseleave', () => {
      if (!state.coverUpload || _filterBeforeHover === null) return;
      state.coverUpload.filter = _filterBeforeHover;
      _filterBeforeHover = null;
      _applyCoverUploadLivePreview();
      _scheduleCoverLivePreview();
    });
    // Mobile: touchend directly commits filter (bypasses iOS double-tap hover issue)
    c.addEventListener('touchend', (e) => {
      if (!state.coverUpload) return;
      e.preventDefault(); // prevent mouseenter/mouseleave/click cascade
      _filterBeforeHover = null;
      document.querySelectorAll('.cu-filter-chip').forEach((x) =>
        x.classList.toggle('is-active', x === c));
      state.coverUpload.filter = c.dataset.filter;
      _applyCoverUploadLivePreview();
      _scheduleCoverLivePreview();
    });
  });

  // Rotate buttons.
  document.querySelectorAll('.cu-rotate-btn').forEach((b) =>
    b.addEventListener('click', () => {
      if (!state.coverUpload) return;
      const delta = parseInt(b.dataset.rot, 10) || 0;
      state.coverUpload.rotation = ((state.coverUpload.rotation + delta) % 360 + 360) % 360;
      _applyCoverUploadLivePreview();
      _scheduleCoverLivePreview();
    }));

  // Level slider — fine-tune horizon ±15°.
  const levelSlider = document.getElementById('cuLevelSlider');
  if (levelSlider) levelSlider.addEventListener('input', () => {
    if (!state.coverUpload) return;
    state.coverUpload.levelDeg = parseFloat(levelSlider.value) || 0;
    _applyCoverUploadLivePreview();
    _scheduleCoverLivePreview();
  });

  // Apply — Phase 4.29: pure UI commit. The viewer already shows the live
  // composition (driven by _scheduleCoverLivePreview on every parameter
  // change), and pricing/summary engaged on file drop. No work to do here
  // beyond the EDITING → APPLIED transition.
  const applyBtn = document.getElementById('cuApply');
  if (applyBtn) applyBtn.addEventListener('click', () => {
    if (!state.coverUpload) return;
    _enterAppliedState();
  });

  // Cover V2 — Done button replaces Apply/Cancel in the new Upload pane.
  // Same behavior as Apply: commit the editing state.
  const doneBtn = document.getElementById('cuDone');
  if (doneBtn) doneBtn.addEventListener('click', () => {
    if (!state.coverUpload) return;
    _enterAppliedState();
  });

  // Reset button — clear current editing upload, return to drop zone or list
  const resetBtn2 = document.getElementById('cuReset');
  if (resetBtn2) resetBtn2.addEventListener('click', () => {
    // Clear Compare / Enhance state
    if (typeof _enhanceEnhancedDataUrl !== 'undefined') { _enhanceEnhancedDataUrl = null; _enhanceShowingOriginal = false; }
    var _cBtnR = document.getElementById('cuCompareBtn');
    if (_cBtnR) { _cBtnR.hidden = true; _cBtnR.classList.remove('is-active'); }
    var _eBtnR = document.getElementById('cuEnhanceBtn');
    if (_eBtnR) _eBtnR.classList.remove('is-active');
    state.coverUpload = null;
    _editingUploadIdx = -1;
    // If there are already saved uploads, show the list; otherwise empty state
    if (state.uploadCovers.length > 0) {
      // Restore last upload on viewer
      var last = state.uploadCovers[state.uploadCovers.length - 1];
      if (last && last.composedDataUrl) _sendUploadToViewer(last.composedDataUrl);
      _enterListState();
    } else {
      state.customCover = null;
      _sendUploadToViewer(null);
      _enterEmptyState();
    }
    if (typeof renderAll === 'function') renderAll();
    if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
    if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
  });

  // Cancel — restore the snapshot AND repaint the viewer so the live
  // composition reverts visibly. If there's no snapshot, this was a
  // first-time edit: clear everything and disengage pricing.
  const cancelBtn = document.getElementById('cuCancel');
  if (cancelBtn) cancelBtn.addEventListener('click', () => {
    // Clear Compare / Enhance state
    if (typeof _enhanceEnhancedDataUrl !== 'undefined') { _enhanceEnhancedDataUrl = null; _enhanceShowingOriginal = false; }
    var _cBtnC = document.getElementById('cuCompareBtn');
    if (_cBtnC) { _cBtnC.hidden = true; _cBtnC.classList.remove('is-active'); }
    var _eBtnC = document.getElementById('cuEnhanceBtn');
    if (_eBtnC) _eBtnC.classList.remove('is-active');
    if (_coverUploadEditSnapshot) {
      const cachedImage = state.coverUpload && state.coverUpload._image;
      state.coverUpload = Object.assign({}, _coverUploadEditSnapshot, { _image: cachedImage });
      // If editing an existing list item, revert to list view
      _editingUploadIdx = -1;
      state.coverUpload = null;
      if (state.uploadCovers.length > 0) {
        var last = state.uploadCovers[state.uploadCovers.length - 1];
        if (last && last.composedDataUrl) _sendUploadToViewer(last.composedDataUrl);
        _enterListState();
      } else {
        _enterEmptyState();
      }
    } else {
      state.coverUpload = null;
      _editingUploadIdx = -1;
      if (state.uploadCovers.length > 0) {
        _enterListState();
      } else {
        state.customCover = null;
        _sendUploadToViewer(null);
        _enterEmptyState();
      }
      if (typeof renderAll === 'function') renderAll();
      if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
      if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
    }
  });

  // ── AI Enhance ──────────────────────────────────────────────────
  const enhanceRow = document.getElementById('cuEnhanceRow');
  const enhanceBtn = document.getElementById('cuEnhanceBtn');
  const enhanceHint = document.getElementById('cuEnhanceHint');
  let _enhanceOriginalDataUrl = null; // stash original for Reset
  let _enhanceEnhancedDataUrl = null; // stash enhanced for Compare toggle
  let _enhanceShowingOriginal = false; // Compare toggle state

  // Helper: set button label text — Phase 6.2 pill: sparkle SVG + text node
  function _enhanceBtnText(txt) {
    if (!enhanceBtn) return;
    // Preserve the leading SVG icon, replace only the text content
    var spark = enhanceBtn.querySelector('.cu-enhance-spark');
    if (spark) {
      // Clear everything after the SVG, then append text
      while (spark.nextSibling) spark.nextSibling.remove();
      enhanceBtn.append(' ' + txt);
    } else {
      enhanceBtn.textContent = txt;
    }
  }

  // Show Enhance row whenever editing state is entered
  const _origEnterEditing = _enterEditingState;
  _enterEditingState = function() {
    _origEnterEditing();
    if (enhanceRow && state.coverUpload && state.coverUpload.dataUrl) {
      enhanceRow.hidden = false;
      // Reset enhance button state for new image
      if (enhanceBtn) { enhanceBtn.classList.remove('is-loading', 'is-done'); }
      if (enhanceRow) enhanceRow.classList.remove('is-processing');
      _enhanceBtnText('AI Enhance');
      if (enhanceHint) { enhanceHint.hidden = true; enhanceHint.textContent = ''; }
      _enhanceOriginalDataUrl = state.coverUpload.dataUrl;
      // Reset Compare state for new image
      _enhanceEnhancedDataUrl = null;
      _enhanceShowingOriginal = false;
      var _cBtn = document.getElementById('cuCompareBtn');
      if (_cBtn) { _cBtn.hidden = true; _cBtn.classList.remove('is-active'); }
      var _eBtn = document.getElementById('cuEnhanceBtn');
      if (_eBtn) _eBtn.classList.remove('is-active');
    }
  };

  // ── Canvas Enhancement Engine ──────────────────────────────────────
  // Unsharp Mask + Local Contrast (Clarity) + subtle color boost.
  // Runs entirely in the browser — no API calls, preserves all detail.
  function _canvasEnhance(canvas) {
    var W = canvas.width, H = canvas.height;
    var ctx = canvas.getContext('2d');

    // 1) Unsharp Mask — sharpen edges via blur-difference
    var blurC = document.createElement('canvas');
    blurC.width = W; blurC.height = H;
    var blurCtx = blurC.getContext('2d');
    blurCtx.filter = 'blur(1.2px)';
    blurCtx.drawImage(canvas, 0, 0);

    var origData = ctx.getImageData(0, 0, W, H);
    var blurData = blurCtx.getImageData(0, 0, W, H);
    var o = origData.data, b = blurData.data;
    var amount = 0.55, threshold = 3;
    for (var i = 0; i < o.length; i += 4) {
      for (var c = 0; c < 3; c++) {
        var diff = o[i + c] - b[i + c];
        if (Math.abs(diff) > threshold) {
          o[i + c] = Math.max(0, Math.min(255, o[i + c] + diff * amount));
        }
      }
    }
    ctx.putImageData(origData, 0, 0);

    // 2) Local Contrast Enhancement (Clarity) — larger radius
    var lcC = document.createElement('canvas');
    lcC.width = W; lcC.height = H;
    var lcCtx = lcC.getContext('2d');
    lcCtx.filter = 'blur(25px)';
    lcCtx.drawImage(canvas, 0, 0);

    var sharpData = ctx.getImageData(0, 0, W, H);
    var lcData = lcCtx.getImageData(0, 0, W, H);
    var s = sharpData.data, l = lcData.data;
    var clarity = 0.25;
    for (var j = 0; j < s.length; j += 4) {
      for (var ch = 0; ch < 3; ch++) {
        var d = s[j + ch] - l[j + ch];
        s[j + ch] = Math.max(0, Math.min(255, s[j + ch] + d * clarity));
      }
    }
    ctx.putImageData(sharpData, 0, 0);

    // 3) Subtle contrast + saturation boost (GPU-accelerated)
    var boostC = document.createElement('canvas');
    boostC.width = W; boostC.height = H;
    var boostCtx = boostC.getContext('2d');
    boostCtx.filter = 'contrast(1.06) saturate(1.08)';
    boostCtx.drawImage(canvas, 0, 0);
    ctx.drawImage(boostC, 0, 0);
  }

  // ── AI Tile Enhancement (BSRGAN) ────────────────────────────────
  // For low-res images that genuinely need more pixels
  async function _aiEnhanceTile(tileDataUrl, retries) {
    retries = retries || 3;
    for (var attempt = 1; attempt <= retries; attempt++) {
      try {
        var resp = await fetch('https://variation.tegrino.co/api/enhance', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ image: tileDataUrl }),
        });
        if (!resp.ok) {
          var err = await resp.json().catch(function() { return {}; });
          var msg = err.detail || err.error || 'Server error ' + resp.status;
          if (attempt < retries && (resp.status === 429 || resp.status >= 500)) {
            console.warn('[enhance] tile attempt ' + attempt + ' failed (' + msg + '), retrying…');
            await new Promise(function(r) { setTimeout(r, attempt * 3000); });
            continue;
          }
          throw new Error(msg);
        }
        var data = await resp.json();
        if (!data.output) throw new Error('No output from AI');
        return await new Promise(function(resolve, reject) {
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() { resolve(img); };
          img.onerror = function() { reject(new Error('Failed to load enhanced tile')); };
          img.src = data.output;
        });
      } catch (e) {
        if (attempt < retries) {
          console.warn('[enhance] tile attempt ' + attempt + ' error: ' + e.message + ', retrying…');
          await new Promise(function(r) { setTimeout(r, attempt * 3000); });
          continue;
        }
        throw e;
      }
    }
  }

  if (enhanceBtn) enhanceBtn.addEventListener('click', async () => {
    if (!state.coverUpload || !state.coverUpload.dataUrl) return;
    if (enhanceBtn.classList.contains('is-loading') || enhanceBtn.classList.contains('is-done')) return;

    _enhanceOriginalDataUrl = _enhanceOriginalDataUrl || state.coverUpload.dataUrl;
    enhanceBtn.classList.add('is-loading');
    if (enhanceRow) enhanceRow.classList.add('is-processing');
    _enhanceBtnText('Analysing…');
    if (enhanceHint) { enhanceHint.hidden = true; enhanceHint.textContent = ''; }

    try {
      // Load source image
      const srcImg = await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = state.coverUpload.dataUrl;
      });
      const W = srcImg.naturalWidth, H = srcImg.naturalHeight;
      let enhancedDataUrl;

      // ═══ Tile calculation ═══
      const TILE = 1024, OVERLAP = 64, SCALE = 2;
      const STRIDE = TILE - OVERLAP;
      const cols = Math.max(1, Math.ceil((W - OVERLAP) / STRIDE));
      const rows = Math.max(1, Math.ceil((H - OVERLAP) / STRIDE));
      const totalTiles = cols * rows;
      const useLocalOnly = totalTiles > 5; // Large images: skip API, enhance locally

      if (useLocalOnly) {
        // ═══ LOCAL PATH: Canvas enhancement for very large images ═══
        // Too many tiles would be slow & costly — local pipeline is instant
        const _localMsgs = [
          'Analysing image…',
          'Sharpening details…',
          'Enhancing contrast…',
          'Boosting colour…',
          'Finishing up…'
        ];
        var _localStep = 0;
        var _localTimer = setInterval(function() {
          _localStep = (_localStep + 1) % _localMsgs.length;
          _enhanceBtnText(_localMsgs[_localStep]);
        }, 1200);
        _enhanceBtnText(_localMsgs[0]);
        await new Promise(r => setTimeout(r, 80));
        const c = document.createElement('canvas');
        c.width = W; c.height = H;
        c.getContext('2d').drawImage(srcImg, 0, 0);
        _canvasEnhance(c);
        await new Promise(r => setTimeout(r, 50));
        clearInterval(_localTimer);
        enhancedDataUrl = c.toDataURL('image/jpeg', 0.95);

      } else {
        // ═══ AI PATH: Real-ESRGAN tile-based upscaling ═══
        // Rotating status messages for multi-tile processing
        const _aiMsgs = [
          'Processing with AI…',
          'Upscaling details…',
          'Reconstructing textures…',
          'Refining edges…',
          'Almost there…'
        ];
        var _aiMsgIdx = 0;
        var _aiMsgTimer = null;
        function _rotateAiMsg(done, total) {
          _enhanceBtnText(_aiMsgs[_aiMsgIdx % _aiMsgs.length] + ' ' + done + '/' + total);
        }
        if (totalTiles > 2) {
          _aiMsgTimer = setInterval(function() { _aiMsgIdx++; }, 4000);
        }
        _enhanceBtnText('Enhancing… 0/' + totalTiles);

        const tiles = [];
        for (let row = 0; row < rows; row++) {
          for (let col = 0; col < cols; col++) {
            let x = col * STRIDE, y = row * STRIDE;
            if (x + TILE > W) x = Math.max(0, W - TILE);
            if (y + TILE > H) y = Math.max(0, H - TILE);
            const tc = document.createElement('canvas');
            tc.width = TILE; tc.height = TILE;
            tc.getContext('2d').drawImage(srcImg, x, y, TILE, TILE, 0, 0, TILE, TILE);
            tiles.push({ x, y, dataUrl: tc.toDataURL('image/jpeg', 0.92) });
          }
        }

        let done = 0;
        const enhancedTiles = new Array(tiles.length);
        for (let i = 0; i < tiles.length; i++) {
          const img = await _aiEnhanceTile(tiles[i].dataUrl);
          enhancedTiles[i] = { ...tiles[i], img };
          done++;
          if (totalTiles > 2) { _rotateAiMsg(done, totalTiles); }
          else { _enhanceBtnText('Enhancing… ' + done + '/' + totalTiles); }
        }
        if (_aiMsgTimer) clearInterval(_aiMsgTimer);

        // Stitch tiles back together at 2× size
        const outW = W * SCALE, outH = H * SCALE;
        const outCanvas = document.createElement('canvas');
        outCanvas.width = outW; outCanvas.height = outH;
        const outCtx = outCanvas.getContext('2d');
        for (const t of enhancedTiles) {
          outCtx.drawImage(t.img, t.x * SCALE, t.y * SCALE);
        }
        // Canvas post-processing — sharpen + contrast + color boost
        _enhanceBtnText('Polishing…');
        _canvasEnhance(outCanvas);
        enhancedDataUrl = outCanvas.toDataURL('image/jpeg', 0.95);
      }

      // Store enhanced version and apply it
      _enhanceEnhancedDataUrl = enhancedDataUrl;
      _enhanceShowingOriginal = false;
      state.coverUpload.dataUrl = enhancedDataUrl;
      state.coverUpload._image = null; // force re-decode
      await _decodeAndCacheUploadImage();

      // Update editor preview
      const cuImg = document.getElementById('cuImg');
      if (cuImg) cuImg.src = enhancedDataUrl;

      // Refresh 3D model
      _applyCoverUploadLivePreview();
      _scheduleCoverLivePreview();

      enhanceBtn.classList.remove('is-loading');
      enhanceBtn.classList.add('is-done');
      if (enhanceRow) enhanceRow.classList.remove('is-processing');
      _enhanceBtnText('Enhanced ✓');

      // Show Original segment in toolbar + mark Enhanced as active
      const compareBtn = document.getElementById('cuCompareBtn');
      if (compareBtn) compareBtn.hidden = false;
      if (enhanceBtn) enhanceBtn.classList.add('is-active');

    } catch (err) {
      console.error('[enhance] failed:', err);
      enhanceBtn.classList.remove('is-loading');
      if (enhanceRow) enhanceRow.classList.remove('is-processing');
      _enhanceBtnText('AI Enhance');
      var errMsg = err.message || 'Unknown error';
      if (enhanceHint) {
        enhanceHint.hidden = false;
        enhanceHint.textContent = 'Enhancement failed: ' + errMsg.substring(0, 100) + '. Please try again.';
        enhanceHint.style.color = '#e74c3c';
        setTimeout(() => { if (enhanceHint) { enhanceHint.hidden = true; enhanceHint.textContent = ''; enhanceHint.style.color = ''; } }, 8000);
      }
    }
  });

  // --- Compare toggle: click "Original" or "Enhanced ✓" to switch ---
  // Must AWAIT the decode before scheduling the 3D preview push, because
  // _scheduleCoverLivePreview bails on the next rAF if `_image` is still null.
  const compareBtn = document.getElementById('cuCompareBtn');
  async function _toggleCompare() {
    if (!_enhanceOriginalDataUrl || !_enhanceEnhancedDataUrl) return;
    _enhanceShowingOriginal = !_enhanceShowingOriginal;
    const targetUrl = _enhanceShowingOriginal ? _enhanceOriginalDataUrl : _enhanceEnhancedDataUrl;
    state.coverUpload.dataUrl = targetUrl;
    state.coverUpload._image = null;
    const cuImg = document.getElementById('cuImg');
    if (cuImg) cuImg.src = targetUrl;
    // Reflect active state immediately for snappy UI feedback
    if (enhanceBtn) enhanceBtn.classList.toggle('is-active', !_enhanceShowingOriginal);
    if (compareBtn) compareBtn.classList.toggle('is-active', _enhanceShowingOriginal);
    _applyCoverUploadLivePreview();
    try {
      await _decodeAndCacheUploadImage();
    } catch (err) {
      console.error('[enhance][compare] decode failed:', err);
      return;
    }
    _scheduleCoverLivePreview();
  }
  if (compareBtn) compareBtn.addEventListener('click', _toggleCompare);
  // Also allow clicking Enhanced ✓ to switch back from Original
  if (enhanceBtn) enhanceBtn.addEventListener('click', function() {
    if (enhanceBtn.classList.contains('is-done') && _enhanceShowingOriginal) {
      _toggleCompare();
    }
  });


  // Phase 6.1 — "Add another design" button in the list view
  const addBtn = document.getElementById('cuAddAnother');
  if (addBtn) addBtn.addEventListener('click', () => {
    _editingUploadIdx = -1;
    state.coverUpload = null;
    const inlineZone = document.getElementById('cuInlineZone');
    if (inlineZone) {
      var isOpen = inlineZone.classList.contains('is-open');
      if (isOpen) {
        inlineZone.classList.remove('is-open');
      } else {
        inlineZone.classList.add('is-open');
        var inp = document.getElementById('cuInlineInput');
        if (inp) inp.value = '';
      }
    }
  });

  // Inline upload — file selected → send to editor via _ingestCoverUploadFile
  var cuInlineInput = document.getElementById('cuInlineInput');
  if (cuInlineInput) cuInlineInput.addEventListener('change', function(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    // Close inline zone
    var inlineZone = document.getElementById('cuInlineZone');
    if (inlineZone) inlineZone.classList.remove('is-open');
    cuInlineInput.value = '';
    // Feed into main editor pipeline (shows editor → Done saves to uploadCovers[])
    _editingUploadIdx = -1;
    _ingestCoverUploadFile(file);
  });

  // Phase 6.1 — Event delegation on upload list items (Edit / Remove / Preview)
  const listContainer = document.getElementById('cuListItems');
  if (listContainer) {
    listContainer.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      const item = btn.closest('.cu-list-item');
      if (!item) return;
      const idx = parseInt(item.dataset.uplIdx, 10);
      if (isNaN(idx)) return;
      const action = btn.dataset.action;
      if (action === 'edit') _editUploadAtIndex(idx);
      else if (action === 'remove') _removeUploadAtIndex(idx);
      else if (action === 'rename') _renameUploadAtIndex(idx, btn);
      else if (action === 'preview') {
        // Hover preview on thumbnail click — show on 3D viewer
        var entry = state.uploadCovers[idx];
        if (entry && entry.composedDataUrl) _sendUploadToViewer(entry.composedDataUrl);
      }
    });
    // Hover preview on thumbnails
    listContainer.addEventListener('mouseenter', (e) => {
      if (!e.target.classList.contains('cu-list-item-thumb')) return;
      var item = e.target.closest('.cu-list-item');
      if (!item) return;
      var idx = parseInt(item.dataset.uplIdx, 10);
      var entry = state.uploadCovers[idx];
      if (entry && entry.composedDataUrl) _sendUploadToViewer(entry.composedDataUrl);
    }, true);
    listContainer.addEventListener('mouseleave', (e) => {
      if (!e.target.classList.contains('cu-list-item-thumb')) return;
      // Revert to last upload
      var last = state.uploadCovers[state.uploadCovers.length - 1];
      if (last && last.composedDataUrl) _sendUploadToViewer(last.composedDataUrl);
    }, true);
  }
}

// Backward-compat shim — anything else in the codebase that still calls
// onImageUploaded(file) routes through the new ingest path.
function onImageUploaded(file) { _ingestCoverUploadFile(file); }

const _coverResetBtn = document.getElementById('coverReset');
if (_coverResetBtn) _coverResetBtn.addEventListener('click', e => {
  e.preventDefault();
  state.customCover = null;
  // Phase 4.28 — Cover reset is a hard "wipe customisation" gesture. It
  // tears down both the Pantone selection AND any uploaded image.
  state.coverUpload = null;
  state.uploadCovers = [];
  _editingUploadIdx = -1;
  if (typeof _enterEmptyState === 'function') _enterEmptyState();
  syncPresetState();
  a9Bridge.setCover(state.cover);
  renderAll();
  // Phase 3.2 — clear selection ring; Phase 3.3 footer refresh
  window._coverSelectedHex = null;
  // Phase 4.25 — scope cover-reset clear to cover grids only (was document-wide,
  // which silently cleared a current legs Custom Pantone selection too).
  document.querySelectorAll('#pantoneGrid .pantone-swatch, #matchRoomRecs .pantone-swatch')
    .forEach(b => b.classList.remove('is-selected'));
  // Phase 4.27 FIX 3 — clear the sticky strip on cover reset.
  if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
  if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
  // Phase 2.1 — reset sub-tab to NORDIC on cover reset (also re-renders pantoneGrid)
  if (typeof _activateSubstab === 'function') _activateSubstab('NORDIC');
  else renderPantoneGrid();
});

/* v8.1 §5 / v9 §C4 — tab switcher (only COLOUR + UPLOAD remain after
   v9 §C4 demoted MATCH A ROOM to a button). Hides every
   [data-tab-panel] and reveals the one matching the clicked tab. */
document.querySelectorAll('.cover-tab').forEach(t => {
  t.addEventListener('click', () => {
    document.querySelectorAll('.cover-tab').forEach(x => x.classList.toggle('is-active', x === t));
    document.querySelectorAll('[data-tab-panel]').forEach(panel => {
      panel.toggleAttribute('hidden', panel.dataset.tabPanel !== t.dataset.tab);
    });
    // Phase 4.27 FIX 3 — strip lives outside the panes; mirror tab state.
    if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
    // Phase 4.29 — leaving COLOUR/UPLOAD while editor is open is a clear
    // context exit. Because the viewer is already live-streaming the user's
    // current composition, the right behaviour is silent COMMIT, not revert
    // — preserve what the user has been seeing on the speaker.
    if (t.dataset.tab === 'colour' || t.dataset.tab === 'upload') {
      const editor = document.getElementById('coverUploadEditor');
      if (editor && !editor.hidden) {
        if (state.coverUpload && state.coverUpload._image) {
          _enterAppliedState();
        } else {
          state.coverUpload = null;
          _enterEmptyState();
        }
      }
    }
  });
});

/* Phase 2.1 — COLOUR pane sub-tab switcher (NORDIC / EARTHY / JAPANDI / STONE / BOLD).
   window._activeStyleTab drives renderPantoneGrid's filter. */
const STYLE_SUBTITLES = {
  NORDIC: 'For Scandinavian, modern farmhouse, coastal interiors',
  EARTHY: 'For bohemian, mid-century, wabi-sabi spaces',
  JAPANDI: 'For Japandi, organic modern, quiet luxury',
  STONE: 'For industrial, refined minimal homes',
  BOLD: 'For maximalist, eclectic, statement rooms',
};
window._activeStyleTab = 'NORDIC';

function _activateSubstab(style) {
  window._activeStyleTab = style;
  // Phase 5.1 — switching sub-tabs collapses any expanded Show-all view.
  window._coverShowAll = false;
  document.querySelectorAll('.cover-substab').forEach(b =>
    b.classList.toggle('is-active', b.dataset.style === style));
  const subtitleEl = document.getElementById('coverSubstabSubtitle');
  if (subtitleEl) subtitleEl.textContent = STYLE_SUBTITLES[style] || '';
  renderPantoneGrid();
}

document.querySelectorAll('.cover-substab').forEach(btn => {
  btn.addEventListener('click', () => {
    const style = btn.dataset.style;
    // Phase 3.2 — clear active search state when switching sub-tabs
    if (window._coverSearchQuery) {
      window._coverSearchQuery = '';
      const si = document.getElementById('coverSearchInput');
      const sc = document.getElementById('coverSearchClear');
      const sn = document.querySelector('.cover-style-subtabs');
      const su = document.getElementById('coverSubstabSubtitle');
      if (si) si.value = '';
      if (sc) sc.hidden = true;
      if (sn) sn.classList.remove('is-search-active');
      if (su) su.classList.remove('is-search-active');
    }
    if (style === window._activeStyleTab) {
      // Same sub-tab but we may have cleared search → still re-render to leave search results
      renderPantoneGrid();
      return;
    }
    _activateSubstab(style);
  });
});

/* Phase 3.2 — search input wiring (full-library 2310 TPG fuzzy search) */
window._coverSearchQuery = '';
(function () {
  const searchInput = document.getElementById('coverSearchInput');
  const searchClear = document.getElementById('coverSearchClear');
  const subtabsNav = document.querySelector('.cover-style-subtabs');
  const subtitleEl = document.getElementById('coverSubstabSubtitle');
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const q = searchInput.value.trim().toLowerCase();
      window._coverSearchQuery = q;
      if (searchClear) searchClear.hidden = q.length === 0;
      if (subtabsNav) subtabsNav.classList.toggle('is-search-active', q.length > 0);
      if (subtitleEl) subtitleEl.classList.toggle('is-search-active', q.length > 0);
      renderPantoneGrid();
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', () => {
      if (searchInput) searchInput.value = '';
      window._coverSearchQuery = '';
      searchClear.hidden = true;
      if (subtabsNav) subtabsNav.classList.remove('is-search-active');
      if (subtitleEl) subtitleEl.classList.remove('is-search-active');
      renderPantoneGrid();
      if (searchInput) searchInput.focus();
    });
  }
})();

/* v9 §C4 Match a Room — superseded by Phase 4.1 modal-based implementation below. */

/* =====================================================================
   v9 §C2 — Nearest-Pantone helpers. The 2310-entry TPG_DATABASE +
   TPG_NAMES globals come from <script src="tpg-database.js"> in head.
   `_tpgArray` + `_tpgList()` are hoisted to before Phase 4.21's
   _renderLegsCustomPantoneGrid (which calls _tpgList at module-load time)
   to avoid temporal-dead-zone — see hoisted block above.
   ===================================================================== */
function nearestPantone(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  let best = null;
  let bestDist = Infinity;
  const list = _tpgList();
  for (let i = 0; i < list.length; i++) {
    const e = list[i];
    const dr = (r - e.r) * 0.30;
    const dg = (g - e.g) * 0.59;
    const db = (b - e.b) * 0.11;
    const d = dr * dr + dg * dg + db * db;
    if (d < bestDist) { bestDist = d; best = e; }
  }
  return best;   // { code, hex, name, r, g, b }
}

function topNPantone(hex, n) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const list = _tpgList();
  const scored = list.map(e => {
    const dr = (r - e.r) * 0.30;
    const dg = (g - e.g) * 0.59;
    const db = (b - e.b) * 0.11;
    return Object.assign({}, e, { dist: dr * dr + dg * dg + db * db });
  });
  scored.sort((a, b) => a.dist - b.dist);
  return scored.slice(0, n);
}

/* =====================================================================
   v8.1 §5 / v9 §C5 — Match a Room (legacy 3-step flow). Superseded by
   Phase 4.1 modal-based implementation further below. _extractPaletteFromImage
   and _matchPantone are kept as utilities for any future palette work but
   are unused by the new Phase 4.1 flow (which calls a remote endpoint).
   ===================================================================== */
async function _extractPaletteFromImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const W = 80, H = 80;
      const c = document.createElement('canvas');
      c.width = W; c.height = H;
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, W, H);
      const data = ctx.getImageData(0, 0, W, H).data;
      // Median-cut style: bin into 4×4×4 buckets, pick top 4
      const buckets = {};
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i], g = data[i+1], b = data[i+2], a = data[i+3];
        if (a < 128) continue;
        const k = (r >> 6) + '-' + (g >> 6) + '-' + (b >> 6);
        if (!buckets[k]) buckets[k] = { r:0, g:0, b:0, n:0 };
        buckets[k].r += r; buckets[k].g += g; buckets[k].b += b; buckets[k].n++;
      }
      const palette = Object.values(buckets)
        .map(b => ({ r: Math.round(b.r/b.n), g: Math.round(b.g/b.n), b: Math.round(b.b/b.n), n: b.n }))
        .sort((a, b) => b.n - a.n)
        .slice(0, 4);
      resolve(palette);
    };
    img.onerror = reject;
    img.src = url;
  });
}

function _matchPantone(palette, k) {
  // Phase 1: take the top dominant tones from the room directly. Phase 2
  // will weight them against the in-stock Pantone library and return
  // wood-warm / neutral-stone / accent triples.
  const reasons = [
    'Picks up the dominant warm tone in your room.',
    'Quiets against the neutral wall behind your speaker.',
    'Pulls a single accent from the soft furnishings.'
  ];
  const names = ['Composition · Anchor', 'Composition · Quiet', 'Composition · Accent'];
  return palette.slice(0, k).map((p, i) => {
    const hex = '#' + [p.r, p.g, p.b].map(v => v.toString(16).padStart(2,'0')).join('').toUpperCase();
    return { hex, name: names[i] || ('Composition · ' + (i+1)), reason: reasons[i] || '' };
  });
}

/* Phase 4.2 (AR) — "View in your room" pill in viewport bottom-right. iOS taps
   trigger Apple Quick Look via <a rel="ar"> + USDZ; Android taps fire a Google
   Scene Viewer intent URL with GLB; desktop falls back to a QR modal that
   encodes the AR landing page so phones can scan it directly. */
const AR_URLS = {
  glb:  './a9-visual-preview/assets/Tegrino_A9_v4.glb',
  usdz: './a9-visual-preview/assets/Tegrino_A9_v4.usdz',
};

document.getElementById('arTrigger')?.addEventListener('click', async () => {
  const ua = navigator.userAgent;
  // Phase 5.2 — iPadOS 13+ ships with desktop UA; navigator.platform
  // 'MacIntel' + maxTouchPoints > 1 is the canonical iPad fingerprint.
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/.test(ua);

  if (isIOS) {
    /* Phase 5.2 — dynamic USDZ export: ask the viewer to materialise the
       current composition into an ArrayBuffer, wrap in a Blob, click an
       <a rel="ar"> pointing at the resulting blob: URL. Replaces the
       static AR_URLS.usdz which can only render whatever cover/legs
       lived in the pre-built file. */
    const arBtn = document.getElementById('arTrigger');
    const originalLabel = arBtn ? arBtn.textContent : null;
    let blobUrl = null;
    let anchor = null;
    try {
      if (arBtn) {
        arBtn.disabled = true;
        arBtn.textContent = 'Preparing AR…';
      }
      const { arrayBuffer } = await a9Bridge.exportUSDZ();
      const blob = new Blob([arrayBuffer], { type: 'model/vnd.usdz+zip' });
      blobUrl = URL.createObjectURL(blob);

      anchor = document.createElement('a');
      anchor.rel = 'ar';
      anchor.href = blobUrl;
      // Apple Quick Look requires an <img> child inside <a rel="ar">,
      // even when the user never sees it.
      const img = document.createElement('img');
      img.alt = '';
      img.style.display = 'none';
      anchor.appendChild(img);
      anchor.style.display = 'none';
      document.body.appendChild(anchor);
      anchor.click();
    } catch (err) {
      console.error('[AR] USDZ export failed:', err);
      // Dev-friendly surfacing; production should swap to a toast.
      alert('AR export failed: ' + (err && err.message ? err.message : String(err)));
    } finally {
      if (arBtn) {
        arBtn.disabled = false;
        if (originalLabel != null) arBtn.textContent = originalLabel;
      }
      // Defer cleanup so Quick Look has time to read the blob.
      setTimeout(() => {
        if (anchor && anchor.parentNode) anchor.parentNode.removeChild(anchor);
        if (blobUrl) URL.revokeObjectURL(blobUrl);
      }, 2000);
    }
  } else if (isAndroid) {
    // Android: Google Scene Viewer — needs absolute URL for the GLB file
    const glbAbsolute = new URL(AR_URLS.glb, window.location.href).href;
    window.location.href =
      'intent://arvr.google.com/scene-viewer/1.0?file=' +
      encodeURIComponent(glbAbsolute) +
      '&mode=ar_preferred&title=Tegrino%20A9' +
      '#Intent;scheme=https;package=com.google.ar.core;' +
      'action=android.intent.action.VIEW;' +
      'S.browser_fallback_url=' + encodeURIComponent(glbAbsolute) + ';end';
  } else {
    // Desktop: export dynamic USDZ → upload to Vercel Blob → QR code
    // Phone scans QR → downloads USDZ → opens directly in AR
    const modal = document.getElementById('arQRModal');
    if (modal) {
      const qrImg     = document.getElementById('arQRImg');
      const qrTitle   = document.getElementById('arQRTitle');
      const qrDesc    = document.getElementById('arQRDesc');
      const qrProgress = document.getElementById('arQRProgress');
      const qrSpinner = document.getElementById('arQRSpinner');
      const qrDevices = document.getElementById('arQRDevices');

      // Reset to loading state
      function showLoading() {
        if (qrTitle)   qrTitle.textContent = 'Building your composition';
        if (qrDesc)    qrDesc.textContent = 'Preparing a life-size model of your A9. Just a moment.';
        if (qrProgress) qrProgress.hidden = false;
        if (qrSpinner) qrSpinner.hidden = false;
        if (qrImg)     { qrImg.hidden = true; qrImg.src = ''; }
        if (qrDevices) qrDevices.hidden = true;
      }

      // Transition to QR-ready state
      function showQR(url) {
        if (qrTitle)   qrTitle.textContent = 'See it where it belongs';
        if (qrDesc)    qrDesc.textContent = 'Scan with your phone to see how it looks in your space.';
        if (qrProgress) qrProgress.hidden = true;
        if (qrSpinner) qrSpinner.hidden = true;
        if (qrImg) {
          qrImg.src = 'https://api.qrserver.com/v1/create-qr-code/?size=240x240&margin=0&data=' + encodeURIComponent(url);
          qrImg.hidden = false;
        }
        if (qrDevices) qrDevices.hidden = false;
      }

      modal.hidden = false;
      showLoading();

      (async () => {
        try {
          // 1. Export USDZ from 3D viewer
          const { arrayBuffer } = await a9Bridge.exportUSDZ();
          if (qrTitle) qrTitle.textContent = 'Uploading…';

          // 2. Get a SCOPED upload token from the API (master key stays
          //    server-side — security fix 2026-06-10), then upload directly
          //    to Vercel Blob at the server-chosen pathname.
          //    Absolute URL: on the Shopify parent page (tegrino.co) a
          //    relative '/api/store-ar' resolved to Shopify → 404. All other
          //    API calls (sign-oss-upload, enhance, match-room) were already
          //    absolute; this one now matches.
          const tokenRes = await fetch('https://variation.tegrino.co/api/store-ar', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: '{}'
          });
          if (!tokenRes.ok) throw new Error('Failed to get upload token (' + tokenRes.status + ')');
          const { token: blobToken, pathname: blobPathname } = await tokenRes.json();
          if (!blobToken || !blobPathname) throw new Error('Upload token response malformed');

          const blobRes = await fetch('https://blob.vercel-storage.com/' + blobPathname, {
            method: 'PUT',
            headers: {
              'Authorization': 'Bearer ' + blobToken,
              'Content-Type': 'model/vnd.usdz+zip',
              'x-api-version': '7',
            },
            body: arrayBuffer,
          });
          if (!blobRes.ok) throw new Error('Blob upload failed: ' + blobRes.status);
          const blob = await blobRes.json();
          const usdzUrl = blob.url;

          // 3. Build AR landing page URL that embeds the USDZ URL.
          //    ar.html lives on the Vercel deployment — absolute so the QR
          //    also works when this page runs on tegrino.co (Shopify).
          const arPageUrl = new URL('https://variation.tegrino.co/ar.html');
          arPageUrl.searchParams.set('usdz', usdzUrl);

          // 4. Show QR code
          showQR(arPageUrl.toString());

        } catch (err) {
          console.error('[AR QR] Failed:', err);
          // Fallback: static ar.html (default model, no custom composition)
          const fallbackUrl = new URL('https://variation.tegrino.co/ar.html');
          showQR(fallbackUrl.toString());
        }
      })();
    }
  }
});

document.getElementById('arQRClose')?.addEventListener('click', () => {
  const modal = document.getElementById('arQRModal');
  if (modal) modal.hidden = true;
});
document.getElementById('arQRModal')?.addEventListener('click', (e) => {
  if (e.target.id === 'arQRModal') {
    document.getElementById('arQRModal').hidden = true;
  }
});

// Auto-trigger AR when opened via QR code (?ar=1) on mobile
// Wait for 3D viewer to be ready, then fire the AR pill click
(function _autoARFromQR() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('ar') !== '1') return;
  const ua = navigator.userAgent;
  const isMobile = /iPad|iPhone|iPod|Android/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isMobile) return;
  // Remove ar=1 from URL so refreshing doesn't re-trigger
  params.delete('ar');
  const cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
  history.replaceState(null, '', cleanUrl);
  // Wait for 3D viewer ready, then auto-trigger AR
  function _tryAR(attempts) {
    if (attempts <= 0) return;
    const arBtn = document.getElementById('arTrigger');
    const iframe = document.getElementById('a9Viewer');
    if (arBtn && iframe && iframe.contentWindow) {
      // Give the viewer a moment to fully render the custom composition
      setTimeout(() => { arBtn.click(); }, 1500);
    } else {
      setTimeout(() => _tryAR(attempts - 1), 1000);
    }
  }
  // Start checking after initial page load
  setTimeout(() => _tryAR(10), 2000);
})();

/* Phase 4.1 — Match a Room (modal-based, remote endpoint).
   Replaces the legacy v9 §C5 three-step flow. Calls
   https://tegrino-match-room.vercel.app/api/match-room with a base64 image
   payload; receives { style, headline, dominant_colors[] }; matches the
   dominant colors against PANTONE_LIBRARY entries in the recommended style
   sub-tab via straight RGB distance; renders 5 swatch cards inline. Click
   on a card commits the cover via state.customCover + renderAll, same as
   the existing pantone-grid click flow. */
const MATCH_ENDPOINT = 'https://tegrino-match-room.vercel.app/api/match-room';

// Phase 4.2 — inline dropzone toggle (replaces fullscreen modal)
(function _wireMatchRoomTrigger() {
  const trigger = document.getElementById('matchRoomTrigger');
  const dropzoneWrap = document.getElementById('matchRoomDropzoneWrap');
  if (!trigger || !dropzoneWrap) return;
  trigger.addEventListener('click', () => {
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    trigger.classList.toggle('is-open', !expanded);
    dropzoneWrap.hidden = expanded;
  });
})();

(function _wireMatchRoomUpload() {
  const dropzone = document.getElementById('matchRoomDropzone');
  const fileInput = document.getElementById('matchRoomFile');
  if (!dropzone || !fileInput) return;
  fileInput.addEventListener('change', () => {
    if (fileInput.files && fileInput.files[0]) _handleMatchUpload(fileInput.files[0]);
  });
  ['dragover', 'drop'].forEach((evt) => {
    dropzone.addEventListener(evt, (e) => {
      e.preventDefault(); e.stopPropagation();
      if (evt === 'drop' && e.dataTransfer.files && e.dataTransfer.files[0]) {
        _handleMatchUpload(e.dataTransfer.files[0]);
      }
    });
  });
})();

async function _handleMatchUpload(file) {
  const loading = document.getElementById('matchRoomLoading');
  const errorEl = document.getElementById('matchRoomError');
  if (loading) loading.hidden = false;
  if (errorEl) errorEl.hidden = true;

  try {
    // Resize to max 1280px and convert to JPEG. Handles HEIC, oversized iPhone
    // photos, etc. — strips raw bytes the backend doesn't need and removes the
    // 5MB-size guard that was rejecting common phone shots.
    const resized = await _resizeImageToJpeg(file, 1280, 0.85);
    const base64 = resized.b64;
    // Stash a data URL of the resized JPEG so the result card can show a
    // thumbnail of the user's upload. Resized (≤1280px) is plenty for a 72px
    // display thumb and avoids holding the original multi-MB file in memory.
    window._matchRoomThumbDataUrl = 'data:image/jpeg;base64,' + base64;

    const response = await fetch(MATCH_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ image: base64, mediaType: 'image/jpeg' }),
    });

    const text = await response.text();
    if (!response.ok) {
      throw new Error('Server ' + response.status + ': ' + text.slice(0, 200));
    }

    let data;
    try { data = JSON.parse(text); } catch { throw new Error('Invalid JSON response'); }
    if (data.error) throw new Error(data.error + (data.details ? ': ' + String(data.details).slice(0, 200) : ''));

    _renderMatchResults(data);

    // Collapse dropzone, reset trigger, hide loading, clear file input
    const dropzoneWrap = document.getElementById('matchRoomDropzoneWrap');
    const trigger = document.getElementById('matchRoomTrigger');
    const fileInput = document.getElementById('matchRoomFile');
    if (dropzoneWrap) dropzoneWrap.hidden = true;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('is-open');
    }
    if (loading) loading.hidden = true;
    if (fileInput) fileInput.value = '';
  } catch (err) {
    console.error('[match-room]', err);
    if (errorEl) {
      errorEl.textContent = String(err.message || err).slice(0, 240);
      errorEl.hidden = false;
    }
    if (loading) loading.hidden = true;
  }
}

function _resizeImageToJpeg(file, maxDim, quality) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width > maxDim || height > maxDim) {
        const scale = maxDim / Math.max(width, height);
        width = Math.round(width * scale);
        height = Math.round(height * scale);
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob((blob) => {
        if (!blob) { reject(new Error('Could not encode image')); return; }
        const reader = new FileReader();
        reader.onload = () => resolve({ b64: String(reader.result).split(',')[1], blob });
        reader.onerror = () => reject(new Error('Could not read encoded image'));
        reader.readAsDataURL(blob);
      }, 'image/jpeg', quality);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Could not load image (HEIC files may not work in some browsers — try saving as JPG first)'));
    };
    img.src = url;
  });
}

function _hexToRgb(hex) {
  const h = hex.replace('#', '');
  return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) };
}

function _renderMatchResults(data) {
  // Thumbnail uses the resized JPEG (set in _handleMatchUpload before fetch)
  const thumb = document.getElementById('matchRoomThumb');
  if (thumb && window._matchRoomThumbDataUrl) thumb.src = window._matchRoomThumbDataUrl;

  const headlineEl = document.getElementById('matchRoomHeadline');
  if (headlineEl) headlineEl.textContent = data.headline || ('A ' + String(data.style || '').toLowerCase() + ' space');

  // PANTONE_LIBRARY is module-scope (not on window), so reference it directly
  // from this same script with a window-fallback for safety.
  const lib = (typeof PANTONE_LIBRARY !== 'undefined') ? PANTONE_LIBRARY : (window.PANTONE_LIBRARY || []);
  const styleFiltered = lib.filter((p) => p.style === data.style);
  const recs = [];
  const used = new Set();

  for (const targetHex of (data.dominant_colors || [])) {
    const t = _hexToRgb(targetHex);
    let best = null, bestDist = Infinity;
    for (const p of styleFiltered) {
      if (used.has(p.hex)) continue;
      const c = _hexToRgb(p.hex);
      const d = (c.r - t.r) ** 2 + (c.g - t.g) ** 2 + (c.b - t.b) ** 2;
      if (d < bestDist) { bestDist = d; best = p; }
    }
    if (best) { recs.push(best); used.add(best.hex); }
    if (recs.length >= 5) break;
  }

  const recsEl = document.getElementById('matchRoomRecs');
  if (!recsEl) return;
  recsEl.innerHTML = '';
  recs.forEach((p) => {
    // Reuse .pantone-swatch class so each rec inherits Phase 3.2 hover-zoom +
    // ::after tooltip (data-name) + .is-selected ring behavior. No child spans —
    // an empty button with bg color and data-* attrs.
    const btn = document.createElement('button');
    btn.className = 'pantone-swatch match-room-rec-swatch';
    btn.type = 'button';
    btn.style.background = p.hex;
    btn.dataset.hex = p.hex;
    btn.dataset.pantone = p.pantone;
    btn.dataset.name = p.name;
    btn.dataset.style = p.style;
    btn.setAttribute('aria-label', p.name);
    btn.addEventListener('click', () => {
      // Same commit pattern as pantoneGrid click: customCover + a9Bridge + renderAll +
      // is-selected ring sync + footer summary refresh.
      window._coverSelectedHex = p.hex;
      state.customCover = { type: 'pantone', hex: p.hex, code: p.pantone, name: p.name };
      currentPresetName = null;
      a9Bridge.setCustomPantone(p.hex);
      renderAll();
      // Phase 4.25 — scope ring sync to cover-side grids only (was document-wide,
      // which leaked into Step 3 legsCustomPantoneGrid).
      document.querySelectorAll('#pantoneGrid .pantone-swatch, #matchRoomRecs .pantone-swatch').forEach((b) =>
        b.classList.toggle('is-selected', b.dataset.hex === p.hex));
      if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
      // Phase 4.27 FIX 3 — sticky strip mirrors the rec selection.
      if (typeof _syncCoverSelectedStrip === 'function') _syncCoverSelectedStrip();
    });
    recsEl.appendChild(btn);
  });

  const results = document.getElementById('matchRoomResults');
  if (results) results.hidden = false;
}

document.getElementById('matchRoomClear')?.addEventListener('click', () => {
  const r = document.getElementById('matchRoomResults');
  if (r) r.hidden = true;
});

/* =====================================================================
   FINAL §8 — DAY / NIGHT toggle wiring
   Toggles body.is-night (drives chrome theme via tokens) AND postMessage
   (drives 3D scene tint). Both must happen.
   ===================================================================== */
// Phase 5.1 — single Day/Night toggle (was two-pill `.day-night-toggle`).
// SVG icon shows the OPPOSITE state (moon invites night; sun invites day).
// Calls a9Bridge.setDayNight (the spec's setEnvironment is a misnomer;
// real method is setDayNight in this codebase).
// Reveal-only Rotation icon (clustered next to the day/night toggle).
// Flips auto-rotate on the reveal; keeps the hidden bottom pill + mobile icon synced.
(function _bindReviewRotToggle() {
  const btn = document.getElementById('revRotToggle');
  if (!btn) return;
  btn.addEventListener('click', () => {
    const nextOn = !btn.classList.contains('is-active');
    btn.classList.toggle('is-active', nextOn);
    btn.setAttribute('aria-pressed', String(nextOn));
    if (typeof a9Bridge !== 'undefined' && a9Bridge && typeof a9Bridge.setRotation === 'function') {
      a9Bridge.setRotation(nextOn);   // bare a9Bridge — it's a `const`, NOT on window
    }
    const pill = document.querySelector('[data-toggle="rotation"]');
    if (pill) { pill.classList.toggle('is-active', nextOn); pill.setAttribute('aria-pressed', String(nextOn)); }
    const mob = document.getElementById('mobRotationBtn');
    if (mob) mob.classList.toggle('is-active', nextOn);
  });
})();

(function _bindDayNightToggle() {
  const btn = document.getElementById('dnToggle');
  if (!btn) return;
  const moonIcon = btn.querySelector('.dn-icon-moon');
  const sunIcon  = btn.querySelector('.dn-icon-sun');
  btn.addEventListener('click', () => {
    const goingNight = !document.body.classList.contains('is-night');
    document.body.classList.toggle('is-night', goingNight);
    // Show sun icon in night mode (invites day), moon in day mode (invites night)
    if (moonIcon) moonIcon.style.display = goingNight ? 'none' : '';
    if (sunIcon)  sunIcon.style.display  = goingNight ? '' : 'none';
    const label = goingNight ? 'Switch to day mode' : 'Switch to night mode';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
    if (a9Bridge && typeof a9Bridge.setDayNight === 'function') {
      a9Bridge.setDayNight(goingNight ? 'night' : 'day'); /* Both Studio(day) and Warm(night) are light themes. */
    }
  });
})();

/* =====================================================================
   Step navigation (top step bar + parts-nav overlay)
   ===================================================================== */
const STEP_TO_PANE = { '1': 'speaker', '2': 'cover', '3': 'legs', '4': 'review' };
function applyStep(step) {
  document.querySelectorAll('.step').forEach(s => s.classList.toggle('is-active', s.dataset.step === step));
  const part = STEP_TO_PANE[step] || 'speaker';
  const enteringReview = (step === '4');
  const leavingReview  = !enteringReview;
  const iframe = document.getElementById('a9Viewer');

  /* Phase 5.2 — FREEZE the iframe at its current pixel size BEFORE the
     CSS layout transition fires. This prevents the WebGL canvas from
     continuously resizing as the side-panel collapses, which caused a
     white flash (Chrome) or blank frames (Safari). After the 500 ms
     transition settles we smoothly expand the iframe to fill the new
     viewport width over 300 ms. */
  if (enteringReview && iframe) {
    const rect = iframe.getBoundingClientRect();
    iframe.style.width  = rect.width  + 'px';
    iframe.style.height = rect.height + 'px';
  }

  /* Phase 5.1 — When ENTERING review, delay hiding the current step-pane
     until the side-panel opacity transition (300 ms) finishes. */
  if (enteringReview) {
    setTimeout(() => {
      document.querySelectorAll('.step-pane').forEach(p => p.toggleAttribute('hidden', p.id !== ('pane-' + part)));
    }, 350);
  } else {
    /* LEAVING review — unfreeze iframe immediately so it fits the
       flex-based viewport-shell as the side panel expands back. */
    if (iframe) {
      iframe.style.transition = '';
      iframe.style.width  = '';
      iframe.style.height = '';
    }
    document.querySelectorAll('.step-pane').forEach(p => p.toggleAttribute('hidden', p.id !== ('pane-' + part)));
  }

  document.querySelectorAll('.parts-nav-label').forEach(l => {
    const isActive = l.dataset.part === part;
    l.classList.toggle('is-active', isActive);
    l.classList.toggle('is-inactive', !isActive);
  });

  document.body.setAttribute('data-active-pane', part);

  if (enteringReview && typeof _renderKeepsake === 'function') _renderKeepsake();

  /* Phase 5.2 — after layout transition completes, smoothly unfreeze
     the iframe so it fills the full-width viewport-shell. */
  if (enteringReview && iframe) {
    setTimeout(() => {
      iframe.style.transition = 'width 300ms ease-out, height 300ms ease-out';
      iframe.style.width  = '100%';
      iframe.style.height = '100%';
      setTimeout(() => { iframe.style.transition = ''; }, 350);
    }, 550);
  }

  /* Cover V2 — update header path whenever step changes */
  if (typeof _updateHeaderPath === 'function') _updateHeaderPath();
}
/* v9 E1-final §3 — step / parts-nav listeners are owned by the
   consolidated toggle+navigation state machine inside bootConfigurator()
   below. The old "applyStep on every click" is replaced by
   _navigateToPart, which force-flips Rotation OFF + Zoom ON every time. */

/* =====================================================================
   FINAL §9 — Boot sequence
   ===================================================================== */
function bootConfigurator() {
  /* =====================================================================
     v9 E1-final §3 — Toggle + part-navigation state machine.
     Boot:           Rotation ON, Zoom OFF
     Click any part: force Rotation OFF, force Zoom ON, fly to reference
     Manual rot:     flips own state only (no zoom/camera side effects)
     Manual zoom ON: snap to current part's reference
     Manual zoom OFF: leave camera (free-look mode)
     ===================================================================== */
  // ============================================================================
  // v9 E1 final: toggle + part-navigation state machine
  // ============================================================================

  const rotPill  = [...document.querySelectorAll('.toggle-pill')]
                    .find(el => /ROTATION/i.test(el.textContent));
  const zoomPill = [...document.querySelectorAll('.toggle-pill')]
                    .find(el => /ZOOM/i.test(el.textContent));

  function _currentPart() {
    const step = document.querySelector('.step.is-active')?.dataset.step;
    return ({ '1': 'speaker', '2': 'cover', '3': 'legs' })[step] || 'speaker';
  }

  // Master "navigate to a part" — force-applies the new state rules every time.
  function _navigateToPart(part) {
    // Rule: rotation force OFF (regardless of current state)
    rotPill?.classList.remove('is-active');
    a9Bridge.setRotation(false);

    // Rule: zoom force OFF on step-click — user's mental model is
    // "click part = rotate to it, click Zoom = then zoom in".
    zoomPill?.classList.remove('is-active');

    // Sync left-side parts-nav-label state. Doing it here (rather than only
    // in the step-bar click handler) means the left-side label click entry
    // point also gets state updated. Both is-active AND is-inactive must
    // toggle in sync because is-inactive has higher CSS specificity.
    document.querySelectorAll('.parts-nav-label').forEach(label => {
      const isMatch = label.dataset.part === part;
      label.classList.toggle('is-active', isMatch);
      label.classList.toggle('is-inactive', !isMatch);
    });

    // Camera flies to the part's WIDE reference view (boot-distance orbit
    // ring with azimuth aligned to the part's face/back).
    a9Bridge.setView(part, false);
  }

  /* Centralized step navigation — single source of truth for ALL three entry
     points (top step bar, left parts-nav-label, ctaNext button). Replaces the
     piecemeal handlers that disagreed and created the "skip" / "no pane switch" bugs. */
  const STEP_TO_PART = { '1': 'speaker', '2': 'cover', '3': 'legs', '4': null };
  const PART_TO_STEP = { speaker: '1', cover: '2', legs: '3' };

  function goToStep(stepNum) {
    const n = String(stepNum);
    if (!['1', '2', '3', '4'].includes(n)) return;

    const enteringReview = (n === '4');
    const leavingReview  = (window._currentStep === '4' && !enteringReview);
    const iframe = document.getElementById('a9Viewer');
    const stage  = document.querySelector('.studio-stage');

    /* ================================================================
       DIP-FADE transition for review entry/exit.
       A full-screen overlay fades to opaque, the layout switches
       invisibly underneath, then the overlay fades back out.
       Simple, clean, no gradient-matching issues.
       ================================================================ */

    if (enteringReview && stage) {
      // Reveal page: rotation ON by default (model auto-rotates); zoom off.
      rotPill?.classList.add('is-active');
      rotPill?.setAttribute('aria-pressed', 'true');
      zoomPill?.classList.remove('is-active');
      a9Bridge.setView('speaker', true); // zoomed 3/4 angle fills tall mobile viewport
      a9Bridge.setRotation(true);         // default-on auto-rotate on the reveal
      // Reveal rotation control = the top-right .rot-toggle icon (next to day/night).
      document.getElementById('revRotToggle')?.classList.add('is-active');
      document.getElementById('revRotToggle')?.setAttribute('aria-pressed', 'true');
      // Bottom Rotation/Zoom pills stay hidden on the reveal.
      var vt = document.querySelector('.viewport-toggles');
      if (vt) vt.style.display = 'none';

      // Update step bar + progress indicators immediately
      const sNumR = parseInt(n, 10);
      document.querySelectorAll('.up-step[data-step]').forEach(el => {
        const s = parseInt(el.dataset.step, 10);
        el.classList.toggle('is-completed', s < sNumR);
        el.classList.toggle('is-active', s === sNumR);
      });
      document.querySelectorAll('.up-connector').forEach((conn, idx) => {
        conn.classList.toggle('is-filled', idx < sNumR - 1);
      });
      // Mobile progress line: hide on Reveal
      var _progLineR = document.getElementById('mobProgressLine');
      if (_progLineR) _progLineR.style.display = 'none';

      // Create or reuse the dip-fade overlay
      let overlay = document.getElementById('dip-fade-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'dip-fade-overlay';
        Object.assign(overlay.style, {
          position: 'fixed', inset: '0', zIndex: '9999',
          pointerEvents: 'none', opacity: '0',
          transition: 'opacity 150ms ease-in'
        });
        document.body.appendChild(overlay);
      }
      const isNight = document.body.classList.contains('is-night');
      overlay.style.background = isNight ? '#121110' : '#FFFFFF';
      // Clean start: kill any leftover transition, snap to 0, then animate in
      overlay.style.transition = 'none';
      overlay.style.opacity = '0';
      overlay.offsetHeight; // reflow — commit the snap
      overlay.style.transition = 'opacity 150ms ease-in';
      overlay.style.opacity = '1'; // fade IN

      // After overlay is fully opaque, snap the layout
      setTimeout(() => {
        const cta = document.querySelector('.studio-cta');
        stage.classList.add('skip-transitions');
        if (cta) cta.classList.add('skip-transitions');

        const paneStepMap = { speaker: '1', cover: '2', legs: '3', review: '4' };
        document.querySelectorAll('.step-pane').forEach(pane => {
          const paneKey = pane.id.replace('pane-', '');
          pane.hidden = paneStepMap[paneKey] !== n;
        });

        document.body.setAttribute('data-active-pane', 'review');

        // Hide fixed CTA bar + side-panel on Reveal (they'd float over the review sheet)
        if (cta) cta.style.display = 'none';
        var _sidePanel = document.querySelector('.side-panel');
        if (_sidePanel) _sidePanel.style.display = 'none';
        // Restore viewport to full size on Reveal (panel is hidden)
        if (typeof window._clearViewportResize === 'function') window._clearViewportResize();

        // Mobile Reveal: shrink the IFRAME (not viewport-shell) so the 3D
        // model reframes above the info sheet. viewport-shell stays full-
        // height with overflow:visible (mobile CSS) so Safari won't clip
        // the position:fixed info sheet.
        // Exposed globally so detail-expand toggle can re-call it.
        window._fitModelAboveCard = function() {
          if (!window.matchMedia('(max-width: 480px)').matches) return;
          requestAnimationFrame(function() {
            var _infoSheet = document.querySelector('.review-overlay__info');
            var _iframe = document.querySelector('.a9-viewer-frame');
            if (_infoSheet && _iframe) {
              var sheetH = _infoSheet.getBoundingClientRect().height;
              _iframe.style.height = 'calc(100% - ' + (sheetH - 20) + 'px)';
              _iframe.style.bottom = 'auto';
              // Keep toast above the card
              var vs = _iframe.closest('.viewport-shell');
              if (vs) vs.style.setProperty('--review-card-h', Math.round(sheetH + 12) + 'px');
            }
          });
        };
        if (window.matchMedia('(max-width: 480px)').matches) {
          window._fitModelAboveCard();
          // Reveal default COLLAPSED: user taps name-row or swipes up to expand.
          if (typeof window._collapseRevealDetail === 'function') window._collapseRevealDetail();
        }

        document.querySelectorAll('.parts-nav-label').forEach(label => {
          label.classList.remove('is-active');
          label.classList.add('is-inactive');
        });

        if (typeof _renderKeepsake === 'function') _renderKeepsake();
        window._currentStep = n;
        if (typeof updateCtaSummary === 'function') updateCtaSummary();

        stage.offsetHeight; // settle layout

        stage.classList.remove('skip-transitions');
        if (cta) cta.classList.remove('skip-transitions');

        // Brief pause for layout to settle, then fade overlay OUT
        requestAnimationFrame(() => {
          overlay.style.transition = 'opacity 200ms ease-out';
          overlay.style.opacity = '0';
          var _cleanupOverlay = function() {
            overlay.style.transition = '';
            overlay.style.opacity = '0';
            overlay.removeEventListener('transitionend', _cleanupOverlay);
          };
          overlay.addEventListener('transitionend', _cleanupOverlay, { once: true });
          // Safety fallback — force cleanup even if transitionend never fires
          setTimeout(function() { overlay.style.transition = ''; overlay.style.opacity = '0'; }, 300);
        });
      }, 170);

      return;
    }

    if (leavingReview && stage) {
      // Create or reuse the dip-fade overlay
      let overlay = document.getElementById('dip-fade-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'dip-fade-overlay';
        Object.assign(overlay.style, {
          position: 'fixed', inset: '0', zIndex: '9999',
          pointerEvents: 'none', opacity: '0'
        });
        document.body.appendChild(overlay);
      }
      const isNight = document.body.classList.contains('is-night');
      overlay.style.background = isNight ? '#121110' : '#FFFFFF';
      // Clean start: kill any leftover transition, snap to 0, then animate in
      overlay.style.transition = 'none';
      overlay.style.opacity = '0';
      overlay.offsetHeight; // reflow — commit the snap
      overlay.style.transition = 'opacity 150ms ease-in';
      overlay.style.opacity = '1'; // fade IN

      // Update step bar + progress indicators immediately
      const sNumL = parseInt(n, 10);
      document.querySelectorAll('.up-step[data-step]').forEach(el => {
        const s = parseInt(el.dataset.step, 10);
        el.classList.toggle('is-completed', s < sNumL);
        el.classList.toggle('is-active', s === sNumL);
      });
      document.querySelectorAll('.up-connector').forEach((conn, idx) => {
        conn.classList.toggle('is-filled', idx < sNumL - 1);
      });

      // After overlay is fully opaque, snap the layout
      setTimeout(() => {
        try {
        const cta = document.querySelector('.studio-cta');
        stage.classList.add('skip-transitions');
        if (cta) cta.classList.add('skip-transitions');

        const paneStepMap = { speaker: '1', cover: '2', legs: '3', review: '4' };
        document.querySelectorAll('.step-pane').forEach(pane => {
          const paneKey = pane.id.replace('pane-', '');
          pane.hidden = paneStepMap[paneKey] !== n;
        });

        // Reset panel scroll — returning from Reveal must land at pane top.
        var _scrollPanelL = document.querySelector('.side-panel');
        if (_scrollPanelL) _scrollPanelL.scrollTop = 0;

        const stepToPane = { '1': 'speaker', '2': 'cover', '3': 'legs', '4': 'review' };
        document.body.setAttribute('data-active-pane', stepToPane[n] || 'speaker');
        // Restore viewport toggles + fixed CTA bar + side-panel when leaving review
        var vt = document.querySelector('.viewport-toggles');
        if (vt) vt.style.display = '';
        if (cta) cta.style.display = '';
        // Leaving Reveal: stop the reveal's default auto-rotation + sync the
        // pill OFF (reveal defaults rotation ON; edit steps expect it OFF).
        a9Bridge.setRotation(false);
        if (typeof _syncRotationPillOff === 'function') _syncRotationPillOff();
        document.getElementById('revRotToggle')?.classList.remove('is-active');
        document.getElementById('revRotToggle')?.setAttribute('aria-pressed', 'false');
        var _sidePanel = document.querySelector('.side-panel');
        if (_sidePanel) _sidePanel.style.display = '';
        // Clear Reveal-specific viewport-shell + iframe sizing
        var _vpShell = document.querySelector('.viewport-shell');
        if (_vpShell) { _vpShell.style.height = ''; _vpShell.style.top = ''; _vpShell.style.bottom = ''; }
        var _iframe = document.querySelector('.a9-viewer-frame');
        if (_iframe) { _iframe.style.height = ''; _iframe.style.bottom = ''; }
        // Re-apply viewport-shell resize. Steps 1-3 default to the half
        // (middle) detent so the configuration list is immediately visible
        // on return from Reveal. User can drag down to collapse.
        if (typeof window._resizeViewport === 'function') window._resizeViewport(true, true);

        const targetPart = STEP_TO_PART[n];
        document.querySelectorAll('.parts-nav-label').forEach(label => {
          const isMatch = label.dataset.part === targetPart;
          label.classList.toggle('is-active', isMatch);
          label.classList.toggle('is-inactive', !isMatch);
        });

        if (targetPart) {
          const _autoZ = (n === '2' || n === '3');
          a9Bridge.setView(targetPart, _autoZ);
          if (_autoZ) {
            a9Bridge.setZoom(true);
            _syncZoomTogglePill(true);
          } else {
            _syncZoomTogglePill(false);
          }
        }

        window._currentStep = n;
        if (typeof updateCtaSummary === 'function') updateCtaSummary();
        if (typeof _updateHeaderPath === 'function') _updateHeaderPath();
        // Update top progress bar on leaving review
        const _sN = parseInt(n, 10);
        document.querySelectorAll('.tg-progress__seg[data-seg]').forEach(seg => {
          const s = parseInt(seg.dataset.seg, 10);
          seg.classList.toggle('is-done', s < _sN);
          seg.classList.toggle('is-current', s === _sN);
        });
        // Mobile progress line: restore when leaving review
        var _progLineL = document.getElementById('mobProgressLine');
        if (_progLineL) _progLineL.style.display = '';
        var _progFillL = document.getElementById('mobProgressFill');
        if (_progFillL) _progFillL.style.width = Math.round((_sN / 3) * 100) + '%';
        // Update CTA label
        var _ctaLblL = document.getElementById('ctaLabel');
        if (_ctaLblL) {
          var _CTA_L = { '1': 'Now, the Cover', '2': 'One More Layer', '3': 'See What You Made' };
          _ctaLblL.textContent = _CTA_L[n] || 'Next';
        }

        stage.offsetHeight;

        // Fix: update mode sliders NOW while skip-transitions is active
        // (instant snap, no animation flash). During review the side-panel
        // was max-width:0, so _updateModeSlider deferred (sliderDirty).
        if (typeof _updateModeSlider === 'function') {
          var _cs = document.getElementById('coverModeSwitch');
          var _ss = document.getElementById('standModeSwitch');
          if (_cs) _updateModeSlider(_cs, true);
          if (_ss) _updateModeSlider(_ss, true);
        }
        // Re-apply tab mode to ensure inner panes are visible after
        // side-panel was display:none during review.
        if (n === '3' && typeof setStandMode === 'function') {
          setStandMode(window._standMode || 'mood');
        }
        if (n === '2' && typeof setCoverMode === 'function') {
          setCoverMode(window._coverMode || 'mood');
        }
        // For step 1, re-render swatches
        if (typeof renderAll === 'function') renderAll();

        stage.classList.remove('skip-transitions');
        if (cta) cta.classList.remove('skip-transitions');
        } finally {
        // ALWAYS fade overlay out, even if layout code throws
        requestAnimationFrame(() => {
          overlay.style.transition = 'opacity 200ms ease-out';
          overlay.style.opacity = '0';
          // Robust cleanup: 'none' fully kills any running transition;
          // '' (empty string) can leave the browser mid-interpolation.
          var _cleanupOverlay = function() {
            overlay.style.transition = 'none';
            overlay.style.opacity = '0';
            overlay.offsetHeight; // force reflow to commit the snap
          };
          overlay.addEventListener('transitionend', _cleanupOverlay, { once: true });
          // Safety fallback — force cleanup even if transitionend never fires
          setTimeout(_cleanupOverlay, 300);
        });
        }
      }, 170);

      return;
    }

    /* ---- Normal step navigation (1↔2↔3, no dip-fade needed) ---- */

    // 1. Update top step bar
    document.querySelectorAll('.up-step[data-step]').forEach(el => {
      el.classList.toggle('is-active', el.dataset.step === n);
    });

    // 2. Switch step-pane visibility
    const paneStepMap = { speaker: '1', cover: '2', legs: '3', review: '4' };
    document.querySelectorAll('.step-pane').forEach(pane => {
      const paneKey = pane.id.replace('pane-', '');
      pane.hidden = paneStepMap[paneKey] !== n;
    });

    // 2a. Reset panel scroll so the new pane starts at its top.
    //     .side-panel is the scroll container on BOTH desktop (overflow-y:
    //     auto, ~line 645) and mobile (bottom-sheet, same element). Without
    //     this, a deep scroll in the previous step leaves the new pane
    //     appearing mid-content.
    const _scrollPanel = document.querySelector('.side-panel');
    if (_scrollPanel) _scrollPanel.scrollTop = 0;

    // 3. data-active-pane
    const stepToPane = { '1': 'speaker', '2': 'cover', '3': 'legs', '4': 'review' };
    document.body.setAttribute('data-active-pane', stepToPane[n] || 'speaker');

    // 4. Update parts-nav-label state
    const targetPart = STEP_TO_PART[n];
    document.querySelectorAll('.parts-nav-label').forEach(label => {
      const isMatch = label.dataset.part === targetPart;
      label.classList.toggle('is-active', isMatch);
      label.classList.toggle('is-inactive', !isMatch);
    });

    // 5. Switch 3D view — auto-zoom for Cover & Stand closeups
    if (targetPart) {
      const autoZoom = (n === '2' || n === '3'); // cover or legs
      rotPill?.classList.remove('is-active');
      a9Bridge.setRotation(false);
      a9Bridge.setView(targetPart, autoZoom);
      if (autoZoom) {
        a9Bridge.setZoom(true);
        _syncZoomTogglePill(true);
      } else {
        zoomPill?.classList.remove('is-active');
        _syncZoomTogglePill(false);
      }
    }

    // 6. Update footer summary + track current step
    window._currentStep = n;
    if (typeof updateCtaSummary === 'function') updateCtaSummary();
    if (typeof _updateHeaderPath === 'function') _updateHeaderPath();

    // 6a. Close cart drawer if it was open — the new step's content
    // belongs in the main sheet, not behind the cart drawer.
    if (typeof window._closeCartDrawer === 'function') window._closeCartDrawer();

    // 7. Update CTA label per step (price stays via recomputeTotal)
    const ctaLabelEl = document.getElementById('ctaLabel');
    if (ctaLabelEl) {
      const CTA_LABELS = { '1': 'Next: Cover', '2': 'Next: Legs', '3': 'Review' };
      ctaLabelEl.textContent = CTA_LABELS[n] || 'Next';
    }
    // Hide price area on REVEAL step
    const _ctaPriceArea = document.getElementById('ctaPriceArea');
    if (_ctaPriceArea) _ctaPriceArea.style.display = (n === '4') ? 'none' : '';

    // 8. Progress indicator — mark completed steps + fill connectors
    const sN = parseInt(n, 10);
    document.querySelectorAll('.up-step[data-step]').forEach(el => {
      const s = parseInt(el.dataset.step, 10);
      el.classList.toggle('is-completed', s < sN);
      el.classList.toggle('is-active', s === sN);
    });
    document.querySelectorAll('.up-connector').forEach((conn, idx) => {
      conn.classList.toggle('is-filled', idx < sN - 1);
    });

    // 9. Top progress bar — 4-segment thin line
    document.querySelectorAll('.tg-progress__seg[data-seg]').forEach(seg => {
      const s = parseInt(seg.dataset.seg, 10);
      seg.classList.toggle('is-done', s < sN);
      seg.classList.toggle('is-current', s === sN);
    });

    // 9b. Mobile progress line — update fill width
    var _progLineN = document.getElementById('mobProgressLine');
    if (_progLineN) _progLineN.style.display = (sN === 4) ? 'none' : '';
    var _progFillN = document.getElementById('mobProgressFill');
    if (_progFillN) _progFillN.style.width = Math.round((sN / 3) * 100) + '%';

    // 10. Init slider indicators when step becomes visible (may have been deferred)
    requestAnimationFrame(function() {
      if (typeof _updateModeSlider === 'function') {
        var cs = document.getElementById('coverModeSwitch');
        var ss = document.getElementById('standModeSwitch');
        if (cs && cs.dataset.sliderDirty) _updateModeSlider(cs, true);
        if (ss && ss.dataset.sliderDirty) _updateModeSlider(ss, true);
      }
    });

    // 11. Ensure mode content is rendered when entering step 2 or 3
    //     (mode pane is visible but renderXxxMoodRows may not have fired yet)
    if (n === '2' && typeof setCoverMode === 'function') {
      setCoverMode(window._coverMode || 'mood');
    }
    if (n === '3' && typeof setStandMode === 'function') {
      setStandMode(window._standMode || 'mood');
    }

    // 12. Mobile bottom-sheet: default to half (middle) detent on step 1-3
    //     click so the configuration list is immediately visible. User can
    //     drag the sheet down to collapse or up to expand fully.
    if (typeof window._expandBottomSheet === 'function') {
      window._expandBottomSheet();
    }
  }
  // Phase 4.34 — expose goToStep so the keepsake back-link (#kpBack) and any
  // future top-level handler can navigate without re-binding inside boot.
  window.goToStep = goToStep;

  function updateCtaSummary() {
    // SPEAKER — prefer custom-section's active swatch, fallback to active preset's rim
    let speakerName;
    const speakerSw = document.querySelector('#speakerSwatches .swatch.is-active');
    if (speakerSw) {
      speakerName = speakerSw.getAttribute('aria-label');
    } else {
      const preset = document.querySelector('#presetList .preset-row.is-active');
      speakerName = preset?.dataset?.rim || 'Gold';
    }
    const speakerEl = document.getElementById('upValSpeaker');
    if (speakerEl) fadeUpdate(speakerEl, speakerName);
    // Phase UX polish #41 — swatch circle removed; unified checkmark metaphor

    // COVER — Phase 4.25: reads ONLY cover state. Never queries `.pantone-swatch.is-selected`
    // document-wide (would leak Step 3 legs grid selections). Source of truth is
    // state.customCover (set by every Step 2 commit path: pantoneGrid click, search-result
    // click, Match-a-Room rec, image upload).
    let coverName, coverCode = '', coverHex = null;
    if (state.customCover && state.customCover.type === 'pantone') {
      // (a) Step 2 Pantone or Match-a-Room selection
      coverName = state.customCover.name || state.customCover.code || 'Custom';
      coverCode = state.customCover.code || '';
      coverHex  = state.customCover.hex || null;
    } else if (state.customCover && state.customCover.type === 'upload') {
      // (b) Step 2 image upload
      coverName = 'Custom upload';
      coverCode = '';
      coverHex = state.customCover.hex || null;
    } else {
      // (c) Fallback to Step 1 cover (the customer's existing cover). Read hex from the
      // matching custom-section swatch's inline `style="background:#XXXXXX"` so the dot
      // populates even when Step 2 was skipped — was blank before Phase 4.24.
      const coverSw = document.querySelector('#coverFaceSwatches .swatch.is-active')
                  || document.querySelector('#coverFaceSwatches .swatch[data-cover="' + (state.cover || '') + '"]');
      if (coverSw) {
        coverName = coverSw.getAttribute('aria-label') || coverSw.dataset.cover;
        const styleAttr = coverSw.getAttribute('style') || '';
        const m = styleAttr.match(/background\s*:\s*(#[0-9a-fA-F]{3,8})/);
        if (m) coverHex = m[1];
      } else {
        const preset = document.querySelector('#presetList .preset-row.is-active');
        coverName = preset?.dataset?.cover || 'Warm White';
      }
    }
    const coverEl = document.getElementById('upValCover');
    const coverDotEl = document.getElementById('upDotCover');
    // Build unified cover display: Pantone names + catalog names
    // Collect ALL cover item names across sources (v10.2 — unified count)
    var _allCoverNames = [];
    if (typeof _pantoneCartQty === 'object') { for (var _pk in _pantoneCartQty) { if (_pantoneCartQty[_pk] > 0) { var _pr = MATCH_RECOMMENDATIONS[parseInt(_pk,10)]; if (_pr) _allCoverNames.push(_pr.name); } } }
    if (typeof _moodCartQty === 'object') { for (var _mk in _moodCartQty) { if (_moodCartQty[_mk] && _moodCartQty[_mk].qty > 0) _allCoverNames.push(_moodCartQty[_mk].name || 'Pantone'); } }
    if (typeof _catalogCartQty === 'object' && typeof _matchCatalogResults === 'object') { for (var _ck in _catalogCartQty) { if (_catalogCartQty[_ck] > 0 && _matchCatalogResults[_ck]) _allCoverNames.push(_matchCatalogResults[_ck].cover.name || 'Cover'); } }
    if (state.uploadCovers && state.uploadCovers.length > 0) _allCoverNames.push('Custom upload');
    var displayCover;
    if (_allCoverNames.length === 0) {
      displayCover = coverName;
    } else if (_allCoverNames.length <= 2) {
      displayCover = _allCoverNames.join(' + ');
    } else {
      displayCover = _allCoverNames[0] + ' + ' + _allCoverNames[1] + ' +' + (_allCoverNames.length - 2) + ' more';
    }
    if (coverEl) fadeUpdate(coverEl, displayCover);
    // Update cart detail popover if open
    if (typeof _updateCartPopover === 'function') _updateCartPopover();
    if (coverDotEl) {
      if (coverHex) {
        fadeUpdate(coverDotEl, coverHex, 'background');
        coverDotEl.hidden = false;
      } else {
        coverDotEl.hidden = true;
      }
    }
    // Phase UX polish #41 — step 2 swatch circle removed

    // LEGS priority (Phase 4.21): Stand cart summary > Custom Pantone > Step 3 in-stock accessory >
    // step 1 custom wood swatch > preset wood.
    var standSummary = (typeof _getStandCartSummary === 'function') ? _getStandCartSummary() : '';
    let legsName;
    if (standSummary) {
      legsName = standSummary;
    } else if (state.legsCustom && state.legsCustom.name) {
      legsName = state.legsCustom.name;
    } else if (state.legsAccessory && state.legsAccessory.name) {
      legsName = state.legsAccessory.name;
    } else {
      const step1Leg = document.querySelector('#legsCustomSwatches .swatch.is-active');
      if (step1Leg) {
        legsName = step1Leg.getAttribute('aria-label');
      } else {
        const preset = document.querySelector('#presetList .preset-row.is-active');
        legsName = preset?.dataset?.wood || state.wood || 'Light Oak';
      }
    }
    const legsEl = document.getElementById('upValLegs');
    if (legsEl) fadeUpdate(legsEl, legsName);

    // Phase 4.22 — LEGS row colour swatch.
    //  - state.legsCustom present  → swatch = state.legsCustom.hex
    //  - state.legsAccessory with hex (Black/White/Red/Aluminium*/Socks) → swatch = LEG_MATERIALS[id].color
    //  - state.legsAccessory ColorPlay Trio → 3-stripe linear-gradient
    //  - Original Legs / wood-only → swatch hidden
    // TODO: extend swatch to speaker + cover rows in the same pattern.
    let legsBg = null;
    if (state.legsCustom && state.legsCustom.hex) {
      legsBg = state.legsCustom.hex;
    } else if (state.legsAccessory && state.legsAccessory.id && typeof LEG_MATERIALS === 'object') {
      const def = LEG_MATERIALS[state.legsAccessory.id];
      if (def && def.perLeg && def.perLeg.length === 3) {
        legsBg = 'linear-gradient(90deg, ' + def.perLeg[0] + ' 0 33%, ' + def.perLeg[1] + ' 33% 66%, ' + def.perLeg[2] + ' 66% 100%)';
      } else if (def && def.color) {
        legsBg = def.color;
      }
    }
    // Surface (a) — bottom CTA bar dot
    const legsDotEl = document.getElementById('upDotLegs');
    if (legsDotEl) {
      if (legsBg) {
        fadeUpdate(legsDotEl, legsBg, 'background');
        legsDotEl.hidden = false;
      } else {
        legsDotEl.hidden = true;
      }
    }
    // Phase UX polish #41 — step 3 swatch circle removed
    // Phase 4.33 FIX 3 — Step 3 row-head retired; #legsRowSwatch element
    // no longer exists. Bottom CTA #ctaSumLegsDot above is the only surface.
  }
  // Make accessible to top-level code (renderAll + pantone-grid click + coverReset call it).
  window.updateCtaSummary = function() {
    updateCtaSummary();
    if (typeof _updateCartPopover === 'function') _updateCartPopover();
  };

  // Boot state: rotation ON, zoom OFF, camera at Speaker default
  function _initToggleState() {
    rotPill?.classList.add('is-active');
    zoomPill?.classList.remove('is-active');
    a9Bridge.setRotation(true);
  }

  window.addEventListener('message', function _onceReady(e) {
    if (e.data?.type !== 'a9:ready') return;
    if (e.source !== a9Frame.contentWindow) return;

    // 父端 a9Bridge 的 ready 门控本应由它自己的 listener 打开；运行时观测它没被
    // 打开，导致 setView/setRotation 全被卡进 queue，表现为 toggle 切了但相机不飞。
    // 抢先把 ready 打开并 flush queue，让后续所有 send 直通 postMessage。
    if (!a9Bridge.ready) {
      a9Bridge.ready = true;
      const pending = a9Bridge.queue.splice(0);
      pending.forEach((m) => a9Bridge.send(m));
    }

    _initToggleState();
    a9Bridge.setView('speaker');
    window.removeEventListener('message', _onceReady);
  });

  // Phase 4.26 — Sync the visible ZOOM pill to a programmatic state. Used by the
  // parts-nav (auto ZOOM ON) + custom-row heading (auto ZOOM OFF) entry points.
  // Mirrors the manual zoomPill click's `is-active` class; also keeps aria-pressed
  // in sync (the manual handler doesn't, but assistive tech needs it correct).
  function _syncZoomTogglePill(enabled) {
    const pill = document.querySelector('[data-toggle="zoom"]');
    if (!pill) return;
    pill.setAttribute('aria-pressed', String(!!enabled));
    pill.classList.toggle('is-active', !!enabled);
  }

  // Manual Rotation toggle: flip own state only.
  rotPill?.addEventListener('click', () => {
    const nextOn = !rotPill.classList.contains('is-active');
    rotPill.classList.toggle('is-active', nextOn);
    a9Bridge.setRotation(nextOn);
    // Sync mobile icon
    const mobBtn = document.getElementById('mobRotationBtn');
    if (mobBtn) mobBtn.classList.toggle('is-active', nextOn);
  });

  // Mobile rotation icon — syncs with desktop pill
  const mobRotBtn = document.getElementById('mobRotationBtn');
  if (mobRotBtn) {
    mobRotBtn.addEventListener('click', () => {
      const nextOn = !mobRotBtn.classList.contains('is-active');
      mobRotBtn.classList.toggle('is-active', nextOn);
      a9Bridge.setRotation(nextOn);
      // Sync desktop pill
      if (rotPill) {
        rotPill.classList.toggle('is-active', nextOn);
        rotPill.setAttribute('aria-pressed', String(nextOn));
      }
    });
  }

  zoomPill?.addEventListener('click', () => {
    zoomPill.classList.toggle('is-active');
    const zoomed = zoomPill.classList.contains('is-active');
    // 点 ZOOM 时同时关闭 ROTATION（用户要求："并取消旋转 关闭rotation按钮"）
    rotPill?.classList.remove('is-active');
    a9Bridge.setRotation(false);
    a9Bridge.setZoom(zoomed);
  });

  // Cart detail drawer — click price area to toggle (v11 sheet-swap)
  // On mobile (steps 1-3): cart drawer occupies the EXACT footprint of the
  // main bottom sheet via shared --sheet-h CSS variable. Main sheet goes
  // visibility:hidden while cart is open so only one sheet is visible at a
  // time and no gap appears between drawers. Drag/snap is shared.
  (function() {
    var priceArea = document.getElementById('ctaPriceArea');
    var popover = document.getElementById('upCartPopover');
    if (!priceArea || !popover) return;
    var isOpen = false;
    var _savedDetentIdx = null;  // main-sheet detent index at open time
    var _sheetSwapped = false;   // true when we've taken over the sheet slot

    function isMobile() {
      return window.matchMedia('(max-width: 480px)').matches;
    }

    function openDrawer() {
      _updateCartPopover();
      popover.classList.add('is-open');
      priceArea.classList.add('is-open');
      isOpen = true;
      // body.cart-open drives BOTH the .side-panel-scrim (all viewports)
      // and the mobile sheet driver's DETENT_COLLAPSED_CART switch.
      document.body.classList.add('cart-open');
      // Mobile + steps 1-3: take over the main sheet slot
      var step = parseInt(window._currentStep || '1', 10);
      if (step < 4 && isMobile() && typeof window._snapSheet === 'function') {
        // Save current detent; ensure cart opens at least at half-detent
        // (idx 1) since the cart needs room — DETENT_COLLAPSED (122px) is
        // too small to show the composition list usefully.
        _savedDetentIdx = (typeof window._getSheetDetentIdx === 'function')
          ? window._getSheetDetentIdx() : 1;
        var openIdx = Math.max(_savedDetentIdx, 1);
        // Main sheet stays in place; .side-panel-scrim dims it.
        _sheetSwapped = true;
        if (typeof window._recalcSheetDetents === 'function') {
          window._recalcSheetDetents();
        }
        // Snap to the open detent (writes --sheet-h, cart popover follows)
        window._snapSheet(openIdx);
      }
    }
    function closeDrawer() {
      popover.classList.remove('is-open');
      priceArea.classList.remove('is-open');
      popover.classList.remove('is-expanded');
      isOpen = false;
      document.body.classList.remove('cart-open');
      // Restore main sheet (it never went hidden — scrim fades out via CSS)
      if (_sheetSwapped) {
        if (typeof window._recalcSheetDetents === 'function') {
          window._recalcSheetDetents();
        }
        // Snap main sheet back to its saved detent (or half if none).
        if (typeof window._snapSheet === 'function') {
          var restoreIdx = (_savedDetentIdx != null) ? _savedDetentIdx : 1;
          window._snapSheet(restoreIdx);
        }
        _sheetSwapped = false;
        _savedDetentIdx = null;
      }
    }
    // Expose closeDrawer so cart delete can auto-close when empty
    window._closeCartDrawer = closeDrawer;

    // Tap the side-panel scrim to dismiss the cart drawer
    var scrim = document.getElementById('sidePanelScrim');
    if (scrim) scrim.addEventListener('click', function() { closeDrawer(); });

    // Click price area → toggle drawer
    priceArea.addEventListener('click', function(e) {
      e.stopPropagation();
      if (isOpen) closeDrawer();
      else openDrawer();
    });

    // Close button inside drawer
    popover.addEventListener('click', function(e) {
      if (e.target.closest('.up-cart-close')) { e.stopPropagation(); closeDrawer(); }
    });

    // Cart item click → 3D preview + visual feedback
    popover.addEventListener('click', function(e) {
      if (e.target.closest('.up-cart-item-del')) return;
      if (e.target.closest('.up-cart-psd-link')) return;
      var item = e.target.closest('.up-cart-item[data-preview-type]');
      if (!item) return;
      e.stopPropagation(); // prevent drawer close
      var pType = item.dataset.previewType;
      var pHex = item.dataset.previewHex || '';
      var pLegs = item.dataset.previewLegs || '';
      if (typeof a9Bridge === 'undefined') return;
      // Visual feedback: highlight selected item
      popover.querySelectorAll('.up-cart-item.is-previewing').forEach(function(el) { el.classList.remove('is-previewing'); });
      item.classList.add('is-previewing');
      try {
        if (pType === 'cover' && pHex && typeof a9Bridge.setCustomPantone === 'function') {
          a9Bridge.setCustomPantone(pHex);
        } else if (pType === 'cover-upload') {
          // Upload covers — show composed image on 3D
          var idx = parseInt((item.querySelector('.up-cart-item-del') || item.querySelector('[data-stepper="minus"]'))?.dataset.delKey || '-1', 10);
          if (idx >= 0 && state.uploadCovers[idx] && state.uploadCovers[idx].composedDataUrl) {
            a9Bridge.setCustomUpload(state.uploadCovers[idx].composedDataUrl, true);  // 上传→trim(原死消息)
          }
        } else if (pType === 'cover-collection') {
          var pImg = item.dataset.previewImg || '';
          if (pImg && typeof _loadPreviewAsDataUrl === 'function') {
            _loadPreviewAsDataUrl(pImg, function(dataUrl) {
              if (typeof a9Bridge !== 'undefined' && typeof a9Bridge.setCustomUpload === 'function') {
                a9Bridge.setCustomUpload(dataUrl);
              }
            });
          }
        } else if (pType === 'stand-pantone' && pHex && typeof a9Bridge.setLegsCustom === 'function') {
          a9Bridge.setLegsCustom({ hex: pHex, mode: 'pantone' });
        } else if (pType === 'stand-stock' && pLegs && typeof LEG_MATERIALS !== 'undefined') {
          var mat = LEG_MATERIALS[pLegs] || { kind: 'fabric' };
          a9Bridge.send({ type: 'a9:setStand', stand: pLegs, material: mat });
        }
      } catch (err) { console.warn('[Cart preview]', err); }
    });

    // Cart item hover → 3D preview (same logic as click, but transient)
    var _cartHoverTimeout = null;
    popover.addEventListener('mouseover', function(e) {
      var item = e.target.closest('.up-cart-item[data-preview-type]');
      if (!item) return;
      clearTimeout(_cartHoverTimeout);
      _cartHoverTimeout = setTimeout(function() {
        var pType = item.dataset.previewType;
        var pHex = item.dataset.previewHex || '';
        var pLegs = item.dataset.previewLegs || '';
        if (typeof a9Bridge === 'undefined') return;
        popover.querySelectorAll('.up-cart-item.is-previewing').forEach(function(el) { el.classList.remove('is-previewing'); });
        item.classList.add('is-previewing');
        try {
          if (pType === 'cover' && pHex && typeof a9Bridge.setCustomPantone === 'function') {
            a9Bridge.setCustomPantone(pHex);
          } else if (pType === 'cover-upload') {
            var idx = parseInt((item.querySelector('.up-cart-item-del') || item.querySelector('[data-stepper="minus"]'))?.dataset.delKey || '-1', 10);
            if (idx >= 0 && state.uploadCovers[idx] && state.uploadCovers[idx].composedDataUrl) {
              a9Bridge.setCustomUpload(state.uploadCovers[idx].composedDataUrl, true);  // 上传→trim(原死消息)
            }
          } else if (pType === 'cover-collection') {
            var pImg = item.dataset.previewImg || '';
            if (pImg && typeof _loadPreviewAsDataUrl === 'function') {
              _loadPreviewAsDataUrl(pImg, function(dataUrl) {
                if (typeof a9Bridge !== 'undefined' && typeof a9Bridge.setCustomUpload === 'function') {
                  a9Bridge.setCustomUpload(dataUrl);
                }
              });
            }
          } else if (pType === 'stand-pantone' && pHex && typeof a9Bridge.setLegsCustom === 'function') {
            a9Bridge.setLegsCustom({ hex: pHex, mode: 'pantone' });
          } else if (pType === 'stand-stock' && pLegs && typeof LEG_MATERIALS !== 'undefined') {
            var mat = LEG_MATERIALS[pLegs] || { kind: 'fabric' };
            a9Bridge.send({ type: 'a9:setStand', stand: pLegs, material: mat });
          }
        } catch (err) { console.warn('[Cart hover preview]', err); }
      }, 120);
    });

    // Close on click outside (but not on popover itself)
    document.addEventListener('click', function(e) {
      if (isOpen && !priceArea.contains(e.target) && !popover.contains(e.target)) {
        closeDrawer();
      }
    });

    // Close on ESC
    document.addEventListener('keydown', function(e) {
      if (isOpen && e.key === 'Escape') closeDrawer();
    });
  })();

  /* --- Mobile cart drawer: finger-tracking drag + spring snap ---
     Mirrors .side-panel drag, but operates on .up-cart-popover. Both
     sheets share the --sheet-h CSS variable, so dragging either one
     resizes both. Only one is visible at a time (cart is hidden when
     closed; side-panel is visibility:hidden while cart is open). */
  (function initCartSheetDrag() {
    if (window.matchMedia('(min-width: 481px)').matches) return;
    var popover = document.getElementById('upCartPopover');
    if (!popover) return;

    var startTouchY = 0;
    var startH = 0;
    var isDragging = false;
    var isScrolling = false;
    var scrollCooldown = false;
    var velocityTracker = [];
    var lastTouchY = 0;
    var lastTouchTime = 0;
    var startTouchX = 0;     // for horizontal-vs-vertical disambiguation
    var horizontalIntent = false; // true once a touch is determined horizontal
    var prevCartTouchY = 0;  // previous frame's clientY, for instant-direction handoff

    function getDetents() {
      return (typeof window._getSheetDetents === 'function')
        ? window._getSheetDetents() : [];
    }
    function getCurrentDetentIdx() {
      return (typeof window._getSheetDetentIdx === 'function')
        ? window._getSheetDetentIdx() : 1;
    }
    function getVelocity() {
      if (!velocityTracker.length) return 0;
      var now = performance.now();
      var wSum = 0, wTotal = 0;
      for (var i = 0; i < velocityTracker.length; i++) {
        var age = now - velocityTracker[i].t;
        if (age > 300) continue;
        var w = 1 - age / 300;
        wSum += velocityTracker[i].v * w;
        wTotal += w;
      }
      return wTotal > 0 ? wSum / wTotal : 0;
    }

    // Inner scroll element owns the only scroll context on the cart drawer
    // (see two-region popover layout). Fall back to the popover itself if
    // the inner wrapper hasn't been rendered yet — keeps the drag controller
    // resilient to call order during init.
    function getScrollEl() {
      return popover.querySelector('.up-cart-scroll') || popover;
    }

    function shouldDragSheet(deltaY) {
      var detents = getDetents();
      if (!detents.length) return false;
      var scrollEl = getScrollEl();
      var atTop = scrollEl.scrollTop <= 1;
      var idx = getCurrentDetentIdx();
      var isScrollable = idx >= 1;

      if (scrollCooldown) return false;
      if (!isScrollable) return true;

      var hasOverflow = scrollEl.scrollHeight > scrollEl.clientHeight + 2;
      if (!hasOverflow) return true;
      if (atTop && deltaY < 0) return true;
      if (atTop && deltaY > 0 && idx < detents.length - 1) return true;
      return false;
    }

    popover.addEventListener('touchstart', function(e) {
      if (isDragging) return;
      // Skip drag if touch starts on a cart item — the horizontal swipe
      // handler (initCartSwipeGestures) owns those gestures.
      // We still allow vertical drag if motion is clearly vertical; that
      // gets sorted out in touchmove via horizontalIntent.
      var touch = e.touches[0];
      startTouchX = touch.clientX;
      startTouchY = touch.clientY;
      startH = (typeof window._getSheetHeight === 'function')
        ? window._getSheetHeight() : 0;
      lastTouchY = touch.clientY;
      prevCartTouchY = touch.clientY;
      lastTouchTime = performance.now();
      velocityTracker = [];
      isDragging = false;
      isScrolling = false;
      horizontalIntent = false;

      // Kill any running animation
      document.body.classList.remove('sheet-animating');
    }, { passive: true });

    popover.addEventListener('touchmove', function(e) {
      var touch = e.touches[0];
      var rawDx = touch.clientX - startTouchX;
      var rawDy = startTouchY - touch.clientY; // positive = finger up
      var now = performance.now();

      // Save instantaneous direction BEFORE updating lastTouchY
      var instantDir = prevCartTouchY - touch.clientY; // positive = up, negative = down
      prevCartTouchY = touch.clientY;

      // Velocity tracking
      var dt = now - lastTouchTime;
      if (dt > 0) {
        var instantV = (lastTouchY - touch.clientY) / dt;
        velocityTracker.push({ v: instantV, t: now });
        if (velocityTracker.length > 6) velocityTracker.shift();
      }
      lastTouchY = touch.clientY;
      lastTouchTime = now;

      // Scroll-to-drag handoff (mirrors main sheet behavior)
      if (!isDragging && isScrolling && !horizontalIntent) {
        var _scrollEl = getScrollEl();
        var atTop = _scrollEl.scrollTop <= 1;
        var pullingDown = instantDir < -1;
        if (atTop && pullingDown && getCurrentDetentIdx() >= 1) {
          isScrolling = false;
          isDragging = true;
          startTouchY = touch.clientY;
          startH = (typeof window._getSheetHeight === 'function')
            ? window._getSheetHeight() : 0;
          velocityTracker = [];
          e.preventDefault();
          return;
        }
      }

      // Disambiguate horizontal vs vertical first — let the cart-item
      // swipe handler take over if the gesture is horizontal-dominant.
      if (!isDragging && !isScrolling && !horizontalIntent) {
        if (Math.abs(rawDx) > 12 && Math.abs(rawDx) > Math.abs(rawDy)) {
          horizontalIntent = true;
          return;
        }
        if (Math.abs(rawDy) < 12) return; // dead zone — generous tap tolerance (was 6, fat-finger drift cancelled taps)
        if (shouldDragSheet(rawDy)) {
          isDragging = true;
        } else {
          isScrolling = true;
          return;
        }
      }
      if (horizontalIntent || isScrolling) return;
      if (!isDragging) return;

      e.preventDefault();

      var detents = getDetents();
      if (!detents.length) return;
      var DETENT_EXPANDED = detents[detents.length - 1];
      var DETENT_COLLAPSED = detents[0];
      var newH = startH + rawDy;

      // Rubber-band at limits
      if (newH > DETENT_EXPANDED) {
        var over = newH - DETENT_EXPANDED;
        var c = 0.55;
        newH = DETENT_EXPANDED + (1 - (1 / ((over * c / 80) + 1))) * 80;
      } else if (newH < DETENT_COLLAPSED) {
        var over2 = DETENT_COLLAPSED - newH;
        var c2 = 0.55;
        newH = DETENT_COLLAPSED - (1 - (1 / ((over2 * c2 / 80) + 1))) * 80;
      }

      if (typeof window._setSheetH === 'function') {
        window._setSheetH(newH, false);
      }
    }, { passive: false });

    popover.addEventListener('touchend', function() {
      if (!isDragging) {
        if (isScrolling && !scrollCooldown) {
          var scrollEl = getScrollEl();
          var _scrollHandler = function() {
            if (scrollEl.scrollTop <= 0) {
              scrollCooldown = true;
              setTimeout(function() { scrollCooldown = false; }, 120);
            }
          };
          scrollEl.addEventListener('scroll', _scrollHandler, { passive: true, once: true });
        }
        isDragging = false;
        isScrolling = false;
        horizontalIntent = false;
        return;
      }
      isDragging = false;
      horizontalIntent = false;

      var detents = getDetents();
      if (!detents.length) return;
      var currentH = (typeof window._getSheetHeight === 'function')
        ? window._getSheetHeight() : detents[1];
      var vel = getVelocity();
      var FLICK = 0.5;
      var targetIdx;
      if (Math.abs(vel) > FLICK) {
        if (vel > 0) {
          targetIdx = detents.length - 1;
          for (var i = 0; i < detents.length; i++) {
            if (detents[i] > currentH + 10) { targetIdx = i; break; }
          }
        } else {
          targetIdx = 0;
          for (var j = detents.length - 1; j >= 0; j--) {
            if (detents[j] < currentH - 10) { targetIdx = j; break; }
          }
        }
      } else {
        // Snap to nearest detent
        var best = 0, bestDist = Math.abs(currentH - detents[0]);
        for (var k = 1; k < detents.length; k++) {
          var d = Math.abs(currentH - detents[k]);
          if (d < bestDist) { bestDist = d; best = k; }
        }
        targetIdx = best;
      }
      if (typeof window._snapSheet === 'function') {
        window._snapSheet(targetIdx);
      }
    }, { passive: true });
  })();

  // Cart popover stepper + × delete handler
  (function() {
    var popover = document.getElementById('upCartPopover');
    if (!popover) return;

    // Adjust qty in the appropriate cart map by ±1. Returns true if the
    // line still has qty > 0 after the change, false if it should be removed.
    function _adjustCartQty(type, key, delta) {
      var stillThere = false;
      if (type === 'mood' && typeof _moodCartQty !== 'undefined' && _moodCartQty[key]) {
        _moodCartQty[key].qty = (_moodCartQty[key].qty || 1) + delta;
        if (_moodCartQty[key].qty <= 0) { delete _moodCartQty[key]; } else { stillThere = true; }
        if (!stillThere) { var _amq = false; for (var _mk4 in _moodCartQty) { if (_moodCartQty[_mk4] && _moodCartQty[_mk4].qty > 0) { _amq = true; break; } } if (!_amq && state.customCover && state.customCover.type === 'pantone') { state.customCover = null; window._coverSelectedHex = null; a9Bridge.setCover(state.cover || 'Warm White'); } }
        if (typeof renderMoodRows === 'function') renderMoodRows();
      } else if (type === 'pantone' && typeof _pantoneCartQty !== 'undefined' && _pantoneCartQty[key]) {
        _pantoneCartQty[key] = (_pantoneCartQty[key] || 1) + delta;
        if (_pantoneCartQty[key] <= 0) { delete _pantoneCartQty[key]; } else { stillThere = true; }
        if (!stillThere) { var _apq = false; for (var _pk2 in _pantoneCartQty) { if (_pantoneCartQty[_pk2] > 0) { _apq = true; break; } } if (!_apq && state.customCover && state.customCover.type === 'pantone') { state.customCover = null; window._coverSelectedHex = null; a9Bridge.setCover(state.cover || 'Warm White'); } }
        if (typeof renderMatchRecs === 'function') renderMatchRecs();
      } else if (type === 'catalog' && typeof _catalogCartQty !== 'undefined') {
        _catalogCartQty[key] = (_catalogCartQty[key] || 0) + delta;
        if (_catalogCartQty[key] <= 0) { delete _catalogCartQty[key]; } else { stillThere = true; }
        if (!stillThere) { var _acq = false; for (var _ck3 in _catalogCartQty) { if (_catalogCartQty[_ck3] > 0) { _acq = true; break; } } if (!_acq && state.customCover) { state.customCover = null; a9Bridge.setCover(state.cover || 'Warm White'); } }
        if (typeof renderMatchCatalog === 'function') renderMatchCatalog();
      } else if (type === 'stand' && typeof _standCartQty !== 'undefined' && _standCartQty[key]) {
        _standCartQty[key].qty = (_standCartQty[key].qty || 1) + delta;
        if (_standCartQty[key].qty <= 0) { delete _standCartQty[key]; } else { stillThere = true; }
        if (!stillThere) {
          var _asl = false; for (var _sk2 in _standCartQty) { if (_standCartQty[_sk2] && _standCartQty[_sk2].qty > 0) { _asl = true; break; } }
          if (!_asl) { state.legsAccessory = null; state.legs = 'original'; state.legsCustom = null; a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } }); a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' }); if (typeof _persistState === 'function') _persistState(); }
        }
        if (typeof renderStandStockRows === 'function') renderStandStockRows();
      } else if (type === 'stand-mood' && typeof _standMoodCartQty !== 'undefined' && _standMoodCartQty[key]) {
        _standMoodCartQty[key].qty = (_standMoodCartQty[key].qty || 1) + delta;
        if (_standMoodCartQty[key].qty <= 0) { delete _standMoodCartQty[key]; } else { stillThere = true; }
        if (!stillThere) {
          var _aml = false; for (var _mk2 in _standMoodCartQty) { if (_standMoodCartQty[_mk2] && _standMoodCartQty[_mk2].qty > 0) { _aml = true; break; } }
          if (!_aml) { state.legsCustom = null; state.legs = 'original'; a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } }); a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' }); if (typeof _persistState === 'function') _persistState(); }
        }
        if (typeof renderStandMoodRows === 'function') renderStandMoodRows();
      } else if (type === 'stand-match' && typeof _standMatchCartQty !== 'undefined' && _standMatchCartQty[key]) {
        _standMatchCartQty[key] = (_standMatchCartQty[key] || 1) + delta;
        if (_standMatchCartQty[key] <= 0) { delete _standMatchCartQty[key]; } else { stillThere = true; }
        if (!stillThere) {
          var _atl = false; for (var _tk2 in _standMatchCartQty) { if (_standMatchCartQty[_tk2] > 0) { _atl = true; break; } }
          if (!_atl) { state.legsCustom = null; state.legs = 'original'; a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } }); a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' }); if (typeof _persistState === 'function') _persistState(); }
        }
        if (typeof renderStandMatchRecs === 'function') renderStandMatchRecs();
      } else if (type === 'upload-single' && state.uploadCovers) {
        // uc.qty lives on the array entry itself (no parallel map like _pantoneCartQty).
        // qty<=0 → splice the entry; if the array drains, clear state.coverUpload
        // to mirror the × delete path at L14822-14828.
        var _uIdx = parseInt(key, 10);
        if (!isNaN(_uIdx) && state.uploadCovers[_uIdx]) {
          state.uploadCovers[_uIdx].qty = (state.uploadCovers[_uIdx].qty || 1) + delta;
          if (state.uploadCovers[_uIdx].qty <= 0) {
            state.uploadCovers.splice(_uIdx, 1);
            if (state.uploadCovers.length === 0) state.coverUpload = null;
          } else {
            stillThere = true;
          }
          if (typeof renderUploadList === 'function') renderUploadList();
        }
      }
      return stillThere;
    }

    popover.addEventListener('click', function(e) {
      // Stepper buttons take priority over the legacy × handler. Single-qty
      // types (upload, stand-custom, single-pantone, single-upload) have no
      // stepper rendered — they still hit the .up-cart-item-del path below.
      var stepper = e.target.closest('[data-stepper]');
      if (stepper) {
        e.stopPropagation();
        var action = stepper.dataset.stepper;
        var sType = stepper.dataset.delType;
        var sKey = stepper.dataset.delKey;
        _adjustCartQty(sType, sKey, action === 'plus' ? 1 : -1);
        _updateCartPopover();
        if (typeof recomputeTotal === 'function') recomputeTotal();
        if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
        var sBadge = document.getElementById('ctaBadge');
        if (sBadge && (!sBadge.textContent || sBadge.textContent === '0')) {
          if (typeof window._closeCartDrawer === 'function') window._closeCartDrawer();
        }
        return;
      }
      var del = e.target.closest('.up-cart-item-del');
      if (!del) return;
      e.stopPropagation();
      var type = del.dataset.delType;
      var key = del.dataset.delKey;
      if (type === 'pantone') {
        delete _pantoneCartQty[key];
        var _anyPL = false; for (var _pk in _pantoneCartQty) { if (_pantoneCartQty[_pk] > 0) { _anyPL = true; break; } }
        if (!_anyPL && state.customCover && state.customCover.type === 'pantone') { state.customCover = null; window._coverSelectedHex = null; a9Bridge.setCover(state.cover || 'Warm White'); }
        if (typeof renderMatchRecs === 'function') renderMatchRecs();
      } else if (type === 'mood') {
        delete _moodCartQty[key];
        var _anyML = false; for (var _mk3 in _moodCartQty) { if (_moodCartQty[_mk3] && _moodCartQty[_mk3].qty > 0) { _anyML = true; break; } }
        if (!_anyML && state.customCover && state.customCover.type === 'pantone') { state.customCover = null; window._coverSelectedHex = null; a9Bridge.setCover(state.cover || 'Warm White'); }
        if (typeof renderMoodRows === 'function') renderMoodRows();
      } else if (type === 'upload') {
        state.uploadCovers = [];
        state.coverUpload = null;
        state.customCover = null;
        a9Bridge.setCover(state.cover || 'Warm White');
        if (typeof renderUploadList === 'function') renderUploadList();
      } else if (type === 'upload-single') {
        var idx = parseInt(key, 10);
        if (state.uploadCovers && !isNaN(idx)) {
          state.uploadCovers.splice(idx, 1);
          if (state.uploadCovers.length === 0) { state.coverUpload = null; state.customCover = null; a9Bridge.setCover(state.cover || 'Warm White'); }
        }
        if (typeof renderUploadList === 'function') renderUploadList();
      } else if (type === 'catalog') {
        delete _catalogCartQty[key];
        var _anyCL = false; for (var _ck2 in _catalogCartQty) { if (_catalogCartQty[_ck2] > 0) { _anyCL = true; break; } }
        if (!_anyCL && state.customCover) { state.customCover = null; a9Bridge.setCover(state.cover || 'Warm White'); }
        if (typeof renderMatchCatalog === 'function') renderMatchCatalog();
      } else if (type === 'single-pantone') {
        state.customCover = null;
        window._coverSelectedHex = null;
        a9Bridge.setCover(state.cover || 'Warm White');
        if (typeof renderMoodRows === 'function') renderMoodRows();
      } else if (type === 'single-upload') {
        state.customCover = null;
        state.coverUpload = null;
        state.uploadCovers = [];
        a9Bridge.setCover(state.cover || 'Warm White');
        if (typeof renderUploadList === 'function') renderUploadList();
      } else if (type === 'stand') {
        delete _standCartQty[key];
        var _anyStandLeft = false;
        for (var _sk in _standCartQty) { if (_standCartQty[_sk] && _standCartQty[_sk].qty > 0) { _anyStandLeft = true; break; } }
        if (!_anyStandLeft) {
          state.legsAccessory = null; state.legs = 'original'; state.legsCustom = null;
          a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } });
          a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
        }
        if (typeof renderStandStockRows === 'function') renderStandStockRows();
      } else if (type === 'stand-mood') {
        delete _standMoodCartQty[key];
        var _anyMoodLeft = false;
        for (var _mk in _standMoodCartQty) { if (_standMoodCartQty[_mk] && _standMoodCartQty[_mk].qty > 0) { _anyMoodLeft = true; break; } }
        if (!_anyMoodLeft) {
          state.legsCustom = null; state.legs = 'original';
          a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } });
          a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
        }
        if (typeof renderStandMoodRows === 'function') renderStandMoodRows();
      } else if (type === 'stand-match') {
        delete _standMatchCartQty[key];
        var _anyMatchLeft = false;
        for (var _mtk in _standMatchCartQty) { if (_standMatchCartQty[_mtk] > 0) { _anyMatchLeft = true; break; } }
        if (!_anyMatchLeft) {
          state.legsCustom = null; state.legs = 'original';
          a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } });
          a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
        }
        if (typeof renderStandMatchRecs === 'function') renderStandMatchRecs();
      } else if (type === 'stand-custom') {
        state.legsCustom = null; state.legs = 'original';
        a9Bridge.send({ type: 'a9:setStand', stand: 'original', material: { kind: 'wood' } });
        a9Bridge.send({ type: 'a9:setWood', name: state.wood || 'Light Oak' });
        if (typeof renderLegs === 'function') renderLegs();
      }
      _updateCartPopover();   // badge first — recomputeTotal reads badge text
      if (typeof recomputeTotal === 'function') recomputeTotal();
      if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
      // Auto-close cart drawer when all items deleted
      var badge = document.getElementById('ctaBadge');
      if (badge && (!badge.textContent || badge.textContent === '0')) {
        if (typeof window._closeCartDrawer === 'function') window._closeCartDrawer();
      }
    });
  })();

  // Cover step hover popover removed — now using click-triggered drawer (v9.1)

  // Mobile cart item swipe gestures: left → -1 qty (delete at 0), right → +1 qty
  (function initCartSwipeGestures() {
    if (window.matchMedia('(min-width: 481px)').matches) return;
    var popover = document.getElementById('upCartPopover');
    if (!popover) return;
    var _swStartX = 0, _swStartY = 0, _swItem = null, _swDx = 0, _swLocked = false;
    var SWIPE_THRESHOLD = 40;

    popover.addEventListener('touchstart', function(e) {
      var item = e.target.closest('.up-cart-item');
      if (!item) return;
      // Items use either legacy × or the new stepper. Either gives us the
      // data-del-type / data-del-key needed downstream.
      if (!item.querySelector('.up-cart-item-del') && !item.querySelector('[data-stepper="minus"]')) return;
      _swItem = item;
      _swStartX = e.touches[0].clientX;
      _swStartY = e.touches[0].clientY;
      _swDx = 0;
      _swLocked = false;
      item.style.transition = 'none';
    }, { passive: true });

    popover.addEventListener('touchmove', function(e) {
      if (!_swItem) return;
      var dx = e.touches[0].clientX - _swStartX;
      var dy = e.touches[0].clientY - _swStartY;
      // Decide direction on first significant move
      if (!_swLocked && Math.abs(dx) < 8 && Math.abs(dy) < 8) return; // too small to decide
      if (!_swLocked) {
        if (Math.abs(dy) > Math.abs(dx)) {
          // Vertical scroll — release item, let list scroll normally
          _swItem.style.transform = '';
          _swItem.style.opacity = '';
          _swItem.style.background = '';
          _swItem = null;
          return;
        }
        // Horizontal swipe — lock in, prevent list from scrolling
        _swLocked = true;
      }
      // Locked horizontal: prevent vertical scroll of container
      e.preventDefault();
      _swDx = dx;
      _swItem.style.transform = 'translateX(' + dx + 'px)';
      _swItem.style.opacity = Math.max(0.4, 1 - Math.abs(dx) / 200);
      if (dx < -20) {
        _swItem.style.background = 'rgba(220,60,60,0.12)';
      } else if (dx > 20) {
        _swItem.style.background = 'rgba(60,160,80,0.12)';
      } else {
        _swItem.style.background = '';
      }
    }, { passive: false });

    popover.addEventListener('touchend', function(e) {
      if (!_swItem) return;
      var item = _swItem;
      var dx = _swDx;
      _swItem = null;
      _swLocked = false;
      item.style.transition = 'transform 0.25s ease, opacity 0.25s ease, background 0.25s ease';

      if (dx < -SWIPE_THRESHOLD) {
        // Swipe left → decrease qty by 1; only delete when qty reaches 0
        item.style.transform = 'translateX(0)';
        item.style.opacity = '1';
        item.style.background = '';
        var del2 = item.querySelector('.up-cart-item-del') || item.querySelector('[data-stepper="minus"]');
        if (del2) {
          var delType2 = del2.dataset.delType;
          var delKey2 = del2.dataset.delKey;
          var shouldRemove = false;
          if (delType2 === 'mood' && typeof _moodCartQty !== 'undefined' && _moodCartQty[delKey2]) {
            _moodCartQty[delKey2].qty = (_moodCartQty[delKey2].qty || 1) - 1;
            if (_moodCartQty[delKey2].qty <= 0) { delete _moodCartQty[delKey2]; shouldRemove = true; }
            if (typeof renderMoodRows === 'function') renderMoodRows();
          } else if (delType2 === 'pantone' && typeof _pantoneCartQty !== 'undefined' && _pantoneCartQty[delKey2]) {
            _pantoneCartQty[delKey2] = (_pantoneCartQty[delKey2] || 1) - 1;
            if (_pantoneCartQty[delKey2] <= 0) { delete _pantoneCartQty[delKey2]; shouldRemove = true; }
            if (typeof renderMatchRecs === 'function') renderMatchRecs();
          } else if (delType2 === 'catalog' && typeof _catalogCartQty !== 'undefined' && _catalogCartQty[delKey2]) {
            _catalogCartQty[delKey2] = (_catalogCartQty[delKey2] || 1) - 1;
            if (_catalogCartQty[delKey2] <= 0) { delete _catalogCartQty[delKey2]; shouldRemove = true; }
            if (typeof renderMatchCatalog === 'function') renderMatchCatalog();
          } else if (delType2 === 'stand' && typeof _standCartQty !== 'undefined' && _standCartQty[delKey2]) {
            _standCartQty[delKey2].qty = (_standCartQty[delKey2].qty || 1) - 1;
            if (_standCartQty[delKey2].qty <= 0) { delete _standCartQty[delKey2]; shouldRemove = true; }
            if (typeof renderStandStockRows === 'function') renderStandStockRows();
          } else if (delType2 === 'stand-mood' && typeof _standMoodCartQty !== 'undefined' && _standMoodCartQty[delKey2]) {
            _standMoodCartQty[delKey2].qty = (_standMoodCartQty[delKey2].qty || 1) - 1;
            if (_standMoodCartQty[delKey2].qty <= 0) { delete _standMoodCartQty[delKey2]; shouldRemove = true; }
            if (typeof renderStandMoodRows === 'function') renderStandMoodRows();
          } else if (delType2 === 'stand-match' && typeof _standMatchCartQty !== 'undefined' && _standMatchCartQty[delKey2]) {
            _standMatchCartQty[delKey2] = (_standMatchCartQty[delKey2] || 1) - 1;
            if (_standMatchCartQty[delKey2] <= 0) { delete _standMatchCartQty[delKey2]; shouldRemove = true; }
            if (typeof renderStandMatchRecs === 'function') renderStandMatchRecs();
          } else if (delType2 === 'upload-single' && state.uploadCovers) {
            // Mirrors the click-stepper path in _adjustCartQty so swipe-left
            // matches tapping − on desktop.
            var _swUIdx = parseInt(delKey2, 10);
            if (!isNaN(_swUIdx) && state.uploadCovers[_swUIdx]) {
              state.uploadCovers[_swUIdx].qty = (state.uploadCovers[_swUIdx].qty || 1) - 1;
              if (state.uploadCovers[_swUIdx].qty <= 0) {
                state.uploadCovers.splice(_swUIdx, 1);
                if (state.uploadCovers.length === 0) state.coverUpload = null;
                shouldRemove = true;
              }
              if (typeof renderUploadList === 'function') renderUploadList();
            }
          } else {
            // Fallback: types without qty tracking → direct delete
            shouldRemove = true;
          }
          if (shouldRemove) {
            item.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
            item.style.transform = 'translateX(-100%)';
            item.style.opacity = '0';
            setTimeout(function() { del2.click(); }, 250);
          }
          if (typeof recomputeTotal === 'function') recomputeTotal();
          if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
          _updateCartPopover();
        }
      } else if (dx > SWIPE_THRESHOLD) {
        // Swipe right → increase qty by 1
        item.style.transform = 'translateX(0)';
        item.style.opacity = '1';
        item.style.background = '';
        var del = item.querySelector('.up-cart-item-del') || item.querySelector('[data-stepper="minus"]');
        if (del) {
          var delType = del.dataset.delType;
          var delKey = del.dataset.delKey;
          // Increase quantity in the appropriate cart map
          if (delType === 'mood' && typeof _moodCartQty !== 'undefined' && _moodCartQty[delKey]) {
            _moodCartQty[delKey].qty = (_moodCartQty[delKey].qty || 0) + 1;
            if (typeof renderMoodRows === 'function') renderMoodRows();
          } else if (delType === 'pantone' && typeof _pantoneCartQty !== 'undefined' && _pantoneCartQty[delKey]) {
            _pantoneCartQty[delKey] = (_pantoneCartQty[delKey] || 0) + 1;
            if (typeof renderMatchRecs === 'function') renderMatchRecs();
          } else if (delType === 'catalog' && typeof _catalogCartQty !== 'undefined') {
            _catalogCartQty[delKey] = (_catalogCartQty[delKey] || 0) + 1;
            if (typeof renderMatchCatalog === 'function') renderMatchCatalog();
          } else if (delType === 'stand' && typeof _standCartQty !== 'undefined' && _standCartQty[delKey]) {
            _standCartQty[delKey].qty = (_standCartQty[delKey].qty || 0) + 1;
            if (typeof renderStandStockRows === 'function') renderStandStockRows();
          } else if (delType === 'stand-mood' && typeof _standMoodCartQty !== 'undefined' && _standMoodCartQty[delKey]) {
            _standMoodCartQty[delKey].qty = (_standMoodCartQty[delKey].qty || 0) + 1;
            if (typeof renderStandMoodRows === 'function') renderStandMoodRows();
          } else if (delType === 'stand-match' && typeof _standMatchCartQty !== 'undefined' && _standMatchCartQty[delKey]) {
            _standMatchCartQty[delKey] = (_standMatchCartQty[delKey] || 0) + 1;
            if (typeof renderStandMatchRecs === 'function') renderStandMatchRecs();
          } else if (delType === 'upload-single' && state.uploadCovers) {
            // Swipe-right +1 — mirrors the click-stepper plus path.
            var _swUIdxP = parseInt(delKey, 10);
            if (!isNaN(_swUIdxP) && state.uploadCovers[_swUIdxP]) {
              state.uploadCovers[_swUIdxP].qty = (state.uploadCovers[_swUIdxP].qty || 1) + 1;
              if (typeof renderUploadList === 'function') renderUploadList();
            }
          }
          if (typeof recomputeTotal === 'function') recomputeTotal();
          if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
          _updateCartPopover();
        }
      } else {
        // Snap back
        item.style.transform = 'translateX(0)';
        item.style.opacity = '1';
        item.style.background = '';
      }
    }, { passive: true });
  })();

  // Step-bar clicks → goToStep
  document.querySelectorAll('.up-step[data-step]').forEach((step) => {
    step.addEventListener('click', () => {
      goToStep(step.dataset.step);
    });
  });

  /* --- Mobile bottom-sheet: finger-tracking drag + spring snap --- */
  (function initMobileBottomSheet() {
    if (window.matchMedia('(min-width: 481px)').matches) return;
    var panel = document.querySelector('.side-panel');
    if (!panel) return;

    // --- dvh unit: set CSS custom property for iOS Safari accuracy ---
    function setDvh() {
      document.documentElement.style.setProperty('--dvh', (window.innerHeight * 0.01) + 'px');
    }
    setDvh();
    window.addEventListener('resize', setDvh);

    // --- Measure CTA bar ---
    var ctaBar = document.querySelector('.studio-cta');
    var ctaBarH = ctaBar ? ctaBar.offsetHeight : 56;
    document.documentElement.style.setProperty('--cta-bar-h', ctaBarH + 'px');

    // === DETENT CONFIGURATION ===
    var DETENT_COLLAPSED = 122; // px — eyebrow visible, title just hidden
    var DETENT_COLLAPSED_CART = 96; // px — grip + "Your Composition" header only,
                                    // no section labels peeking. Used when the
                                    // cart drawer owns the sheet slot.
    var DETENT_HALF;            // calculated below
    var DETENT_EXPANDED;        // calculated below
    var detents = [];

    function recalcDetents() {
      var ih = window.innerHeight;
      DETENT_HALF = Math.round(ih * 0.50);
      DETENT_EXPANDED = Math.round(ih * 0.72);
      var collapsedH = document.body.classList.contains('cart-open')
        ? DETENT_COLLAPSED_CART : DETENT_COLLAPSED;
      detents = [collapsedH, DETENT_HALF, DETENT_EXPANDED];
    }
    recalcDetents();
    window.addEventListener('resize', recalcDetents);
    window._recalcSheetDetents = recalcDetents;

    // === STATE ===
    var currentH = DETENT_COLLAPSED;   // current visible sheet height
    var startTouchY = 0;
    var startH = 0;
    var isDragging = false;
    var isScrolling = false;
    var scrollCooldown = false;
    var velocityTracker = [];
    var lastTouchY = 0;
    var lastTouchTime = 0;
    var currentDetentIdx = 0;          // 0=collapsed, 1=half, 2=expanded
    // FIX 2026-06-06: when a touch begins inside the upload image editor
    // (#cuPreview), the sheet-drag gesture must stand down so panning the
    // photo doesn't also resize/collapse the sheet. Set in touchstart,
    // checked at the top of _boundTouchMove.
    var _touchInEditor = false;

    // === HELPERS ===

    // Rubber-band damping (Apple-style logarithmic)
    function rubberBand(dist, dim) {
      var c = 0.55;
      return (1 - (1 / ((dist * c / dim) + 1))) * dim;
    }

    // Weighted-average velocity from recent samples
    function getVelocity() {
      if (!velocityTracker.length) return 0;
      var now = performance.now();
      var wSum = 0, wTotal = 0;
      for (var i = 0; i < velocityTracker.length; i++) {
        var age = now - velocityTracker[i].t;
        if (age > 300) continue;
        var w = 1 - age / 300;
        wSum += velocityTracker[i].v * w;
        wTotal += w;
      }
      return wTotal > 0 ? wSum / wTotal : 0;
    }

    // Find target detent based on position + velocity + direction of motion.
    // Slow but deliberate drags (>=30px) commit to the direction of motion
    // rather than snapping back to the nearest detent — fixes "I dragged up
    // but the panel sprang back to collapsed."
    function findTarget(h, vel, startHForDir) {
      var FLICK = 0.5; // px/ms
      if (Math.abs(vel) > FLICK) {
        if (vel > 0) { // flicking up → find next higher detent
          for (var i = 0; i < detents.length; i++) {
            if (detents[i] > h + 10) return i;
          }
          return detents.length - 1;
        } else { // flicking down → find next lower detent
          for (var i = detents.length - 1; i >= 0; i--) {
            if (detents[i] < h - 10) return i;
          }
          return 0;
        }
      }
      // Slow drag with clear directional intent: commit to direction.
      var DIR_THRESH = 30;
      if (typeof startHForDir === 'number') {
        var moved = h - startHForDir;
        if (moved >= DIR_THRESH) { // dragged up
          for (var i = 0; i < detents.length; i++) {
            if (detents[i] > startHForDir + 10) return i;
          }
          return detents.length - 1;
        }
        if (moved <= -DIR_THRESH) { // dragged down
          for (var i = detents.length - 1; i >= 0; i--) {
            if (detents[i] < startHForDir - 10) return i;
          }
          return 0;
        }
      }
      // Tiny drag (<30px): snap to nearest
      var best = 0, bestDist = Math.abs(h - detents[0]);
      for (var i = 1; i < detents.length; i++) {
        var d = Math.abs(h - detents[i]);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    // === POSITION SHEET (core render — sets actual height) ===
    // Writes to --sheet-h CSS variable so both .side-panel and .up-cart-popover
    // (when cart-drawer is open) share the same footprint. body.sheet-animating
    // triggers the height transition on whichever sheet is currently visible.
    function setSheetH(h, animate) {
      currentH = h;
      document.body.classList.toggle('sheet-animating', !!animate);
      document.documentElement.style.setProperty('--sheet-h', Math.round(h) + 'px');
    }
    // Expose detent state so cart-drawer can stay in sync with main sheet.
    window._getSheetDetentIdx = function() { return currentDetentIdx; };
    window._getSheetDetents = function() { return detents.slice(); };
    window._getSheetHeight = function() { return currentH; };
    window._snapSheet = function(idx, skipTransition) { snapTo(idx, skipTransition); };
    window._setSheetH = function(h, animate) { setSheetH(h, animate); };
    window._sheetHelpers = {
      rubberBand: rubberBand,
      findTarget: findTarget
    };

    // === SCROLL vs DRAG DISAMBIGUATION ===
    function shouldDragSheet(deltaY) {
      // deltaY positive = finger moved up = wants to expand sheet
      var atTop = panel.scrollTop <= 1;
      var isScrollable = currentDetentIdx >= 1; // half or expanded

      if (scrollCooldown) return false;

      // Collapsed → always drag
      if (!isScrollable) return true;

      // At scrollable detent: check if panel content overflows
      var hasOverflow = panel.scrollHeight > panel.clientHeight + 2;

      // No overflow → drag the sheet
      if (!hasOverflow) return true;

      // Has overflow + content at top + dragging down → drag sheet down
      if (atTop && deltaY < 0) return true;

      // Has overflow + at top + swiping up + NOT at max detent → drag sheet to expand
      if (atTop && deltaY > 0 && currentDetentIdx < detents.length - 1) return true;

      // Has overflow + at max detent or scrolled → let content scroll
      return false;
    }

    // === TOUCH HANDLERS (Google Maps–style full-sheet drag) ===
    // ANY touch on the panel can become a sheet drag. Scroll vs drag is
    // decided by content state, not touch-start position. This eliminates
    // the HANDLE_ZONE_PX=44 restriction that made content-area swipes
    // feel stuck.
    //
    // Architecture (matches Google Maps / Apple Maps bottom sheet):
    // 1. Sheet NOT at max detent → vertical movement drags the sheet
    // 2. Sheet at max detent → let content scroll natively
    // 3. Sheet at max detent + scrollTop=0 + finger pulling down → drag sheet
    // 4. Content scrolling + scrollTop hits 0 + still pulling down → seamless handoff to sheet drag
    //
    // Click/tap preservation: touchmove listener is on WINDOW (not panel)
    // and only calls preventDefault when isDragging=true + movement > dead zone.
    // This avoids iOS Safari click-synthesis delay.

    var prevTouchY = 0; // previous frame's touch.clientY, for instantaneous direction

    var _boundTouchMove = function(e) {
      // Touch began inside the upload image editor → never drag the sheet;
      // let #cuPreview's own pan/pinch handlers own the gesture.
      if (_touchInEditor) return;
      var touch = e.touches[0];
      var rawDy = startTouchY - touch.clientY; // positive = finger up (expand)
      var now = performance.now();

      // Save instantaneous direction BEFORE updating lastTouchY
      var instantDir = prevTouchY - touch.clientY; // positive = up, negative = down
      prevTouchY = touch.clientY;

      // Velocity tracking
      var dt = now - lastTouchTime;
      if (dt > 0) {
        var instantV = (lastTouchY - touch.clientY) / dt;
        velocityTracker.push({ v: instantV, t: now });
        if (velocityTracker.length > 6) velocityTracker.shift();
      }
      lastTouchY = touch.clientY;
      lastTouchTime = now;

      // --- Scroll-to-drag handoff ---
      // User was scrolling content, content reached top, finger still pulling down
      // → seamlessly switch to sheet-drag (Google Maps behavior).
      if (!isDragging && isScrolling) {
        var atTop = panel.scrollTop <= 1;
        var pullingDown = instantDir < -1; // finger moving downward
        if (atTop && pullingDown && currentDetentIdx >= 1) {
          isScrolling = false;
          isDragging = true;
          startTouchY = touch.clientY;
          startH = currentH;
          velocityTracker = [];
          // Lock content scroll so it doesn't fight the sheet drag
          panel.style.overflowY = 'hidden';
          e.preventDefault();
          return;
        }
        return; // still scrolling, let native handle it
      }

      // --- First-move disambiguation (12px dead zone for tap tolerance) ---
      if (!isDragging && !isScrolling) {
        if (Math.abs(rawDy) < 12) return;
        if (shouldDragSheet(rawDy)) {
          isDragging = true;
          // Lock content scroll during sheet drag
          panel.style.overflowY = 'hidden';
        } else {
          isScrolling = true;
          return;
        }
      }
      if (!isDragging) return;

      e.preventDefault();

      // Calculate new sheet height
      var newH = startH + rawDy;

      // Rubber-band at limits
      var collapsedLimit = detents[0];
      if (newH > DETENT_EXPANDED) {
        var over = newH - DETENT_EXPANDED;
        newH = DETENT_EXPANDED + rubberBand(over, 80);
      } else if (newH < collapsedLimit) {
        var over = collapsedLimit - newH;
        newH = collapsedLimit - rubberBand(over, 80);
      }

      setSheetH(newH, false);
    };

    // Restore scrollability after drag ends
    function restoreScroll() {
      // Restore overflow based on current detent
      if (currentDetentIdx >= 1) {
        panel.style.overflowY = '';
        panel.classList.add('is-expanded');
      } else {
        panel.style.overflowY = '';
      }
    }

    panel.addEventListener('touchstart', function(e) {
      if (isDragging) return;
      // Stand down if the gesture starts in the upload image editor —
      // panning the photo must not resize/collapse the sheet.
      _touchInEditor = !!(e.target && e.target.closest && e.target.closest('#cuPreview'));
      var touch = e.touches[0];
      startTouchY = touch.clientY;
      startH = currentH;
      lastTouchY = touch.clientY;
      prevTouchY = touch.clientY;
      lastTouchTime = performance.now();
      velocityTracker = [];
      isDragging = false;
      isScrolling = false;

      // Attach window-level touchmove (non-passive for preventDefault)
      window.addEventListener('touchmove', _boundTouchMove, { passive: false });

      // Kill any running animation
      document.body.classList.remove('sheet-animating');
    }, { passive: true });

    panel.addEventListener('touchend', function(e) {
      window.removeEventListener('touchmove', _boundTouchMove);

      if (!isDragging) {
        if (isScrolling && !scrollCooldown) {
          var _scrollHandler = function() {
            if (panel.scrollTop <= 0) {
              scrollCooldown = true;
              setTimeout(function() { scrollCooldown = false; }, 120);
            }
          };
          panel.addEventListener('scroll', _scrollHandler, { passive: true, once: true });
        }
        isDragging = false;
        isScrolling = false;
        return;
      }

      isDragging = false;
      restoreScroll();

      var vel = getVelocity();
      var targetIdx = findTarget(currentH, vel, startH);
      snapTo(targetIdx);
    }, { passive: true });

    panel.addEventListener('touchcancel', function() {
      window.removeEventListener('touchmove', _boundTouchMove);
      isDragging = false;
      isScrolling = false;
      restoreScroll();
    }, { passive: true });

    // === SNAP ANIMATION (anti-flicker: iframe frozen through animation) ===
    function snapTo(detentIdx, skipTransition) {
      currentDetentIdx = detentIdx;
      var targetH = detents[detentIdx];
      var cartPop = document.getElementById('upCartPopover');

      // Scrollable at half and expanded detents (not collapsed)
      if (detentIdx >= 1) {
        panel.classList.add('is-expanded');
        if (cartPop) cartPop.classList.add('is-expanded');
      } else {
        panel.scrollTop = 0;
        panel.classList.remove('is-expanded');
        if (cartPop) {
          // Inner scroll element owns the scroll context now — reset it.
          var cartScroll = cartPop.querySelector('.up-cart-scroll');
          if (cartScroll) cartScroll.scrollTop = 0;
          cartPop.scrollTop = 0;
          cartPop.classList.remove('is-expanded');
        }
      }

      if (skipTransition) {
        setSheetH(targetH, false);
      } else {
        setSheetH(targetH, true);
        var _cleanup = function() {
          document.body.classList.remove('sheet-animating');
          panel.removeEventListener('transitionend', _cleanup);
        };
        panel.addEventListener('transitionend', _cleanup, { once: true });
        setTimeout(_cleanup, 600);
      }
    }

    // === TAP TO EXPAND/COLLAPSE ===
    panel.addEventListener('click', function(e) {
      if (e.target.closest('button, input, label, a, select, textarea, .cover-mode-btn')) return;
      var rect = panel.getBoundingClientRect();
      var yInPanel = e.clientY - rect.top;

      if (currentDetentIdx === 0) {
        // Collapsed → expand to half
        snapTo(1);
      } else if (yInPanel <= 36) {
        // Tap drag handle → collapse
        snapTo(0);
      }
    });

    // === EXPOSE GLOBAL API (backward-compatible) ===
    window._collapseBottomSheet = function() { snapTo(0); };
    window._expandBottomSheet = function(skipTransition) { snapTo(1, skipTransition); };
    window._clearViewportResize = function() {
      panel.style.height = '';
      panel.style.maxHeight = '';
      panel.style.minHeight = '';
      document.documentElement.style.removeProperty('--sheet-h');
    };
    window._resizeViewport = function(expanded, skip) {
      snapTo(expanded ? 1 : 0, skip);
    };

    // Re-apply on resize (iOS Safari address bar)
    window.addEventListener('resize', function() {
      if (document.body.getAttribute('data-active-pane') === 'review') return;
      recalcDetents();
      setSheetH(detents[currentDetentIdx], false);
    });

    // Default: expanded (half) on load
    snapTo(1, true);
  })();

  // Mobile Reveal: expandable detail bottom-sheet (v7 "Hero Model" pattern)
  (function initMobileRevealDetail() {
    if (window.matchMedia('(min-width: 481px)').matches) return;
    var info = document.querySelector('.review-overlay__info');
    var rightPanel = document.querySelector('.review-overlay__right-panel');
    var nameRow = document.querySelector('.review-overlay__name-row');
    var cta = document.querySelector('.review-overlay__cta');
    if (!info || !nameRow) return;

    // --- Headline: hide top placard, move comp number below name ---
    var headline = document.querySelector('.review-overlay__headline');
    if (headline) headline.style.display = 'none';

    // Inject "Variation No. XXXX" as subtitle below name
    var compSpan = document.getElementById('reviewCompNumber');
    var compNum = compSpan ? compSpan.textContent : '';
    var subtitle = document.createElement('p');
    subtitle.className = 'review-overlay__comp-subtitle';
    subtitle.textContent = 'Variation No. ' + compNum;
    subtitle.id = 'mobileCompSubtitle';
    nameRow.parentNode.insertBefore(subtitle, nameRow.nextSibling);
    // Keep subtitle in sync when comp number changes
    if (compSpan) {
      new MutationObserver(function() {
        subtitle.textContent = 'Variation No. ' + compSpan.textContent;
      }).observe(compSpan, {childList: true, characterData: true, subtree: true});
    }

    // Speaker editorial line — mirrors the desktop headline ("on a Gold Tone
    // BeoSound A9.") since headline is hidden on mobile. Mirrors the live
    // value from #reviewSpeaker (which JS keeps populated).
    var spkSource = document.getElementById('reviewSpeaker');
    if (spkSource) {
      var spkLine = document.createElement('p');
      spkLine.id = 'mobileSpeakerLine';
      spkLine.className = 'review-overlay__speaker-line-mob';
      spkLine.innerHTML = 'on a <em><span class="ms-name"></span></em> BeoSound A9.';
      subtitle.parentNode.insertBefore(spkLine, subtitle.nextSibling);
      var nameSpan = spkLine.querySelector('.ms-name');
      var syncSpkName = function() { nameSpan.textContent = spkSource.textContent; };
      syncSpkName();
      new MutationObserver(syncSpkName).observe(spkSource, {childList:true, characterData:true, subtree:true});
    }


    // --- Move right-panel inside info sheet (between specs and CTA) ---
    if (rightPanel && cta) {
      rightPanel.style.position = 'relative';
      rightPanel.style.bottom = 'auto';
      rightPanel.style.left = 'auto';
      rightPanel.style.right = 'auto';
      info.insertBefore(rightPanel, cta);
    }

    var _detailOpen = false;

    // Continuously refit iframe during card CSS transition (smooth sync)
    function _animateFit() {
      if (typeof window._fitModelAboveCard !== 'function') return;
      window._fitModelAboveCard();
      if (info._fitRaf) cancelAnimationFrame(info._fitRaf);
      var _start = performance.now();
      (function _tick() {
        window._fitModelAboveCard();
        if (performance.now() - _start < 500) {
          info._fitRaf = requestAnimationFrame(_tick);
        }
      })();
    }

    // 3-level detent: 0 = minimized (grip + name only, max speaker),
    // 1 = collapsed (default — name + specs summary + CTA), 2 = expanded.
    var _level = 1;
    function _applyLevel() {
      info.classList.toggle('detail-expanded', _level === 2);
      info.classList.toggle('detail-minimized', _level === 0);
      if (rightPanel) rightPanel.classList.toggle('detail-expanded', _level === 2);
      _detailOpen = (_level === 2);
      _animateFit();
    }

    function toggleRevealDetail() {
      // Tap name-row / handle: expand if not already, else back to collapsed.
      _level = (_level === 2) ? 1 : 2;
      _applyLevel();
    }

    // Tap name-row or drag handle to toggle
    nameRow.addEventListener('click', toggleRevealDetail);
    // Also tap the drag handle (::before pseudo — use info top area)
    info.addEventListener('click', function(e) {
      var rect = info.getBoundingClientRect();
      var yInInfo = e.clientY - rect.top;
      // Only toggle if clicking in the handle area (top 24px)
      if (yInInfo <= 24) toggleRevealDetail();
    });

    // Swipe up to expand, swipe down to collapse (matches configurator panel behavior)
    var _rvStartY = 0;
    info.addEventListener('touchstart', function(e) {
      _rvStartY = e.touches[0].clientY;
    }, { passive: true });
    info.addEventListener('touchend', function(e) {
      var dy = e.changedTouches[0].clientY - _rvStartY;
      // Swipe up → step one level more open (min→collapsed→expanded).
      if (dy < -40 && _level < 2) {
        _level += 1;
        _applyLevel();
      // Swipe down → step one level more closed (expanded→collapsed→min).
      // From expanded, only collapse once content is scrolled to top so the
      // gesture doesn't fight inner scroll.
      } else if (dy > 40 && _level > 0 && (_level !== 2 || info.scrollTop <= 0)) {
        _level -= 1;
        _applyLevel();
      }
    }, { passive: true });

    // Expose for goToStep to reset
    window._collapseRevealDetail = function() {
      _level = 1;
      _applyLevel();
    };
    window._expandRevealDetail = function() {
      _level = 2;
      _applyLevel();
    };
  })();

  // Parts-nav-label clicks → goToStep (via PART_TO_STEP map)
  document.querySelectorAll('.parts-nav-label[data-part]').forEach((el) => {
    el.addEventListener('click', () => {
      // 'stand' is a legacy alias for legs
      const part = el.dataset.part === 'stand' ? 'legs' : el.dataset.part;
      const targetStep = PART_TO_STEP[part];
      if (targetStep) goToStep(targetStep);
      // Phase 4.26 — parts-nav click implies "I want a closeup of this part".
      // goToStep just put zoom OFF; flip it ON so the iframe re-frames the
      // current view at zoomed radius (a9:setZoom re-runs _setView on
      // state.lastView with the new zoom flag).
      a9Bridge.setZoom(true);
      _syncZoomTogglePill(true);
    });
  });

  /* Phase 4.50 — Scroll-wheel navigation on parts-nav. Scrolling
     down cycles Speaker → Cover → Legs; scrolling up goes back.
     Debounced so one "tick" = one step, with a 400ms cooldown. */
  (function () {
    const nav = document.querySelector('.parts-nav');
    if (!nav) return;
    const PARTS_ORDER = ['speaker', 'cover', 'legs'];
    let _wheelLock = false;
    nav.style.pointerEvents = 'auto';        // enable wheel capture
    nav.addEventListener('wheel', function (e) {
      if (_wheelLock) return;
      const dir = e.deltaY > 0 ? 1 : e.deltaY < 0 ? -1 : 0;
      if (!dir) return;
      e.preventDefault();
      const cur = _currentPart();
      const idx = PARTS_ORDER.indexOf(cur);
      const next = idx + dir;
      if (next < 0 || next >= PARTS_ORDER.length) return;
      goToStep(PART_TO_STEP[PARTS_ORDER[next]]);
      a9Bridge.setZoom(true);
      _syncZoomTogglePill(true);
      _wheelLock = true;
      setTimeout(() => { _wheelLock = false; }, 400);
    }, { passive: false });
  })();

  // Phase 4.26 — Custom-row heading click (Step 1's left-side Speaker./Cover./Legs.
  // sections) is a "back to the panoramic boot framing" gesture: pulls camera
  // back to default (boot's setView('speaker')), drops ZOOM, clears parts-nav
  // active. Custom-rows only exist inside #pane-speaker; clicks elsewhere are
  // a no-op because the selector won't match.
  document.querySelectorAll('.custom-row .custom-row-head').forEach((head) => {
    head.addEventListener('click', () => {
      a9Bridge.setView('speaker');
      document.querySelectorAll('.parts-nav-label').forEach((l) => {
        l.classList.remove('is-active');
        l.classList.add('is-inactive');
      });
      a9Bridge.setZoom(false);
      _syncZoomTogglePill(false);
    });
  });

  // Phase 4.37 FIX B — composition number is now the same hour-based
  // variation No. that Step 4 shows. The legacy random 0-999 fed
  // #compNumber a different value than #kpNumber, so the customer saw two
  // different identifiers across Steps 1-3 vs Step 4. One source now.
  const _compEl = document.getElementById('compNumber');
  const _varNum = _getOrCreateVariationNumber();
  if (_compEl) _compEl.textContent = _varNum;
  const _reviewCompEl = document.getElementById('reviewCompNumber');
  if (_reviewCompEl) _reviewCompEl.textContent = _varNum;

  // CTA cycles through steps → goToStep (current+1)
  document.getElementById('ctaNext').addEventListener('click', () => {
    const cur = parseInt(window._currentStep || '1', 10);
    if (cur < 4) goToStep(String(cur + 1));
  });

  // Mobile eyebrow back chevrons (‹ inside panel-eyebrow)
  document.addEventListener('click', function(e) {
    var backEl = e.target.closest('.mob-eyebrow-back[data-back]');
    if (backEl) {
      e.preventDefault();
      goToStep(backEl.dataset.back);
    }
  });

  // Dev hook
  Object.defineProperty(window, '__a9', {
    value: {
      get state() { return state; },
      get materialConfig() { return materialConfig; },
      get presetName() { return currentPresetName; },
      get bridge() { return a9Bridge; }
    },
    configurable: true
  });

  /* =====================================================================
     Phase 5.27 — State Persistence (URL params + LocalStorage)
     ===================================================================== */
  const LS_KEY = 'tegrino_a9_state';

  // --- Serialize current state into a compact param map ---
  function _stateToParams() {
    const p = {};
    if (state.body && state.body !== 'Warm White')        p.b = state.body;
    if (state.cover && state.cover !== 'Golden')           p.c = state.cover;
    if (state.wood && state.wood !== 'Light Oak')          p.w = state.wood;
    if (state.legs && state.legs !== 'original')           p.l = state.legs;
    if (state.legsAccessory && state.legsAccessory.id)     p.la = state.legsAccessory.id;
    if (state.legsCustom && state.legsCustom.hex)          p.lc = state.legsCustom.hex;
    if (state.customCover) {
      p.cc = state.customCover.type;  // 'pantone' or 'upload'
      if (state.customCover.hex)  p.ch = state.customCover.hex;
      if (state.customCover.code) p.cn = state.customCover.code;
      if (state.customCover.name) p.cname = state.customCover.name;
    }
    // Composition name + number for shared links
    const compName = (typeof _composeCompositionName === 'function')
      ? _composeCompositionName() : (state.compositionName || null);
    if (compName) p.name = compName;
    const compNum = (typeof _getOrCreateVariationNumber === 'function')
      ? _getOrCreateVariationNumber() : null;
    if (compNum) p.num = compNum;
    const step = window._currentStep || '1';
    if (step !== '1') p.s = step;
    return p;
  }

  // --- Build a shareable URL from current state ---
  // forShare=true forces step=4 (reveal) so recipients see the finished composition
  function _buildShareUrl(forShare) {
    const params = _stateToParams();
    if (forShare) params.s = '4';  // land on reveal page
    const url = new URL(window.location.href.split('?')[0]);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));
    // Keep the cache-bust param if present
    const orig = new URLSearchParams(window.location.search);
    if (orig.has('v')) url.searchParams.set('v', orig.get('v'));
    return url.toString();
  }

  // --- Save to LocalStorage (debounced; pass immediate=true to bypass) ---
  // Bypass-the-debounce path matters for navigation events (pagehide,
  // checkout redirect). Without it, the most recent state change may still
  // be sitting in the 300ms timer when the page unloads — lost forever.
  let _saveTimer = null;
  function _persistState(immediate) {
    clearTimeout(_saveTimer);
    const _doSave = () => {
      try {
        const snap = {
          body: state.body, cover: state.cover, wood: state.wood,
          legs: state.legs,
          legsAccessory: state.legsAccessory,
          legsCustom: state.legsCustom,
          customCover: state.customCover ? {
            type: state.customCover.type,
            hex: state.customCover.hex || null,
            code: state.customCover.code || null,
            name: state.customCover.name || null
          } : null,
          step: window._currentStep || '1',
          coverMode: window._coverMode || 'mood',
          standMode: window._standMode || 'stock',
          ts: Date.now()
        };
        localStorage.setItem(LS_KEY, JSON.stringify(snap));
      } catch (e) { /* quota / private mode — silent */ }
      // Persist uploadCovers to sessionStorage (per-tab, survives back/forward
      // on full reload). dataUrls are too large for localStorage's 5–10MB quota.
      try {
        if (state.uploadCovers && state.uploadCovers.length > 0) {
          const _ucs = state.uploadCovers.map(uc => ({
            id: uc.id, filename: uc.filename, qty: uc.qty || 1,
            dataUrl: uc.dataUrl || null,
            composedDataUrl: uc.composedDataUrl || null,
            filter: uc.filter || null,
            cropX: uc.cropX, cropY: uc.cropY, cropW: uc.cropW, cropH: uc.cropH,
            naturalW: uc.naturalW, naturalH: uc.naturalH
          }));
          sessionStorage.setItem('tg_uploadCovers', JSON.stringify(_ucs));
        } else {
          sessionStorage.removeItem('tg_uploadCovers');
        }
      } catch (e) { /* quota / private mode — silent */ }
      // Also update URL without reload
      try {
        const url = _buildShareUrl();
        history.replaceState(null, '', url);
      } catch (e) { /* ignore */ }
    };
    if (immediate) { _doSave(); return; }
    _saveTimer = setTimeout(_doSave, 300);
  }

  // Expose immediate-flush so navigation paths (cart checkout) can force a
  // sync write before location.href fires.
  window._flushPersistState = function () { _persistState(true); };

  // Expose share URL builder for the Share button handler (different scope)
  window._buildShareUrl = function(forShare) { return _buildShareUrl(forShare); };

  // Flush on page lifecycle transitions so any pending debounced state is
  // never lost when the user navigates away (Place Order → /checkout,
  // tab close, browser back into Shopify checkout, etc).
  //   - pagehide:  fires on real navigation AND on bfcache entry (mobile Safari).
  //                Preferred over beforeunload/unload, which are flaky on iOS.
  //   - visibilitychange→hidden:  belt-and-braces for backgrounded mobile tabs
  //                that may be killed without firing pagehide.
  window.addEventListener('pagehide', () => { _persistState(true); });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') _persistState(true);
  });
  // Returning via bfcache (browser back/forward): JS state is intact, but the
  // upload-list UI can lag — rebuild it from in-memory uploadCovers. Full
  // reloads go through _restoreState() above and don't need this.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted && state.uploadCovers && state.uploadCovers.length > 0) {
      if (typeof _enterListState === 'function') _enterListState();
      if (typeof renderAll === 'function') renderAll();
      if (typeof window.updateCtaSummary === 'function') window.updateCtaSummary();
    }
  });

  // --- Restore state from URL params or LocalStorage ---
  function _restoreState() {
    const params = new URLSearchParams(window.location.search);
    const hasStateParams = ['b','c','w','l','la','lc','cc','s','name','num'].some(k => params.has(k));

    let restored = null;

    if (hasStateParams) {
      // URL params take priority
      restored = {
        body:  params.get('b') || 'Warm White',
        cover: params.get('c') || 'Golden',
        wood:  params.get('w') || 'Light Oak',
        legs:  params.get('l') || 'original',
        step:  params.get('s') || '1',
        compositionName: params.get('name') || null,
        compositionNum:  params.get('num')  || null
      };
      if (params.has('la')) {
        const legId = params.get('la');
        const legDef = LEG_MATERIALS[legId];
        if (legDef) {
          // Reconstruct legsAccessory with price from LEG_MATERIALS
          restored.legsAccessory = { id: legId, kind: legDef.kind };
        }
      }
      if (params.has('lc')) {
        restored.legsCustom = { hex: params.get('lc') };
      }
      if (params.has('cc')) {
        restored.customCover = {
          type: params.get('cc'),
          hex: params.get('ch') || null,
          code: params.get('cn') || null,
          name: params.get('cname') || null
        };
      }
    } else {
      // Try LocalStorage
      try {
        const raw = localStorage.getItem(LS_KEY);
        if (raw) {
          const snap = JSON.parse(raw);
          // Only restore if less than 7 days old
          if (snap.ts && (Date.now() - snap.ts) < 7 * 24 * 3600 * 1000) {
            restored = snap;
            // Bugfix: a plain reload must not drop the user into the review/reveal
            // step (4). Cap to the last EDIT step. Shared links (URL params) go
            // through the other branch and still open the review as intended.
            if (String(restored.step) === '4') restored.step = '3';
          }
        }
      } catch (e) { /* corrupt data — ignore */ }
    }

    if (!restored) return;

    // Apply restored state
    if (restored.body)  state.body  = restored.body;
    if (restored.cover) state.cover = restored.cover;
    if (restored.wood)  state.wood  = restored.wood;
    state.rim = BODY_TO_RIM[state.body] || 'Gold Tone';
    if (restored.legs) state.legs = restored.legs;
    if (restored.legsAccessory) state.legsAccessory = restored.legsAccessory;
    if (restored.legsCustom) state.legsCustom = restored.legsCustom;
    if (restored.customCover) state.customCover = restored.customCover;
    // Composition name + number from shared link
    if (restored.compositionName) {
      state.compositionName = restored.compositionName;
      state.compositionNameKey = null; // will be recomputed
    }
    if (restored.compositionNum) {
      try { sessionStorage.setItem('tg_variation_no_v2', restored.compositionNum); } catch (e) { /* ignore */ }
    }

    // Sync preset name
    syncPresetState();

    // Sync 3D model + UI via the existing high-level functions that handle
    // both bridge commands AND DOM updates (swatch highlights, CTA summary).
    function _syncAll() {
      // Try restoring uploadCovers from sessionStorage (back/forward survival
      // when bfcache misses and the page is fully reloaded). dataUrls aren't
      // serialized into URL/localStorage, so sessionStorage is the only source
      // of truth for the user's uploaded images across reloads in this tab.
      try {
        const _ucRaw = sessionStorage.getItem('tg_uploadCovers');
        if (_ucRaw) {
          const _ucArr = JSON.parse(_ucRaw);
          if (Array.isArray(_ucArr) && _ucArr.length > 0) {
            state.uploadCovers = _ucArr;
            const _lastUc = _ucArr[_ucArr.length - 1];
            state.customCover = { type: 'upload', filename: _lastUc.filename };
            if (_lastUc.composedDataUrl && typeof _sendUploadToViewer === 'function') {
              _sendUploadToViewer(_lastUc.composedDataUrl);
            }
            if (typeof _enterListState === 'function') _enterListState();
          }
        }
      } catch (e) { /* corrupt session data — fall through */ }
      // Fallback: if nothing was restored and customCover still claims upload,
      // clear it (the original behavior — no dataUrl means no image to show)
      if ((!state.uploadCovers || state.uploadCovers.length === 0) &&
          state.customCover && state.customCover.type === 'upload') {
        state.customCover = null;
      }

      // Save customCover before preset/body calls (they may clear it)
      const savedCustomCover = state.customCover
        ? JSON.parse(JSON.stringify(state.customCover)) : null;

      // Check if state matches an official preset
      const matchedPreset = materialConfig && materialConfig.officialPresets
        ? materialConfig.officialPresets.find(p =>
            p.body === state.body && p.rim === state.rim &&
            p.cover === state.cover && p.wood === state.wood)
        : null;

      if (matchedPreset && !savedCustomCover) {
        pickPreset(matchedPreset.name);
      } else {
        // Manual sync — fire body, wood, cover individually
        pickBody(state.body);
        pickWood(state.wood);
      }

      // Restore custom cover after preset/body calls
      if (savedCustomCover) {
        state.customCover = savedCustomCover;
        if (savedCustomCover.type === 'pantone' && savedCustomCover.hex) {
          a9Bridge.setCustomPantone(savedCustomCover.hex);
        }
      }

      // Legs
      if (state.legs && state.legs !== 'original') {
        const legDef = LEG_MATERIALS[state.legs];
        if (legDef) a9Bridge.send({ type: 'a9:setStand', stand: state.legs, material: legDef });
      }

      // Re-render all UI + sync swatch highlights from state
      if (typeof _syncCustomSwatchesFromState === 'function') _syncCustomSwatchesFromState();
      if (typeof renderAll === 'function') renderAll();
      recomputeTotal();

      // Bugfix: restore a custom Pantone leg via the CANONICAL selection path,
      // here at the end of the authoritative on-ready sync so nothing wipes it
      // afterwards. selectStandMoodSwatch populates _standMoodCartQty (the real
      // source of truth) + ring + state + model + total — a plain state set did
      // not survive later re-renders.
      if (restored.legsCustom && restored.legsCustom.hex && restored.legsCustom.mode !== 'upload'
          && typeof selectStandMoodSwatch === 'function') {
        const _lcR = restored.legsCustom;
        if (typeof setStandMode === 'function') setStandMode('mood');
        selectStandMoodSwatch(_lcR.hex, _lcR.tpg || _lcR.code || '', _lcR.name || '', true);
      }
    }

    // Fire once on a9:ready (iframe posts this when loaded)
    let _bridgeSynced = false;
    const _bridgeListener = (evt) => {
      if (evt.data && evt.data.type === 'a9:ready' && !_bridgeSynced) {
        _bridgeSynced = true;
        window.removeEventListener('message', _bridgeListener);
        setTimeout(_syncAll, 80);
      }
    };
    window.addEventListener('message', _bridgeListener);
    // Fallback: also fire after a delay in case a9:ready already fired
    setTimeout(() => {
      if (!_bridgeSynced) { _bridgeSynced = true; _syncAll(); }
    }, 1500);

    // Navigate to restored step after render
    const targetStep = restored.step || '1';
    if (targetStep !== '1') {
      // Delay so initial render completes first
      setTimeout(() => { goToStep(targetStep); }, 120);
    }

    // Restore cover mode (mood/upload/match)
    if (restored.coverMode && typeof setCoverMode === 'function') {
      setTimeout(() => { setCoverMode(restored.coverMode); }, 150);
    }
    // Restore stand mode (stock/mood/match)
    if (restored.standMode && typeof setStandMode === 'function') {
      setTimeout(() => { setStandMode(restored.standMode); }, 160);
    }
    // (Custom Pantone leg is restored at the end of _syncAll above — the
    // authoritative on-ready sync — so it isn't wiped by later re-renders.)
  }

  // --- Hook persistence into state-change paths ---
  const _origRecompute = recomputeTotal;
  recomputeTotal = function() {
    _origRecompute();
    _persistState();
  };

  // Hook goToStep to persist on navigation
  const _origGoToStep = goToStep;
  goToStep = function(stepNum) {
    _origGoToStep(stepNum);
    _persistState();
  };
  window.goToStep = goToStep;

  // --- Share button handler now lives in the reveal IIFE (generates share card image) ---

  // Run restore before initial render
  _restoreState();

  /* v9 §E1.5 / E1-final — guarantee the right panel is populated on
     first paint. UI-only: just runs renderAll(). The toggle state +
     camera framing are handled by _onceReady above (which fires once on
     the first a9:ready). Calling renderAll() multiple times is
     idempotent (it just re-paints swatch grids). */
  function _initialRender() {
    if (typeof renderAll === 'function') renderAll();
    // Cover V2 — set initial header path based on current step + mode
    if (typeof _updateHeaderPath === 'function') _updateHeaderPath();
    // FOUC guard — reveal UI now that state is restored + rendered
    const app = document.querySelector('.studio-app');
    if (app && !app.classList.contains('is-ready')) {
      requestAnimationFrame(() => app.classList.add('is-ready'));
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _initialRender);
  } else {
    _initialRender();
  }
  window.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'a9:ready') _initialRender();
  });
}

bootConfigurator();

/* =====================================================================
   Checkout data-layer self-test — run by appending ?selftest=1 to the URL.
   Feeds a battery of edge-case data URLs through the REAL _dataUrlToBlob +
   _isValidImageDataUrl (the layer that threw "did not match the expected
   pattern" in production). Asserts: valid inputs → a Blob; bad inputs →
   null/false, never an uncaught throw. Prints a pass/fail table to console.
   No network, no Shopify — safe to run on prod too. Catches regressions
   before a customer does.
   ===================================================================== */
(function _tgCheckoutSelfTest() {
  try {
    var p = new URLSearchParams(window.location.search);
    if (p.get('selftest') !== '1') return;
  } catch (e) { return; }

  function run() {
    var oss = window.tgOssUpload;
    if (!oss || !oss._dataUrlToBlob) { console.error('[selftest] tgOssUpload not ready'); return; }

    // 1×1 px PNG, valid base64
    var PNG1 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==';
    var b64body = PNG1.split(',')[1];

    var cases = [
      // [label, input, expectBlob(bool), expectValid(bool)]
      ['clean PNG',                 PNG1,                                            true,  true],
      ['base64 with newlines',      'data:image/png;base64,' + b64body.replace(/(.{8})/g, '$1\n'), true,  true],
      ['base64 with spaces',        'data:image/png;base64,' + b64body.replace(/(.{8})/g, '$1 '),  true,  true],
      ['jpeg mime',                 'data:image/jpeg;base64,' + b64body,             true,  true],
      ['webp mime',                 'data:image/webp;base64,' + b64body,             true,  true],
      ['empty string',             '',                                               false, false],
      ['null',                      null,                                            false, false],
      ['undefined',                 undefined,                                       false, false],
      ['number (non-string)',       12345,                                           false, false],
      ['degenerate data:,',         'data:,',                                        false, false],
      ['blob: URL',                 'blob:https://x/abc-123',                        false, false],
      ['plain error string',        'Tainted canvases may not be exported',          false, false],
      ['data URL no base64 (utf8)', 'data:text/plain,hello%20world',                 true,  false],
      ['svg+xml base64',            'data:image/svg+xml;base64,' + btoa('<svg/>'),   true,  true],
      ['truncated base64 (odd len)','data:image/png;base64,iVBORw0KGgoAAAANSUhEUg',  true,  true]
    ];

    var rows = [], pass = 0, fail = 0;
    var pending = cases.map(function (c) {
      var label = c[0], input = c[1], expectBlob = c[2], expectValid = c[3];
      var gotValid = false;
      try { gotValid = !!oss._isValidImageDataUrl(input); } catch (e) { gotValid = 'THREW:' + e.message; }
      return Promise.resolve()
        .then(function () { return oss._dataUrlToBlob(input); })
        .then(function (blob) {
          var gotBlob = !!(blob && blob.size >= 0 && typeof blob.size === 'number' && blob.constructor && /Blob/.test(blob.constructor.name));
          var okBlob = (gotBlob === expectBlob);
          var okValid = (gotValid === expectValid);
          var ok = okBlob && okValid;
          if (ok) pass++; else fail++;
          rows.push({ case: label, expectBlob: expectBlob, gotBlob: gotBlob,
                      expectValid: expectValid, gotValid: gotValid,
                      size: blob ? blob.size : '-', result: ok ? 'PASS' : 'FAIL' });
        })
        .catch(function (e) {
          // An uncaught throw is itself a FAIL — this is exactly the prod bug.
          fail++;
          rows.push({ case: label, expectBlob: expectBlob, gotBlob: 'THREW: ' + e.message,
                      expectValid: expectValid, gotValid: gotValid, size: '-', result: 'FAIL (threw)' });
        });
    });

    Promise.all(pending).then(function () {
      // keep table order stable
      rows.sort(function (a, b) {
        return cases.findIndex(function(c){return c[0]===a.case;}) - cases.findIndex(function(c){return c[0]===b.case;});
      });
      console.log('%c[selftest] checkout data-layer — ' + pass + ' passed, ' + fail + ' failed',
        'font-weight:bold;color:' + (fail ? '#c0392b' : '#1d9e75'));
      if (console.table) console.table(rows); else rows.forEach(function(r){ console.log(r); });
      window.__tgSelfTest = { pass: pass, fail: fail, rows: rows };
    });
  }

  if (window.tgOssUpload && window.tgOssUpload._dataUrlToBlob) run();
  else setTimeout(run, 800);
})();


// ── next extracted block ──


/* ── #2 Mobile address-bar (theme-color) follows the review page ──
   Default chrome is dark (#191817). The final review/reveal page is the
   light warm scene with a white card, so the dark address bar clashes.
   Swap theme-color to match the card while on the review pane, restore
   on leave. Uses a MutationObserver so it covers every data-active-pane
   call site without touching each one. */
(function () {
  var DEFAULT = '#191817';
  var REVIEW  = '#FFFFFF';   /* matches the white review card */
  var meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'theme-color');
    document.head.appendChild(meta);
  }
  function sync() {
    var pane = document.body.getAttribute('data-active-pane');
    meta.setAttribute('content', pane === 'review' ? REVIEW : DEFAULT);
  }
  new MutationObserver(sync).observe(document.body, {
    attributes: true, attributeFilter: ['data-active-pane']
  });
  sync();
})();
